/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111d30a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111d30a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"c7c47d21-c92b-41ac-b43c-49d83461d056","title":"Historial de cambios","link":"change-history.html","desc":"Enero de 2023 Se ha","descFull":"Enero de 2023 Se ha añadido información sobre la configuración  Markvision  Enterprise (MVE) y el flujo de trabajo para ADFS. Se ha actualizado la información sobre el acceso al panel de seguridad. Se ha añadido el capítulo Acceso a la base de datos. Agosto de 2022 Se ha añadido información sobre lo siguiente: Protocolo Enrollment over Secure Transport (EST) según se define en RFC 7030 Panel de seguridad Asignación automática de palabras clave durante el descubrimiento Compatibilidad con correo electrónico a través de SSL/TLS Compatibilidad con Windows Server 2022 Se ha actualizado información sobre lo siguiente: Modelos de impresora admitidos Administración de certificados con la autoridad certificadora de Microsoft a través de los servicios web de inscripción de certificados de Microsoft (MSEWS) Configuración del servidor de la CA de OpenXPKI Administración de configuraciones MVE Marzo de 2022 Se ha actualizado la información sobre los modelos de impresora admitidos. Se ha añadido información sobre la creación de un certificado de cliente. Mayo de 2021 Se ha actualizado información sobre lo siguiente: Modelos de impresora admitidos Administración de la autoridad certificadora (CA) de Microsoft Configuración de MVE para la administración automática de certificados Configuración de la CA de Microsoft Enterprise con el servicio de inscripción de dispositivos de red (NDES) Se ha añadido información sobre lo siguiente: Administración de certificados con la autoridad certificadora de Microsoft a través de los servicios web de inscripción de certificados de Microsoft (MSEWS) Creación de un certificado SSL para el servicio web de la política de inscripción de certificados (CEP) y los servidores del servicio web de inscripción de certificados (CES) Métodos de autenticación para CEP y CES Certificado de dispositivo con nombre Noviembre de 2020 Se ha actualizado información sobre lo siguiente: Modelos de impresora admitidos Bases de datos admitidas Se ha añadido información sobre lo siguiente: Administración e implementación de configuraciones Copia de seguridad y restauración de la base de datos Administración de certificados mediante la autoridad certificadora de Microsoft y OpenXPKI Se ha añadido compatibilidad con lo siguiente: Administración e implementación de configuraciones en un grupo de modelos de impresora Creación de nombres de base de datos personalizados Febrero de 2020 Se ha actualizado información sobre lo siguiente: Modelos de impresora admitidos Servidores admitidos Bases de datos admitidas Ruta de actualización de MVE válida Se ha añadido información sobre lo siguiente: Instrucciones de mejores prácticas Instrucciones sobre la administración de certificados automatizados Componentes de seguridad avanzada predeterminados y sus valores Otras formas de proteger las impresoras Casos de ejemplo Junio de 2019 Se ha actualizado información sobre lo siguiente: Se han añadido notas a pie de página para los modelos de impresora que necesitan certificados Asignación de derechos dbo al configurar la base de datos Ruta de actualización válida al actualizar a la versión 3.4 Archivos necesarios para la copia de seguridad y la restauración de la base de datos Configuración de la autenticación del servidor LDAP Se ha añadido el estado de validez del certificado, las fechas y los parámetros de la zona horaria a los valores de criterios de búsqueda Configuración de los permisos y los controles de acceso a funciones en los valores de seguridad de la impresora Selección de un archivo de firmware de la biblioteca de recursos al actualizar el firmware de la impresora Selección de la fecha de inicio, las horas de inicio y de pausa, y los días de la semana para actualizar el firmware de la impresora Administración de configuraciones Se ha añadido información sobre lo siguiente: Descripción de los estados de seguridad de la impresora Configuración de los componentes de seguridad avanzada Creación de un componente de seguridad avanzada desde una impresora Generación de una versión para imprimir de la configuración Carga de la autoridad certificadora de una flota de impresoras Eliminación de la información de usuario y las referencias a este Descripción de los permisos y los controles de acceso a funciones Pasos para la solución de problemas cuando falla la aplicación de configuraciones en varias aplicaciones Pasos para la solución de problemas cuando un usuario  Administración  ha olvidado la contraseña Agosto de 2018 Se ha actualizado información sobre lo siguiente: Modelos de impresora admitidos Configuración de la base de datos Actualización a MVE 3.3 Preguntas más frecuentes Creación de una acción Creación de un programa Se ha añadido información sobre lo siguiente: Configuración de una cuenta de ejecución como usuario de dominio Exportación de registros Pasos para la solución de problemas si MVE no reconoce las impresoras protegidas Julio de 2018 Se ha actualizado la información sobre cómo actualizar a MVE 3.2. Abril de 2018 Se ha actualizado información sobre lo siguiente: Modelos de impresora admitidos Configuración de la base de datos Copia de seguridad y restauración de archivos de bases de datos La URL para acceder a MVE Descripción de los ajustes de variables Se ha añadido información sobre lo siguiente: Configuración de los certificados de impresora Detención de tareas Actualización del firmware de la impresora Septiembre de 2017 Se ha actualizado información sobre lo siguiente: Requisitos del sistema Comunicación entre MVE y los modelos de impresora  Lexmark  Forms 2580, 2581, 2590 y 2591 Eliminación manual de bases de datos de Microsoft SQL Server Copia de seguridad y restauración de archivos de bases de datos Configuración de seguridad necesaria para el control de acceso a funciones al implementar archivos de firmware y soluciones en impresoras Compatibilidad con licencias al implementar aplicaciones Alertas de la impresora y acciones asociadas Recuperación automática del estado de la impresora Asignación de eventos y palabras clave Junio de 2017 Publicación del documento inicial para MVE 3.0. historial de cambios"},{"UUID":"4f7a5a87-66d9-4a24-8b97-ec3156f06a5d","title":"Descripción general","link":"overview-chapter.html","desc":"Descripción de  Markvision ","descFull":"Descripción de  Markvision  Enterprise Markvision  La empresa (MVE) es un software de utilidad de administración de impresoras basado en web diseñado para profesionales de TI. Con MVE, puede gestionar un grupo grande de impresoras en un entorno de empresa de manera eficaz haciendo lo siguiente: Buscar, organizar y realizar un seguimiento de las impresoras. Puede realizar una auditoría de una impresora para recopilar datos de la impresora, como su estado, configuración y consumibles. Crear configuraciones y asignarlas a las impresoras. Implementar firmware, certificados de impresora, la autoridad de certificación (CA) y las aplicaciones en las impresoras. Supervisar los eventos y las alertas de las impresoras. En este documento se proporcionan instrucciones sobre cómo configurar, utilizar y solucionar los problemas en la aplicación. Este documento está dirigido a administradores. descripción general Markvision Enterprise Markvision Enterprise descripción"},{"UUID":"84bbc95a-7de6-47b1-89d6-b1b7739fab00","title":"Introducción","link":"best-practices-topic.html","desc":"Mejores prácticas En este tema","descFull":"Mejores prácticas En este tema se indican los pasos recomendados para utilizar MVE y gestionar su flota de forma efectiva. Instale MVE en su entorno. Cree un servidor con el entorno Windows Server más reciente. Contenido relacionado: Requisitos de servidor web Cree una cuenta de usuario de dominio que no tenga acceso de administrador. Contenido relacionado: Configuración para ejecutar como usuario Cree una base de datos de Microsoft SQL Server, configure el cifrado y, a continuación, otorgue a la nueva cuenta de usuario acceso a las bases de datos. Contenido relacionado: Requisitos de base de datos Configuración de la base de datos Instale MVE con la cuenta de usuario de dominio y el servidor SQL con la autenticación de Windows. Contenido relacionado: Instalación de MVE Configure MVE y, a continuación, detecte y organice su flota. Firme el certificado del servidor. Contenido relacionado: Firma del certificado MVE Configuración de MVE para gestionar certificados de forma automática Configure los valores de LDAP. Contenido relacionado: Activación de la autenticación del servidor LDAP Instalación de certificados LDAP Conéctese a un servidor de correo electrónico. Contenido relacionado: Configuración de los valores del correo electrónico Detecte su flota. Contenido relacionado: Búsqueda de impresoras Programe auditorías y actualizaciones de estado. Contenido relacionado: Auditoría de impresoras Actualización del estado de la impresora Configure los valores básicos, como los nombres de los contactos, las ubicaciones, las etiquetas de activos y las zonas horarias. Organice su flota. Utilice palabras clave, como las ubicaciones, para clasificar las impresoras. Contenido relacionado: Asignación de palabras clave a las impresoras Creación de una búsqueda guardada Proteja su flota. Proteja el acceso a las impresoras con los componentes de seguridad avanzada predeterminados. Contenido relacionado: Protección de impresoras con la configuración predeterminada Descripción de los permisos y controles de acceso a función Otras maneras de proteger sus impresoras Cree una configuración segura en la que se incluyan certificados. Contenido relacionado: Creación de una configuración Importación de archivos a la biblioteca de recursos Aplique la configuración a su flota actual. Contenido relacionado: Asignación de configuraciones a impresoras Aplicación de configuraciones Programe las tareas de aplicación y las comprobaciones de cumplimiento. Contenido relacionado: Creación de un programa Añada configuraciones a los perfiles de búsqueda para proteger las nuevas impresoras. Contenido relacionado: Creación de perfiles de búsqueda Firme los certificados de la impresora. Contenido relacionado: Firma del certificado MVE Mantenga actualizado el firmware. Contenido relacionado: Actualización del firmware de la impresora Instale y configure las aplicaciones. Contenido relacionado: Creación de una configuración Importación de archivos a la biblioteca de recursos Supervise su flota. Contenido relacionado: Creación de una búsqueda guardada mejores prácticas"},{"UUID":"3b71e20e-9679-4aa8-a70f-06d2fc60df37","title":"Introducción","link":"system-requirements-topic.html","desc":"Requisitos del sistema MVE está","descFull":"Requisitos del sistema MVE está instalado como servidor web y se puede acceder a él mediante un navegador web desde cualquier equipo de la red. MVE también utiliza una base de datos para almacenar información sobre la flota de impresoras. A continuación se enumeran los requisitos para el servidor web, para la base de datos y para el sistema de usuario: Requisitos de servidor web Requisitos del sistema Procesador Procesador de doble núcleo de al menos 2 GHz que utilice tecnología hyper-threading (HTT) RAM Al menos 4 GB Unidad de disco duro Al menos 60 GB MVE, Document Distributor de Lexmark (LDD) y Device Deployment Utility (DDU) no se pueden ejecutar en el mismo servidor. Servidores admitidos Windows Server 2022 Standard Edition Windows Server 2019 Windows Server 2016 Standard Edition Windows Server 2012 Standard Edition Windows Server 2012 R2 MVE es compatible con la virtualización de los servidores compatibles en un entorno local. Requisitos de base de datos Bases de datos admitidas Firebird  base de datos (integrada) Microsoft SQL Server 2019 Microsoft SQL Server 2017 Microsoft SQL Server 2016 Microsoft SQL Server 2014 Microsoft SQL Server 2012 El tamaño mínimo recomendado para la base de datos es de 60 GB para asignar 20 MB a FRAMEWORK y 4,5 MB a MONITOR y QUARTZ. Para obtener más información, consulte  . Requisitos del sistema de usuario Navegadores web admitidos Microsoft Edge Mozilla Firefox (última versión) Google Chrome  (última versión) Apple Safari (última versión) Resolución de pantalla Al menos 1280 x 768 píxeles requisitos de servidor web servidor web requisitos requisitos de base de datos base de datos requisitos requisitos del sistema de usuario sistema de usuario requisitos sistemas operativos compatibles navegadores web admitidos bases de datos admitidas servidores admitidos"},{"UUID":"19da500d-62ad-46a7-8f42-bfcd44e56370","title":"Introducción","link":"supported-languages-topic.html","desc":"Idiomas compatibles Portugués de Brasil","descFull":"Idiomas compatibles Portugués de Brasil Inglés Francés Alemán Italiano Chino simplificado Español idiomas compatibles idiomas compatibles"},{"UUID":"d3ba628e-e135-47f9-80ff-536b12588589","title":"Introducción","link":"supported-printer-models-topic.html","desc":"Modelos de impresora admitidos Lexmark","descFull":"Modelos de impresora admitidos Lexmark 6500 Lexmark B2236 2 Lexmark B2338 2 , B2442 2 , B2546 2 , B2650 2 , B2865 1 Lexmark B3440 2 , B3442 2 Lexmark C2132 Lexmark C2240 2 , C2325 2 , C2425 2 , C2535 2 Lexmark C2335 2 Lexmark C3224 2 Lexmark C3326 2 Lexmark C3426 2 Lexmark C4150 2 , C6160 2 , C9235 2 Lexmark C4342 2 , C4352 2 Lexmark C746, C748 Lexmark C792 Lexmark C925 1 , C950 Lexmark CS310, CS410, CS510 Lexmark CS317, CS417, CS517 Lexmark CS331 2 Lexmark CS421 2 , CS521 2 , CS622 2 Lexmark CS431 2 Lexmark CS531 2 , CS632 2 Lexmark CS720 2 , CS725 2 Lexmark CS727 2 , CS728 2 Lexmark CS730 2 Lexmark CS735 2 Lexmark CS820 2 , CS827 2 Lexmark CS921 2 , CS923 2 , CS927 2 Lexmark CS943 2 Lexmark CX310, CX410, CX510 Lexmark CX317, CX417, CX517 Lexmark CX331 2 Lexmark CX421 2 , CX522 2 , CX622 2 , CX625 2 Lexmark CX431 2 Lexmark CX532 2 Lexmark CX625 2 Lexmark CX635 2 Lexmark CX725 2 Lexmark CX728 2 Lexmark CX730 2 Lexmark CX735 2 Lexmark CX820 2 , CX825 2 , CX827 2 , CX860 2 Lexmark CX920 2 , CX921 2 , CX922 2 , CX923 2 , CX924 2 , CX927 2 Lexmark CX930 2 , CX931 2 Lexmark CX942 2 , CX943 2 , CX944 2 Impresora Lexmark Forms 2580 4 , 2581 4 , 2590 4 , 2591 4 Lexmark M1140, M1145, M3150 Lexmark M1242 2 , M1246 2 , M3250 2 , M5255 2 , M5265 2 , M5270 2 Lexmark M3350 2 Lexmark M5155, M5163, M5170 Lexmark M5255 2 , M5265 2 , M5270 2 Lexmark MB2236 2 Lexmark MB2338 2 , MB2442 2 , MB2546 2 , MB2650 2 , MB2770 2 Lexmark MB3442 2 Lexmark MC2325 2 , MC2425 2 , MC2535 2 , MC2640 2 Lexmark MC3224 2 Lexmark MC3326 2 Lexmark MC3426 2 Lexmark MS310, MS312, MS315, MS410, MS415, MS510, MS610 Lexmark MS317, MS417, MS517 Lexmark MS321 2 , MS421 2 , MS521 2 , MS621 2 , MS622 2 Lexmark MS331 2 , MS431 2 Lexmark MS531 2 , MS631 2 , MS632 2 Lexmark MS617, MS817, MS818 Lexmark MS710, MS711, MS810, MS811, MS812 Lexmark MS725 2 , MS821 2 , MS822 2 , MS823 2 , MS824 2 , MS825 2 , MS826 2 Lexmark MS911 Lexmark MX310, MX410, MX510, MX511, MX610, MX611 Lexmark MX317, MX417, MX517 Lexmark MX321 2 , MX421 2 , MX521 2 , MX522 2 , MX622 2 Lexmark MX331 2 , MX431 2 Lexmark MX432 2 Lexmark MX532 2 , MX632 2 Lexmark MX617, MX717, MX718 Lexmark MX6500 Lexmark MX710, MX711, MX810, MX811, MX812 Lexmark MX721 2 , MX722 2 , MX725 2 , MX822 2 , MX824 2 , MX826 2 Lexmark MX910, MX911, MX912 Lexmark MX931 2 Lexmark T650 1 , T652 1 , T654 1 , T656 1 Lexmark X651 1 , X652 1 , X654 1 , X656 1 , X658 1 , XS651 1 , XS652 1 , XS654 1 , XS658 1 Lexmark X746, X748, X792 Lexmark X850 1 , X852 1 , X854 1 , X860 1 , X862 1 , X864 1 , XS864 1 Lexmark X925, X950, X952, X954 Lexmark XC2130, XC2132 Lexmark XC2235 2 , XC2240 2 , XC4240 2 Lexmark XC2335 2 Lexmark XC4140 2 , XC4150 2 , XC6152 2 , XC8155 2 , XC8160 2 Lexmark XC9225 2 , XC9235 2 , XC9245 2 , XC9255 2 , XC9265 2 Lexmark XC9325 2 , XC9335 2 Lexmark XC9445 2 , XC9455 2 , XC9465 2 Lexmark XM1135, XM1140, XM1145, XM3150 Lexmark XM1242 2 , XM1246 2 , XM3250 2 Lexmark XM3142 2 Lexmark XM3350 2 Lexmark XM5163, XM5170, XM5263, XM5270 Lexmark XM5365 2 , XM5370 2 Lexmark XM7155, XM7163, XM7170, XM7263, XM7270 Lexmark XM7355 2 , MX7365 2 , MX7370 2 Lexmark XM9145, XM9155, XM9165 Lexmark XM9335 2 Lexmark XC2326 Lexmark XC2326 Lexmark XC4342 2 , XC4352 2 1  Es necesario actualizar el certificado de la impresora. En esta versión, las actualizaciones de seguridad y rendimiento de la plataforma Java dejan de admitir algunos algoritmos de firma de certificados, como MD5 y SHA1. Este cambio impide que MVE funcione con algunas impresoras. Para conocer más detalles, consulte la  documentación de información de ayuda. 2  La compatibilidad con SNMPv3 debe estar activada en la impresora. 3  Si se establece una contraseña de seguridad avanzada en la impresora, MVE no será compatible con ella. 4  MVE no se puede comunicar con los modelos de impresora Lexmark Forms 2580, 2581, 2590 y 2591 si se encuentran en estado No lista. La comunicación solo funciona si MVE se ha comunicado previamente con la impresora en el estado Lista. La impresora puede estar en el estado No lista cuando se producen errores o advertencias; por ejemplo, si hay consumibles vacíos. Para cambiar el estado, resuelva el error o la advertencia y pulse  Lista . modelos de impresora admitidos modelos de impresora compatibles"},{"UUID":"97e0ae83-f781-4d67-8f9e-5ead03dc87ee","title":"Introducción","link":"setting-up-database-topic.html","desc":"Configuración de la base de","descFull":"Configuración de la base de datos Puede utilizar Firebird o Microsoft SQL Server como base de datos back-end. La siguiente tabla le ayudará a decidir qué base de datos utilizar. Firebird Microsoft SQL Server Instalación del servidor Debe estar instalado en el mismo servidor que MVE. Se puede ejecutar desde cualquier servidor. Comunicación Limitado únicamente al host local. Se comunica a través de un puerto estático o instancia dinámica con nombre. Se admite la comunicación SSL/TLS con Microsoft SQL Server protegido. Rendimiento Muestra problemas de rendimiento con grandes flotas. Muestra el mejor rendimiento para grandes flotas. Tamaño de la base de datos Los tamaños predeterminados de bases de datos son de 6 MB para FRAMEWORK y de 1 MB para MONITOR y QUARTZ. La tabla de FRAMEWORK aumenta 1 KB por cada registro de impresora añadido. Los tamaños predeterminados de bases de datos son de 20MB para FRAMEWORK y de 4,5MB para MONITOR y QUARTZ. La tabla de FRAMEWORK aumenta 1 KB por cada registro de impresora añadido. Configuración Configurada automáticamente durante la instalación. Requiere ajustar la configuración antes de la instalación. Si utiliza Firebird, el instalador de MVE instala y configura Firebird sin ningún otro tipo de configuración. Si utiliza Microsoft SQL Server, realice las siguientes acciones antes de instalar MVE: Permita a la aplicación ejecutarse automáticamente. Configure las bibliotecas de la red para el uso de sockets TCP/IP. Cree las siguientes bases de datos: A continuación se muestran los nombres de base de datos predeterminados. También puede proporcionar nombres de base de datos personalizados. FRAMEWORK MONITOR QUARTZ Si está utilizando una instancia con nombre, configure el servicio de Microsoft SQL Server Browser para que se inicie automáticamente. De lo contrario, configure un puerto estático en los sockets TCP/IP. Cree una cuenta de usuario con derechos de dbowner para las tres bases de datos que MVE utiliza para conectar y configurar la base de datos. Si el usuario es una cuenta de Microsoft SQL Server, active Microsoft SQL Server y los modos de autenticación de Windows en Microsoft SQL Server. Si MVE está configurado para utilizar Microsoft SQL Server, al desinstalarlo no se eliminarán las tablas o bases de datos que se hayan creado. Tras la instalación, las bases de datos de FRAMEWORK, MONITOR y QUARTZ se deben eliminar manualmente. Asigne derechos de dbo al usuario de la base de datos y, a continuación, establezca el esquema dbo como el esquema predeterminado. configuración de la base de datos base de datos configuración Firebird, base de datos Microsoft SQL Server"},{"UUID":"1a6e4d11-de42-4d9b-9ba5-d88a28f79946","title":"Introducción","link":"setting-mve-run-as-user-topic.html","desc":"Configuración para ejecutar como usuario","descFull":"Configuración para ejecutar como usuario Durante la instalación, puede especificar que MVE se ejecute como una cuenta del sistema local o como una cuenta de usuario de dominio. Si se ejecuta MVE como una cuenta de usuario de dominio, la instalación será más segura. La cuenta de usuario de dominio tiene privilegios limitados en comparación con una cuenta del sistema local. Ejecutar como cuenta de usuario de dominio Ejecutar como sistema local Permisos locales del sistema Todo tipo de acceso a archivos a lo siguiente: $MVE_INSTALL /tomcat/logs $MVE_INSTALL /tomcat/temp $MVE_INSTALL /tomcat/work $MVE_INSTALL /apps/library $MVE_INSTALL /apps/dm-mve/picture $MVE_INSTALL /../mve_truststore* $MVE_INSTALL /jre/lib/security/cacerts $MVE_INSTALL /apps/dm-mve/WEB-INF/ldap $MVE_INSTALL /apps/dm-mve/download Donde  $MVE_INSTALL  es el directorio de instalación. Privilegio de Windows: LOGON_AS_A_SERVICE Permisos de administrador Autenticación de conexión de la base de datos Autenticación de Windows con Microsoft SQL Server Autenticación SQL Autenticación SQL Configuración Debe configurarse un usuario de dominio antes de la instalación. Configurada automáticamente durante la instalación Si configura MVE para que se ejecute como cuenta de usuario de dominio, debe crear el usuario en el mismo dominio que el servidor MVE. ejecución como usuario configuración configuración de MVE para ejecutar como usuario"},{"UUID":"85927c97-f338-436e-b690-ed10702bff94","title":"Introducción","link":"installing-markvision-topic.html","desc":"Instalación de MVE Descargue el","descFull":"Instalación de MVE Descargue el archivo ejecutable en una ruta que no contenga espacios. Ejecute el archivo como administrador y siga las instrucciones que aparecen en la pantalla del equipo. Las contraseñas se crean y almacenan de forma segura. Asegúrese de que recuerda sus contraseñas o guárdelas en un lugar seguro, ya que las contraseñas no se pueden descifrar una vez almacenadas. Si se conecta a Microsoft SQL Server mediante la autenticación de Windows, no se producirá la verificación de la conexión durante la instalación. Asegúrese de que el usuario designado para ejecutar el servicio de la ventana de MVE tiene una cuenta correspondiente en la instancia de Microsoft SQL Server. El usuario designado debe tener derechos de dbowner a las bases de datos de FRAMEWORK, MONITOR y QUARTZ. MVE instalación instalar MVE"},{"UUID":"c2b54e0a-d45f-40bf-a93f-7e216664280f","title":"Introducción","link":"installing-mve-silently-topic.html","desc":"Instalación silenciosa de MVE Configuración","descFull":"Instalación silenciosa de MVE Configuración de la base de datos para una instalación silenciosa Configuración Descripción Valor --help Muestra la lista de opciones válidas. --version Muestra la información del producto. --unattendedmodeui <unattendedmodeui> Interfaz de usuario para el modo sin atención. Valor predeterminado:  ninguno Permitido: ninguno minimal minimalWithDialogs --optionfile <optionfile> Archivo de opciones de instalación. Valor predeterminado: --debuglevel <debuglevel> Nivel de información de depuración de nivel de detalle. Valor predeterminado:  2 Permitido: 0 1 2 3 4 --mode <mode> Modo de instalación. Valor predeterminado:  win32 Permitido: win32 unattended --debugtrace <debugtrace> Nombre del archivo de depuración. Valor predeterminado: --installer-language <installer-language> Selección de idioma. Valor predeterminado:  es Permitido: es es de fr it pt_BR zh_CN --encryptionKey <encryptionKey> Clave de cifrado. Clave de cifrado: Valor predeterminado: --prefix <prefix> Directorio de instalación Valor predeterminado:  C:\\Archivos de programa --mveLexmark_runas <mveLexmark_runas> Opciones para ejecutar como usuario. Valor predeterminado:  LOCAL_SYSTEM Permitido: LOCAL_SYSTEM SPECIFIC_USER --serviceRunAsUsername <serviceRunAsUsername> Nombre para ejecutar como usuario. Nombre de usuario: Valor predeterminado: --serviceRunAsPassword <serviceRunAsPassword> Contraseña para ejecutar como usuario. Contraseña: Valor predeterminado: --mveLexmark_database <mveLexmark_database> Tipo de base de datos. Valor predeterminado: Permitido: FIREBIRD SQL_SERVER --firebirdUsername <firebirdUsername> Nombre de usuario de la base de datos Firebird. Nombre de usuario: Valor predeterminado: --firebirdPassword <firebirdPassword> Contraseña de la base de datos Firebird. Contraseña: Valor predeterminado: --firebirdFWDbName <firebirdFWDbName> Nombre de la base de datos Firebird para FRAMEWORK. Nombres de las bases de datos: Valor predeterminado:  FRAMEWORK --firebirdMNDbName <firebirdMNDbName> Nombre de la base de datos Firebird para MONITOR. Valor predeterminado:  MONITOR --firebirdQZDbName <firebirdQZDbName> Nombre de la base de datos Firebird para QUARTZ. Valor predeterminado:  QUARTZ --databaseIPAddress <databaseIPAddress> Dirección IP o nombre de host de la base de datos. Dirección IP o nombre de host: Valor predeterminado: --databasePort <databasePort> Número de puerto de la base de datos. Número de puerto: Valor predeterminado: --instanceName <instanceName> Nombre de instancia. Nombre de instancia: Valor predeterminado: --instanceIdentifier <instanceIdentifier> Instancia. Valor predeterminado:  databasePort Permitido: databasePort instanceName --databaseUsername <databaseUsername> Nombre de usuario de la base de datos. Nombre de usuario: Valor predeterminado: --databasePassword <databasePassword> Contraseña de la base de datos. Contraseña: Valor predeterminado: --sqlServerAuthenticationMethod <sqlServerAuthenticationMethod> Método de autenticación de Microsoft SQL Server. Valor predeterminado:  sqlServerDbAuthentication Permitido: sqlServerDbAuthentication sqlServerWindowsAuthentication --fWDbName <fWDbName> Nombre de la base de datos para FRAMEWORK. Nombres de las bases de datos: Valor predeterminado:  FRAMEWORK --mNDbName <mNDbName> Nombre de la base de datos para MONITOR. Valor predeterminado:  MONITOR --qZDbName <qZDbName> Nombre de la base de datos para QUARTZ. Valor predeterminado:  QUARTZ --mveAdminUsername <mveAdminUsername> Nombre de usuario del administrador. Nombre de usuario: Valor predeterminado:  admin --mveAdminPassword <mveAdminPassword> Contraseña del administrador. Contraseña: Valor predeterminado: instalación silenciosa de MVE instalación de MVE silenciosa instalación silenciosa MVE"},{"UUID":"b731740f-1bf9-49c3-9686-8c2030402360","title":"Introducción","link":"accessing-mve-topic.html","desc":"Acceso a MVE Para acceder","descFull":"Acceso a MVE Para acceder a MVE, utilice las credenciales de inicio de sesión que ha creado durante la instalación. También puede configurar otros métodos de inicio de sesión, como los LDAP, Kerberos u otras cuentas locales. Para obtener más información, consulte  . Abra un navegador web y escriba  https:// MVE_SERVER /mve/ , donde  MVE_SERVER  es el nombre de host o la dirección IP del servidor que aloja MVE. Si es necesario, acepte la renuncia de responsabilidad. Introduzca sus credenciales. Haga clic en  Iniciar sesión . Después de iniciar sesión, asegúrese de que cambia la contraseña de administrador predeterminada utilizada durante la instalación. Para obtener más información, consulte  . Si MVE está inactivo durante más de 30 minutos, se cierra la sesión de usuario automáticamente. MVE acceso acceso a MVE"},{"UUID":"de563870-08dd-49ab-ba09-b84e6dfa0011","title":"Introducción","link":"changing-language-topic.html","desc":"Cambio de idioma Abra un","descFull":"Cambio de idioma Abra un navegador web y escriba  https:// MVE_SERVER /mve/ , donde  MVE_SERVER  es el nombre de host o la dirección IP del servidor que aloja MVE. Si es necesario, acepte la renuncia de responsabilidad. En la esquina superior derecha de la página, seleccione un idioma. cambio del idioma idioma cambio"},{"UUID":"f84bfde9-7ed0-497f-8df8-a3755a3d5e19","title":"Introducción","link":"changing-your-password-topic.html","desc":"Cambio de la contraseña Abra","descFull":"Cambio de la contraseña Abra un navegador web y escriba  https:// MVE_SERVER /mve/ , donde  MVE_SERVER  es el nombre de host o la dirección IP del servidor que aloja MVE. Si es necesario, acepte la renuncia de responsabilidad. Introduzca sus credenciales. Haga clic en  Iniciar sesión . En la esquina superior derecha de la página, haga clic en su nombre de usuario y, a continuación, haga clic en  Cambiar contraseña . Cambie la contraseña. contraseña cambio cambio de la contraseña"},{"UUID":"0f35d764-891d-427e-8c44-e1cd9820e23c","title":"Mantenimiento de la aplicación","link":"upgrading-to-latest-version-topic.html","desc":"Actualización a MVE 4.3 Antes","descFull":"Actualización a MVE 4.3 Antes de iniciar la actualización, realice las siguientes acciones: Haga una copia de seguridad de los archivos de propiedades, de la aplicación y de la base de datos. Para obtener más información, consulte  . Si es necesario, proporcione nombres de base de datos personalizados. Si va a actualizar desde la versión 1.x, actualice a la versión 2.0 en primer lugar, a la versión 3.3 a continuación y luego a la versión 4.0 respectivamente, antes de actualizar a la versión 4.3. El proceso de migración de políticas solo se realiza al actualizar a MVE 2.0. Ejemplo Ruta de actualización válida 3.3  a  4.0  a  4.3 Ruta de actualización no válida 1.6.x  a  4.3 2.0  a  4.3 Haga una copia de seguridad de los archivos de la aplicación y de la base de datos, ya que realizar una actualización o una desinstalación siempre supone un riesgo de pérdida irrecuperable de datos. Así, en caso de se produzca un fallo en la actualización, puede utilizar los archivos de la copia de seguridad para restablecer la aplicación a su estado anterior. Cuando se actualiza MVE, se modifica la base de datos. No restaure una copia de seguridad de la base de datos creada a partir de una versión anterior. Para obtener más información, consulte  . Descargue el archivo ejecutable a una ubicación temporal. Ejecute el instalador como administrador y siga las instrucciones que aparecen en la pantalla del equipo. Al actualizar a la versión 2.0 de MVE, las políticas asignadas a las impresoras se migran a una única configuración para cada modelo de impresora. Por ejemplo, si las políticas de fax, copia, papel e impresión están asignadas a una impresora X792, se consolidan en una configuración X792. Este proceso no se aplica a las políticas que no están asignadas a las impresoras. MVE genera un archivo de registro que confirma que las políticas se han migrado correctamente a una configuración. Para obtener más información, consulte  . Después de la actualización, asegúrese de borrar la caché del navegador antes de volver a acceder a la aplicación. Al actualizar MVE a la versión 3.5 o posterior, los componentes de seguridad avanzada se extraen de las configuraciones en las que se encuentran. Si uno o más componentes de seguridad avanzada son iguales, se combinan en un solo componente. El componente de seguridad avanzada resultante se añade automáticamente a la biblioteca de componentes de seguridad avanzada. actualización a la última versión de MVE MVE actualización"},{"UUID":"03c99397-5308-4589-8b1d-d4bff673c1e3","title":"Mantenimiento de la aplicación","link":"backing-up-and-restoring-database-topic.html","desc":"Copia de seguridad y restauración","descFull":"Copia de seguridad y restauración de la base de datos Hacer una copia de seguridad o una restauración supone un riesgo potencial de pérdida de datos. Asegúrese de realizar los pasos correctamente. Copia de seguridad de los archivos de la aplicación y de la base de datos Se recomienda que realice una copia de seguridad de la base de datos de forma periódica. Detenga el servicio Firebird y el servicio Markvision Enterprise. Abra el cuadro de diálogo  Ejecutar  y escriba  services.msc . Haga clic con el botón derecho en  Firebird Guardian - DefaultInstance  y, a continuación, en  Detener . Haga clic con el botón derecho en  Markvision Enterprise  y, a continuación, haga clic en  Detener . Vaya a la carpeta donde se ha instalado Markvision Enterprise. Por ejemplo,  C:\\Archivos de programa\\ Haga una copia de seguridad de los archivos de la aplicación y de la base de datos. Copia de seguridad de los archivos de la aplicación Copie los archivos siguientes a un repositorio seguro: Lexmark\\mve_encryption.jceks Lexmark\\mve_truststore.p12 Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\platform.properties Lexmark\\Markvision Enterprise\\apps\\library Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml Compruebe que estos archivos están almacenados de forma correcta. Sin las claves de cifrado del archivo mve_encryption.jceks, los datos almacenados en un formato cifrado en la base de datos y en el sistema de archivos no se pueden recuperar. Copia de seguridad de los archivos de la base de datos Para ello, realice una de las siguientes acciones: Los siguientes archivos utilizan los nombres de base de datos predeterminados. Estas instrucciones también se aplican a los nombres de base de datos personalizados. Si está utilizando una base de datos Firebird, copie los siguientes archivos en un repositorio seguro. Se debe realizar una copia de seguridad de estos archivos con regularidad para evitar pérdidas de datos. Lexmark\\Markvision Enterprise\\firebird\\security2.fdb Si utiliza nombres de base de datos personalizados, actualice lo siguiente: Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service/WEB-INF\\classes\\application.yml Lexmark\\Markvision Enterprise\\firebird\\aliases.conf Lexmark\\Markvision Enterprise\\firebird\\data\\QUARTZ.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\MONITOR.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\FRAMEWORK.FDB Si está utilizando Microsoft SQL Server, cree una copia de seguridad de FRAMEWORK, MONITOR y QUARTZ. Para obtener más información, póngase en contacto con el administrador de Microsoft SQL Server. Reinicie el servicio Firebird y el servicio Markvision Enterprise. Abra el cuadro de diálogo  Ejecutar  y escriba  services.msc . Haga clic con el botón derecho en  Firebird Guardian - DefaultInstance  y, a continuación, en  Reiniciar . Haga clic con el botón derecho en  Markvision Enterprise  y, a continuación, haga clic en  Reiniciar . Restauración de los archivos de la aplicación y de la base de datos Cuando se lleva a cabo la actualización MVE, la base de datos puede modificarse. No restaure una copia de seguridad de la base de datos creada a partir de una versión anterior. Pare el dispositivo Markvision Enterprise. Para obtener más información, consulte   de  . Vaya a la carpeta donde se ha instalado Markvision Enterprise. Por ejemplo,  C:\\Archivos de programa\\ Restaure los archivos de la aplicación. Sustituya los archivos siguientes por archivos que haya guardado durante el proceso de creación de la copia de seguridad: Lexmark\\mve_encryption.jceks Lexmark\\mve_truststore.p12 Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\platform.properties Lexmark\\Markvision Enterprise\\apps\\library Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml Puede restaurar una copia de seguridad de una base de datos a una nueva instalación MVE solo si la nueva instalación MVE tiene la misma versión. Restaure los archivos de la base de datos. Para ello, realice una de las siguientes acciones: Si utiliza una base de datos Firebird, sustituya los siguientes archivos que guardó durante el proceso de copia de seguridad: Los siguientes archivos utilizan los nombres de base de datos predeterminados. Esta instrucción también se aplica a los nombres de base de datos personalizados. Lexmark\\Markvision Enterprise\\firebird\\security2.fdb Si utiliza nombres de base de datos personalizados, también se restauran los siguientes archivos: Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service/WEB-INF\\classes\\application.yml Lexmark\\Markvision Enterprise\\firebird\\aliases.conf Lexmark\\Markvision Enterprise\\firebird\\data\\QUARTZ.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\MONITOR.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\FRAMEWORK.FDB Si utiliza Microsoft SQL Server, póngase en contacto con su administrador de Microsoft SQL Server. Reinicie el servicio Markvision Enterprise. Para obtener más información, consulte   de  . base de datos realización de una copia de seguridad base de datos restauración copia de seguridad y restauración de la base de datos"},{"UUID":"97b613ec-3d40-4991-ad20-cfd39ff3b6e7","title":"Mantenimiento de la aplicación","link":"changing-installer-settings-topic.html","desc":"Actualización de la configuración del","descFull":"Actualización de la configuración del instalador tras la instalación La utilidad de contraseña de Markvision Enterprise le permite actualizar la configuración del servidor Microsoft SQL Server que se ha configurado durante la instalación sin necesidad de volver a instalar MVE. La utilidad también le permite actualizar las credenciales de la cuenta de dominio para ejecutar como usuario; por ejemplo, el nombre de usuario y la contraseña. También puede utilizar la utilidad para crear otro usuario Administrador si ha olvidado las credenciales de su usuario Administrador anterior. Vaya a la carpeta donde se ha instalado Markvision Enterprise. Por ejemplo,  C:\\Archivos de programa\\ Ejecute el archivo  mvepwdutility-windows.exe  en el directorio Lexmark\\Markvision Enterprise\\. Seleccione un dispositivo y, a continuación, haga clic en  Aceptar Siguiente . Siga las instrucciones que aparecen en la pantalla del equipo. cambio de los ajustes inalámbricos tras la instalación configuración del instalador cambio"},{"UUID":"765d2ede-271f-4368-bda5-79063b0b672c","title":"Configuración del acceso de usuario","link":"setting-up-user-access-overview-topic.html","desc":"Descripción general MVE le permite","descFull":"Descripción general MVE le permite agregar usuarios internos directamente al servidor MVE o utilizar las cuentas de usuario registradas en un servidor LDAP. Para obtener más información sobre la adición de usuarios internos, consulte  . Para obtener más información sobre cómo utilizar cuentas de usuario de LDAP, consulte  . Al agregar usuarios, se tienen que asignar las funciones. Para obtener más información, consulte  . Durante la autenticación, el sistema comprueba las credenciales de usuario de los usuarios internos presentes en el servidor MVE. Si MVE no puede autenticar el usuario, intenta realizar la autenticación en el servidor LDAP. Si el nombre de usuario existe tanto en el servidor MVE como LDAP, se utiliza la contraseña en el servidor MVE. descripción general de la configuración del acceso de usuario descripción general configuración del acceso de usuario"},{"UUID":"a9aa4a1d-8f1e-46f8-b963-77dcdc0a9964","title":"Configuración del acceso de usuario","link":"understanding-user-roles-topic.html","desc":"Descripción de las funciones de","descFull":"Descripción de las funciones de usuario Los usuarios MVE se pueden asignar a una o más funciones. Según la función, los usuarios pueden realizar las siguientes tareas: Administrador : acceder y realizar tareas en todos los menús. También tienen privilegios administrativos, como agregar usuarios al sistema o configurar los ajustes del sistema. Solo los usuarios con la función de administrador pueden detener cualquier tarea en ejecución, independientemente del tipo de usuario que la haya iniciado. Impresoras Administrar perfiles de búsqueda. Definir el estado de la impresora. Realizar una auditoría. Administrar categorías y palabras clave. Programar una auditoría, exportación de datos y la búsqueda de impresoras. Configuraciones Administrar configuraciones, como la importación y exportación de archivos de configuración. Cargar archivos en la biblioteca de recursos. Asignar y aplicar las configuraciones en impresoras. Programar una comprobación de conformidad y ejecución de configuraciones. Implementar archivos en impresoras. Actualizar el firmware de la impresora. Generar solicitudes de firma de certificado de impresora. Descargar solicitudes de firma de certificado de impresora. Gestor de incidencias Administrar acciones y eventos. Asignar eventos a impresoras. Probar acciones. Servicio de mantenimiento Actualizar el estado de la impresora. Reiniciar impresoras. Ejecutar una comprobación de conformidad. Aplicar las configuraciones a impresoras. Todos los usuarios en MVE pueden ver la página de información de la impresora y administrar las búsquedas guardadas y vistas. Para obtener más información sobre la asignación de funciones de usuario, consulte  . funciones de usuario descripción descripción de las funciones de usuario"},{"UUID":"99757fb9-ab5f-4f3b-88f2-1e84704709c7","title":"Configuración del acceso de usuario","link":"managing-users-topic.html","desc":"Administración de usuarios Haga clic","descFull":"Administración de usuarios Haga clic   en la esquina superior derecha de la página. Haga clic en  Usuario  y, a continuación, realice una de las acciones siguientes: Añadir un usuario Haga clic en  Crear . Escriba el nombre de usuario, el ID de usuario y la contraseña. Seleccione las funciones. Para obtener más información, consulte  . Haga clic en  Crear usuario . Edite un usuario Seleccione un usuario. Configure los valores. Haga clic en  Guardar cambios . Eliminar usuarios Seleccione uno o más usuarios. Haga clic en  Eliminar y, a continuación, confirme la eliminación. La cuenta de usuario se bloquea después de tres intentos fallidos de inicio de sesión consecutivos. Sólo un usuario Administrador puede reactivar la cuenta de usuario. Si el usuario Administrador está bloqueado, el sistema lo reactiva automáticamente tras cinco minutos. administración de usuarios usuarios administración usuarios adición usuarios edición usuarios eliminación"},{"UUID":"b13bcd45-bfb1-4b98-a106-41dbb649d19c","title":"Configuración del acceso de usuario","link":"enabling-ldap-server-authentication-topic.html","desc":"Activación de la autenticación del","descFull":"Activación de la autenticación del servidor LDAP LDAP es un protocolo basado en estándares, multiplataforma y extensible que se ejecuta directamente sobre TCP/IP. Se utiliza para acceder a bases de datos especializadas que se denominan directorios. Para evitar mantener varias credenciales de usuario, puede utilizar el servidor LDAP de la empresa para autenticar los ID de usuario y sus contraseñas. Como requisito, el servidor LDAP debe contener grupos de usuarios que corresponden a las funciones requeridas del usuario. Para obtener más información, consulte  . Haga clic en  , en la esquina superior derecha de la página. Haga clic en  LDAP  y, a continuación, seleccione  Activar LDAP para la autenticación . En el campo  Nombre de host del servidor LDAP , escriba la dirección IP o el nombre de host del servidor LDAP donde se llevará a cabo la autenticación. Si desea utilizar una comunicación cifrada entre el servidor MVE y el servidor LDAP, utilice el nombre de dominio completo (FQDN). Especifique el número de puerto del servidor de acuerdo con el protocolo de cifrado seleccionado. Seleccione el protocolo de cifrado. Ninguno TLS : un protocolo de seguridad que utiliza el cifrado de datos y la autenticación de certificados para proteger la comunicación entre un servidor y un cliente. Si se selecciona esta opción, se envía un comando START_TLS al servidor LDAP una vez establecida la conexión. Utilice esta configuración si quiere establecer una comunicación segura a través del puerto 389. SSL/TLS : un protocolo de seguridad que utiliza la criptografía de clave pública para autenticar la comunicación entre un servidor y un cliente. Utilice esta opción si quiere establecer una comunicación segura desde el inicio del enlace LDAP. Esta opción se utiliza normalmente para el puerto 636 u otros puertos LDAP seguros. Seleccione el tipo de enlace. Sencillo : el servidor MVE proporciona las credenciales especificadas al servidor LDAP para usar la utilidad de búsqueda del servidor LDAP. Escriba el nombre de usuario del enlace. Escriba la contraseña del enlace y confírmela. Kerberos : para configurar los valores, haga lo siguiente: Escriba el nombre de usuario del enlace. Escriba la contraseña del enlace y confírmela. Haga clic en  Elegir archivo  y, a continuación, busque el archivo krb5.conf. SPNEGO : para configurar los valores, haga lo siguiente: Escriba el nombre principal del servicio. Haga clic en  Elegir archivo  y, a continuación, busque el archivo krb5.conf. Haga clic en  Elegir archivo  y, a continuación, busque el archivo Keytab de Kerberos. Esta opción solo se utiliza para la configuración del Mecanismo de negociación GSSAPI simple y protegido (SPNEGO) para admitir la funcionalidad de inicio de sesión único. En la sección  Opciones avanzadas , configure lo siguiente: Base de búsqueda : el nombre base distinguido (DN) del nodo raíz. En la jerarquía del servidor de comunidad de LDAP, este nodo debe ser el antecesor del nodo de usuario y del nodo de grupo. Por ejemplo,  dc=mvetest,dc=com . Al especificar el DN raíz, asegúrese de que solo  dc  y  o  sean parte del DN raíz. Si  ou  o  cn  es el antecesor de los nodos de usuario y grupo, utilice  ou  o  cn  en las bases de búsqueda de grupo y de usuario. Base de búsqueda de usuarios : el nodo en el servidor de comunidad de LDAP en el que existe el objeto de usuario. Este nodo se encuentra bajo el DN raíz, donde se muestran todos los nodos de usuario. Por ejemplo,  ou=people . Filtro de búsqueda de usuarios : el parámetro para localizar un objeto de usuario en el servidor de comunidad de LDAP. Por ejemplo,  (uid={0}) . Ejemplos de expresiones complejas y condiciones múltiples permitidas Iniciar sesión con En el campo  Filtro de búsqueda de usuarios , escriba Nombre común (CN={0}) Nombre de inicio de sesión (sAMAccountName={0}) Nombre principal del usuario (userPrincipalName={0}) Número de teléfono (telephoneNumber={0}) Nombre de inicio de sesión o nombre común (|(sAMAccountName={0})(CN={0})) Solo se pueden utilizar los patrones  {0}  y  {1} . Si se utiliza  {0} , MVE busca el DN de usuario de LDAP. Si se utiliza  {1} , MVE busca el nombre de inicio de sesión de usuario de MVE. Objeto base de búsqueda de usuarios y subárbol completo : el sistema realiza la búsqueda en todos los nodos de la base de búsqueda de usuarios. Base de búsqueda de grupo : el nodo en el servidor de comunidad de LDAP en el que están los grupos de usuarios correspondientes a las funciones de MVE. Este nodo se encuentra bajo el DN raíz, donde se muestran todos los nodos de grupo. Por ejemplo,  ou=group . Filtro de búsqueda de grupo : el parámetro para localizar a un usuario dentro de un grupo que corresponda a una función en MVE. El único patrón válido es  {0} , lo que significa que MVE busca el nombre de inicio de sesión de usuario de MVE. Atributo de función de grupo : escriba el atributo LDAP para el nombre completo del grupo. Un atributo LDAP tiene un significado específico y define una asignación entre un atributo y un nombre de campo. Por ejemplo, el atributo LDAP  cn  está asociado al campo  Nombre completo . El atributo LDAP  commonname  también está asignado al campo  Nombre completo . Por lo general, este atributo debe permanecer en su valor predeterminado:  cn . Objeto base de búsqueda de usuarios y subárbol completo : el sistema realiza la búsqueda en todos los nodos de la base de búsqueda de grupo. En la sección  Asignación de grupos de LDAP a función de MVE , escriba los nombres de los grupos LDAP que corresponden a las funciones de MVE. Para obtener más información, consulte  . Puede asignar un grupo LDAP a varias funciones de MVE. También puede introducir más de un grupo LDAP en un campo de función utilizando el carácter de barra vertical ( | ) para separar varios grupos. Por ejemplo, si desea incluir los grupos  administración  y  activos  para la función  Administración , escriba  administración|activos  en el campo de función  Grupos de LDAP para Admin . Si solo desea utilizar la función  Administración  y no las otras funciones de MVE, deje los campos en blanco. Haga clic en  Guardar cambios . Servidor LDAP activación de la autenticación activación de la autenticación del servidor LDAP"},{"UUID":"720b0fc4-ad6e-4c10-ab41-38ab5bc9e85c","title":"Configuración del acceso de usuario","link":"installing-ldap-server-certificates-topic.html","desc":"Instalación de certificados del servidor","descFull":"Instalación de certificados del servidor LDAP Para establecer una comunicación cifrada entre el servidor MVE y el servidor LDAP, MVE debe confiar en el certificado del servidor LDAP. En la arquitectura de MVE, cuando MVE esté autenticando con un servidor LDAP, MVE es el cliente y el servidor LDAP es del mismo nivel. Haga clic en   en la esquina superior derecha de la página. Haga clic en  LDAP  y configure LDAP. Para obtener más información, consulte  . Haga clic en  Probar LDAP . Introduzca un nombre de usuario y contraseña de LDAP válidos y, a continuación, haga clic en  Iniciar prueba . Compruebe la validez del certificado y, a continuación, acéptelo. instalación de certificados del servidor LDAP Certificados del servidor LDAP instalación"},{"UUID":"78e9eb88-d9f1-490f-bb3f-f843ce26c795","title":"Configuración del acceso de usuario","link":"adding-root-ca-certificate-java-truststore-topic.html","desc":"Adición de un certificado CA","descFull":"Adición de un certificado CA raíz en el almacén de confianza de Java Algunas configuraciones LDAP de MVE utilizan un equilibrador de carga o una IP virtual (VIP) para redirigir las solicitudes LDAPS. En estos casos, el certificado CA raíz del dominio debe estar instalado e incluido en el almacén de confianza Java de MVE. Importe el certificado CA raíz y, a continuación, confirme que el certificado es de confianza. Haga una copia de seguridad de los archivos de la aplicación y de la base de datos, ya que Detenga el servicio MVE. Ejecute la línea de comandos como administrador y escriba lo siguiente: \"C:\\Archivos de programa\\Lexmark\\Markvision Enterprise\\jre\\bin\\keytool.exe\" -import -trustcacerts -alias EnterpriseRootCA -Disco C:\\temp\\EnterpriseRootCA.cer -keystore \"C:\\Archivos de programa\\Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts\" Cuando se le solicite que introduzca la contraseña del almacén de claves, escriba  changeit . Cuando se le pregunte si desea confiar en el certificado, escriba  yes . Si el proceso se realiza correctamente, aparecerá el mensaje  Se ha agregado un certificado al almacén de claves . Si los permisos de nivel de archivo para el archivo cacerts no le permiten actualizar el archivo, aparecerá un mensaje de acceso denegado. Puede actualizar los permisos del archivo o ejecutar el símbolo del sistema como administrador con permiso para actualizar el archivo. Reinicie el servicio MVE. añadir un certificado CA raíz Almacén de confianza de Java"},{"UUID":"a9c8f6dd-7766-4de2-9191-3b922e34f2dc","title":"Búsqueda de impresoras","link":"creating-discovery-profile-topic.html","desc":"Creación de perfiles de búsqueda","descFull":"Creación de perfiles de búsqueda El perfil de búsqueda permite encontrar impresoras en su red y agregarlas al sistema. En un perfil de búsqueda, realice una de las siguientes acciones para incluir o excluir una lista de direcciones IP o nombres de host: Añadir entradas de una en una Importar entradas mediante un archivo TXT o CSV También puede asignar y aplicar una configuración automáticamente a un modelo de impresora compatible. Una configuración debe contener los valores de la impresora, aplicaciones, licencias, firmware y certificados CA que se pueden implementar para las impresoras. En el menú  Impresoras , haga clic en  Perfiles de búsqueda Crear . En la sección  General , escriba un nombre exclusivo y una descripción para el perfil de búsqueda y configure lo siguiente: Tiempo de espera : el tiempo que espera el sistema para que responda una impresora. Reintentos : el número de veces que el sistema intenta comunicarse con una impresora. Administrar impresoras detectadas automáticamente : las nuevas impresoras detectadas se establecen automáticamente en un estado Administrado, y el estado Nuevo se omite durante la búsqueda. En la sección  Direcciones , realice una de las siguientes acciones: Añadir las direcciones Seleccione  Incluir  o  Excluir . Escriba la dirección IP, el nombre de host, la subred o el rango de direcciones IP. No introduzca más de una entrada a la vez. Utilice los formatos siguientes para las direcciones: 10.195.10.1  (dirección IPv4 individual) miimpresora.ejemplo.com  (nombre de host único) 10.195.10.3-10.195.10.255  (rango de direcciones IPv4) 10.195.*.*  (comodines) 10.195.10.1/22  (enrutamiento entre dominios sin clase IPv4 o notación CIDR) 2001:db8:0:0:0:0:2:1  (dirección IPv6 completa) 2001:db8::2:1  (dirección IPv6 contraída) Si se crean perfiles de búsqueda independientes para las direcciones IPv6 e IPv4 de la misma impresora, se muestra la última dirección detectada. Por ejemplo, si se detecta una impresora utilizando IPv6 y se vuelve a detectar utilizando IPv4, solo se muestra la dirección IPv4 en la lista de impresoras. Haga clic en  Agregar . Importar las direcciones Haga clic en  Importar . Seleccione si desea incluir o excluir direcciones IP durante la búsqueda. Busque el archivo de texto que contiene una lista de direcciones. Cada entrada de dirección debe estar en una línea distinta. Archivo de texto de ejemplo 10.195.10.1\nmyprinter.example.com\n10.195.10.3-10.195.10.255\n10.195.*.*\n10.195.10.1/22\n2001:db8:0:0:0:0:2:1\n2001:db8::2:1 Haga clic en  Importar . En la sección  SNMP , seleccione  Versión 1 ,  Versión 2c  o  Versión 3  y configure los permisos de acceso. Para buscar impresoras mediante la versión 3 de SNMP, cree un nombre de usuario y una contraseña en Embedded Web Server de la impresora y, a continuación, reiníciela. Si no se puede establecer una conexión, vuelva a buscar las impresoras. Para más información, consulte la  Guía del administrador de Embedded Web Server  . Si fuera necesario, en la sección  Introducir credenciales , seleccione el método de autenticación que utilizan las impresoras e introduzca las credenciales. Esta función le permite establecer la comunicación con las impresoras protegidas durante la búsqueda. Se deben proporcionar las credenciales correctas para poder realizar tareas en las impresoras protegidas, como auditorías, actualizaciones de estado y actualizaciones de firmware. Si fuera necesario, en la sección  Asignar configuraciones , asocie una configuración a un modelo de impresora. Para obtener más información sobre la creación de configuraciones, consulte  . Si fuera necesario, en la sección  Asignar palabras clave , asocie una configuración a un modelo durante el descubrimiento. Para obtener información sobre la asignación de palabras clave a impresoras, consulte  . Todas las impresoras detectadas a través de este perfil se asignan con las nuevas palabras clave. Las nuevas palabras clave se añaden a la lista existente de palabras clave que ya están asignadas a una impresora. Haga clic en  Guardar perfil  o  Guardar y ejecutar perfil . Se puede programar una tarea de búsqueda para que se realice con regularidad. Para obtener más información, consulte  . creación de perfiles de búsqueda perfil de búsqueda creación"},{"UUID":"091e2199-d04e-4662-860b-99495d3a4b3a","title":"Búsqueda de impresoras","link":"managing-discovery-profiles-topic.html","desc":"Administración de perfiles de búsqueda","descFull":"Administración de perfiles de búsqueda En el menú Impresoras, haga clic en  Perfiles de búsqueda . Haga lo siguiente: Edite un perfil Seleccione un perfil y haga clic en  Editar . Configure los valores. Haga clic en  Guardar perfil  o  Guardar y ejecutar perfil . Copiar un perfil Seleccione un perfil y haga clic en  Copiar . Configure los valores. Agregar las direcciones IP. Para obtener más información, consulte  . Haga clic en  Guardar perfil  o  Guardar y ejecutar perfil . Eliminar un perfil Seleccione uno o más perfiles. Haga clic en  Eliminar y, a continuación, confirme la eliminación. Ejecutar un perfil Seleccione uno o más perfiles. Haga clic en  Ejecutar . Compruebe el estado de búsqueda desde el menú Tareas. administración de perfiles de búsqueda perfiles de búsqueda administración edición del perfil de búsqueda borrado de perfiles de búsqueda Copia de perfiles de búsqueda ejecución de perfiles de búsqueda perfiles de búsqueda edición perfiles de búsqueda eliminación perfiles de búsqueda copia perfiles de búsqueda ejecución"},{"UUID":"974a0534-4454-492a-ad8b-a969bf0c7c71","title":"Búsqueda de impresoras","link":"sample-scenario-discovering-printers-topic.html","desc":"Caso de ejemplo: Búsqueda de","descFull":"Caso de ejemplo: Búsqueda de impresoras ABC es una gran empresa de fabricación que ocupa un edificio de nueve plantas. La empresa acaba de comprar 30 nuevas impresoras Lexmark y las ha distribuido en las nueve plantas. Como personal del equipo de TI, debe añadir estas nuevas impresoras a MVE. Las impresoras ya están conectadas a la red, pero desconoce todas las direcciones IP. Quiere proteger estas impresoras nuevas del departamento de contabilidad: 10.194.55.60 10.194.56.77 10.194.55.71 10.194.63.27 10.194.63.10 Implementación de ejemplo Cree un perfil de búsqueda para las impresoras del departamento de contabilidad. Agregue las cinco direcciones IP. Cree una configuración que proteja las impresoras en cuestión. Incluya las configuraciones en el perfil de búsqueda. Guarde y ejecute el perfil. Cree otro perfil de búsqueda para el resto de las impresoras. Incluya las direcciones IP con un comodín. Utilice lo siguiente:  10.194.*.* Excluya las cinco direcciones IP de las impresoras del departamento de contabilidad. Guarde y ejecute el perfil. búsqueda de impresoras impresoras búsqueda"},{"UUID":"6a66f89d-cb56-46e5-aba4-1db5734bf8c2","title":"Administración del panel de seguridad","link":"overview-security-dashboard-topic.html","desc":"Descripción general El panel de","descFull":"Descripción general El panel de control de seguridad le permite ver el estado de la configuración de seguridad del dispositivo. Es una representación visual de varias configuraciones de seguridad, como puertos, protocolos, estado de cifrado de disco, cuentas de administrador de dispositivos y estado de certificado predeterminado. Proporciona visibilidad de la situación de seguridad de su flota, lo que ayuda a los administradores a identificar y corregir los ajustes que no cumplen las normativas. descripción general panel de seguridad"},{"UUID":"3e1ae583-cab4-434c-ab64-f37cff793f0b","title":"Administración del panel de seguridad","link":"accessing-dashboard-topic.html","desc":"Acceso al panel de seguridad","descFull":"Acceso al panel de seguridad En el portal web de MVE, haga clic en  Panel . El panel de seguridad es la página de inicio predeterminada para los administradores. Haga clic en uno de los siguientes widgets: Información de seguridad del dispositivo Comprobación de cumplimiento del dispositivo Mostrar u ocultar el panel de seguridad Modifique el parámetro  dashboard.display  en el archivo platform.properties para ocultar o mostrar el panel de seguridad. Encontrará el archivo platform.properties en  \\ Installation Location \\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes , donde  Installation Location  es la carpeta de instalación de MVE. El valor predeterminado de este campo es  True . Si introduce un valor incorrecto o deja el campo en blanco para este parámetro, se mostrará el panel. Para deshabilitar el panel, establezca el parámetro  dashboard.display  en  False . Después de modificar el parámetro, reinicie el servicio MVE. panel acceso"},{"UUID":"434eada2-f963-49d0-b2d1-4c6cbfadd767","title":"Administración del panel de seguridad","link":"managing-device-security-information-topic.html","desc":"Administración de  Información de","descFull":"Administración de  Información de seguridad del dispositivo Este widget resume la vista de seguridad de la flota. Haga clic en cualquier barra del gráfico para ir a la ventana  Información de seguridad del dispositivo . Pase el ratón sobre las barras para ver los siguientes detalles: Número de puerto Número de impresoras asociadas Si la configuración de la impresora está abierta o activada Haga clic en  Imprimir  para obtener un formato imprimible de la vista detallada. La ventana Información de seguridad del dispositivo proporciona al usuario una función de desglose. Al hacer clic en cualquier elemento de la barra del gráfico, el usuario puede navegar a una vista filtrada de la página de listado de impresoras. Para obtener más información, consulte  . Información de seguridad del dispositivo administración"},{"UUID":"44999255-0a02-48bf-a2bb-373ae83b7f35","title":"Administración del panel de seguridad","link":"managing-device-conformance-check-topic.html","desc":"Administración de  Comprobación de","descFull":"Administración de  Comprobación de cumplimiento del dispositivo Este widget resume la vista detallada de la comprobación de cumplimiento de la flota. Haga clic en cualquier sección del gráfico circular para ir a la ventana  Comprobación de cumplimiento del dispositivo . En el panel izquierdo, aplique el filtro  Intervalo de fechas . El intervalo predeterminado es de siete días. Haga clic en  Imprimir  para obtener un formato imprimible de la vista detallada. La ventana Comprobación de cumplimiento del dispositivo proporciona al usuario una función de desglose. Al hacer clic en cualquier sección del gráfico circular, el usuario puede desplazarse a una vista filtrada de la página de lista de impresoras. Para obtener más información, consulte  . Comprobación de cumplimiento del dispositivo administración"},{"UUID":"6b17ee29-5063-470d-90dc-d5edd79521f0","title":"Visualización de impresoras","link":"viewing-printer-list-topic.html","desc":"Visualización de la lista de","descFull":"Visualización de la lista de la impresora La página Lista de impresoras es la página de aterrizaje predeterminada al acceder a MVE. La tabla muestra la lista de las impresoras agregadas a MVE. En el menú  Impresoras , haga clic en  Listado de impresoras . En la página de  Listado de impresoras , realice las siguientes acciones: Para buscar impresoras específicas, haga lo siguiente: Utilice el cuadro de búsqueda para buscar una dirección IP, un nombre de host, un nombre de sistema o el número de serie. Cambie la vista de la lista de impresoras. Para obtener más información, consulte  . Si utiliza el cuadro de búsqueda, la aplicación busca todas las impresoras en el sistema. Los filtros seleccionados y las búsquedas guardadas se ignoran. Si ejecuta una búsqueda guardada, se utilizan los criterios especificados en la búsqueda guardada. Los filtros seleccionados y la dirección IP o el nombre de host introducido en el cuadro de búsqueda se ignoran. También puede utilizar los filtros para limitar la búsqueda actual resultados. Utilice los filtros. Ejecute una búsqueda guardada. Para obtener más información, consulte  . Para ordenar las impresoras, en la tabla de la lista de impresoras, haga clic en el encabezado de cualquier columna. Las impresoras se ordenarán en función de la columna seleccionada. Para ver más información sobre las impresoras, cambie el tamaño de las columnas. Coloque el cursor sobre el borde vertical del encabezado de la columna y, a continuación, arrastre el borde hacia la izquierda o hacia la derecha. visualización de la lista de la impresora lista de impresoras visualización"},{"UUID":"0fae015d-c215-49f3-b785-6e57ba2c56cb","title":"Visualización de impresoras","link":"viewing-device-information-topic.html","desc":"Visualización de la información de","descFull":"Visualización de la información de la impresora Para ver la lista completa de información, asegúrese de que se realiza una auditoría a la impresora. Para obtener más información, consulte  . En el menú  Impresoras , haga clic en  Listado de impresoras . Haga clic en la dirección IP de la impresora. Vea la siguiente información: Estado : el estado de la impresora. Consumibles : los detalles de los consumibles y el porcentaje de suministro restante. Identificación : la información de identificación de la red de la impresora. La información de la zona horaria solo está disponible en determinados modelos de impresora. Fechas : la fecha en que la impresora se añade al sistema, la fecha de detección y la fecha de la auditoría más reciente. Firmware : las propiedades del firmware de la impresora y los niveles de código. Funciones : características de la impresora. Opciones de memoria : el tamaño del disco duro y el espacio libre del usuario flash. Opciones de entrada : la configuración de las bandejas disponibles. Opciones de salida : la configuración de las salidas disponibles. Aplicaciones eSF : la información sobre las aplicaciones Embedded Solutions Framework (eSF) instaladas en la impresora. Estadísticas de la impresora : los valores específicos de todas las propiedades de la impresora. Cambiar detalles : la información sobre los cambios en la impresora. Esta información solo se está disponible en impresoras en estado Administradas (modificadas). Para obtener más información, consulte  . Credenciales de la impresora : las credenciales utilizadas en la configuración asignadas a la impresora. Certificado de impresora : propiedades del certificado de la impresora: Predeterminado HTTPS 802.1x IPSec Esta información está disponible únicamente en algunos modelos de impresora. Un estado de validez  Caducará pronto  indica la fecha de caducidad definida en  Autoridad certificadora , en  Configuración del sistema . Propiedades de configuración : las propiedades de la configuración asignadas a la impresora. Alertas activas : las alertas de la impresora que están a la espera de ser eliminadas. Eventos asignados : los eventos asignados a la impresora. visualización de la información de la impresora información de la impresora visualización"},{"UUID":"369f0565-3afd-4572-9a20-f77d07f62b29","title":"Visualización de impresoras","link":"exporting-data-topic.html","desc":"Exportación de datos de la","descFull":"Exportación de datos de la impresora MVE le permite exportar la información de la impresora disponible en su vista actual. En el menú  Impresoras  , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Impresora Exportar datos . Los datos exportados se guardan en un archivo CSV. Se puede programar una tarea de exportación de datos para que se realice con regularidad. Para obtener más información, consulte  . exportación de datos de impresora datos de impresora exportación"},{"UUID":"d6920d02-37e2-429f-8cc4-89e6c4196499","title":"Visualización de impresoras","link":"managing-views-topic.html","desc":"Administración de vistas La función","descFull":"Administración de vistas La función  Vistas  le permite personalizar la información que se muestra en la página de lista de impresoras. En el menú  Impresoras , haga clic en  Vistas . Haga lo siguiente: Crear una vista Haga clic en  Crear . Introduzca un nombre exclusivo para la vista y su descripción. Diríjase a la pestaña  Ver columnas  y luego al menú  Columna 1 ; a continuación, seleccione la columna del identificador. En la sección  Posibles columnas  , seleccione la información que desea mostrar como una columna y, a continuación, haga clic en  > . Capacidades : muestra si las funciones seleccionadas están disponibles en la impresora. Certificado : muestra la fecha de creación del certificado de la impresora, el estado de inscripción, la fecha de caducidad, la fecha de renovación, el número de revisión, el asunto del certificado, la validez y el estado de firma. Información de configuración : muestra la información de la impresora relacionada con la configuración, como la conformidad, el nombre de la configuración y el estado. Fechas : muestra la última auditoría, la última comprobación de conformidad, la última detección y la fecha en que la impresora se añadió al sistema. Eventos : muestra información de la impresora relacionada con los eventos. Firmware : muestra información relacionada con el firmware, como la versión. Identificación : muestra información sobre la impresora, como la dirección IP, el nombre de host y el número de serie. Opciones de entrada : muestra información sobre las opciones de entrada, como el tamaño de la bandeja y el tipo de papel. Opciones : muestra información sobre las opciones de la impresora, como el disco duro y la unidad flash. Estadísticas de la impresora : muestra información sobre el uso de la impresora, como el número de páginas impresas o escaneadas y el número total de trabajos de fax. Soluciones : muestra las aplicaciones eSF instaladas en la impresora y sus números de versión. Estado : muestra el estado de los consumibles y de la impresora. Consumibles : muestra información relacionada con los consumibles. Puertos de la impresora : muestra información relacionada con los puertos. La opción  Desconocido  en el valor de puerto puede significar que el puerto no existe en la impresora o que MVE no puede recuperar el puerto. Opciones de seguridad de la impresora : muestra la información TLS  y de cifrado. Haga clic en  Crear vista . Editar una vista Seleccione una vista. Haga clic en  Editar  y, a continuación, modifique los valores. Haga clic en  Guardar cambios . Copiar una vista Seleccione una vista. Haga clic en  Copiar  y configure los valores. Haga clic en  Crear vista . Eliminar vistas Seleccione una o más vistas. Haga clic en  Eliminar y, a continuación, confirme la eliminación. Establecer una vista predeterminada Seleccione una vista. Haga clic en  Establecer como predeterminada . El sistema genera las siguientes vistas, que no se pueden modificar ni eliminar: Configuración Lista de impresoras Evento Seguridad Servicio de mantenimiento Estándar administración de vistas edición de vistas copia de vistas eliminación de vistas establecimiento de una vista predeterminada vistas administración vistas edición vistas copia vistas eliminación"},{"UUID":"2b685384-bfc6-4ac1-bab9-e2db987d95de","title":"Visualización de impresoras","link":"changing-printer-listing-view-topic.html","desc":"Cambio de la vista de","descFull":"Cambio de la vista de lista de impresoras Para obtener más información, consulte  . En el menú Impresoras, haga clic en  Lista de impresoras . Haga clic en  Vistas  y seleccione una vista. cambio de la vista de lista de impresoras vista de lista de impresoras cambio"},{"UUID":"e5c103ff-8c84-41fd-9ea8-6a4002ea4076","title":"Visualización de impresoras","link":"filtering-printers-using-search-bar-topic.html","desc":"Filtrado de impresoras mediante la","descFull":"Filtrado de impresoras mediante la barra de búsqueda Tenga en cuenta lo siguiente al utilizar la barra de búsqueda para buscar impresoras. Si desea buscar una dirección IP, asegúrese de escribir la dirección IP o rango completos. Por ejemplo: 10.195.10.1 10.195.10.3-10.195.10.255 10.195.*.* 2001:db8:0:0:0:0:2:1 Si la cadena de búsqueda no es una dirección IP completa, las impresoras se buscan según su nombre de host, nombre de sistema o número de serie. El carácter de guion bajo ( _ ) se puede utilizar como un carácter comodín. filtrado de impresoras mediante la barra de búsqueda barra de búsqueda filtrado de impresoras impresoras filtrar"},{"UUID":"813819d0-15c0-4dbf-8720-66707a930632","title":"Visualización de impresoras","link":"managing-keywords-topic.html","desc":"Administración de palabras clave Las","descFull":"Administración de palabras clave Las palabras clave permiten crear etiquetas personalizadas y asignarlas a las impresoras. En el menú  Impresoras , haga clic en  Palabras clave . Para ello, realice una de las siguientes acciones: Añada, edite o elimine una categoría. Las categorías agrupan las palabras. Añada, edite o elimine una palabra clave. Para obtener información sobre la asignación de palabras clave a impresoras, consulte  . administración de palabras clave palabras clave administración creación de palabras clave edición de palabras clave eliminación de palabras claves palabras clave creación palabras clave edición palabras clave eliminación"},{"UUID":"cd5e3b7e-a172-4cb5-acfa-df42f2b1febe","title":"Utilización de las búsquedas guardadas","link":"understanding-device-life-cycle-states-topic.html","desc":"Descripción de los estados de","descFull":"Descripción de los estados de la vida útil de la impresora Las búsquedas guardadas generadas por el sistema muestran las impresoras en los siguientes estados de vida útil: Todas las impresoras : todas las impresoras del sistema. Impresoras administradas : las impresoras que aparecen pueden estar en cualquiera de los siguientes estados: Administrada (normal) Administrada (modificada) Administrada (desaparecida) Administrada (encontrada) Impresoras administradas (modificadas) : las impresoras en el sistema cuyas propiedades siguientes han cambiado desde la última auditoría: Etiqueta de propiedad Nombre de host Nombre de contacto Ubicación de contacto Tamaño de la memoria Doble cara Consumibles (excluyendo los niveles) Opciones de entrada Opciones de salida Aplicaciones eSF Certificado de la impresora predeterminada Impresoras administradas (encontradas) : las impresoras que estaban declaradas como desaparecidas, pero que ahora se han encontrado. Impresoras administradas (desaparecidas) : las impresoras con las que el sistema no ha podido comunicarse. Impresoras administradas (normales) : las impresoras en el sistema cuyas propiedades han permanecido iguales desde la última auditoría. Nuevas impresoras : las impresoras recién encontradas y que no se han ajustado automáticamente al estado Administradas. Impresoras retiradas : las impresoras marcadas como que ya no están activas en el sistema. Impresoras no administradas : las impresoras que se han marcado para excluirlas de las actividades llevadas a cabo en el sistema. Estado inicial Estado de final Transición 1  El ajuste \" Impresoras detectadas gestionadas automáticamente \" está activado en el perfil de búsqueda. 2  El ajuste \" Impresoras detectadas gestionadas automáticamente \" está desactivado en el perfil de búsqueda. Empezar Normal Detectado. 1 Empezar Nueva Detectado. 2 Cualquiera Normal, no administrada o retirada Manual (Desaparecida no cambia a normal). Retirada Normal Detectado. 1 Retirada Nueva Detectado. 2 Normal, desaparecida o encontrada Modificada Nueva dirección al encontrarla. Normal Modificada Las propiedades de auditoría no coinciden con las de la base de datos. Normal, cambiada o encontrada Desaparecida No se ha encontrado en la auditoría o en la actualización de estado. Modificada Normal Las propiedades de auditoría coinciden con las de la base de datos. Desaparecida Encontrada Estado de descubierto, auditoría o actualización. Encontrada Normal Estado de descubierto, auditoría o actualización. estados de la vida útil de la impresora descripción Descripción de los estados de la vida útil de la impresora"},{"UUID":"64fa4d1b-b255-47ff-a48c-d2970a1ce9c4","title":"Utilización de las búsquedas guardadas","link":"understanding-device-life-cycle-states-topic.html","desc":"Ejecución de una búsqueda guardada","descFull":"Ejecución de una búsqueda guardada Una búsqueda guardada es un conjunto guardado de parámetros que devuelve la información más reciente de la impresora que coincide con dichos parámetros. Puede crear y ejecutar una búsqueda guardada personalizada o bien utilizar las búsquedas guardadas predeterminadas generadas por el sistema. Las búsquedas guardadas generadas por el sistema muestran las impresoras en sus estados de vida útil. Para obtener más información, consulte  . En el menú  Impresoras , haga clic en  Listado de impresoras . En el menú desplegable, seleccione una búsqueda guardada. ejecución de una búsqueda guardada búsquedas guardadas ejecución"},{"UUID":"c079529c-d869-4b35-973b-d4a543817c7a","title":"Utilización de las búsquedas guardadas","link":"understanding-device-life-cycle-states-topic.html","desc":"Creación de una búsqueda guardada","descFull":"Creación de una búsqueda guardada Uso de filtros En el menú  Impresoras , haga clic en  Listado de impresoras . En el lado izquierdo de la página, seleccione los filtros. Los filtros seleccionados se enumeran encima del encabezado de resultados de búsqueda. Haga clic en  Guardar  e introduzca un nombre exclusivo para su búsqueda guardada y su descripción. Haga clic en  Crear búsqueda guardada . Uso de la página de búsqueda guardada En el menú  Impresoras , haga clic en  Búsquedas guardadas Crear . En la sección  General , escriba un nombre exclusivo para su búsqueda guardada y su descripción. En la sección  Reglas y grupos de reglas , en el menú  Coincidencia , especifique si los resultados de búsqueda deben coincidir con todas o con alguna de las reglas. Para ello, realice una de las siguientes acciones: Agregar una regla Haga clic en  Agregar regla . Especifique el parámetro, la operación y el valor de su criterio de búsqueda. Para obtener más información, consulte  . Agregar un grupo de reglas Un grupo de reglas puede contener una combinación de reglas. Si el menú  Coincidencia  está definido en  CUALQUIER regla y grupo de reglas , el sistema busca impresoras que coincidan con todas las reglas en el grupo de reglas. Si el menú  Coincidencia  está definido en  TODAS las reglas y grupos de reglas , el sistema busca impresoras que coincidan con todas las reglas en el grupo de reglas. Haga clic en  Añadir grupo de reglas . Especifique el parámetro, la operación y el valor de su criterio de búsqueda. Para obtener más información, consulte  . Para agregar otra regla, haga clic en  Agregar regla . Haga clic en  Crear búsqueda guardada  o  Crear y ejecutar búsqueda guardada . creación de una búsqueda guardada personalizada búsqueda guardada personalizada creación"},{"UUID":"cfea4f1f-6978-4752-a7c3-f809478a43ff","title":"Utilización de las búsquedas guardadas","link":"understanding-device-life-cycle-states-topic.html","desc":"Descripción de la configuración de","descFull":"Descripción de la configuración de los criterios de búsqueda Puede buscar impresoras utilizando uno o varios de los siguientes parámetros: Parámetro Descripción Etiqueta de activo El valor de la configuración de la etiqueta de activo en la impresora. Fecha de creación del certificado 1 La fecha en que se creó el certificado. Estado de inscripción del certificado 1 El estado de inscripción del certificado. Fecha de caducidad del certificado 1 La fecha en que caduca el certificado. Fecha de renovación del certificado 1 La fecha en que se renueva el certificado. Número de revisión del certificado 1 El número de revisión del certificado. Estado de firma de certificado 1 El estado del certificado. Estado de validez del certificado 1 La validez del certificado. El estado  Caducará pronto  indica que el certificado caducará en menos de 30 días. Capacidad de color La impresora imprime en color o en blanco y negro. Configuración El nombre de configuración asignado a la impresora. Cumplimiento de configuración El estado de conformidad de la impresora en relación con la configuración asignada. Ubicación de contacto El valor de configuración de la ubicación del contacto en la impresora. Nombre de contacto El valor de la configuración de nombre de la persona de contacto en la impresora. Copia La impresora admite la función de copia. Fecha: adición al sistema La fecha en que se añadió la impresora al sistema. Fecha: última auditoría La fecha en que la impresora se auditó por última vez. Fecha: última comprobación de cumplimiento La fecha en que se comprobó el cumplimiento de la configuración de la impresora por última vez. Fecha: última detección La fecha en que se detectó la impresora por última vez. Codificación de disco La impresora está configurada para la codificación de discos. Borrado de disco La impresora está configurada para el borrado del disco. A dos caras La impresora es compatible con impresión a doble cara. Capacidad de eSF La impresora es compatible con la administración de aplicaciones eSF. Información de eSF Información sobre la aplicación eSF instalada en la impresora, como el nombre, el estado y la versión. Nombre del evento El nombre de los eventos asignados. Nombre de fax El valor de la configuración de nombre de fax en la impresora. Número de fax El valor de la configuración de número de fax en la impresora. Recepción de fax La impresora admite la recepción de fax. Información de firmware La información sobre el firmware instalado en la impresora. Nombre : el nombre del firmware. Por ejemplo,  Base  o  Kernel . Versión : la versión del firmware de la impresora. Nombre de host El nombre de host de la impresora. Dirección IP La dirección IP de la impresora. Puede utilizar un asterisco en los tres últimos octetos para buscar varias entradas. Por ejemplo,  123.123.123.* ,  123.123.*.* ,  123.*.*.* ,  2001:db8::2:1  y  2001:db8:0:0:0:0:2:1 . Palabra clave Las palabras clave asignadas. Número total de páginas impresas El valor del número total de páginas impresas de la impresora. Dirección MAC La dirección MAC de la impresora. Contador de mantenimiento El valor del contador de mantenimiento de la impresora. Fabricante El nombre del fabricante de la impresora. Tecnología de marca La tecnología de marca compatible con la impresora. Capacidad de impresora mutifunción La impresora es un producto multifuncional (MFP). Modelo El nombre de modelo de la impresora. Número de serie modular El número de serie modular. Estado de la impresora El estado de la impresora. Por ejemplo,  Listo ,  Atasco de papel ,  Falta bandeja 1 . Gravedad del estado de la impresora El valor del estado más grave presente en la impresora. Por ejemplo,  Desconocido ,  Listo ,  Advertencia  o  Error . Perfil La impresora admite perfiles. Escanear a correo electrónico La impresora admite la digitalización a correo electrónico. Digitalizar a fax La impresora admite la digitalización a fax. Digitalizar a red La impresora admite la digitalización a red. Estado de comunicación segura El estado de autenticación o la seguridad de la impresora. Número de serie El número de serie de la impresora. Estado El estado actual de la impresora en la base de datos. Estado de consumible El estado de consumibles de la impresora. Gravedad del estado de los consumibles El valor del estado de los consumibles más grave presente en la impresora. Por ejemplo,  Desconocido ,  Correcto ,  Advertencia  o  Error . Nombre del sistema El nombre del sistema de la impresora. Zona horaria La zona horaria de la región en la que se encuentra la impresora. TLI El valor de la configuración de TLI en la impresora. 1 Los parámetros relacionados con el certificado se aplican a los siguientes certificados de dispositivo: Predeterminado HTTPS 802.1x IPSec Utilice los siguientes operadores cuando busque impresoras: Coincide exactamente : un parámetro es equivalente a un valor especificado. No es : un parámetro no es equivalente a un valor especificado. Contiene : un parámetro contiene un valor especificado. No contiene : un parámetro no contiene un valor especificado. Comienza con : un parámetro comienza con un valor especificado. Finaliza con : un parámetro finaliza con un valor especificado. Fecha Anterior a : un parámetro para buscar días antes de los días especificados. Dentro del último : un parámetro para buscar dentro de los días especificados antes del día de hoy. Dentro del siguiente : un parámetro para buscar dentro de los días especificados después de hoy. Para buscar impresoras que tienen parámetros con valores vacíos, utilice  _EMPTY_O_NULL_ . Por ejemplo, para buscar impresoras que tienen vacío el  Nombre de fax  en el campo  Valor , escriba  _EMPTY_O_NULL_ . configuración de los criterios de búsqueda descripción criterios de búsqueda parámetros criterios de búsqueda operadores"},{"UUID":"5b28bc21-80b0-49e8-be61-45855d3b62f2","title":"Utilización de las búsquedas guardadas","link":"understanding-device-life-cycle-states-topic.html","desc":"Administración de búsquedas guardadas En","descFull":"Administración de búsquedas guardadas En el menú Impresoras, haga clic en  Búsquedas guardadas . Haga lo siguiente: Edite una búsqueda guardada Seleccione una búsqueda guardada y haga clic en  Editar . Las búsquedas guardadas generadas por el sistema no se pueden editar. Para obtener más información, consulte  . Configure los valores. Haga clic en  Guardar cambios  o  Guardar y ejecutar . Copiar una búsqueda guardada Seleccione una búsqueda guardada y haga clic en  Copiar . Configure los valores. Haga clic en  Crear búsqueda guardada  o  Crear y ejecutar búsqueda guardada . Eliminar búsquedas guardadas Seleccionar una o más búsquedas guardadas. Las búsquedas guardadas generadas por el sistema no se pueden eliminar. Para obtener más información, consulte  . Haga clic en  Eliminar y, a continuación, confirme la eliminación. administración de búsquedas guardadas búsquedas guardadas administración editar búsquedas guardadas copiar búsquedas guardadas eliminar búsquedas guardadas búsquedas guardadas edición búsquedas guardadas copia búsquedas guardadas eliminación"},{"UUID":"c9949889-220c-44f8-8e85-5b8377e3fb5a","title":"Visualización de impresoras","link":"sample-scenario-monitor-fleet-topic.html","desc":"Caso de ejemplo: Controlar los","descFull":"Caso de ejemplo: Controlar los niveles de tóner de su flota Como personal del equipo de TI de la empresa ABC, debe organizar la flota de impresoras para poder controlarlas fácilmente. Quiere controlar el uso de tóner de las impresoras para determinar si es necesario sustituir los consumibles. Implementación de ejemplo Cree una búsqueda guardada que recupere las impresoras cuyos consumibles tengan errores o advertencias. Regla de ejemplo para la búsqueda guardada Parámetro:  Gravedad del estado de los suministros Operación:  No es Valor:  Consumibles correctos Cree una vista que muestre el estado de los consumibles, la capacidad y el nivel para cada impresora. Columnas de ejemplo que se mostrarán en la vista de consumibles Estado de suministro Capacidad de cartucho negro Nivel de cartucho negro Capacidad de cartucho cian Nivel de cartucho cian Capacidad de cartucho magenta Nivel de cartucho magenta Capacidad de cartucho amarillo Nivel de cartucho amarillo Ejecute la búsqueda guardada mientras utiliza la vista. La información que se muestra en la vista de listado de impresoras se basa en la última auditoría. Realice una auditoría y una actualización de estado para obtener el estado actual de la impresora. control de impresoras"},{"UUID":"a0cbb396-d529-42a5-8565-958c33d1690f","title":"Protección de las comunicaciones de la impresora","link":"understanding-security-status-topic.html","desc":"Descripción de los estados de","descFull":"Descripción de los estados de seguridad de la impresora Durante la detección, la impresora puede estar en cualquiera de los siguientes estados de seguridad: Desprotegidas : MVE no requiere credenciales para comunicarse con el dispositivo. Protegidas : MVE requiere credenciales y se le han proporcionado. Faltan credenciales : MVE requiere credenciales pero no se le han proporcionado. Credenciales no válidas : MVE requiere credenciales pero se le han proporcionado credenciales incorrectas. Una impresora tiene el estado  Credenciales no válidas  cuando presenta credenciales no válidas durante la detección, la auditoría, la actualización del estado, la comprobación de conformidad o la aplicación de la configuración. La impresora tiene el estado  Desprotegidas  únicamente cuando no requiere credenciales durante la detección. Para cambiar el estado de  Desprotegidas  a  Protegidas , aplique una configuración protegida. Para cambiar el estado de la impresora  Faltan credenciales  o  Credenciales no válidas , introduzca las credenciales en MVE de forma manual o cree una configuración desde la impresora. estados de seguridad de la impresora descripción"},{"UUID":"6b022f36-b310-46f3-998d-3a8e34472d00","title":"Protección de las comunicaciones de la impresora","link":"securing-printers-using-default-config-topic.html","desc":"Protección de impresoras con la","descFull":"Protección de impresoras con la configuración predeterminada Algunos modelos de impresora no disponen de un usuario administrador predeterminado. El usuario invitado tiene acceso abierto y no tiene que iniciar sesión. Esta configuración otorga acceso al usuario a todos los permisos de la impresora y a los controles de acceso. MVE gestiona este riesgo a través de configuraciones predeterminadas. Después de una nueva instalación, se crean dos componentes de seguridad avanzada de forma automática. Cada componente contiene los valores de seguridad predeterminados y la cuenta de administrador local preconfigurada. Puede utilizar estos componentes de seguridad cuando cree una configuración y, a continuación, implementar y aplicar dicha configuración a las nuevas impresoras. En el menú  Configuraciones , haga clic en  Todos los componentes de seguridad avanzada . Autenticación basada en una cuenta simple Este componente de seguridad contiene una  Cuenta local Nombre de usuario/Contraseña  denominada  administración . La cuenta  administración  es miembro del Grupo de administración, entre cuyos permisos se incluyen los controles de acceso a función, así como permisos para proteger la impresora y restringir el acceso público. Para obtener más información, consulte  . Antes de añadir este componente a una configuración, asegúrese de establecer la contraseña de  administración  y las credenciales de la impresora. Autenticación basada en plantilla sencilla Este componente de seguridad contiene una plantilla de seguridad denominada  Proteg. con PIN admin , configurada con una  Contraseña de cuenta local . Esta plantilla de seguridad se aplica a los siguientes controles de acceso: Actualizaciones de firmware Administración remota Menú de seguridad  de forma remota Los controles de acceso restantes se han establecido como  Sin seguridad . Sin embargo, siempre puede establecer los demás menús administrativos de la impresora para que utilicen la plantilla de seguridad para obtener más protección. Para obtener más información sobre los controles de acceso, consulte  . Antes de añadir este componente a una configuración, asegúrese de establecer la contraseña y las credenciales de la impresora. protección de impresoras con la configuración predeterminada impresoras seguridad configuraciones predeterminadas"},{"UUID":"5970ba4a-8753-44b6-8567-0746799b6b7d","title":"Protección de las comunicaciones de la impresora","link":"understanding-fac-permissions-topic.html","desc":"Descripción de los permisos y","descFull":"Descripción de los permisos y controles de acceso a función Es posible configurar las impresoras para restringir el acceso público a los menús administrativos y las funciones de gestión de dispositivos. En los modelos de impresora más recientes, se pueden proteger los permisos para acceder a las funciones de la impresora mediante diferentes tipos de métodos de autenticación. En modelos de impresora anteriores, es posible aplicar una plantilla de seguridad al control de acceso a función (FAC). Para comunicarse con estas impresoras protegidas y gestionarlas, MVE requiere determinados permisos o FAC, en función del modelo de impresora. La siguiente tabla explica qué funciones de gestión de impresora se pueden gestionar en MVE y qué permisos o FAC se requieren. Tenga en cuenta que MVE requiere las credenciales de autenticación cuando la  Administración remota  está protegida. Si otros menús administrativos y permisos de gestión de dispositivos o FAC están protegidos, entonces  Administración remota  también deberá estarlo. De lo contrario, MVE no podrá ejecutar las funciones. Estos permisos y controles de acceso a funciones están predefinidos en MVE como componentes de seguridad avanzada predeterminados y se pueden utilizar fácilmente en una configuración. Para obtener más información, consulte  . Si no utiliza los componentes de seguridad avanzada predeterminados, compruebe que estos permisos y controles de acceso a funciones se configuran manualmente en la impresora. Para obtener más información, consulte  . Permisos o FAC Descripción Administración remota La capacidad de leer y escribir valores de forma remota. Si cualquier otro permiso o FAC incluido en esta tabla está protegido, entonces  Administración remota  también debe estarlo. Actualizaciones de firmware La capacidad de actualizar firmware utilizando cualquier método. Configuración de aplicaciones La capacidad de instalar o eliminar aplicaciones de la impresora y enviar los archivos de valores de la aplicación a la impresora. Importar/Exportar todos los valores o Importación/exportación de archivo de configuración La capacidad de enviar archivos de configuración a la impresora. Menú de seguridad o Menú de seguridad de forma remota La capacidad de gestionar métodos de inicio de sesión y configurar opciones de seguridad de la impresora. Para proteger nuevos modelos de impresora en MVE, desactive el acceso público a  Administración remota  y los permisos del  Menú de seguridad . Para modelos de impresora anteriores, aplique una plantilla de seguridad al FAC de  Administración remota . controles de acceso a funciones descripción permisos descripción"},{"UUID":"15648076-bb3f-4d6d-aa50-00ad81d4d469","title":"Protección de las comunicaciones de la impresora","link":"configuring-device-security-topic.html","desc":"Configuración de la seguridad de","descFull":"Configuración de la seguridad de la impresora En el menú  Impresoras , haga clic en  Lista de impresoras . Haga clic en la dirección IP de la impresora y, a continuación, haga clic en  Abrir servidor web incorporado . Haga clic en  Ajustes  o  Configuración . En función del modelo de impresora, realice una de las siguientes acciones: Haga clic en  Seguridad Métodos de inicio de sesión  y proceda de la siguiente manera: Para los modelos de impresora más recientes En la sección  Seguridad , cree un método de inicio de sesión. Haga clic en  Administrar grupo/permisos  o  Administrar permisos  al lado del método de inicio de sesión. Expanda los  Menús administrativos  y seleccione  Menú de seguridad . Expanda  Administración de dispositivos  y, a continuación, seleccione las siguientes opciones: Administración remota Actualizaciones de firmware Configuración de aplicaciones Importar/Exportar todos los valores Haga clic en  Guardar . En la sección  Público , haga clic en  Administrar permisos . Despliegue los  Menús administrativos  y elimine el  Menú de seguridad . Despliegue la  Administración de dispositivos  y, a continuación, elimine la  Administración remota . Haga clic en  Guardar . Haga clic en  Seguridad Configuración de seguridad  o  Editar configuración de seguridad y, a continuación, haga lo siguiente: Para los modelos de impresora anteriores En la sección de  Configuración de seguridad avanzada , cree un componente y una plantilla de seguridad. Haga clic en  Controles de acceso  y, a continuación, expanda los  Menús administrativos . En el  Menú de seguridad remota , seleccione la plantilla de seguridad. Expanda  Administración  y, a continuación, seleccione la plantilla de seguridad para los siguientes controles de acceso a función: Configuración de aplicaciones Administración remota Actualizaciones de firmware Importación/exportación de archivo de configuración Haga clic en  Enviar . configuración de la seguridad de la impresora seguridad de la impresora configuración"},{"UUID":"65646cb9-8ea6-4ba6-8690-ee8f963be3ff","title":"Protección de las comunicaciones de la impresora","link":"securing-printer-communications-on-your-fleet-topic.html","desc":"Protección de las comunicaciones de","descFull":"Protección de las comunicaciones de la impresora en su grupo Encuentre una impresora segura. Para obtener más información, consulte  . Una impresora es segura cuando aparece un   junto a ella. Para obtener información sobre la protección de una impresora, consulte el  documento de ayuda . Para obtener más información sobre los estados de seguridad de la impresora, consulte  . Crear una configuración desde una impresora. Para obtener más información, consulte  . Asigne la configuración a su flota. Para obtener más información, consulte  . Aplicar dicha configuración. Para obtener más información, consulte  . Aparece un símbolo de candado junto a la impresora segura. protección de las comunicaciones de la impresora en su grupo comunicaciones de la impresora seguridad"},{"UUID":"b0a79934-7813-4207-85e0-60cecfc36501","title":"Protección de las comunicaciones de la impresora","link":"securing-printers-topic.html","desc":"Otras maneras de proteger sus","descFull":"Otras maneras de proteger sus impresoras Para obtener más información sobre la configuración de los valores de seguridad de la impresora, consulte la  Guía del administrador de Embedded Web Server  de la impresora. En la impresora, compruebe los siguientes valores: Compruebe que la codificación de disco esté activada. Compruebe que los siguientes puertos estén restringidos: TCP 79 (Finger) TCP 21 (FTP) UDP 69 (TFTP) TCP 5001 (IPDS) TCP 9600 (IPDS) TCP 10000 (Telnet) La lista de cifrado predeterminada es la cadena de cifrado \"B\" de OWASP. protección de impresoras impresoras seguridad"},{"UUID":"9126a92c-a354-47ad-80cf-505a1dc4ea93","title":"Administración de impresoras","link":"restarting-printer-topic.html","desc":"Reinicio de la impresora En","descFull":"Reinicio de la impresora En el menú  Impresoras  , haga clic en  Listado de impresoras . Haga clic en la dirección IP de la impresora. Haga clic en  Reiniciar impresora . reinicio de la impresora impresora reinicio"},{"UUID":"080f25e8-b644-406c-bdbc-c536035f3c22","title":"Administración de impresoras","link":"viewing-ews-topic.html","desc":"Visualización de Embedded Web Server","descFull":"Visualización de Embedded Web Server de la impresora Embedded Web Server es un software integrado en la impresora que proporciona un panel de control para la configuración de la impresora desde cualquier navegador web. En el menú  Impresoras  , haga clic en  Listado de impresoras . Haga clic en la dirección IP de la impresora. Haga clic en  Abrir Embedded Web Server . visualización de Embedded Web Server de la impresora Embedded Web Server visualización"},{"UUID":"a1c3a39b-cb50-4513-907c-85aebd1825d1","title":"Administración de impresoras","link":"auditing-devices-topic.html","desc":"Auditoría de impresoras Una auditoría","descFull":"Auditoría de impresoras Una auditoría recopila información de cualquier impresora en estado Administrada y la almacena en el sistema. Para asegurarse de que la información del sistema es actual, realice una auditoría regularmente. En el menú Impresoras, haga clic en  Lista de impresoras . Seleccione una o más impresoras. Haga clic en  Impresora Auditoría . Se puede programar una auditoría para que se realice con regularidad. Para obtener más información, consulte  . auditoría de impresoras impresoras auditoría"},{"UUID":"bba4a491-28c7-4bc0-a5d2-ff4edadae4cb","title":"Administración de impresoras","link":"updating-printer-status-topic.html","desc":"Actualización del estado de la","descFull":"Actualización del estado de la impresora La función Actualizar estado le permite actualizar el estado de la impresora y proporciona información. Para comprobar que el estado de la impresora y la información de suministros están actualizados, actualice el estado con regularidad. En el menú  Impresoras , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Impresora Actualizar estado . Se puede programar una tarea de actualización de estado para que se realice con regularidad. Para obtener más información, consulte  . actualización del estado de la impresora estado de la impresora actualización"},{"UUID":"a65350c0-60cd-47a5-8c61-35582ad192c9","title":"Administración de impresoras","link":"setting-device-state-topic.html","desc":"Configuración del estado de la","descFull":"Configuración del estado de la impresora Para obtener más información sobre los estados de la impresora, consulte  . En el menú Impresoras, haga clic en  Lista de impresoras . Seleccione una o más impresoras. Haga clic en  Impresora  y, a continuación, seleccione una de las siguientes opciones: Establecer estado en administrado : la impresora se incluye en todas las actividades que se pueden realizar en el sistema. Establecer estado en no administrado : la impresora se excluye de todas las actividades que se pueden realizar en el sistema. Establecer estado en retirado : la impresora se ha eliminado de la red. El sistema conserva la información de la impresora, pero no pretende volver a ver a la impresora en la red. estado de la impresora configuración configuración del estado de la impresora"},{"UUID":"21d3e454-9230-4cfb-b3b2-1e9f4da1bdd1","title":"Administración de impresoras","link":"assigning-configurations-to-devices-topic.html","desc":"Asignación de configuraciones a impresoras","descFull":"Asignación de configuraciones a impresoras Antes de comenzar, asegúrese de que se ha creado una configuración para la impresora. La asignación de una configuración a una impresora permite que el sistema ejecute comprobaciones de conformidad y de aplicación. Para obtener más información, consulte  . En el menú  Impresoras , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Configurar Asignar configuraciones . En la sección  Configuración , seleccione una configuración. Si se ha establecido el sistema en  Utilizar Markvision para gestionar los certificados de dispositivo , seleccione  Confiar en los dispositivos seleccionados . Con esta confirmación, el usuario puede verificar que las impresoras son dispositivos reales y no están suplantados. Haga clic en  Asignar configuraciones . asignación de configuraciones a impresoras configuraciones asignación"},{"UUID":"72ae0002-f41d-4396-9b6f-5dcdffa01514","title":"Administración de impresoras","link":"unassigning-configurations-topic.html","desc":"Desasignación de configuraciones En el","descFull":"Desasignación de configuraciones En el menú Impresoras, haga clic en  Lista de impresoras . Seleccione una o más impresoras. Haga clic en  Configurar Desasignar configuraciones . Haga clic en  Desasignar configuraciones . desasignación de configuraciones configuraciones desasignación"},{"UUID":"3cbe71b5-767a-4e1b-969e-bf08c5e64194","title":"Administración de impresoras","link":"enforcing-configurations-topic.html","desc":"Aplicación de configuraciones MVE ejecuta","descFull":"Aplicación de configuraciones MVE ejecuta una comprobación de conformidad con la impresora. Si algunos ajustes están fuera de conformidad, MVE cambiará los ajustes de la impresora. MVE ejecuta una comprobación de conformidad final tras modificar los ajustes. Las actualizaciones que necesitan que se reinicie la impresora, como las actualizaciones de firmware, es posible que necesiten un segundo reinicio para completarse. Antes de empezar, asegúrese de que se ha asignado una configuración a la impresora. Para obtener más información, consulte  . En el menú  Impresoras  , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Configurar Aplicar las configuraciones . Si la impresora se encuentra en estado de error, es posible que algunos ajustes no se pueden actualizar. Para que MVE implemente archivos de firmware y soluciones en una impresora, el control de acceso a la función Actualizaciones de firmware debe estar establecido en  Sin seguridad . Si se ha aplicado la seguridad, el control de acceso a la función Actualizaciones de firmware debe utilizar la misma plantilla de seguridad que el control de acceso a la función Administración remota. Para obtener más información, consulte  . Se puede programar una tarea de aplicación para que se realice con regularidad. Para obtener más información, consulte  . aplicación de configuraciones configuraciones aplicación"},{"UUID":"d4036d17-d8c6-4a96-9a71-64c2691fadc1","title":"Administración de impresoras","link":"checking-device-conformance-topic.html","desc":"Comprobación de la conformidad de","descFull":"Comprobación de la conformidad de la impresora con una configuración Durante una comprobación de conformidad, MVE comprueba la configuración de la impresora y confirma si coincide con la configuración asignada. MVE no realiza cambios en la impresora durante esta operación. Antes de empezar, asegúrese de que se ha asignado una configuración a la impresora. Para obtener más información, consulte  . En el menú  Impresoras  , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Configurar Comprobar la conformidad . Puede ver los resultados en la página de estado de la tarea. Se puede programar una tarea de comprobación de conformidad para que se realice con regularidad. Para obtener más información, consulte  . comprobación de la conformidad con una configuración cumplimiento comprobación impresora cumplimiento de finalizador con grapado cumplimiento"},{"UUID":"ce5892fc-a092-410c-9d96-ff5bf274a1bb","title":"Administración de impresoras","link":"deploying-files-to-printers-topic.html","desc":"Implementación de archivos en impresoras","descFull":"Implementación de archivos en impresoras Puede implementar los siguientes archivos en la impresora: Certificados CA : archivos  .cer  o  .pem  que se añaden al almacén de confianza de la impresora. Paquete de configuración : archivos  .zip  que se exportan desde una impresora compatible o que se obtienen directamente de Lexmark. Actualización de firmware : un archivo  .fls  que actualiza el firmware de la impresora. Archivo genérico : cualquier archivo que desee enviar a la impresora. Socket básico : se envía mediante el puerto 9100. La impresora lo trata como cualquier otro dato de impresión. FTP : se envía mediante FTP. Este método de implementación no es compatible con las impresoras con seguridad. Certificado de impresora : un certificado firmado instalado en la impresora como certificado predeterminado. Archivo de configuración universal (UCF) : un archivo de configuración exportado desde una impresora. Servicio web : se utiliza el servicio web HTTPS cuando el modelo de impresora es compatible. En caso contrario, la impresora utiliza el servicio web HTTP. FTP : se envía mediante FTP. Este método de implementación no es compatible con las impresoras con seguridad. En el menú  Impresoras  haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Configurar Implementar archivo en impresoras . Haga clic en  Elegir archivo  y, a continuación, busque el archivo. Seleccione un tipo de archivo y un método de implementación. Haga clic en  Implementar archivo . Para que MVE implemente archivos de firmware y soluciones en una impresora, el control de acceso a la función Actualizaciones de firmware debe estar establecido en  Sin seguridad . Si se ha aplicado la seguridad, el control de acceso a la función Actualizaciones de firmware debe utilizar la misma plantilla de seguridad que el control de acceso a la función Administración remota. Se puede programar una tarea de implementación de archivos para que se realice con regularidad. Para obtener más información, consulte  . implementación de archivos en impresoras archivos implementación impresoras implementación de archivos"},{"UUID":"bbf12d9f-c8db-4d29-9290-f4aadef596f0","title":"Administración de impresoras","link":"updating-printer-firmware-topic.html","desc":"Actualización del firmware de la","descFull":"Actualización del firmware de la impresora En el menú  Impresoras , haga clic en  Lista de impresoras . Seleccione una o más impresoras. Haga clic en  Configurar Actualizar firmware en impresoras . Seleccione un archivo de firmware de la biblioteca de recursos o haga clic en  Elegir archivo y, a continuación, busque el archivo de firmware. Para obtener más información sobre la adición de archivos de firmware en la biblioteca, consulte  . Si es necesario, para programar la actualización, seleccione  Definir ventana de actualización y, a continuación, seleccione la fecha de inicio, y las horas de inicio y de pausa. El firmware se envía a las impresoras dentro la hora de inicio y la hora de pausa especificadas. La tarea se pone en pausa después de la hora de pausa y se reanuda en la siguiente hora de inicio, hasta que se haya completado. Haga clic en  Actualizar firmware . Para que MVE actualice el firmware de la impresora, el control de acceso a la función Actualizaciones de firmware debe estar establecido en  Sin seguridad . Si se ha aplicado la seguridad, el control de acceso a la función  Actualizaciones de firmware  debe utilizar la misma plantilla de seguridad que el control de acceso a la función  Administración remota . En este caso, MVE debe gestionar la impresora de forma segura. Para obtener más información, consulte  . actualización del firmware de la impresora firmware de la impresora actualización"},{"UUID":"b4f32db6-984a-421e-85a6-c6088f8779a1","title":"Administración de impresoras","link":"uninstalling-applications-from-devices-topic.html","desc":"Desinstalación de aplicaciones de las","descFull":"Desinstalación de aplicaciones de las impresoras MVE solo puede desinstalar las aplicaciones que se han añadido al sistema en el formato Package Builder. Para obtener más información sobre cómo cargar aplicaciones en el sistema, consulte  . En el menú  Impresoras , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Configurar Desinstalar aplicaciones de las impresoras . Seleccione las aplicaciones. Haga clic en  Desinstalar aplicaciones . desinstalación de aplicaciones de las impresoras aplicaciones desinstalación"},{"UUID":"84051b46-ae8d-49ca-bed8-7e2236dd6931","title":"Administración de impresoras","link":"assigning-events-to-device-topic.html","desc":"Asignación de eventos a impresoras","descFull":"Asignación de eventos a impresoras La asignación de eventos a impresoras permite a MVE realizar la acción asociada cada vez que se produce una de las alertas asociadas en la impresora asignada. Para obtener más información sobre la creación de eventos, consulte  . Los eventos solo pueden asignarse a impresoras sin seguridad. En el menú Impresoras, haga clic en  Lista de impresoras . Seleccione una o más impresoras. Haga clic en  Asignar eventos . Seleccione uno o más eventos. Si algunas de las impresoras seleccionadas ya tienen el evento asignado, aparecerá un guion en la casilla de verificación. Si lo deja como un guion, el evento no cambia. Si selecciona la casilla de verificación, el evento se asignará a todas las impresoras seleccionadas. Si desactiva la casilla de verificación, el evento dejará de estar asignado a las impresoras a las que estaba asignado. Haga clic en  Asignar eventos . asignación de eventos a impresoras eventos asignar impresoras eventos"},{"UUID":"a72fafed-9867-49f6-9d25-97d244027abc","title":"Administración de impresoras","link":"assigning-keyword-topic.html","desc":"Asignar palabras clave a impresoras","descFull":"Asignar palabras clave a impresoras La asignación de palabras clave a impresoras le permite organizar sus impresoras. Para obtener más información sobre la creación de palabras clave, consulte  . En el menú Impresoras, haga clic en  Lista de impresoras . Seleccione una o más impresoras. Haga clic en  Asignar palabras clave . Si es necesario, en el menú Ver, seleccione una categoría. Seleccione una o más palabras clave. Las palabras clave se enumeran según una categoría. Si algunas de las impresoras seleccionadas ya tienen la palabra clave asignada, aparecerá un guion en la casilla de verificación. Si deja el guion, no se asignará ni desasignará la palabra clave a las impresoras seleccionadas. Si selecciona la casilla de verificación, la palabra clave se asignará a todas las impresoras seleccionadas. Si desactiva a casilla de verificación, la palabra clave dejará de estar asignada a las impresoras a las que estaba asignada. Haga clic en  Asignar palabras clave . asignación de una palabra clave clave asignar"},{"UUID":"21cb1fe8-3b6b-478b-ba5a-dac847bd2ce8","title":"Administración de impresoras","link":"entering-credentials-secured-printers-topic.html","desc":"Introducción de las credenciales para","descFull":"Introducción de las credenciales para impresoras protegidas Las impresoras protegidas pueden detectarse e inscribirse. Para comunicarse con estas impresoras, puede aplicar una configuración o introducir las credenciales directamente en MVE. Una impresora es segura cuando aparece un   junto a ella. Para introducir las credenciales, siga estas instrucciones: En el menú  Impresoras , haga clic en  Lista de impresoras . Seleccione una o más impresoras protegidas. Haga clic en  Seguridad Introducir credenciales . Seleccione el método de autenticación e introduzca las credenciales. Haga clic en  Introducir credenciales . Las impresoras inscritas que se encuentran protegidas pero no cuentan con las credenciales correctas guardadas en MVE se etiquetan como  Faltan las credenciales  en el filtro  Comunicaciones . Después de introducir las credenciales correctas, las impresoras se etiquetan como  Protegida . introducción de las credenciales para impresoras protegidas credenciales introducción impresoras protegidas autenticación"},{"UUID":"9ae098e4-3e16-4425-be8d-c6eef505b124","title":"Administración de impresoras","link":"configuring-printer-certificates-manually-topic.html","desc":"Configuración de los certificados de","descFull":"Configuración de los certificados de la impresora predeterminada de forma manual Cuando no utilice la función de administración de certificados automatizados, MVE puede ayudarle a facilitar el proceso de firma del certificado de la impresora predeterminada en una flota de impresoras. MVE reúne las solicitudes de firma de certificado de la flota y, una vez que los certificados están firmados, los implementa en las impresoras correspondientes. Un administrador del sistema debe realizar las siguientes acciones: Genere las solicitudes de firma de certificado de la impresora. En el menú  Impresoras , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Seguridad Generar solicitudes de firma de certificado de impresora . Al generar solicitudes de firma de certificado se puede seleccionar una o más impresoras, pero solo puede haber un conjunto de solicitudes a la vez. Para evitar que se sobrescriba alguna solicitud existente de firma de certificado, debe descargar las solicitudes de firma de certificado antes de generar otro conjunto. Espere a que finalice la tarea y, a continuación, descargue las solicitudes de firma de certificado de impresora. En el menú  Impresoras , haga clic en  Listado de impresoras . Haga clic en  Seguridad Descargar solicitudes de firma de certificado de impresora . Utilice una CA de confianza para firmar las solicitudes de firma de certificado. Guarde los certificados firmados en un archivo ZIP. Todos los certificados firmados deben estar en la ubicación raíz del archivo ZIP. De lo contrario, MVE no podrá analizar el archivo. En el menú  Impresoras , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Configurar Implementar archivo en impresoras . Haga clic en  Elegir archivo  y, a continuación, busque el archivo ZIP. En el menú  Tipo de archivo , seleccione  Certificados de impresora . Haga clic en  Implementar archivo . configuración de los certificados de la impresora de forma manual certificados de impresora configuración manual"},{"UUID":"b97a939d-f10e-4463-8865-2813c64de153","title":"Administración de impresoras","link":"removing-printers-topic.html","desc":"Eliminación de impresoras En el","descFull":"Eliminación de impresoras En el menú  Impresoras , haga clic en  Listado de impresoras . Seleccione una o más impresoras. Haga clic en  Impresora . Si es necesario, para eliminar el certificado de la impresora, seleccione  Eliminar certificados de dispositivo asociados . Si MVE administra los certificados de dispositivo, al eliminar el certificado de la impresora se elimina el certificado predeterminado de la impresora. En ese caso, la impresora genera un nuevo certificado firmado automáticamente. Para ello, realice una de las siguientes acciones: Para mantener la información de la impresora, haga clic en  Retirar impresora . Para eliminar la impresora del sistema, haga clic en  Eliminar impresora . eliminación de impresoras impresoras eliminación"},{"UUID":"4e3a9529-5a95-403c-ad5c-77a0f5c01a08","title":"Administración de configuraciones","link":"managing-configurations-overview-topic.html","desc":"Descripción general MVE emplea configuraciones","descFull":"Descripción general MVE emplea configuraciones para administrar las impresoras de su flota. Una configuración es una recopilación de valores que pueden asignarse y aplicarse a una impresora o a un grupo de modelos de impresora. Dentro de una configuración, puede modificar los valores de la impresora e implementar aplicaciones, licencias, firmware y certificados de impresoras. Puede crear una configuración que se componga de: Valores básicos de la impresora Valores de seguridad avanzada Permisos de impresión en color Este ajuste solo está disponible en las configuraciones de las impresoras en color compatibles. Firmware de la impresora Aplicaciones certificados CA Archivos de recurso Al utilizar configuraciones, puede hacer lo siguiente para administrar las impresoras: Asigne una configuración a las impresoras. Aplique las configuraciones a las impresoras. Los valores especificados en la configuración se aplican a las impresoras. Se instala el firmware, las aplicaciones, el certificado de impresora, los archivos de aplicación (.fls) y los certificados de CA. Compruebe la conformidad de las impresoras con una configuración. Si una impresora no es conforme, se le puede aplicar la configuración. La aplicación de la configuración y la comprobación de conformidad se pueden programar para que tengan lugar de forma periódica. Si la impresora admite los ajustes de configuración pero los valores no son aplicables, la impresora se muestra como no conforme. administración de configuraciones descripción general administración de configuraciones configuraciones administración"},{"UUID":"cde367dc-d0b6-496d-a215-451d20f78bfb","title":"Administración de configuraciones","link":"creating-configuration-topic.html","desc":"Creación de una configuración Una","descFull":"Creación de una configuración Una configuración es una recopilación de valores que se pueden asignar y aplicar a una impresora o a un grupo de impresoras. Dentro de una configuración, se pueden modificar los valores de la impresora e implementar aplicaciones, licencias, firmware y certificados CA en las impresoras. En el menú  Configuraciones , haga clic en  Todas las configuraciones Crear . Escriba un nombre exclusivo para la configuración y su descripción. En la ventana  Ajuste , realice una o varias de las siguientes acciones: En la pestaña  Básicas , seleccione uno o más ajustes y, a continuación, especifique los valores. Si el valor es un ajuste variable, incluya el encabezado con  ${} . Por ejemplo,  ${Contact_Name} . Para utilizar un archivo de ajustes variables, selecciónelo en el menú  Usar archivo de datos de configuración de variables  o impórtelo. Para obtener más información, consulte  . Seleccionar uno o más ajustes y luego especificar los valores. Si el valor es un ajuste variable, incluya el encabezado con  ${} . Por ejemplo,  ${Contact_Name} . Para utilizar un archivo de ajustes variables, selecciónelo en el menú  Usar archivo de datos de configuración de variables  o impórtelo. Para obtener más información, consulte  . Si se agregan uno o más certificados a esta configuración, puede seleccionar cualquiera de los certificados en el menú desplegable  Valor . En la pestaña  Seguridad avanzada , seleccione un componente de seguridad avanzada. Para crear un componente de seguridad avanzada, consulte  . Solo puede administrar la configuración de seguridad avanzada cuando se crea una configuración a partir de una impresora seleccionada. Para obtener más información, consulte  . Configure los ajustes en la pestaña  Permisos de impresión en color . Para obtener más información, consulte  . Este ajuste solo está disponible en las configuraciones de las impresoras en color compatibles. En la pestaña  Firmware , seleccione un archivo de firmware. Si una configuración contiene varias versiones del mismo firmware, durante la conformidad y la aplicación solo se tiene en cuenta la versión superior del firmware. Para importar un archivo de firmware, consulte  . En la pestaña  Aplicaciones  seleccione una o más aplicaciones que desee implementar. Para obtener más información, consulte  . MVE no admite la implementación de aplicaciones con licencias de prueba. Solo puede implementar aplicaciones gratuitas o aplicaciones con licencias de producción. En la pestaña  Certificados , seleccione uno o más certificados que desee implementar. Para importar un archivo de certificado, consulte  . Seleccione  Utilizar Markvision para gestionar los certificados de dispositivo  para que MVE evalúe los certificados que falten, que no sean válidos, que estén caducados o que se hayan revocado, y los reemplace de forma automática. Seleccione una de las siguientes opciones: Certificado de dispositivo predeterminado Certificado de dispositivo con nombre De forma predeterminada, un usuario puede agregar 10 certificados con nombre por instalación de MVE y 5 certificados con nombre por configuración de MVE. Para obtener más información, consulte  . En la pestaña  Archivos de recurso , seleccione cualquiera de los siguientes tipos de archivo para implementar: Archivo de aplicación (.fls) Paquete de configuración (.zip) Archivo de configuración universal (.ucf) Cualquier opción de la pestaña de recursos no está verificada para su conformidad. No recomendamos utilizar varios paquetes de configuración y UCF en una sola configuración. Este método no se aplica a los archivos UCF al configurar la digitalización a la red en impresoras anteriores. Los archivos UCF se deben implementar mediante la acción  Implementar archivo en impresora . Haga clic en  Crear configuración . La siguiente lista muestra la secuencia de implementación en una configuración: Certificados CA Archivos de aplicación Paquetes de soluciones Seguridad avanzada Certificados de dispositivo Valores básicos Paquete de configuración y UCF Firmware creación de una configuración configuración creación"},{"UUID":"f750e5e3-d598-452a-aeee-c461e22c7f0e","title":"Administración de configuraciones","link":"creating-configuration-from-printer-topic.html","desc":"Creación de una configuración desde","descFull":"Creación de una configuración desde una impresora No se incluyen los siguientes componentes: Firmware de la impresora Aplicaciones Certificados Para añadir el firmware, las aplicaciones y los certificados, edite la configuración en MVE. En el menú  Impresoras , haga clic en  Lista de impresoras . Seleccione la impresora y haga clic en  Configurar Crear configuración desde impresora . Si fuera necesario, seleccione  Incluir valores de seguridad avanzada  para crear un componente de seguridad avanzada desde la impresora seleccionada. Si la impresora está protegida, seleccione el método de autenticación e introduzca las credenciales. Escriba un nombre exclusivo para la configuración y su descripción y haga clic en  Crear configuración . En el menú  Configuraciones , haga clic en  Todas las configuraciones . Seleccione la configuración y haga clic en  Editar . Si es necesario, modifique los ajustes. Haga clic en  Guardar cambios . creación de una configuración desde una impresora configuración creación"},{"UUID":"cf40a159-0ed1-4aa7-be2f-c905d4f2f9fb","title":"Administración de configuraciones","link":"sample-scenario-cloning-configurations-topic.html","desc":"Caso de ejemplo: clonación de","descFull":"Caso de ejemplo: clonación de una configuración Se han añadido 15 impresoras Lexmark MX812 al sistema tras la detección. Como personal del equipo de TI, debe aplicar los valores de las impresoras existentes a las nuevas. También puede clonar una configuración de una impresora y, a continuación, aplicar la configuración a un grupo de modelos de impresora. Implementación de ejemplo En la lista de impresoras existentes, seleccione una impresora Lexmark MX812. Cree una configuración desde la impresora. Para proteger las impresoras, incluya los valores de seguridad avanzada. Asigne y, a continuación, aplique dicha configuración a las impresoras recién detectadas. clonación de configuraciones caso de ejemplo caso de ejemplo de clonación de configuraciones"},{"UUID":"966907eb-c04e-405e-a28b-522a3c32d240","title":"Administración de configuraciones","link":"creating-advanced-security-component-topic.html","desc":"Creación de un componente de","descFull":"Creación de un componente de seguridad avanzada desde una impresora Cree un componente de seguridad avanzada desde una impresora para gestionar los valores de seguridad avanzada. MVE lee todos los valores de esa impresora y, a continuación, crea una configuración que incluye los valores. El componente puede estar asociado a varias configuraciones para modelos de impresora con el mismo marco de seguridad. En el menú  Impresoras , haga clic en  Listado de impresoras . Seleccione la impresora y haga clic en  Configuración Crear componente de seguridad avanzada desde la impresora . Introduzca un nombre exclusivo para el componente y su descripción. Si la impresora está protegida, seleccione el método de autenticación e introduzca las credenciales. Haga clic en  Crear componente . Cuando crea y aplica una configuración con un componente de seguridad avanzada que contiene cuentas locales, dichas cuentas locales se añaden a las impresoras. Se conservarán las cuentas locales existentes preconfiguradas en la impresora. creación de un componente de seguridad avanzada desde una impresora componente de seguridad avanzada creación"},{"UUID":"f6dd80e4-af7d-49bb-8f3c-a3e0bb8c40ae","title":"Administración de configuraciones","link":"generating-printable-version-topic.html","desc":"Generación de una versión para","descFull":"Generación de una versión para imprimir de la configuración Edite una configuración o un componente de seguridad avanzada. Haga clic en  Versión para imprimir . valores de configuración versión para imprimir"},{"UUID":"ddb1f431-70fb-45fe-aac0-58b580f07d6c","title":"Administración de configuraciones","link":"understanding-dynamic-settings-topic.html","desc":"Descripción de los ajustes dinámicos","descFull":"Descripción de los ajustes dinámicos Estas opciones incluyen Certificado de dispositivo 802.1x, Certificado de dispositivo HTTPS y Certificado de dispositivo IPSec, que se enumeran en la pestaña  Básico  de una configuración. Las opciones de cada una de estos ajustes se rellenan con los certificados seleccionados en la pestaña  Certificado . Al clonar, exportar o importar una configuración, se borran los valores preseleccionados de estos ajustes. Debe seleccionar los valores manualmente. ajustes dinámicos descripción"},{"UUID":"47857be3-7b70-4457-9c9d-8c579b9eaccc","title":"Administración de configuraciones","link":"understanding-variable-settings-topic.html","desc":"Descripción de los ajustes de","descFull":"Descripción de los ajustes de variables La configuración de variables le permite administrar la configuración en toda su flota que es exclusiva de cada impresora, como el nombre del host o la etiqueta de activos. Al crear o editar una configuración, puede seleccionar un archivo CSV que asociar con la configuración. Ejemplo de formato de CSV: \nIP_ADDRESS,Contact_Name,Address,Disp_Info\n1.2.3.4,John Doe,1600 Penn. Ave., Blue\n4.3.2.1,Jane Doe,1601 Penn. Ave., Red\n2.3.6.5,\"Joe, Jane and Douglas\",1601 Penn. Ave.,Yellow\n2.3.6.7,\"Joe, Jane and Douglas\",1600 Penn. Ave.,He is 6’7” tall En la fila de encabezado del archivo variable, la primera columna es un identificador token de impresora exclusivo. El token debe contener uno de los siguientes elementos: HOSTNAME IP_ADDRESS SYSTEM_NAME SERIAL_NUMBER Cada una de las columnas en el encabezado del archivo variable es un token de sustitución definido por el usuario. Se debe hacer referencia a este token en la configuración utilizando el formato ${HEADER}. Se sustituye por los valores de las filas posteriores cuando se aplica la configuración. Asegúrese de que los tokens no contienen ningún espacio. Puede importar el archivo CSV que contiene los ajustes de variables al crear o editar una configuración. Para obtener más información, consulte  . configuración de variables descripción importar CSV configuración de variables exportación de CSV configuración de variables CSV configuración de variables"},{"UUID":"0e5591bf-0007-4a30-96c0-b4851db32721","title":"Administración de configuraciones","link":"configuring-color-permissions-topic.html","desc":"Configuración de los permisos de","descFull":"Configuración de los permisos de impresión en color MVE le permite restringir la impresión en color para ordenadores host y usuarios específicos. Este ajuste solo está disponible en las configuraciones de las impresoras en color compatibles. En el menú Configuraciones, haga clic en  Todas las configuraciones . Cree o edite una configuración. En la pestaña Permisos de impresión en color, realice una de las siguientes acciones: Configurar los permisos de impresión en color para los ordenadores host En el menú Ver, seleccione  Ordenadores host  y, a continuación, seleccione  Incluir permisos de impresión en color para ordenadores host . Haga clic en  Agregar  y, a continuación, escriba el nombre del ordenador host. Para permitir que el ordenador host imprima en color, seleccione  Permitir impresión en color . Para permitir imprimir en color a los usuarios que inician sesión en el ordenador host, seleccione  Anular el permiso del usuario . Haga clic en  Guardar y agregar  o  Guardar . Configurar los permisos de impresión en color para los usuarios En el menú Ver, seleccione  Usuarios  y, a continuación, seleccione  Incluir permisos de impresión en color para usuarios . Haga clic en  Agregar  y, a continuación, escriba el nombre del usuario. Seleccione  Permitir impresión en color . Haga clic en  Guardar y agregar  o  Guardar . configuración de los permisos de impresión en color impresión en color, permisos configuración"},{"UUID":"a7905110-295f-4d95-819c-8b7e0a688dec","title":"Administración de configuraciones","link":"creating-applications-package-topic.html","desc":"Creación de un paquete de","descFull":"Creación de un paquete de aplicaciones Inicie sesión en el Generador de paquetes en  iss.lexmark.com/cdp/package-builder . En la página  Paquetes , haga clic en  Crear paquete . En la página  Crear paquete , introduzca el nombre del paquete. Haga clic en  Añadir producto , seleccione un producto y, a continuación, haga clic en  Añadir producto . Si es necesario, seleccione  Canjear un código de activación para un producto con licencia  . Haga clic en  Crear paquete . Descargue el paquete realizando una de las siguientes acciones: Haga clic en el nombre del paquete y, a continuación, haga clic en  Descargar . En la columna  Descargar paquete , haga clic en  Descargar . MVE no admite la implementación de aplicaciones con licencias de prueba. Solo puede implementar aplicaciones gratuitas o aplicaciones con licencias de producción. Si necesita códigos de activación, póngase en contacto con su representante de Lexmark. Para agregar las aplicaciones a una configuración, importe el paquete de aplicaciones a la biblioteca de recursos. Para obtener más información, consulte  . creación de un paquete de aplicaciones paquete de aplicaciones creación"},{"UUID":"2349b51b-e298-496b-810f-5e94d33a5398","title":"Administración de configuraciones","link":"importing-exporting-configuration-file-topic.html","desc":"Importación o exportación de una","descFull":"Importación o exportación de una configuración Antes de comenzar, al importar un archivo de configuración, asegúrese de que se ha exportado desde un MVE de la misma versión. En el menú  Configuraciones , haga clic en  Todas las configuraciones . Para ello, realice una de las siguientes acciones: Para importar un archivo de configuración, haga clic en  Importar , desplácese hasta el archivo de configuración y, a continuación, haga clic en  Importar . Para exportar un archivo de configuración, seleccione una configuración y, a continuación, haga clic en  Exportar . Al exportar una configuración, las contraseñas no se incluyen. Después de la importación, añada manualmente las contraseñas. Los UCF, paquetes de configuración y archivos de aplicación no forman parte de una configuración exportada. exportación o importación de una configuración configuración importación configuración exportación"},{"UUID":"9c95883f-9b59-4584-8185-4e9a03544e59","title":"Administración de configuraciones","link":"importing-files-to-resource-library-topic.html","desc":"Importación de archivos a la","descFull":"Importación de archivos a la biblioteca de recursos La biblioteca de recursos es una colección de archivos de firmware, certificados de CA y paquetes de aplicaciones que se importan a MVE. Estos archivos pueden asociarse con una o más configuraciones. En el menú  Configuraciones , haga clic en  Biblioteca de recursos . Haga clic en  Importar  Elegir archivo  y, a continuación, busque el archivo. Solo se pueden importar archivos de firmware (.fls), archivos de aplicaciones (.fls), paquetes de aplicaciones o paquetes de configuración (.zip), certificados de CA (.pem) y archivos de configuración universal (.ucf). Haga clic en  Importar recurso . importación de archivos a la biblioteca de recursos biblioteca de recursos importar archivos a importación de archivos a la biblioteca de recursos"},{"UUID":"a96ed728-23d7-4aa9-8f46-c9da4f3eb707","title":"Configuración de MVE para gestionar certificados de forma automática","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Descripción de la función de","descFull":"Descripción de la función de administración automática de certificados Puede configurar MVE para gestionar certificados de impresora de forma automática y, a continuación, instalarlos en las impresoras mediante la aplicación de la configuración. El siguiente diagrama describe el proceso completo de la función de administración automática de certificados. Los puntos finales de la autoridad de certificación, como el servidor de la CA y la dirección del servidor, deben establecerse en MVE. Los servidores de la CA siguientes son compatibles: CA de OpenXPKI : los usuarios pueden utilizar cualquiera de los siguientes protocolos: Protocolo de cifrado de certificados seguro (SCEP) Conector de EST EST es la forma recomendada de conectarse al servidor de OpenXPKI. Para obtener más información sobre la configuración de la CA de OpenXPKI mediante el protocolo EST, consulte  Para obtener más información sobre la configuración de la CA de OpenXPKI mediante el protocolo SCEP, consulte  CA de Microsoft Enterprise : los usuarios pueden utilizar cualquiera de los siguientes protocolos Protocolo de cifrado de certificados seguro (SCEP) Servicios web de inscripción de certificados de Microsoft (MSEWS) MSCEWS es la forma recomendada de conectarse al servidor de la CA de Microsoft Enterprise. Para obtener más información sobre la configuración de la CA de Microsoft mediante el protocolo MSCEWS, consulte  Para obtener más información sobre la configuración de la CA de Microsoft mediante el protocolo SCEP, consulte  Debe validarse la conexión entre MVE y los servidores de la CA. Durante la validación, MVE se comunica con el servidor de la CA para descargar la cadena de certificados y la lista de revocación de certificados (CRL). También se genera el certificado de agente de inscripción o el certificado de prueba. Este certificado permite al servidor de la CA confiar en MVE. Para obtener más información sobre la definición de los puntos finales y su validación, consulte  . Una configuración establecida en  Utilizar Markvision para gestionar los certificados de dispositivo  debe asignarse y aplicarse en la impresora. Para obtener más información, consulte los siguientes temas: Durante la aplicación, MVE comprueba la conformidad de la impresora. Para el  certificado de dispositivo predeterminado El certificado se valida con respecto a la cadena de certificados descargada del servidor de la CA. Si la impresora no cumple los requisitos, se pide una solicitud de firma de certificado (CSR) para dicha impresora. Para el  certificado de dispositivo con nombre El certificado se valida con respecto a la cadena de certificados descargada del servidor de la CA. MVE crea un certificado de dispositivo con nombre firmado automáticamente en el dispositivo. Si la impresora no cumple los requisitos, se pide una CSR para dicha impresora. MVE se comunica con el servidor de la CA mediante los protocolos compatibles. El servidor de la CA genera el nuevo certificado y, a continuación, MVE envía el certificado a la impresora. Si existe un certificado con nombre en la impresora, no se crea un nuevo certificado con nombre, sino que se genera una CSR para la impresora. función de administración de certificados automatizados administración de certificados"},{"UUID":"b5bc935f-1e46-4b5a-8266-e08a7389df39","title":"Configuración de MVE para gestionar certificados de forma automática","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Configuración de MVE para la","descFull":"Configuración de MVE para la administración automática de certificados Haga clic en  , en la esquina superior derecha de la página. Haga clic en  Autoridad de certificación Utilizar el servidor de la autoridad de certificación . El botón  Utilizar el servidor de la autoridad de certificación  solo aparecerá cuando configure la autoridad de certificación por primera vez o cuando elimine el certificado. Configure los puntos finales del servidor. Servidor de la CA : es el servidor de la autoridad de certificación (CA) que genera los certificados de la impresora. Seleccione una de las siguientes opciones: CA de OpenXPKI CA de Microsoft Enterprise El usuario también puede configurar un servidor de la CA compatible con el protocolo  Enrollment over Secure Transport (EST) . El servidor de la CA debe implementar el protocolo EST tal como se define en RFC 7030. Cualquier desviación de la especificación puede dar lugar a una configuración no válida. EST es el protocolo recomendado para conectarse al servidor de la CA de OpenXPKI. El servidor de Microsoft Enterprise no es compatible con el protocolo EST. Dirección del servidor de la CA : es la dirección IP o el nombre de host del servidor de la CA. Este campo solo se aplica a los protocolos SCEP y EST. Introduzca una de las siguientes opciones: Para el servidor MSCA (mediante SCEP): <dirección IP del servidor o nombre de host>/certsrv/mssep/mssep.dll Para el servidor OpenXPKI (mediante SCEP): <dirección IP del servidor o nombre de host>/scep/scep Para EST, escriba cualquiera de las siguientes opciones: https://172.87.95.240 https://estserver.com estserver.com Etiqueta de servidor de la CA (opcional) : si el usuario crea un nuevo dominio, se debe usar el mismo nombre de dominio en este campo. Dirección del servidor del CEP : este campo solo se aplica al protocolo MSCEWS. Introduzca una de las siguientes opciones: Autenticación de nombre de usuario y contraseña: https://democep.com/ADPolicyProvider_CEP_UsernamePassword/service.svc/CEP Para autenticación integrada de Windows: https://democep.com/ADPolicyProvider_CEP_Kerberos/service.svc/CEP Para autenticación de certificado de cliente: https://democep.com/ADPolicyProvider_CEP_Certificate/service.svc/CEP Nombre de host del servidor de la CA : es el nombre de host del servidor de la CA. Por ejemplo, para el protocolo MSCEWS, el usuario puede seleccionar  democa.lexmark.com Nombre de host del servidor del CES : es la dirección IP o el nombre de host del servidor del CES. Por ejemplo, para el protocolo MSCEWS, el usuario puede seleccionar  democes.lexmark.com Contraseña de comprobación : es la contraseña necesaria para confirmar la identidad de MVE en el servidor de la CA. Esta contraseña sólo es necesaria para la CA OpenXPKI. No es compatible con la CA de Microsoft Enterprise. En función del servidor de la CA, debe configurar el modo de autenticación del servidor. Para ello, realice una de las siguientes acciones: Si selecciona el protocolo  EST , en el menú  Modo de autenticación del servidor de la CA , seleccione una de las siguientes opciones: Autenticación de nombre de usuario y contraseña Autenticación de certificado de cliente Si selecciona el protocolo  MSCEWS , en el menú  Modo de autenticación del servidor de la CA , seleccione una de las siguientes opciones: Autenticación de nombre de usuario y contraseña Autenticación de certificado de cliente Autenticación integrada de Windows El protocolo  SCEP  solo admite el modo de autenticación  Contraseña de comprobación . Dependiendo del servidor de la CA, consulte cualquiera de las secciones: Haga clic en  Guardar cambios y validar Aceptar . La opción  Descartar cambios  solo funciona si los cambios aún no se han guardado o se han guardado y validado. El usuario no puede recuperar datos de una configuración no válida porque MVE no almacena el último estado válido de ninguna configuración. MVE solo almacena una configuración de certificado individual a la vez, que puede ser o no válida. Debe validarse la conexión entre MVE y los servidores de la CA. Durante la validación, MVE se comunica con el servidor de la CA para descargar la cadena de certificados y la lista de revocación de certificados (CRL). También se genera el certificado de agente de inscripción o el certificado de prueba. Este certificado permite al servidor de la CA confiar en MVE. Puede seleccionar una o varias plantillas CEP cuando utilice el protocolo MSCEWS. Haga lo siguiente: Después de hacer clic en  Guardar cambios y validar , aparece la ventana Selección de plantilla CEP. Seleccione una o más de las plantillas disponibles. El cuadro de diálogo Utilizar el servidor de la autoridad certificadora recupera la lista de revocaciones de certificados. Un cuadro de diálogo confirma que la validación del certificado se ha realizado correctamente. Puede ver las plantillas del CEP seleccionadas en la página de configuración del servidor de la CA. Cuando aplica esta configuración a cualquier dispositivo, se crea un certificado según la plantilla seleccionada. Vuelva a la página  Configuración del sistema  y, a continuación, revise el certificado CA. También puede descargar o eliminar el certificado CA. configuración de MVE para la administración de certificados automatizados administración de certificados automatizados configuración"},{"UUID":"290cf505-122b-46bf-81aa-639c8e265c2b","title":"Configuración de la CA de Microsoft Enterprise con NDES","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Descripción general En el siguiente","descFull":"Descripción general En el siguiente escenario de implementación, todos los permisos se basan en los permisos definidos en las plantillas de certificado publicadas en el controlador de dominio. Las solicitudes de certificado enviadas a la CA se basan en las plantillas de certificado. Para esta configuración, asegúrese de que dispone de lo siguiente: Un equipo que aloja la CA subordinada Un equipo que aloja el servicio NDES Un controlador de dominio Usuarios necesarios Cree los siguientes usuarios en el controlador de dominio: Administrador del servicio Denominado  SCEPAdmin Debe ser miembro de los grupos  local admin  y  Enterprise Admin Debe estar registrado localmente cuando se active la instalación de la función NDES Dispone de  permiso de inscripción  para las plantillas de certificado Dispone de  permiso para agregar plantillas  en la CA Cuenta de servicio Denominada  SCEPSvc Debe ser miembro del grupo  IIS_IUSRS  local Debe ser un usuario de dominio y disponer de los permisos de  escritura  e  inscripción  en las plantillas configuradas Dispone de permiso de  solicitud  en la CA Administrador de CA de Enterprise Denominado  CAAdmin Miembro del grupo  Administrador de Enterprise Debe formar parte del grupo  administrador local configuración de la CA de Microsoft Enterprise con NDES descripción general CA de Microsoft Enterprise con NDES configuración"},{"UUID":"08437e16-e7a2-4c7b-ba72-8af836ed5349","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Descripción general El servidor de","descFull":"Descripción general El servidor de la CA raíz es el servidor de la CA principal de cualquier organización y el principal de la infraestructura PKI. La CA raíz autentica el servidor de la CA subordinada. Este servidor se mantiene generalmente en modo sin conexión para evitar cualquier intrusión y para proteger la clave privada. Para configurar el servidor de la CA raíz, haga lo siguiente: Asegúrese de que el servidor de la CA raíz está instalado. Para obtener más información, consulte  . Configure los ajustes de punto de distribución de certificación y acceso a la información de entidad. Para obtener más información, consulte  . Configure la accesibilidad de la CRL. Para obtener más información, consulte  . descripción general configuración del servidor de la CA raíz descripción general de la configuración del servidor de la CA raíz"},{"UUID":"dffdc297-099f-4e60-82f0-2d55f091f0cb","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Instalación del servidor de la","descFull":"Instalación del servidor de la CA raíz En Server Manager, haga clic en  Administrar  Agregar roles y características . Haga clic en  Funciones de servidor , seleccione  Servicios de certificados de Active Directory  y todas sus características y, a continuación, haga clic en  Siguiente . En la sección  Servicios de función AD CS , seleccione  Entidad de certificación  y, a continuación, haga clic en  Siguiente  Instalar . Después de la instalación, haga clic en  Configurar Servicios de Certificate Server de Active Directory en el servidor de destino . En la sección  Servicios de función , seleccione  Entidad de certificación  Siguiente . En la sección  Tipo de configuración , seleccione  CA independiente  y, a continuación, haga clic en  Siguiente . En la sección  Tipo de CA , seleccione  CA raíz  y, a continuación, haga clic en  Siguiente . Seleccione  Crear una nueva clave privada  y, a continuación, haga clic en  Siguiente . En el menú  Seleccione un proveedor de criptografía , seleccione  RSA#Microsoft Software Key Storage Provider . En el menú  Longitud de la clave , seleccione  4096 . En la lista de algoritmos hash, seleccione  SHA512  y, a continuación, haga clic en  Siguiente . En el campo  Nombre común de esta CA , escriba el nombre del servidor host. En el campo  Sufijo de nombre distinguido , escriba el componente de dominio. Ejemplo de configuración de nombre de CA Nombre de dominio completamente cualificado (FQDN) del equipo:  test.dev.lexmark.com Nombre común (CN):  TEST Sufijo de nombre distinguido:  DC=DEV,DC=LEXMARK,DC=COM Haga clic en  Siguiente . Especifique el período de validez y, a continuación, haga clic en  Siguiente . Normalmente, el período de validez es de 10 años. No cambie nada en la ventana de ubicaciones de la base de datos. Complete la instalación. instalación de servidores de la CA raíz servidores de la CA raíz instalación"},{"UUID":"2cb224fc-cefc-4160-9808-e105abff0362","title":"Configuración de la CA de Microsoft Enterprise con NDES","link":"managing-certificates-using-SCEP-group.html","desc":"Descripción general En el siguiente","descFull":"Descripción general En el siguiente escenario de implementación, todos los permisos se basan en los permisos definidos en las plantillas de certificado publicadas en el controlador de dominio. Las solicitudes de certificado enviadas a la CA se basan en las plantillas de certificado. Para esta configuración, asegúrese de que dispone de lo siguiente: Un equipo que aloja la CA subordinada Un equipo que aloja el servicio NDES Un controlador de dominio Usuarios necesarios Cree los siguientes usuarios en el controlador de dominio: Administrador del servicio Denominado  SCEPAdmin Debe ser miembro de los grupos  local admin  y  Enterprise Admin Debe estar registrado localmente cuando se active la instalación de la función NDES Dispone de  permiso de inscripción  para las plantillas de certificado Dispone de  permiso para agregar plantillas  en la CA Cuenta de servicio Denominada  SCEPSvc Debe ser miembro del grupo  IIS_IUSRS  local Debe ser un usuario de dominio y disponer de los permisos de  escritura  e  inscripción  en las plantillas configuradas Dispone de permiso de  solicitud  en la CA configuración de la CA de Microsoft Enterprise con NDES descripción general CA de Microsoft Enterprise con NDES configuración"},{"UUID":"da569ad0-9c4e-4e94-8f0c-956f126c580b","title":"Configuración del servidor de la CA subordinada","link":"managing-certificates-using-SCEP-group.html","desc":"Descripción general El servidor de","descFull":"Descripción general El servidor de la CA subordinada es el servidor de la CA intermedia y siempre está en línea. Generalmente se ocupa de la administración de certificados. Para configurar el servidor de la CA subordinada, haga lo siguiente: Asegúrese de que el servidor de la CA subordinada está instalado. Para obtener más información, consulte  . Configure los ajustes de punto de distribución de certificación y acceso a la información de entidad. Para obtener más información, consulte  . Configure la accesibilidad de la CRL. Para obtener más información, consulte  . descripción general configuración del servidor de la CA subordinada descripción general de la configuración del servidor de la CA subordinada"},{"UUID":"e9e8700e-c966-4985-8b48-5e1fb7b0636d","title":"Configuración del servidor de la CA subordinada","link":"managing-certificates-using-SCEP-group.html","desc":"Instalación del servidor de la","descFull":"Instalación del servidor de la CA subordinada En el servidor, inicie sesión como un usuario de dominio  CAAdmin . En Server Manager, haga clic en  Administrar  Agregar roles y características . Haga clic en  Funciones de servidor , seleccione  Servicios de certificados de Active Directory  y todas sus características y, a continuación, haga clic en  Siguiente . En la sección  Servicios de función AD CS , seleccione  Entidad de certificación  e  Inscripción en línea de la entidad de certificación  y, a continuación, haga clic en  Siguiente . Asegúrese de que se han agregado todas las funciones de  Inscripción en línea de la entidad de certificación . En la sección  Función de servidor web (IIS) Servicios de función , conserve la configuración predeterminada. Después de la instalación, haga clic en  Configurar Servicios de Certificate Server de Active Directory en el servidor de destino . En la sección  Servicios de función , seleccione  Entidad de certificación  e  Inscripción en línea de la entidad de certificación  y, a continuación, haga clic en  Siguiente . En la sección  Tipo de configuración , seleccione  CA empresarial  y, a continuación, haga clic en  Siguiente . En la sección  Tipo de CA , seleccione  CA subordinada  y, a continuación, haga clic en  Siguiente . Seleccione  Crear una nueva clave privada  y, a continuación, haga clic en  Siguiente . En el menú  Seleccione un proveedor de criptografía , seleccione  RSA#Microsoft Software Key Storage Provider . En el menú  Longitud de la clave , seleccione  4096 . En la lista de algoritmos hash, seleccione  SHA512  y, a continuación, haga clic en  Siguiente . En el campo  Nombre común de esta CA , escriba el nombre del servidor host. En el campo  Sufijo de nombre distinguido , escriba el componente de dominio. Ejemplo de configuración de nombre de CA Nombre de dominio completamente cualificado (FQDN) del equipo:  test.dev.lexmark.com Nombre común (CN):  TEST Sufijo de nombre distinguido:  DC=DEV,DC=LEXMARK,DC=COM En el cuadro de diálogo  Solicitud de certificado , guarde el archivo de solicitud y, a continuación, haga clic en  Siguiente . No cambie nada en la ventana de ubicaciones de la base de datos. Complete la instalación. Firme la solicitud de CA de la CA raíz y, a continuación, exporte el certificado firmado con el formato PKCS7. En la CA subordinada, abra  Entidad de certificación . En el panel de la izquierda, haga clic con el botón derecho del ratón en la CA y, a continuación, haga clic en  Todas las tareas  Instalar certificado de CA . Seleccione el certificado firmado y, a continuación, inicie el servicio CA. instalación de servidores de la CA subordinada servidores de la CA subordinada instalación"},{"UUID":"1471e9d1-59b0-4fc2-9ba2-1488a6e408d0","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configuración de los ajustes de","descFull":"Configuración de los ajustes de punto de distribución de certificación y acceso a la información de entidad Configure los ajustes de punto de distribución de certificación (CDP) y acceso a la información de entidad (AIA) de la lista de revocación de certificados (CRL). En Server Manager, haga clic en  Herramientas  Entidad de certificación . En el panel de la izquierda, haga clic con el botón derecho del ratón en la CA y, a continuación, haga clic en  Propiedades  Extensiones . En el menú  Seleccionar extensión , seleccione  Puntos de distribución de lista de revocación de certificados (CDP) . En la lista de revocación de certificados, seleccione la entrada  C:\\Windows\\system32\\  y, a continuación, realice lo siguiente: Seleccione  Publicar las listas de revocación de certificados (CRL) en esta ubicación . Desactive  Publicar CRL incrementales en esta ubicación . Elimine todas las demás entradas excepto  C:\\Windows\\system32\\ . Haga clic en  Agregar . En el campo  Ubicación , agregue  http:// serverIP /CertEnroll/<CAName><CRLNameSuffix><DeltaCRLAllowed>.crl , donde  serverIP  es la dirección IP del servidor. Si puede acceder al servidor mediante FQDN, utilice  <ServerDNSName>  en lugar de la dirección IP del servidor. Haga clic en  Aceptar . Seleccione  Incluir en la extensión CDP de los certificados emitidos  para la entrada creada. En el menú  Seleccionar extensión , seleccione  Acceso a la información de entidad (AIA) . Elimine todas las demás entradas excepto  C:\\Windows\\system32\\ . Haga clic en  Agregar . En el campo  Ubicación , agregue  http:// ServerIP /CertEnroll/<ServerDNSName>_<CAName><CertificateName>.crt , donde  ServerIP  es la dirección IP del servidor. Si puede acceder al servidor mediante FQDN, utilice  <ServerDNSName>  en lugar de la dirección IP del servidor. Haga clic en  Aceptar . Seleccione  Incluir en la extensión AIA de los certificados emitidos  para la entrada creada. Haga clic en  Aplicar Aceptar . Si es necesario, reinicie el servicio de certificación. En el panel de la izquierda, expanda la CA, haga clic con el botón derecho del ratón en  Certificados revocados  y, a continuación, haga clic en  Propiedades . Especifique el valor de  Intervalo de publicación de CRL  y de  Publicar Delta Intervalo de publicación de CRL  y, a continuación, haga clic en  Aplicar  Aceptar . En el panel de la izquierda, haga clic con el botón derecho del ratón en  Certificados revocados , haga clic en  Todas las tareas  y, a continuación, publique la CRL  Nuevo . configuración de ajustes del punto de distribución de certificación configuración de ajustes de acceso a la información de entidad Punto de distribución de certificación configuración Acceso a la información de entidad configuración CDP configuración AIA configuración"},{"UUID":"c385fade-aab8-41f2-84b8-79d0e0931a42","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configuración de la accesibilidad de","descFull":"Configuración de la accesibilidad de la CRL Antes de comenzar, asegúrese de que está instalado el Administrador de Internet Information Services (IIS). En el Administrador de IIS, expanda la CA y, a continuación, expanda  Sitios . Haga clic con el botón derecho del ratón en  Sitio web predeterminado  y, a continuación, haga clic en  Agregar directorio virtual . En el campo  Alias , escriba  CertEnroll . En el campo  Ruta física , escriba  C:\\Windows\\System32\\CertSrv\\CertEnroll . Haga clic en  Aceptar . Haga clic con el botón derecho del ratón en  CertEnroll  y, a continuación, haga clic en  Editar permisos . En la pestaña  Seguridad , elimine todos los accesos de escritura excepto para el sistema. Haga clic en  Aceptar . configuración de la accesibilidad de la CRL accesibilidad de la CRL configuración"},{"UUID":"9e7a2751-c71e-4d52-8e1a-1aca3776f5f0","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configuración del servidor NDES En","descFull":"Configuración del servidor NDES En el servidor, inicie sesión como un usuario de dominio  SCEPAdmin . En Server Manager, haga clic en  Administrar  Agregar roles y características . Haga clic en  Funciones de servidor , seleccione  Servicios de certificados de Active Directory  y todas sus características y, a continuación, haga clic en  Siguiente . En la sección  Servicios de función AD CS , desactive  Entidad de certificación . Seleccione  Servicio de inscripción de dispositivos de red  y todas sus características y, a continuación, haga clic  Siguiente . En la sección  Función de servidor web (IIS) Servicios de función , conserve la configuración predeterminada. Después de la instalación, haga clic en  Configurar Servicios de Certificate Server de Active Directory en el servidor de destino . En la sección  Servicios de función , seleccione  Servicio de inscripción de dispositivos de red  y, a continuación, haga clic en  Siguiente . Seleccione la cuenta de servicio  SCEPSvc . En la sección  CA para NDES , seleccione  Nombre de CA  o  Nombre de equipo  y, a continuación, haga clic en  Siguiente . En la sección  Información de RA , especifique la información y, a continuación, haga clic en  Siguiente . En la sección  Criptografía para NDES , haga lo siguiente: Seleccione los proveedores de firma y clave de cifrado adecuados. En el menú  Longitud de la clave , seleccione la misma longitud de clave que el servidor de la CA. Haga clic en  Siguiente . Complete la instalación. Ahora puede acceder al servidor NDES desde un navegador web como un usuario SCEPSvc. En el servidor NDES, puede ver la huella digital del certificado de CA, la contraseña de comprobación de inscripción y el período de validez de la contraseña de comprobación. Acceso al servidor NDES Abra un navegador web y, a continuación, escriba  http:// NDESserverIP /certsrv/mscep_admin , donde  NDESserverIP  es la dirección IP del servidor NDES. configuración de servidores NDES servidores NDES configuración configuración de servidores del servicio de inscripción de dispositivos de red servidores del servicio de inscripción de dispositivos de red configuración"},{"UUID":"f8beffd8-3f33-416e-888c-8113bf391d8a","title":"Configuración de NDES para MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Creación de una plantilla de","descFull":"Creación de una plantilla de certificado En la CA subordinada (certserv), abra  Entidad de certificación . En el panel de la izquierda, expanda la CA, haga clic con el botón derecho del ratón en  Plantillas de certificado  y, a continuación, haga clic en  Administrar . En  Consola de plantillas de certificados , cree una copia de  Servidor web . En la pestaña  General , escriba  MVEWebServer  como nombre de plantilla. En la pestaña  Seguridad , otorgue a los usuarios  SCEPAdmin  y  SCEPSvc  los permisos adecuados. Para obtener más información, consulte  . En la pestaña  Nombre del sujeto , seleccione  Proporcionar en la solicitud . En la CA subordinada (certserv), abra  Entidad de certificación . En la pestaña  Extensiones , seleccione  Directivas de aplicación  Editar . Haga clic en  Agregar  Autenticación del cliente  Aceptar . En el panel de la izquierda, expanda la CA, haga clic con el botón derecho del ratón en  Plantillas de certificado  y, a continuación, haga clic en  Nueva  Plantilla de certificado que se va a emitir . Seleccione los certificados que acaba de crear y, a continuación, haga clic en  Aceptar . Ahora puede acceder a las plantillas mediante el portal web de inscripción de la CA. Acceso a las plantillas Abra un navegador web y, a continuación, escriba  http:// CAserverIP /certsrv/certrqxt.asp , donde  CAserverIP  es la dirección IP del servidor de la CA. En el menú  Plantilla de certificado , vea las plantillas. creación de plantillas de certificado plantillas de certificado creación"},{"UUID":"05890d92-5d5f-47a0-a0c3-7f4aa896e726","title":"Configuración de NDES para MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Definición de plantillas de certificado","descFull":"Definición de plantillas de certificado para NDES En el ordenador, inicie el editor del registro. Desplácese a  SOFTWARE HKEY_LOCAL_MACHINE  Microsoft   Cryptography  MSCEP . Configure lo siguiente y, a continuación, defínalos en  MVEWebServer : EncryptionTemplate GeneralPurposeTemplate SignatureTemplate Otorgue al usuario de SCEPSvc permiso completo para MSCEP. En el Administrador de IIS, expanda la CA y, a continuación, haga clic en  Grupos de aplicaciones . En el panel de la derecha, haga clic en   Reciclar  para reiniciar el grupo de aplicaciones SCEP. En el Administrador de IIS, expanda la CA y, a continuación, expanda  Sitios  Sitio web predeterminado . En el panel de la derecha, haga clic en  Reiniciar . definición de plantillas de certificado para NDES plantillas de certificado para NDES configuración"},{"UUID":"f4ddafe5-d8fe-4fd1-85f4-7b06ebaed89a","title":"Configuración de NDES para MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Desactivación de la  Contraseña","descFull":"Desactivación de la  Contraseña de comprobación  en el servidor de la CA de Microsoft En el ordenador, inicie el editor del registro. Desplácese a  HKEY_LOCAL_MACHINE   SOFTWARE   Microsoft   Cryptography  MSCEP . Defina  Aplicar contraseña  en  0 . En el Administrador de IIS, expanda la CA, haga clic en  Grupos de aplicaciones  y, a continuación, seleccione  SCEP . En el panel de la derecha, haga clic en  Configuración avanzada . Defina  Cargar perfil de usuario  en  Verdadero  y, a continuación, haga clic en  Aceptar . En el panel de la derecha, haga clic en   Reciclar  para reiniciar el grupo de aplicaciones SCEP. En el Administrador de IIS, expanda la CA y, a continuación, expanda  Sitios  Sitio web predeterminado . En el panel de la derecha, haga clic en  Reiniciar . Al abrir NDES desde el navegador web, ahora solo podrá ver la huella digital de la CA. desactivación de la  Contraseña de comprobación  en el servidor de la CA de Microsoft Contraseña de comprobación desactivación en el servidor de la CA de Microsoft"},{"UUID":"8c3b3a5d-1b44-48aa-8a11-50c10e20be69","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Requisitos del sistema Para todas","descFull":"Requisitos del sistema Para todas las configuraciones de este documento se utiliza el sistema operativo Windows Server 2012 R2. Los siguientes requisitos y capacidades de instalación se aplican tanto a CEP como a CES, a menos que se especifique lo contrario. Cree los siguientes tipos de cuenta en el controlador de dominio: Administrador del servicio: Se denomina  CEPAdmin  y  CESAdmin Este usuario debe formar parte del  grupo administración local  en los respectivos servidores CEP y CES. Este usuario debe formar parte del grupo  Administador de Enterprise . Cuenta de servicio: Se denomina  CEPSvc  y  CESSvc Este usuario debe formar parte del grupo  IIS_IUSRS local . Requiere el permiso  Solicitar certificado  en la CA para los  CEPSvc  y  CESSvc  correspondientes. requisitos sistema requisitos del sistema"},{"UUID":"ddb7697a-4d3d-43bf-9303-b8cabe261c18","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Requisitos de conectividad de red","descFull":"Requisitos de conectividad de red Los requisitos de conectividad de la red son una parte clave de la planificación de la implementación, especialmente en los escenarios en los que CEP y CES se alojan en una red perimetral. Toda la conectividad del cliente a ambos servicios se produce dentro de una sesión HTTPS, por lo que sólo se permite el tráfico HTTPS entre el cliente y los servicios web. CEP se comunica con los Servicios de dominio de Active Directory (AD DS), utilizando los puertos estándar LDAP (Lightweight Directory Access Protocol) y LDAP (LDAPS) (TCP 389 y 636 respectivamente). CES se comunica con CA mediante el modelo de objetos componentes distribuidos (DCOM). De forma predeterminada, DCOM utiliza puertos efímeros aleatorios. CA se puede configurar para reservar un rango específico de puertos para simplificar la configuración del firewall. requisitos conectividad de red requisitos de conectividad de red requisitos de conectividad"},{"UUID":"39153fcd-0dad-4f80-8f63-61117d0d158f","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Creación de certificados SSL para","descFull":"Creación de certificados SSL para servidores CEP y CES CES y CEP deben utilizar Secure Sockets Layer (SSL) para la comunicación con los clientes (mediante HTTPS). Cada servicio debe tener un certificado válido que tenga una directiva de uso de clave mejorado (EKU) de autenticación de servidor en el almacén de certificados del equipo local. Instale el servicio IIS en el servidor. Inicie sesión en el servidor CEP y, a continuación, agregue el  Certificado raíz (autoridad certificadora)  en el almacén  Autoridad certificadora raíz de confianza . Inicie la  Consola de IIS Manager  y, a continuación, seleccione el  inicio del servidor . En la sección de vista principal, abra  Certificados de servidor . Haga clic en  Acciones Crear solicitud de certificado . En la ventana  Propiedades de nombre distinguido , proporcione la información necesaria y, a continuación, haga clic en  Siguiente . En el cuadro de diálogo  Propiedades del proveedor de servicios criptográficos , seleccione la longitud de bit y, a continuación, haga clic en  Siguiente . Guarde el archivo. Obtenga el archivo firmado por la CA que planea utilizar para CEP y CES. Asegúrese de que  EKU de autenticación de servidor  está activada en el certificado firmado. Vuelva a copiar el archivo firmado en el servidor CEP. En  Consola de IIS Manager , seleccione el  inicio del servidor . En  Vista principal , abra  Certificados de servidor . Haga clic en  Acciones Completar solicitud de certificado . En la ventana  Especificar respuesta de la autoridad certificadora , seleccione el archivo firmado. Escriba un nombre y, a continuación, en el menú  Almacén de certificados , seleccione  Personal . Complete la instalación del certificado. En  Consola del IIS Manager , seleccione el sitio web predeterminado. Haga clic en  Acciones Enlaces . En el cuadro de diálogo  Enlaces de sitio , haga clic en  Agregar . En el cuadro de diálogo  Agregar enlace de sitio , establezca  Tipo  en  https  y, a continuación, desde el certificado SSL, busque el certificado recién creado. En  Consola de IIS Manager , seleccione  Sitio web predeterminado  y, a continuación, abra la configuración de SSL. Active  Requerir SSL  y establezca  Certificado de cliente  en  Ignorar . Reinicie IIS. Siga el mismo proceso para el servidor CES. servidores CEP y CES creación de certificados SSL creación de certificados SSL servidores CEP y CES certificados SSL creación"},{"UUID":"5885df55-ef55-4418-8c39-4533375a8b60","title":"Administración de certificados mediante la autoridad certificadora de Microsoft a través de MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Creación de plantillas de certificado","descFull":"Creación de plantillas de certificado El usuario debe crear una plantilla de certificado para la inscripción de certificados. Haga lo siguiente para copiar desde una plantilla de certificado existente: Inicie sesión en la CA de Enterprise con credenciales de administrador de CA. Expanda la CA, haga clic con el botón derecho en  Plantillas de certificado  y, a continuación, haga clic en  Administrar . En la  Consola de plantillas de certificados , haga clic con el botón derecho en  Plantilla de certificado de servidor web  y, a continuación, haga clic en  Duplicar plantilla . En la ficha  General  de la plantilla, asigne un nombre a la plantilla  MVEWebServer . En la ficha  Seguridad , otorgue al administrador de CA permisos de  lectura ,  escritura  e  inscripción . Otorgue permisos de  lectura  e  inscripción  a los usuarios autenticados. En la pestaña  Nombre del sujeto , seleccione  Proporcionar  en la solicitud. En la ficha  General , establezca el período de validez del certificado. Si piensa utilizar esta plantilla de certificado para emitir un  certificado 802.1X  para impresoras, haga lo siguiente: En la ficha  Extensiones , seleccione  Políticas de aplicación  en la lista de extensiones incluidas en esta plantilla. Haga clic en  Editar Agregar . En el cuadro de diálogo  Agregar política de aplicación , seleccione  Autenticación de cliente . Haga clic en  Aceptar . En el cuadro de diálogo  Propìedades de plantilla de certificado , haga clic en  Aceptar . En la ventana CA, haga clic con el botón derecho en  Plantillas de certificado  y, a continuación, haga clic en  Nuevo Plantilla de certificado . Seleccione  MVEWebServer  y, a continuación, haga clic en  Aceptar . plantillas de certificado creación de plantillas de certificado"},{"UUID":"5281c57e-612d-4fa3-8cac-a81d5bd756b6","title":"Descripción de los métodos de autenticación","link":"managing-certificates-using-MSCEWS-group.html","desc":"CEP y CES admiten los","descFull":"CEP y CES admiten los siguientes métodos de autenticación: Autenticación integrada en Windows, también conocida como  autenticación Kerberos Autenticación de certificado de cliente, también conocida como  Autenticación de certificado X.509 Autenticación de nombre de usuario y contraseña métodos de autenticación"},{"UUID":"ebd58929-9167-4665-9fb0-16abe69073fe","title":"Descripción de los métodos de autenticación","link":"managing-certificates-using-MSCEWS-group.html","desc":"autenticación integrada de Windows La","descFull":"autenticación integrada de Windows La autenticación integrada en Windows utiliza Kerberos para proporcionar un flujo de autenticación ininterrumpido para los dispositivos conectados a la red interna. Este método es el preferido para las implementaciones internas porque utiliza la infraestructura Kerberos existente en AD DS. También requiere cambios mínimos en los equipos cliente de certificados. Utilice este método de autenticación si necesita que los clientes accedan  sólo  al servicio web mientras está conectado directamente a la red interna. autenticación integrada de Windows autenticación integrado en Windows"},{"UUID":"dd45fb6d-1ce0-48c8-832a-b80b9cfdc555","title":"Descripción de los métodos de autenticación","link":"managing-certificates-using-MSCEWS-group.html","desc":"Autentificación de certificado de cliente","descFull":"Autentificación de certificado de cliente Este método es preferible a la autenticación de nombre de usuario y contraseña porque es más seguro. No requiere una conexión directa a la red corporativa. Utilice este método de autenticación si tiene previsto proporcionar a los clientes certificados X.509 digitales para la autenticación. Este método activa los servicios Web disponibles en Internet. autenticación de certificado de cliente autenticación certificado de cliente"},{"UUID":"5d7426cb-18d1-4ba0-9edc-20fcd608c8e8","title":"Descripción de los métodos de autenticación","link":"managing-certificates-using-MSCEWS-group.html","desc":"Información de nombre de usuario","descFull":"Información de nombre de usuario y contraseña. El método de nombre de usuario y contraseña es la forma más sencilla de autenticación. Este método se utiliza normalmente para prestar servicio a clientes que no están conectados directamente a la red interna. Es una opción de autenticación menos segura que la autenticación de certificado de cliente, pero no requiere el aprovisionamiento de un certificado. Utilice este método de autenticación cuando pueda acceder al servicio Web en la red interna o a través de Internet. autenticación de nombre de usuario y contraseña autenticación nombre de usuario y contraseña"},{"UUID":"4ad3260e-c1e2-45f9-8e99-cbea3c887b6d","title":"Requisitos de delegación","link":"managing-certificates-using-MSCEWS-group.html","desc":"La delegación permite a un","descFull":"La delegación permite a un servicio suplantar a una cuenta de usuario o equipo para tener acceso a los recursos de toda la red. Se requiere delegación para el servidor CES cuando se aplican todas las situaciones siguientes: CA y CES no residen en el mismo equipo. CES puede procesar las solicitudes de inscripción iniciales, en lugar de procesar únicamente las solicitudes de renovación de certificados. El tipo de autenticación se establece en  Autenticación integrada de Windows  o  Autenticación de certificado de cliente . No es necesaria la delegación para el servidor CES en los siguientes casos: CA y CES residen en el mismo equipo. El nombre de usuario y la contraseña son el método de autenticación. Microsoft recomienda ejecutar CEP y CES como cuentas de usuario de dominio. Los usuarios deben crear un nombre principal de servicio (SPN) adecuado antes de configurar la delegación en la cuenta de usuario de dominio. delegación requisitos requisitos de delegación"},{"UUID":"b7ed27e3-a5df-448a-9e42-e16347c4615e","title":"Requisitos de delegación","link":"managing-certificates-using-MSCEWS-group.html","desc":"Activación de la delegación Para","descFull":"Activación de la delegación Para crear un SPN para una cuenta de usuario de dominio, utilice el comando  setspn  de la siguiente manera: setspn -s http/ces.msca.com msca\\CESSvc El nombre de la cuenta es CESSvc. CES se ejecuta en un equipo con un nombre de dominio (FQDN) de  ces.msca.com  en el dominio msca.com. Abra la cuenta de usuario de dominio CESSvc en el controlador de dominio. En la pestaña  Delegación , seleccione  Confiar en este usuario para delegar solo a servicios especificados . Seleccione la delegación adecuada según el método de autenticación. Si selecciona Autenticación integrada en Windows, configure la delegación para que utilice  sólo Kerberos . Si el servicio utiliza Autenticación de certificado de cliente, configure la delegación para que utilice cualquier protocolo de autenticación. Si tiene previsto configurar varios métodos de autenticación, configure la delegación para utilizar cualquier protocolo de autenticación. Haga clic en  Agregar . En el cuadro de diálogo  Agregar servicios , seleccione  Usuarios  o  Equipos . Escriba el nombre de host del servidor de la CA y, a continuación, haga clic en  Comprobar nombres . En el cuadro de diálogo  Agregar servicios , seleccione uno de los siguientes servicios para delegar: Servicio host (HOST) para ese servidor de la CA Servicio de sistema de llamada a procedimiento remoto (RPCSS) para ese servidor de la CA Cierre el cuadro de diálogo de propiedades de usuario de dominio. Para los usuarios del dominio CEP que utilizan la autenticación integrada en Windows, haga lo siguiente: Para crear un SPN para una cuenta de usuario de dominio, utilice el comando  setspn  de la siguiente manera: setspn -s http/cep.msca.com msca\\CEPSvc El nombre de la cuenta es CEPSvc. Abra la cuenta de usuario de dominio CEPSvc en el controlador de dominio. En la pestaña  Delegación , seleccione  No confiar en este usuario para la delegación . delegación activación"},{"UUID":"dbd01ba8-3103-4e43-a566-714df6d5d79b","title":"Configuración de la autenticación integrada de Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Para instalar CEP y CES,","descFull":"Para instalar CEP y CES, utilice Windows PowerShell. CEP instalación CES instalación"},{"UUID":"c0e789c2-0a5d-4598-ae8b-01326dc37b88","title":"Configuración de la autenticación integrada de Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuración de CEP El cmdlet","descFull":"Configuración de CEP El cmdlet  Install-AdcsEnrollmentPolicyWebService  configura el servicio web de inscripción de certificados (CEP). También se utiliza para crear otras instancias del servicio en de una instalación existente. Inicie sesión en el servido CEP con el nombre de usuario  CEPAdmin  y, a continuación, inicie PowerShell en modo administrativo. Ejecute el comando  Import-Module ServerManager . Ejecute el comando  Add-WindowsFeature Adcs-Enroll-Web-Pol . Ejecute el comando  Install-AdcsEnrollmentPolicyWebService -AuthenticationType Kerberos -SSLCertThumbprint \"sslCertThumbPrint\" . Sustituya < sslCertThumbPrint > por la huella digital del certificado SSL creado para el servidor CEP, tras haber eliminado los espacios entre los valores de la huella digital. Complete la instalación seleccionando  Y  o  A . Inicie la consola de IIS Manager. En el panel  Conexiones , expanda el servidor web que aloja CEP. Expanda  Sitios ,  Sitio web predeterminado  y, a continuación, haga clic en el nombre de la aplicación virtual de instalación que corresponda  ADPolicyProvider_CEP_Kerberos . En la aplicación virtual denominada  Inicio , haga doble clic en la configuración de la aplicación y, a continuación, haga doble clic en  FriendlyName . Escriba un nombre en  Valor  y cierre el cuadro de diálogo. Haga doble clic en  URI  y, a continuación, copie  Valor . Si desea configurar otro método de autenticación en el mismo servidor CEP, debe cambiar el ID. Esta URL se utiliza en MVE o en cualquier aplicación cliente. En el panel izquierdo, haga clic en  Grupo de aplicaciones . Seleccione  WSEnrollmentPolicyServer  y, a continuación, en el panel derecho, haga clic en  Acciones Configuración avanzada . Seleccione el campo de identidad de  Modelo de proceso . En el cuadro de diálogo  Identidad del grupo de aplicaciones , seleccione la cuenta personalizada e introduzca  CEPSvc  como el nombre de usuario de dominio. Cierre todos los cuadros de diálogo y actualice IIS desde el panel derecho de  Consola de IIS Manager  . En PowerShell, escriba  iisreset  para reiniciar IIS. CEP configuración configuración de CEP"},{"UUID":"4a91d57b-d45f-4865-9c4b-9f0030024a4a","title":"Configuración de la autenticación integrada de Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuración de CES El cmdlet","descFull":"Configuración de CES El cmdlet  Install-AdcsEnrollmentWebService  configura el servicio web de inscripción de certificados (CES). También se utiliza para crear otras instancias del servicio en de una instalación existente. Inicie sesión en el servidor CES con el nombre de usuario  CESAdmin  y, a continuación, inicie PowerShell en modo administrativo. Ejecute el comando  Import-Module ServerManager . Ejecute el comando  Add-WindowsFeature Adcs-Enroll-Web-Svc . Ejecute el comando  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig \"CA1.contoso.com\\contoso-CA1-CA\" -SSLCertThumbprint \"sslCertThumbPrint\" -AuthenticationType Kerberos . Sustituya < sslCertThumbPrint > por la huella digital del certificado SSL creado para el servidor CES, tras haber eliminado los espacios entre los valores de la huella digital. Sustituya  CA1.contoso.com  por el nombre del equipo de la CA. Sustituya  contoso-CA1-CA  por el nombre común de la CA. Complete la instalación seleccionando  Y  o  A . Inicie la consola de IIS Manager. En el panel  Conexiones , expanda el servidor web que aloja CES. Expanda  Sitios ,  Sitio web predeterminado  y, a continuación, haga clic en el nombre de la aplicación virtual de instalación que corresponda:  contoso-CA1-CA _CES_Kerberos . En el panel izquierdo, haga clic en  Grupo de aplicaciones . Seleccione  WSEnrollmentServer  y, a continuación, en el panel derecho, haga clic en  Acciones Configuración avanzada . Seleccione el campo de identidad de  Modelo de proceso . En el cuadro de diálogo  Identidad del grupo de aplicaciones , seleccione la cuenta personalizada e introduzca  CESSvc  como el nombre de usuario de dominio. Cierre todos los cuadros de diálogo y actualice IIS desde el panel derecho de  Consola de IIS Manager . En PowerShell, escriba  iisreset  para reiniciar IIS. Para los usuarios de dominio CESSvc, active la delegación. Para obtener más información, consulte  . CES configuración configuración de CES"},{"UUID":"401a0080-f8d7-4018-9d6a-00992cff8815","title":"Configuración de la autenticación del certificado de cliente","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuración de CEP El cmdlet","descFull":"Configuración de CEP El cmdlet  Install-AdcsEnrollmentPolicyWebService  configura CEP. También se utiliza para crear otras instancias del servicio en de una instalación existente. Inicie sesión en el servido CEP con el nombre de usuario  CEPAdmin  y, a continuación, inicie PowerShell en modo administrativo. Ejecute el comando  Import-Module ServerManager . Ejecute el comando  Add-WindowsFeature Adcs-Enroll-Web-Pol . Ejecute el comando  Install-AdcsEnrollmentPolicyWebService -AuthenticationType Certificate -SSLCertThumbprint “sslCertThumbPrint” . Sustituya < sslCertThumbPrint > por la huella digital del certificado SSL creado para el servidor CEP, tras haber eliminado los espacios entre los valores de la huella digital. Complete la instalación seleccionando  Y  o  A . Inicie la consola de IIS Manager. En el panel  Conexiones , expanda el servidor web que aloja CEP. Expanda  Sitios ,  Sitio web predeterminado  y, a continuación, haga clic en el nombre de la aplicación virtual de instalación que corresponda  ADPolicyProvider_CEP_Certificate . En la aplicación virtual denominada  Inicio , haga doble clic en la configuración de la aplicación y, a continuación, haga doble clic en  FriendlyName . Escriba un nombre en  Valor  y cierre el cuadro de diálogo. Haga doble clic en  URI  y, a continuación, copie  Valor . Si desea configurar otro método de autenticación en el mismo servidor CEP, debe cambiar el ID. Esta URL se utiliza en MVE o en cualquier aplicación cliente. En el panel izquierdo, haga clic en  Grupo de aplicaciones . Seleccione  WSEnrollmentPolicyServer  y, a continuación, en el panel derecho, haga clic en  Acciones Configuración avanzada . Seleccione el campo de identidad de  Modelo de proceso . En el cuadro de diálogo  Identidad del grupo de aplicaciones , seleccione la cuenta personalizada e introduzca  CEPSvc  como el nombre de usuario de dominio. Cierre todos los cuadros de diálogo y actualice IIS desde el panel derecho de  Consola de IIS Manager  . En PowerShell, escriba  iisreset  para reiniciar IIS. CEP configuración configuración de CEP"},{"UUID":"52baa266-4939-4cb1-9cb4-518ca823ff8e","title":"Configuración de la autenticación del certificado de cliente","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuración de CES El cmdlet","descFull":"Configuración de CES El cmdlet  Install-AdcsEnrollmentWebService  configura el servicio web de inscripción de certificados (CES). También se utiliza para crear otras instancias del servicio en de una instalación existente. Inicie sesión en el servidor CES con el nombre de usuario  CESAdmin  y, a continuación, inicie PowerShell en modo administrativo. Ejecute el comando  Import-Module ServerManager . Ejecute el comando  Add-WindowsFeature Adcs-Enroll-Web-Svc . Ejecute el comando  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig “CA1.contoso.com\\contoso-CA1-CA” -SSLCertThumbprint “sslCertThumbPrint” -AuthenticationType Certificate . Sustituya < sslCertThumbPrint > por la huella digital del certificado SSL creado para el servidor CES, tras haber eliminado los espacios entre los valores de la huella digital. Sustituya  CA1.contoso.com  por el nombre del equipo de la CA. Sustituya  contoso-CA1-CA  por el nombre común de la CA. Si ya ha configurado un método de autenticación en al host, elimine  ApplicationPoolIdentity  del comando. Complete la instalación seleccionando  Y  o  A . Inicie la consola de IIS Manager. En el panel  Conexiones , expanda el servidor web que aloja CEP. Expanda  Sitios ,  Sitio web predeterminado  y, a continuación, haga clic en el nombre de la aplicación virtual de instalación que corresponda:  contoso-CA1-CA _CES_Certificate . En el panel izquierdo, haga clic en  Grupo de aplicaciones . Seleccione  WSEnrollmentServer  y, a continuación, en el panel derecho, haga clic en  Acciones Configuración avanzada . Seleccione el campo de identidad de  Modelo de proceso . En el cuadro de diálogo  Identidad del grupo de aplicaciones , seleccione la cuenta personalizada e introduzca  CESSvc  como el nombre de usuario de dominio. Cierre todos los cuadros de diálogo y actualice IIS desde el panel derecho de la  Consola de IIS Manager . En PowerShell, escriba  iisreset  para reiniciar IIS. Para el usuario de dominio CESSvc, active la delegación. Para obtener más información, consulte  . CES configuración configuración de CES"},{"UUID":"96aeae4f-6bc3-4804-81a9-12547584e706","title":"Configuración de la autenticación del certificado de cliente","link":"managing-certificates-using-MSCEWS-group.html","desc":"Creación de un certificado de","descFull":"Creación de un certificado de cliente Abra  certlm.msc  desde una cuenta de usuario de dominio. Haga clic en  Certificados Personal Certificados Todas las tareas Solicitar nuevo certificado . Haga clic en  Siguiente . Haga clic en  Inscripción a Active Directory Acceso de cliente . Si no quiere usar las opciones de  Inscripción a Active Directory , haga lo siguiente: Haga clic en  Configurado por usted Agregar nuevo . Introduzca la URI del servidor de políticas de inscripción como dirección de servidor CEP para la autenticación de Nombre de usuario_Contraseña o de Kerberos. Seleccione el tipo de autenticación  Integrado en Windows . Haga clic en  Validar servidor . Cuando se haya validado correctamente, haga clic en  Agregar . Haga clic en  Siguiente . Seleccione una plantilla. Haga clic en  Detalles Propiedades . Haga clic en  Inscribir . En la pestaña  Asunto , proporcione un nombre de dominio completo (FQDN). En la pestaña  Clave privada , seleccione  Hacer exportable la clave privada . Haga clic en  Aplicar Inscribir . Después de inscribir el certificado de cliente, haga lo siguiente para exportarlo en formato PFX. Haga clic en  Certificado Todas las tareas Exportar . Haga clic en  Siguiente Exportar la clave privada . Haga clic en  Siguiente . Escriba la contraseña proporcionada por el cliente. Haga clic en  Siguiente . Especifique el nombre de archivo en el cuadro de diálogo Exportación de certificados . Haga clic en  Siguiente Finalizar . certificado de cliente creación de un certificado de cliente"},{"UUID":"5b777f62-b2f2-4a83-9cf8-1da9ce768e6d","title":"Configuración de la autenticación nombre de usuario-contraseña","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuración de CEP El cmdlet","descFull":"Configuración de CEP El cmdlet  Install-AdcsEnrollmentPolicyWebService  configura el servicio web de inscripción de certificados (CEP). También se utiliza para crear otras instancias del servicio en de una instalación existente. Inicie sesión en el servido CEP con el nombre de usuario  CEPAdmin  y, a continuación, inicie PowerShell en modo administrativo. Ejecute el comando  Import-Module ServerManager . Ejecute el comando  Add-WindowsFeature Adcs-Enroll-Web-Pol . Ejecute el comando  Install-AdcsEnrollmentPolicyWebService -AuthenticationType UserName -SSLCertThumbprint “sslCertThumbPrint” . Sustituya < sslCertThumbPrint > por la huella digital del certificado SSL creado para el servidor CEP, tras haber eliminado los espacios entre los valores de la huella digital. Complete la instalación seleccionando  Y  o  A . Inicie la consola de IIS Manager. En el panel  Conexiones , expanda el servidor web que aloja CEP. Expanda  Sitios ,  Sitio web predeterminado  y, a continuación, haga clic en el nombre de la aplicación virtual de instalación que corresponda:  ADPolicyProvider_CEP_UsernamePassword . En la aplicación virtual denominada  Inicio , haga doble clic en la configuración de la aplicación y, a continuación, haga doble clic en  FriendlyName . Escriba un nombre en  Valor  y cierre el cuadro de diálogo. Haga doble clic en  URI  y, a continuación, copie  Valor . Si desea configurar otro método de autenticación en el mismo servidor CEP, debe cambiar el ID. Esta URL se utiliza en MVE o en cualquier aplicación cliente. En el panel izquierdo, haga clic en  Grupo de aplicaciones . Seleccione  WSEnrollmentPolicyServer  y, a continuación, en el panel derecho, haga clic en  Acciones Configuración avanzada . Seleccione el campo de identidad de  Modelo de proceso . En el cuadro de diálogo  Identidad del grupo de aplicaciones , seleccione la cuenta personalizada e introduzca  CESSvc . Cierre todos los cuadros de diálogo y actualice IIS desde el panel derecho de  Consola de IIS Manager  . En PowerShell, escriba  iisreset  para reiniciar IIS. CEP configuración configuración de CEP"},{"UUID":"4bd77b6f-aeaf-4a99-82d3-131fecc2ebdd","title":"Configuración de la autenticación nombre de usuario-contraseña","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuración de CES El cmdlet","descFull":"Configuración de CES El cmdlet  Install-AdcsEnrollmentWebService  configura el servicio web de inscripción de certificados (CES). También se utiliza para crear otras instancias del servicio en de una instalación existente. Inicie sesión en el servidor CES con el nombre de usuario  CESAdmin  y, a continuación, inicie PowerShell en modo administrativo. Ejecute el comando  Import-Module ServerManager . Ejecute el comando  Add-WindowsFeature Adcs-Enroll-Web-Svc . Ejecute el comando  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig “CA1.contoso.com\\contoso-CA1-CA” -SSLCertThumbprint “sslCertThumbPrint” -AuthenticationType UserName . Sustituya < sslCertThumbprint > por la huella digital del certificado SSL creado para el servidor CES, tras haber eliminado los espacios entre los valores de la huella digital. Sustituya  CA1.contoso.com  por el nombre del equipo de la CA. Sustituya  contoso-CA1-CA  por el nombre común de la CA. Si ya ha configurado un método de autenticación en al host, elimine  ApplicationPoolIdentity  del comando. Complete la instalación seleccionando  Y  o  A . Inicie la consola de IIS Manager. En el panel  Conexiones , expanda el servidor web que aloja CES. Expanda  Sitios ,  Sitio web predeterminado  y, a continuación, haga clic en el nombre de la aplicación virtual de instalación que corresponda:  contoso-CA1-CA_CES_UsernamePassword . En el panel izquierdo, haga clic en  Grupo de aplicaciones . Seleccione  WSEnrollmentServer  y, a continuación, en el panel derecho, haga clic en  Acciones Configuración avanzada  en  Acciones . Seleccione el campo de identidad de  Modelo de proceso . En el cuadro de diálogo  Identidad del grupo de aplicaciones , seleccione la cuenta personalizada e introduzca  CESSvc  como el nombre de usuario de dominio. Cierre todos los cuadros de diálogo y actualice IIS desde el panel derecho de  Consola de IIS Manager . En PowerShell, escriba  iisreset  para reiniciar IIS. CES configuración configuración de CES"},{"UUID":"ecb749d6-3f07-48d0-bb97-b00bf713b269","title":"Configuración de la CA de OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Instalación de la CA OpenXPKI","descFull":"Instalación de la CA OpenXPKI Conecte el equipo utilizando PuTTY u otro cliente. En el cliente, ejecute el comando  sudo su -  para ir al usuario raíz. Introduzca la contraseña raíz. En  nano /etc/apt/sources.list , cambie el origen para la instalación de las actualizaciones. Actualice el archivo. Por ejemplo: #\n\n# deb cdrom:[Debian GNU/Linux 8.11.1 _Jessie_ - Official amd64 CD Binary-1 20190211-02:10]/ jessie local main\n# deb cdrom:[Debian GNU/Linux 8.11.1 _Jessie_ - Official amd64 CD Binary-1 20190211-02:10]/ jessie local main\n\ndeb http://security.debian.org/ jessie/updates main\ndeb-src http://security.debian.org/ jessie/updates main\n\n# jessie-updates, previously known as 'volatile'\n# A network mirror was not selected during install.  The following entries\n# are provided as examples, but you should amend them as appropriate\n# for your mirror of choice.\n#\ndeb http://ftp.debian.org/debian/jessie-updates main\ndeb-src http://ftp.debian.org/debian/jessie-updates main\ndeb http://ftp.us.debian.org/debian/jessie main\n Guarde el archivo. Ejecute los siguientes comandos: apt-get update apt-get upgrade Actualice las listas de certificados de CA en el servidor mediante  apt-get install ca-certificates . Instale  en_US.utf8 locale  mediante  dpkg-reconfigure locales . Seleccione la configuración regional  en_US.UTF-8 UTF-8  y, a continuación, haga que sea la configuración regional predeterminada del sistema. Utilice las teclas de tabulación y barra espaciadora para seleccionar y desplazarse por el menú. Compruebe las configuraciones regionales que ha generado mediante  locale –a . Salida de ejemplo C\nC.UTF-8\nen_IN\nen_IN.utf8\nen_US.utf8\nPOSIX Copie la huella del paquete de OpenXPKI mediante  nano /home/Release.key . En este caso, copie la clave en  /home . Escriba  9B156AD0 F0E6A6C7 86FABE7A D8363C4E 1611A2BE 2B251336 01D1CDB4 6C24BEF3  como valor. Ejecute el siguiente comando: gpg --print-md sha256 /home/Release.key Agregue el paquete utilizando el comando  wget https://packages.openxpki.org/v2/debian/Release.key -O - | apt-key add - . Agregue el repositorio a la lista de orígenes (jessie) mediante  echo \"deb http://packages.openxpki.org/v2/debian/jessie release\" > /etc/apt/sources.list.d/openxpki.list  y, a continuación,  aptitude update . Instale el enlace MySQL y Perl MySQL mediante  aptitude install mysql-server libdbd-mysql-perl . Instale apache2.2-common mediante  aptitude install apache2.2-common . En  nano /etc/apt/sources.list , instale el módulo fastcgi para acelerar la interfaz de usuario. Recomendamos que se utilice  mod_fcgid . Agregue la línea  deb http://http.us.debian.org/debian/jessie main  en el archivo y, a continuación, guárdelo. Ejecute los siguientes comandos: apt-get update aptitude install libapache2-mod-fcgid Active el módulo fastcgi mediante  a2enmod fcgid . Instale el paquete principal de OpenXPKI mediante  aptitude install libopenxpki-perl openxpki-cgi-session-driver openxpki-i18n . Reinicie el  Apache  Servidor mediante  service apache2 restart . Compruebe si la instalación se ha realizado correctamente mediante  openxpkiadm version . Si la instalación se ha realizado correctamente, el sistema muestra la versión de OpenXPKI instalada. Por ejemplo,  Version (core): 2.5.5 . Cree la base de datos vacía y, a continuación, asigne el usuario de la base de datos mediante  mysql -u root –p . Este comando debe escribirse en el cliente. De lo contrario, no podrá introducir la contraseña. Escriba la contraseña para MySQL. En este caso,  root  es el usuario MySQL. openxpki  es el usuario en el que está instalado OpenXPKI. CREATE DATABASE openxpki CHARSET utf8; \nCREATE USER 'openxpki'@'localhost' IDENTIFIED BY 'openxpki';\nGRANT ALL ON openxpki.* TO 'openxpki'@'localhost';\nflush privileges; Si el servicio MySQL no se está ejecutando, ejecute  /etc/init.d/mysql start  para iniciar el servicio. Escriba  quit  para salir de MySQL. Almacene las credenciales utilizadas en  /etc/openxpki/config.d/system/database.yaml . Contenido de archivo de ejemplo debug: 0\ntype: MySQL\nname: openxpki\nhost: localhost\nport: 3306\nuser: openxpki \npasswd: openxpki Cambie  user  y  passwd  para que coincidan con el nombre de usuario y la contraseña de MySQL. Guarde el archivo. Para un esquema de base de datos vacío, ejecute  zcat /usr/share/doc/libopenxpki-perl/examples/schema-mysql.sql.gz | \\mysql -u root --password --database openxpki  desde el archivo de esquema proporcionado. Introduzca la contraseña de la base de datos. instalación de la CA OpenXPKI CA OpenXPKI instalación"},{"UUID":"1de583ee-817b-45d6-a76f-c28cbf7909e7","title":"Configuración de la CA de OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Configuración de la CA OpenXPKI","descFull":"Configuración de la CA OpenXPKI mediante el script predeterminado El script predeterminado solo configura el dominio predeterminado,  ca-one . El CDP y las CRL no se configuran. Descomprima el script de ejemplo para instalar el certificado mediante  gunzip -k /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh.gz . Ejecute el script mediante  bash /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh . Confirme la configuración mediante  openxpkiadm alias --realm ca-one . Salida de ejemplo === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set Compruebe si la instalación se realiza correctamente mediante  openxpkictl start . Salida de ejemplo Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Realice lo siguiente para acceder al servidor OpenXPKI: En un navegador web, escriba  http://ipaddress/openxpki/ . Inicie sesión como  Operador . La contraseña predeterminada es  openxpki . El inicio de sesión del operador tiene dos cuentas de operador preconfiguradas,  raop  y  raop2 . Cree una solicitud de certificado y, a continuación, pruébela. configuración de la CA OpenXPKI mediante el script predeterminado CA OpenXPKI configuración mediante el script predeterminado"},{"UUID":"91d4df10-af50-48db-b9b8-ef748e2d9065","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Descripción general Antes de comenzar,","descFull":"Descripción general Antes de comenzar, asegúrese de que tiene conocimientos básicos sobre la creación de certificados OpenSSL. Para configurar la CA OpenXPKI de forma manual, debe crear lo siguiente: Certificado de la CA raíz. Para obtener más información, consulte  . Certificado del firmante de la CA, firmado por la CA raíz. Para obtener más información, consulte  . Certificado de almacén de datos, autofirmado. Para obtener más información, consulte  . Certificado SCEP, firmado por el certificado del firmante. Al seleccionar el hash de firma, utilice SHA256 o SHA512. El cambio del tamaño de la clave pública es opcional. En este caso, vamos a utilizar el directorio  /etc/certs/openxpki_ca-one/  para la generación de certificados. Sin embargo, puede utilizar cualquier directorio. configuración de la CA OpenXPKI de forma manual CA OpenXPKI configurar manualmente"},{"UUID":"30d0f2b7-2054-49c0-ac94-925e20da9a16","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creación de un archivo de","descFull":"Creación de un archivo de configuración de OpenSSL Ejecute el siguiente comando: nano /etc/certs/openxpki_ca-one/openssl.conf Si se puede acceder al servidor mediante el nombre de dominio completo (FQDN), utilice el DNS del servidor en lugar de su dirección IP. Archivo de ejemplo # x509_extensions               = v3_ca_extensions\n# x509_extensions               = v3_issuing_extensions\n# x509_extensions               = v3_datavault_extensions\n# x509_extensions               = v3_scep_extensions\n# x509_extensions               = v3_web_extensions\n# x509_extensions               = v3_ca_reqexts # not for root self-signed, only for issuing\n## x509_extensions              = v3_datavault_reqexts # not required self-signed\n# x509_extensions               = v3_scep_reqexts\n# x509_extensions               = v3_web_reqexts\n\n[ req ]\ndefault_bits            = 4096\ndistinguished_name      = req_distinguished_name\n\n[ req_distinguished_name ]\ndomainComponent         = Domain Component\ncommonName              = Common Name\n\n[ v3_ca_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\n\n[ v3_datavault_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\n\n[ v3_scep_reqexts ]\nsubjectKeyIdentifier    = hash\n\n[ v3_web_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\n\n[ v3_ca_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_issuing_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer:always\ncrlDistributionPoints   = URI:http://FQDN of the server/CertEnroll/MYOPENXPKI.crl\nauthorityInfoAccess     = caIssuers;URI:http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\n\n[ v3_datavault_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_scep_extensions ]\nsubjectKeyIdentifier    = hash\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid,issuer\n\n[ v3_web_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\nbasicConstraints        = critical,CA:FALSE\nsubjectAltName          = DNS:stlopenxpki.lexmark.com\ncrlDistributionPoints   = URI:http://FQDN of the server/CertEnroll/MYOPENXPKI_ISSUINGCA.crl\nauthorityInfoAccess     = caIssuers;URI:http://FQDN of the server/CertEnroll/MYOPENXPKI_ISSUINGCA.crt\n Cambie la dirección IP y el nombre del certificado de la CA con la información de configuración. Guarde el archivo. creación de archivos de configuración de OpenSSL archivo de configuración de OpenSSL creación"},{"UUID":"cb051260-12a5-48ef-9150-bf8006f26dec","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creación de un archivo de","descFull":"Creación de un archivo de contraseña para claves de certificado Ejecute el siguiente comando: nano /etc/certs/openxpki_ca-one/pd.pass Escriba su contraseña. Guarde el archivo. creación de archivos de contraseña para claves de certificado archivos de contraseña para claves de certificado creación claves de certificado creación de archivos de contraseña"},{"UUID":"73202df7-7af8-44a0-a5dd-8e2b57281934","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creación de un certificado de","descFull":"Creación de un certificado de la CA raíz Puede crear un certificado de la CA raíz autofirmado o generar una solicitud de certificado y, a continuación, obtenerlo firmado por la CA raíz. Ejecute los siguientes comandos: Sustituya la longitud de clave, el algoritmo de firma y el nombre del certificado por los valores adecuados. openssl genrsa -out /etc/certs/openxpki_ca-one/ca-root-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 openssl req -new -key /etc/certs/openxpki_ca-one/ca-root-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ROOTCA -out /etc/certs/openxpki_ca-one/ca-root-1.csr openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_ca_extensions -x509 -days 3560 -in /etc/certs/openxpki_ca-one/ca-root-1.csr -key /etc/certs/openxpki_ca-one/ca-root-1.key -out /etc/certs/openxpki_ca-one/ca-root-1.crt -sha256 creación de certificados de la CA raíz certificado de la CA raíz creación"},{"UUID":"831cf3f5-1dd2-48ca-8497-0c6809da188f","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creación de un certificado de","descFull":"Creación de un certificado de firmante Sustituya la longitud de clave, el algoritmo de firma y el nombre del certificado por los valores adecuados. Ejecute el siguiente comando: openssl genrsa -out /etc/certs/openxpki_ca-one/ca-signer-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 Cambie el asunto de la solicitud con la información de la CA mediante  openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_ca_reqexts -new -key /etc/certs/openxpki_ca-one/ca-signer-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ISSUINGCA -out /etc/certs/openxpki_ca-one/ca-signer-1.csr . Obtenga el certificado firmado por la CA raíz mediante  openssl x509 -req -extfile /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_issuing_extensions -days 3650 -in /etc/certs/openxpki_ca-one/ca-signer-1.csr -CA /etc/certs/openxpki_ca-one/ca-root-1.crt -CAkey /etc/certs/openxpki_ca-one/ca-root-1.key -CAcreateserial -out /etc/certs/openxpki_ca-one/ca-signer-1.crt -sha256 . creación de certificados de firmante certificados de firmante creación"},{"UUID":"35e5b52e-fbdf-45e7-9d91-63c1f640306a","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creación de un certificado de","descFull":"Creación de un certificado de almacén El certificado de almacén se firma automáticamente. Sustituya la longitud de clave, el algoritmo de firma y el nombre del certificado por los valores adecuados. Ejecute el siguiente comando: openssl genrsa -out /etc/certs/openxpki_ca-one/vault-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 Cambie el asunto de la solicitud con la información de la CA mediante  openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_datavault_reqexts -new -key /etc/certs/openxpki_ca-one/vault-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/DC=STLOPENXPKI_INTERNAL/CN=MYOPENXPKI_DATAVAULT -out /etc/certs/openxpki_ca-one/vault-1.csr . Ejecute el siguiente comando: openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_datavault_extensions -x509 -days 3560 -in /etc/certs/openxpki_ca-one/vault-1.csr -key /etc/certs/openxpki_ca-one/vault-1.key -out /etc/certs/openxpki_ca-one/vault-1.crt creación de certificados de almacén certificados de almacén creación"},{"UUID":"4910b668-b68a-4c08-951e-1b3b29d0d030","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creación de un certificado SCEP","descFull":"Creación de un certificado SCEP El certificado SCEP está firmado por el certificado del firmante. Ejecute los siguientes comandos: Sustituya la longitud de clave, el algoritmo de firma y el nombre del certificado por los valores adecuados. openssl genrsa -out /etc/certs/openxpki_ca-one/scep-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_scep_reqexts -new -key /etc/certs/openxpki_ca-one/scep-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_SCEPCA -out /etc/certs/openxpki_ca-one/scep-1.csr openssl x509 -req -extfile /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_scep_extensions -days 900 -in /etc/certs/openxpki_ca-one/scep-1.csr -CA /etc/certs/openxpki_ca-one/ca-signer-1.crt -CAkey /etc/certs/openxpki_ca-one/ca-signer-1.key -CAcreateserial -out /etc/certs/openxpki_ca-one/scep-1.crt -sha256 creación de certificados SCEP certificados SCEP creación"},{"UUID":"eb2e182c-1fc2-4925-a154-eea0af844010","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Copia del archivo de clave","descFull":"Copia del archivo de clave y creación de un enlace simbólico Copie los archivos de clave en  /etc/openxpki/ca/ca-one/ . Los archivos de clave deben ser legibles para OpenXPKI. cp /etc/certs/openxpki_ca-one/ca-signer-1.key /etc/openxpki/ca/ca-one/\n\ncp /etc/certs/openxpki_ca-one/vault-1.key /etc/openxpki/ca/ca-one/\n\ncp /etc/certs/openxpki_ca-one/scep-1.key /etc/openxpki/ca/ca-one/ Cree el enlace simbólico. Los enlaces simbólicos son alias utilizdos por la configuración predeterminada. ln -s /etc/openxpki/ca/ca-one/ca-signer-1.key /etc/openxpki/ca/ca-one/ca-signer-1.pem\n\nln -s /etc/openxpki/ca/ca-one/scep-1.key /etc/openxpki/ca/ca-one/scep-1.pem\n\nln -s /etc/openxpki/ca/ca-one/vault-1.key /etc/openxpki/ca/ca-one/vault-1.pem copia de archivos de clave creación de enlaces simbólicos archivos clave copia enlaces simbólicos creación"},{"UUID":"1018bbb8-41dd-4fc3-b1f7-1a358e9eac50","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Importación de certificados Importe el","descFull":"Importación de certificados Importe el certificado raíz, el certificado del firmante, el certificado de almacén y el certificado SCEP a la base de datos con los tokens adecuados. Ejecute los siguientes comandos: openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/ca-root-1.crt openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/ca-signer-1.crt --realm ca-one --token certsign openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/scep-1.crt --realm ca-one --token scep openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/vault-1.crt --realm ca-one --token datasafe Compruebe que la importación se realiza correctamente mediante  openxpkiadm alias --realm ca-one .. Salida de ejemplo === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set\n importación de certificados certificados importación"},{"UUID":"eeeb1107-614a-4ef9-b885-2b91736108ec","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Inicio de OpenXPKI Ejecute el","descFull":"Inicio de OpenXPKI Ejecute el comando  openxpkictl start Salida de ejemplo Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Realice lo siguiente para acceder al servidor OpenXPKI: En un navegador web, escriba  http://ipaddress/openxpki/ . En lugar de  ipaddress , también puede utilizar el FQDN del servidor. Inicie sesión como  Operador . La contraseña predeterminada es  openxpki . El inicio de sesión del operador tiene dos cuentas de operador preconfiguradas,  raop  y  raop2 . Cree una solicitud de certificado y, a continuación, pruébela. inicio de OpenXPKI OpenXPKI inicio"},{"UUID":"1881721f-c163-4718-8f8c-64b1fd727590","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Generación de información de la","descFull":"Generación de información de la CRL Si se puede acceder al servidor mediante el FQDN, utilice el DNS del servidor en lugar de su dirección IP. Detenga el servicio OpenXPKI mediante  Openxpkictl stop . En  nano /etc/openxpki/config.d/realm/ca-one/publishing.yaml , actualice la sección  connectors: cdp  para que muestre lo siguiente: class: Connector::Builtin::File::Path\nLOCATION: /var/www/openxpki/CertEnroll/\nfile: \"[% ARGS.0 %].crl\"\ncontent: \"[% pem %]\" En  nano /etc/openxpki/config.d/realm/ca-one/profile/default.yaml , actualice lo siguiente: crl_distribution_points:  sección critical: 0\nuri:\n    - http://FQDN of the server/CertEnroll/[% ISSUER.CN.0 %].crl\n    - ldap://localhost/[% ISSUER.DN %] authority_info_access:  sección critical: 0\nca_issuers: http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\nocsp: http://ocsp.openxpki.org/ Cambie la dirección IP y el nombre del certificado de la CA de acuerdo con el servidor de la CA. En  nano /etc/openxpki/config.d/realm/ca-one/crl/default.yaml , realice lo siguiente: Si es necesario, actualice  nextupdate  y  renewal . Agregue  ca_issuers  a la siguiente sección: extensions:\n    \t\tauthority_info_access:\n        \t\t\tcritical: 0\n        \t\t\t# ca_issuers and ocsp can be scalar or list\n        \t\t\tca_issuers: http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\n       \t\t\t#ocsp: http://ocsp.openxpki.org/\n Cambie la dirección IP y el nombre del certificado de la CA de acuerdo con el servidor de la CA. Inicie el servicio OpenXPKI mediante  Openxpkictl start . generación de información de la CRL información de la CRL generar"},{"UUID":"07ebb4ae-c76d-4a8d-ba52-5fc81e1cb3c6","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Configuración de la accesibilidad de","descFull":"Configuración de la accesibilidad de la CRL Detenga el servicio Apache mediante  service apache2 stop . Cree un directorio  CertEnroll  para crl en el directorio  /var/www/openxpki/ . Defina  openxpki  como propietario de este directorio y, a continuación, configure los permisos para permitir a Apache leer y ejecutar, y a otros servicios solo leer. chown openxpki /var/www/openxpki/CertEnroll chmod 755 /var/www/openxpki/CertEnroll Agregue una referencia al archivo alias.conf de Apache mediante  nano /etc/apache2/mods-enabled/alias.conf . Después de la sección  <Directory \"/usr/share/apache2/icons\"> , agregue lo siguiente:         \tAlias /CertEnroll/ \"/var/www/openxpki/CertEnroll/\"\n         \t<Directory \"/var/www/openxpki/CertEnroll\">\n               Options FollowSymlinks\n               AllowOverride None\n               Require all granted\n         \t</Directory> Agregue una referencia en el archivo apache2.conf utilizando  nano /etc/apache2/apache2.conf . Agregue lo siguiente en la sección  Apache2 HTTPD server :          \t<Directory /var/www/openxpki/CertEnroll>\n               Options FollowSymlinks\n               AllowOverride None\n               Allow from all\n         \t</Directory> Inicie el servicio Apache mediante  service apache2 start . configuración de la accesibilidad de la CRL accesibilidad de la CRL configuración"},{"UUID":"70afac2b-42cd-48da-80b1-bfd6529b1ece","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Activación del servicio SCEP Detenga","descFull":"Activación del servicio SCEP Detenga el servicio OpenXPKI mediante  openxpkictl stop . Instale el paquete openca-tools usando  aptitude install openca-tools . Inicie el servicio OpenXPKI mediante  openxpkictl start . Pruebe el servicio con cualquier cliente; por ejemplo, certnanny con SSCEP. SSCEP es un cliente de línea de comandos para SCEP. Puede descargar SSCEP de  https://github.com/certnanny/sscep . activación del servicio SCEP servicio SCEP activación Protocolo de inscripción de certificados simple activación"},{"UUID":"c7886776-1697-4626-950a-bcef9909916c","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Activación del certificado Firmante en","descFull":"Activación del certificado Firmante en nombre de un tercero (agente de inscripción) Para las solicitudes automáticas de certificados, se utilizará la función de certificado Firmante en nombre de un tercero de OpenXPKI. Detenga el servicio OpenXPKI mediante  openxpkictl stop . En  nano /etc/openxpki/config.d/realm/ca-one/scep/generic.yaml , desde la sección  authorized_signer: , agregue una regla para el nombre del sujeto del certificado de firmante. rule1:\n        \t\t# Full DN\n            \t\tsubject: CN=Markvision_.*\n En esta regla, cualquier certificado CN que empiecen por  MarkVision_  es el certificado Firmante en nombre de un tercero. El nombre del sujeto se define en MVE para generar el certificado Firmante en nombre de un tercero. Revise el espacio y la sangría en el archivo de script. Si el CN se cambia en MVE, agregue el CN actualizado en OpenXPKI. Solo se puede especificar un certificado como Firmante en nombre de un tercero y, a continuación, especificar el CN completo. Guarde el archivo. Inicie el servicio OpenXPKI mediante  openxpkictl start . activación de certificados Firmante en nombre de un tercero certificados Firmante en nombre de un tercero activación"},{"UUID":"3a81ec9a-83d4-48e1-9ef5-d26b890c33c8","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Activación de la aprobación automática","descFull":"Activación de la aprobación automática de solicitudes de certificado en la CA OpenXPKI Detenga el servicio OpenXPKI mediante  openxpkictl stop . En  nano /etc/openxpki/config.d/realm/ca-one/scep/generic.yaml , actualice la sección  eligible  : Contenido antiguo eligible:\n\t\t\tinitial:\n\t\t\t\tvalue@: connector:scep.generic.connector.initial\n       \t\targs: '[% context.cert_subject_parts.CN.0 %]'\n       \t\texpect:\n       \t\t\t- Build\n       \t\t\t- New Nuevo contenido eligible:\n\t\t\tinitial:\n\t\t\t\tvalue: 1\n\t\t\t\t# value@: connector:scep.generic.connector.initial\n\t\t\t\t# args: '[% context.cert_subject_parts.CN.0 %]'\n\t\t\t\t# expect:\n\t\t\t\t#\t- Build\n\t\t\t\t#\t- New Revise el espacio y la sangría en el archivo de script. Para aprobar certificados de forma manual, comente  value: 1  y, a continuación, quite el comentario de las otras líneas que se hayan comentado previamente. Guarde el archivo. Inicie el servicio OpenXPKI mediante  openxpkictl start . activación de la aprobación automática de solicitudes de certificado en la CA OpenXPKI aprobación automática de solicitudes de certificado activación en la CA OpenXPKI solicitudes de certificado en la CA OpenXPKI aprobación automática"},{"UUID":"50c6d085-cbbc-42fe-b38b-3bb7f7dd9d79","title":"Creación de un segundo dominio","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Copia y configuración del directorio","descFull":"Copia y configuración del directorio Copie el árbol de directorios de ejemplo  /etc/openxpki/config.d/realm/ca-one  en un nuevo directorio ( cp -avr /etc/openxpki/config.d/realm/ca-one /etc/openxpki/config.d/realm/ca-two ) dentro del directorio del dominio. En  /etc/openxpki/config.d/system/reinos.yaml , actualice la siguiente sección: Contenido antiguo # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\nca-one:\n    label: Verbose name of this realm\n    baseurl: https://pki.example.com/openxpki/\n\n#ca-two:\n#    label: Verbose name of this realm\n#    baseurl: https://pki.acme.org/openxpki/ Nuevo contenido # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\nca-one:\n    label: CA-ONE\n    baseurl: https://pki.example.com/openxpki/\n\nca-two:\n    label: CA-TWO\n    baseurl: https://pki.example.com/openxpki/ Guarde el archivo. copia del directorio configuración del directorio"},{"UUID":"c84a434e-7413-44ec-8e6f-c31bf182b610","title":"Creación de un segundo dominio","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Creación de certificados En las","descFull":"Creación de certificados En las siguientes instrucciones se muestra cómo generar el certificado de firmante, el certificado de almacén y el certificado SCEP. La CA raíz firma el certificado de firmante y, a continuación, el certificado de firmante firma el certificado SCEP. El certificado de almacén se firma automáticamente. Genere los certificados y, a continuación, fírmelos. Para obtener más información, consulte  . Cambie el nombre común del certificado para que el usuario pueda distinguir fácilmente entre distintos certificados para diferentes dominios. Puede cambiar  DC=CA-ONE  a  DC=CA-DOS . Los archivos de certificado se crean en el directorio  /etc/certs/openxpki_ca-two/ . Copie los archivos de clave en  /etc/openxpki/ca/ca-two/ . Los archivos de clave deben ser legibles para OpenXPKI. cp /etc/certs/openxpki_ca-two/ca-signer-1.key /etc/openxpki/ca/ca-two/\n\ncp /etc/certs/openxpki_ca-two/vault-1.key /etc/openxpki/ca/ca-two/\n\ncp /etc/certs/openxpki_ca-two/scep-1.key /etc/openxpki/ca/ca-two/ Cree el enlace simbólico. Además, cree un enlace simbólico para el certificado de la CA raíz. Los enlaces simbólicos son alias utilizdos por la configuración predeterminada. ln -s /etc/openxpki/ca/ca-one/ca-root-1.crt /etc/openxpki/ca/ca-two/ca-root-1.crt\n\nln -s /etc/openxpki/ca/ca-two/ca-signer-1.key /etc/openxpki/ca/ca-two/ca-signer-1.pem\n\nln -s /etc/openxpki/ca/ca-two/scep-1.key /etc/openxpki/ca/ca-two/scep-1.pem\n\nln -s /etc/openxpki/ca/ca-two/vault-1.key /etc/openxpki/ca/ca-two/vault-1.pem Importe el certificado de firmante, el certificado de almacén y el certificado SCEP a la base de datos con los tokens adecuados para  ca-two . openxpkiadm certificate import --file /etc/certs/openxpki_ca-two/ca-signer-1.crt --realm ca-two –issuer /etc/openxpki/ca/ca-two/ca-one-1.crt --token certsign\n\nopenxpkiadm certificate import --file /etc/certs/openxpki_ca-two/scep-1.crt --realm ca-two --token scep\n\nopenxpkiadm certificate import --file /etc/certs/openxpki_ca-two/vault-1.crt --realm ca-two --token datasafe Compruebe si la importación se realiza correctamente utilizando  openxpkiadm alias --realm ca-two . Salida de ejemplo === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set\n En este caso, la información de la CA raíz es la misma para  ca-one  y  ca-two . Si ha cambiado la contraseña de la clave de certificado durante la creación del certificado, actualice  nano /etc/openxpki/config.d/realm/ca-two/crypto.yaml . Genere las CRL para este dominio. Para obtener más información, consulte  . Publique las CRL para este dominio. Para obtener más información, consulte  . Reinicie el servicio OpenXPKI mediante  openxpkictl restart . Salida de ejemplo Stopping OpenXPKI\nStopping gracefully, 3 (sub)processes remaining...\nDONE.\nStarting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Realice lo siguiente para acceder al servidor OpenXPKI: En un navegador web, escriba  http://ipaddress/openxpki/ . Inicie sesión como  Operador . La contraseña predeterminada es  openxpki . El inicio de sesión del operador tiene dos cuentas de operador preconfiguradas,  raop  y  raop2 . creación de certificados certificados creación"},{"UUID":"5a9477bd-1143-4a87-b55a-f430d52feee8","title":"Creación de un segundo dominio","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Configuración del punto final SCEP","descFull":"Configuración del punto final SCEP para varios dominios El punto final SCEP del dominio predeterminado es  http://<ipaddress>/scep/scep . Si tiene varios dominios, configure un punto final SCEP único (archivo de configuración diferente) para cada dominio. En las siguientes instrucciones, utilizamos dos dominios PKI,  ca-one  y  ca-two . Copie el archivo de configuración predeterminado en  cp /etc/openxpki/scep/default.conf /etc/openxpki/scep/ca-one.conf . Asigne al archivo el nombre  ca-one.conf . En  nano /etc/openxpki/scep/ca-one.conf , cambie el valor de dominio a  realm=ca-one . Cree otro archivo de configuración en  cp /etc/openxpki/scep/default.conf /etc/openxpki/scep/ca-two.conf . Asigne al archivo el nombre  ca-two.conf . En  nano /etc/openxpki/scep/ca-two.conf , cambie el valor de dominio a  realm=ca-two . Reinicie el servicio OpenXPKI mediante  openxpkictl restart . Los puntos finales SCEP son los siguientes: ca‑one — http://ipaddress/scep/ca-one ca-two — http://ipaddress/scep/ca-two Si desea diferenciar entre credenciales de inicio de sesión y plantillas de certificado predeterminadas para diferentes dominios PKI, puede que necesite una configuración avanzada. configuración de puntos finales SCEP para varios dominios puntos finales SCEP configuración para varios dominios"},{"UUID":"14987b8e-6382-40c2-a3c5-e60f51ea5ebf","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Activación de varios certificados activos","descFull":"Activación de varios certificados activos con el mismo asunto para que estén presentes a la vez De forma predeterminada, en OpenXPKI sólo puede estar activo un certificado con el mismo nombre de asunto a la vez. Sin embargo, cuando se aplican varios certificados con nombre, deben estar presentes varios certificados activos con el mismo nombre de asunto a la vez. En  /etc/openxpki/config.d/realm/REALM NAME/scep/generic.yaml , en la sección  policy , cambie el valor de  max_active_certs  de  1  a  0 . REALM NAME es el nombre de dominio. Por ejemplo,  ca‑one . Revise el espacio y la sangría en el archivo de script. Reinicie el servicio OpenXPKI mediante  openxpkictl restart . activación de varios certificados activos mismo asunto"},{"UUID":"fb776753-368b-4260-9152-b8c36f82317b","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Definición del número de puerto","descFull":"Definición del número de puerto predeterminado para la CA OpenXPKI De forma predeterminada, Apache escucha en el número de puerto 80. Defina el número de puerto predeterminado para la CA OpenXPKI para evitar conflictos. En  /etc/apache2/ports.conf , agregue o modifique un puerto. Por ejemplo,  Listen 8080 . En  /etc/apache2/sites-enabled/000-default.conf , agregue o modifique la sección  VirtualHost  para asignar un nuevo puerto. Por ejemplo,  <VirtualHost *:8080> . Reinicie el servidor Apache con  systemctl restart apache2 . Para comprobar el estado, ejecute  netstat -tlpn| grep apache . La URL SCEP de OpenXPKI es ahora  http://ipaddress:8080/Scep/ca-one  y la URL web es  http://dirección IP:8080/Openxpki. . definición de números de puerto predeterminados para la CA OpenXPKI números de puerto predeterminados configuración para la CA OpenXPKI"},{"UUID":"07076639-6cea-4b84-a298-58c58caebe8c","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Cómo rechazar solicitudes de certificado","descFull":"Cómo rechazar solicitudes de certificado sin  Contraseña de comprobación  en la CA OpenXPKI De forma predeterminada, OpenXPKI acepta solicitudes sin comprobar la contraseña de comprobación. La solicitud de certificado no se rechaza y la CA y el administrador de la CA determinan si se debe aprobar o rechazar la solicitud. Para evitar posibles problemas de seguridad, desactive esta función de modo que se rechacen inmediatamente todas las solicitudes de certificado que contengan contraseñas no válidas. En MVE, la  Contraseña de comprobación  solo es necesaria cuando se genera el certificado del agente de inscripción. En  etc/openxpki/config.d/realm/REALM NAME/scep/generic.yaml , en la sección  policy , cambie el valor de  allow_man_authen  de  1  a  0 . REALM NAME es el nombre de dominio. Por ejemplo,  ca‑one . Revise el espacio y la sangría en el archivo de script. Reinicie el servicio OpenXPKI mediante  openxpkictl restart . cómo rechazar solicitudes de certificado sin  Contraseña de comprobación  en la CA OpenXPKI solicitudes de certificado sin  Contraseña de comprobación cómo rechazar en la CA OpenXPKI"},{"UUID":"bb2542fd-8b46-4e05-8e7c-b4892f562a5c","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Adición de EKU de autenticación","descFull":"Adición de EKU de autenticación de cliente en los certificados En  /etc/openxpki/config.d/realm/REALM NAME/profile/I18N_OPENXPKI_PROFILE_TLS_SERVER.yaml , en la sección  extended_key_usage:  cambie el valor de  client_auth:  a  1 . REALM NAME es el nombre de dominio. Por ejemplo,  ca‑one . Revise el espacio y la sangría en el archivo de script. Reinicie el servicio OpenXPKI mediante  openxpkictl restart . adición de EKU de autenticación de cliente en los certificados EKU de autenticación de cliente adición de certificados"},{"UUID":"e9da1a97-982a-4e75-a7bb-75e8578fe4d2","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Obtención del asunto del certificado","descFull":"Obtención del asunto del certificado completo al realizar la solicitud a través de SCEP De forma predeterminada, OpenXPKI solo lee el CN del asunto del certificado que se solicita. El resto de la información, como el país, la localidad y el DC, están codificados. Por ejemplo, si un asunto de certificado es  C=US ,  ST=KY ,  L=Lexington ,  O=Lexmark ,  OU=ISS ,  CN=ET0021B7C34AEC.dhcp.dev.lexmark.com , después de firmar el certificado a través de SCEP, el asunto se cambia a  DC=Test Deployment ,  DC= OpenXPKI , CN=ET0021B7C34AEC.dhcp.dev.lexmark.com . REALM NAME es el nombre de dominio. Por ejemplo,  ca‑one . En  /etc/openxpki/config.d/realm/REALM NAME/profile/I18N_OPENXPKI_PROFILE_TLS_SERVER.yaml , en la sección  enroll , cambie el valor de  dn  a lo siguiente: CN=[% CN.0 %][% IF OU %][% FOREACH entry = OU %],OU=[% entry %][% END %][% END %][% IF O %][% FOREACH entry = O %],O=[% entry %][% END %][% END %][% IF L %],L=[% L.0 %][% END %][% IF ST %],ST=[% ST.0 %][% END %][% IF C %],C=[% C.0 %][% END %][% IF DC %][% FOREACH entry = DC %],DC=[% entry %][% END %][% END %][% IF EMAIL %][% FOREACH entry = EMAIL %],EMAIL=[% entry %][% END %][% END %] Guarde el archivo. Cree un archivo denominado  l.yaml  en el directorio  /etc/openxpki/config.d/realm/REALM NAME/profile/template . Agregue lo siguiente: id: L\nlabel: L\ndescription: I18N_OPENXPKI_UI_PROFILE_L_DESC\npreset: L\ntype: freetext\nwidth: 60\nplaceholder: Kolkata Guarde el archivo. Cree un archivo denominado  st.yaml  en el directorio  /etc/openxpki/config.d/realm/REALM NAME/profile/template . Agregue lo siguiente: id: ST\nlabel: ST\ndescription: I18N_OPENXPKI_UI_PROFILE_ST_DESC\npreset: ST\ntype: freetext\nwidth: 60\nplaceholder: WB Guarde el archivo. OpenXPKI debe ser propietario de ambos archivos y debe permitir la lectura, la escritura y la ejecución. Reinicie el servicio OpenXPKI mediante  openxpkictl restart . obtención de asuntos de certificado completos al realizar la solicitud a través de SCEP asuntos de certificado completos solicitud a través de SCEP"},{"UUID":"bbd3e8a7-e360-4796-b5c4-c90bd237b1ee","title":"Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Revocación de certificados y publicación","descFull":"Revocación de certificados y publicación de CRL Acceda al servidor OpenXPKI. En un navegador web, escriba  http://ipaddress/openxpki/ . Inicie sesión como  Operador . La contraseña predeterminada es  openxpki . El inicio de sesión del operador tiene dos cuentas de operador preconfiguradas,  raop  y  raop2 . Haga clic en  Búsqueda de flujo de trabajo Buscar ahora . Haga clic en el certificado que desee revocar y, a continuación, en el enlace del certificado. En la sección  Acción , haga clic en la  solicitud de revocación . Escriba los valores adecuados y, a continuación, haga clic en  Continuar Enviar solicitud . En la página siguiente, apruebe la solicitud. La revocación del certificado está esperando la siguiente publicación de la CRL. En la sección  Operación PKI , haga clic en  Emitir una lista de revocación de certificados (CRL) . Haga clic en  Aplicar creación de listas de revocación Continuar . En la sección  Operación PKI , haga clic en  Publicar CA/CRL . Haga clic en  Búsqueda de flujo de trabajo Buscar ahora . Haga clic en el certificado revocado con el tipo  certificate_revocation_request_v2 . Haga clic en  Forzar reactivación . En la nueva CRL, puede encontrar el número de serie y el motivo de revocación del certificado revocado. revocación de certificados certificados revocación publicación de CRL CRL publicación"},{"UUID":"5bdee323-5140-497e-a530-a6a12dc33217","title":"Configuración de la CA de OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Instalación de la CA OpenXPKI","descFull":"Instalación de la CA OpenXPKI Conecte el equipo utilizando PuTTY u otro cliente. En el cliente, ejecute el comando  sudo su -  para ir al usuario raíz. Introduzca la contraseña raíz. En  nano /etc/apt/sources.list , cambie el origen para la instalación de las actualizaciones. Actualice el archivo. Por ejemplo: #\n\n# deb cdrom:[Debian GNU/Linux testing _Buster_ - Official Snapshot amd64 DVD Binary-1 20190527-04:04]/ buster contrib main\n# deb cdrom:[Debian GNU/Linux testing _Buster_ - Official Snapshot amd64 DVD Binary-1 20190527-04:04]/ buster contrib main\n\ndeb http://security.debian.org/debian-security buster/updates main contrib\ndeb-src http://security.debian.org/debian-security buster/updates main contrib\n\n# buster-updates, previously known as 'volatile'\n# A network mirror was not selected during install. The following entries\n# are provided as examples, but you should amend them as appropriate\n# for your mirror of choice.\n#\ndeb http://ftp.debian.org/debian/ buster-updates main\ndeb-src http://ftp.debian.org/debian/ buster-updates main\ndeb http://ftp.us.debian.org/debian/ buster main\n Guarde el archivo. Ejecute los siguientes comandos: apt-get update apt-get upgrade Actualice las listas de certificados de CA en el servidor mediante  apt-get install ca-certificates . Instale  en_US.utf8 locale  mediante  dpkg-reconfigure locales . Seleccione la configuración regional  en_US.UTF-8 UTF-8  y, a continuación, haga que sea la configuración regional predeterminada del sistema. Utilice las teclas de tabulación y barra espaciadora para seleccionar y desplazarse por el menú. Compruebe las configuraciones regionales que ha generado mediante  locale –a . Salida de ejemplo C\nC.UTF-8\nen_IN\nen_IN.utf8\nen_US.utf8\nPOSIX Copie la huella del paquete de OpenXPKI mediante  nano /home/Release.key . En este caso, copie la clave en  /home . Escriba  55D89776 006F632B E0196E3E D2495509 BAFDDC74 22FEAAD2 F055074E 0FE3A724  como valor. Ejecute el siguiente comando: gpg --print-md sha256 /home/Release.key Agregue el paquete utilizando el comando  wget https: comando  //packages.openxpki.org/v3/debian/Release.key -O - | apt-key add - . Agregue el repositorio a la lista de orígenes (buster) mediante  echo \"deb http://packages.openxpki.org/v3/debian/ buster release\" > /etc/apt/sources.list.d/openxpki.list  y, a continuación,  apt update . Instale el enlace MySQL y Perl MySQL mediante  apt install mariadb-server libdbd-mariadb-perl . Instale apache2.2-common using  apt install apache2 . En  nano /etc/apt/sources.list , instale el módulo fastcgi para acelerar la interfaz de usuario. Recomendamos que se utilice  mod_fcgid . Agregue la línea  deb http://http.us.debian.org/debian/ buster main  en el archivo y, a continuación, guárdelo. Ejecute los siguientes comandos: apt-get update apt install libapache2-mod-fcgid Active el módulo fastcgi mediante  a2enmod fcgid . Instale el paquete principal de OpenXPKI mediante  apt install libopenxpki-perl openxpki-cgi-session-driver openxpki-i18n . Reinicie el  Apache  Servidor mediante  service apache2 restart . Compruebe si la instalación se ha realizado correctamente mediante  openxpkiadm version . Si la instalación se ha realizado correctamente, el sistema muestra la versión de OpenXPKI instalada. Por ejemplo,  Version (core): 3.18.2 . Cree la base de datos vacía y, a continuación, asigne el usuario de la base de datos mediante  mariadb -u root -p . Este comando debe escribirse en el cliente. De lo contrario, no podrá introducir la contraseña. Escriba la contraseña para MySQL. En este caso,  root  es el usuario MySQL. openxpki  es el usuario en el que está instalado OpenXPKI. CREATE DATABASE openxpki CHARSET utf8; \nCREATE USER 'openxpki'@'localhost' IDENTIFIED BY 'openxpki';\nGRANT ALL ON openxpki.* TO 'openxpki'@'localhost';\nflush privileges; Si el servicio MySQL no se está ejecutando, ejecute  /etc/init.d/mysql start  para iniciar el servicio. Escriba  quit  para salir de MySQL. Almacene las credenciales utilizadas en  /etc/openxpki/config.d/system/database.yaml . Contenido de archivo de ejemplo main:\ndebug: 0\ntype: MariaDB\nname: openxpki\nhost: localhost\nport: 3306\nuser: openxpki \npasswd: openxpki Cambie  user  y  passwd  para que coincidan con el nombre de usuario y la contraseña de MariaDB. Guarde el archivo. Para un esquema de base de datos vacío, ejecute  zcat /usr/share/doc/libopenxpki-perl/examples/schema-mariadb.sql.gz | \\ mysql -u root --password --database openxpki  desde el archivo de esquema proporcionado. Introduzca la contraseña de la base de datos. instalación de la CA de OpenXPKI CA de OpenXPKI instalación"},{"UUID":"2697423d-43ea-4682-86c5-a31bce08cb9e","title":"Configuración de la CA de OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Configuración de la CA de","descFull":"Configuración de la CA de OpenXPKI mediante el script predeterminado El script predeterminado solo configura el dominio predeterminado,  ca-one . El CDP y las CRL no se configuran. Ejecute el script mediante  bash /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh . Confirme la configuración mediante  openxpkiadm alias --realm democa . Salida de ejemplo === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set Compruebe si la instalación se realiza correctamente mediante  openxpkictl start . Salida de ejemplo Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Realice lo siguiente para acceder al servidor OpenXPKI: En un navegador web, escriba  http://ipaddress/openxpki/ . Agregue el nombre de usuario y sus contraseñas correspondientes en un archivo  userdb.yaml . Para agregar el nombre de usuario y la contraseña, haga lo siguiente: Eche un vistazo a  /home/pkiadm  y, a continuación, a  nano userdb.yaml . Pegue lo siguiente: estRA:  \n       digest:\"{ssha256}somePassword”\n       role: RA Operator En este caso, estRA hace referencia al nombre de usuario. Para generar la contraseña, escriba  openxpkiadm hashpwd . Cuando aparezca un mensaje solicitando la contraseña y aparezca una contraseña cifrada ssha256, cópiela y péguela en el resumen de cualquier usuario. Las funciones disponibles en el inicio de sesión del operador son Operador de RA, Operador de CA y usuario. Introduzca el nombre de usuario y la contraseña. Cree una solicitud de certificado y, a continuación, pruébela. configuración de la CA de OpenXPKI mediante el script predeterminado CA de OpenXPKI configuración mediante el script predeterminado"},{"UUID":"48b1b712-82e7-45b9-870e-549a951ea6d0","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Descripción general Antes de comenzar,","descFull":"Descripción general Antes de comenzar, asegúrese de que tiene conocimientos básicos sobre la creación de certificados OpenSSL. Para configurar la CA OpenXPKI de forma manual, debe crear lo siguiente: Certificado de la CA raíz. Para obtener más información, consulte  . Certificado del firmante de la CA, firmado por la CA raíz. Para obtener más información, consulte  . Certificado de almacén de datos, autofirmado. Para obtener más información, consulte  . Certificado web, firmado por el certificado del firmante. Para obtener más información, consulte  . Al seleccionar el hash de firma, utilice SHA256 o SHA512. El cambio del tamaño de la clave pública es opcional. Para la versión 3.10 o posterior, puede administrar las claves directamente mediante el comando openxpkiadm alias: Ejecute  mkdir -p /etc/openxpki/local/keys  para crear el directorio. La ubicación predeterminada del directorio es  /etc/openxpki/local/keys . Ejecute  openxpkictl start  para iniciar el servidor. En este caso, vamos a utilizar el directorio  /etc/certs/openxpki_democa/  para la generación de certificados. Sin embargo, puede utilizar cualquier directorio. configuración de la CA de OpenXPKI de forma manual CA de OpenXPKI configuración manual"},{"UUID":"4615e116-2f9c-474f-b188-fccfb39ddbaa","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Creación de un archivo de","descFull":"Creación de un archivo de configuración de OpenSSL El archivo de configuración OpenSSL contiene extensiones X.509 para generar y firmar solicitudes de certificado. Ejecute el siguiente comando: nano /etc/certs/openxpki_democa/openssl.conf Si se puede acceder al servidor mediante el nombre de dominio completo (FQDN), utilice el DNS del servidor en lugar de su dirección IP. Archivo de ejemplo # x509_extensions               = v3_ca_extensions\n# x509_extensions               = v3_issuing_extensions\n# x509_extensions               = v3_datavault_extensions\n# x509_extensions               = v3_scep_extensions\n# x509_extensions               = v3_web_extensions\n# x509_extensions               = v3_ca_reqexts # not for root self-signed, only for issuing\n## x509_extensions              = v3_datavault_reqexts # not required self-signed\n# x509_extensions               = v3_scep_reqexts\n# x509_extensions               = v3_web_reqexts\n\n[ req ]\ndefault_bits            = 4096\ndistinguished_name      = req_distinguished_name\n\n[ req_distinguished_name ]\ndomainComponent         = Domain Component\ncommonName              = Common Name\n\n[ v3_ca_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\n\n[ v3_datavault_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\n\n[ v3_scep_reqexts ]\nsubjectKeyIdentifier    = hash\n\n[ v3_web_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\n\n[ v3_ca_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_issuing_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer:always\ncrlDistributionPoints   = URI:https://FQDN of your system/openxpki/CertEnroll/MYOPENXPKI.crl\nauthorityInfoAccess     = caIssuers;URI:https://FQDN of your system/download/MYOPENXPKI.crt\n\n[ v3_datavault_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_scep_extensions ]\nsubjectKeyIdentifier    = hash\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid,issuer\n\n[ v3_web_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\nbasicConstraints        = critical,CA:FALSE\nsubjectAltName          = DNS:FQDN of est server\ncrlDistributionPoints   = URI:https://FQDN of your system/openxpki/CertEnroll/MYOPENXPKI_ISSUINGCA.cr\nauthorityInfoAccess     = caIssuers;URI:https://FQDN of your system/download/MYOPENXPKI_ISSUINGCA.crt\n Sustituya la dirección IP y el nombre del certificado CA por la información de configuración. Guarde el archivo. archivo de configuración de OpenSSL creación"},{"UUID":"71d7f77e-a8c4-4484-9442-a16f07bf26a5","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Creación de un archivo de","descFull":"Creación de un archivo de contraseña para claves de certificado Ejecute el siguiente comando: nano /etc/certs/openxpki_democa/pd.pass Escriba su contraseña. Guarde el archivo. archivos de contraseña para claves de certificado creación claves de certificado creación de archivos de contraseña"},{"UUID":"6f26d901-cc70-4e56-8d0e-44c1e68992fb","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Creación de un certificado de","descFull":"Creación de un certificado de la CA raíz Puede crear un certificado de la CA raíz autofirmado o generar una solicitud de certificado y, a continuación, obtenerlo firmado por la CA raíz. Sustituya la longitud de clave, el algoritmo de firma y el nombre del certificado por los valores adecuados. Ejecute el siguiente comando: openssl genrsa -out /etc/certs/openxpki_democa/ca-root-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Sustituya el asunto de la solicitud por su información de la CA mediante  openssl req -new -key /etc/certs/openxpki_democa/ca-root-1.key -out /etc/certs/openxpki_democa/ca-root-1.csr . Obtenga el certificado firmado por la CA raíz utilizando  openssl req -config /etc/certs/openxpki_democa/openssl.conf -extensions v3_ca_extensions - x509 -days 3560 -in /etc/certs/openxpki_democa/ca-root-1.csr -key /etc/certs/openxpki_democa/ca-root-1.key -out /etc/certs/openxpki_democa/ca-root-1.crt - sha256 . Vaya a  /etc/certs/openxpki_democa  donde se guarda  ca-root-1.crt . Ejecute el siguiente comando: openxpkiadm certificate import --file ca-root-1.crt certificados CA raíz creación"},{"UUID":"87d71d80-20e1-40f3-aef6-44a03ab71ded","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Creación de un certificado de","descFull":"Creación de un certificado de firmante Sustituya la longitud de clave, el algoritmo de firma y el nombre del certificado por los valores adecuados. Ejecute el siguiente comando: openssl genrsa -out /etc/certs/openxpki_democa/ca-signer-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Cambie el asunto de la solicitud con la información de CA mediante  openssl req -config /etc/certs/openxpki_democa/openssl.conf -reqexts v3_ca_reqexts -new -key /etc/certs/openxpki_democa/ca-signer-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ISSUINGCA -out / etc/certs/openxpki_democa/ca-signer-1.csr . Obtenga el certificado firmado por la CA raíz mediante  openssl x509 -req -extfile /etc/certs/openxpki_democa/openssl.conf -extensions v3_issuing_extensions -days 3650 -in /etc/certs/openxpki_democa/ca-signer-1.csr -CA /etc/certs/openxpki_democa/ca-root-1.crt -CAkey /etc/certs/openxpki_democa/ca-root-1.key -CAcreateserial -out /etc/certs/openxpki_democa/ca-signer-1.crt -sha256 . Ejecute el siguiente comando: openxpkiadm alias --realm democa --token certsign --file ca-signer-1.crt --key ca-signer-1.key certificados de firmante creación"},{"UUID":"36a01182-0898-4336-816c-984f57399704","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Creación de un certificado de","descFull":"Creación de un certificado de almacén El certificado de almacén se firma automáticamente. Sustituya la longitud de clave, el algoritmo de firma y el nombre del certificado por los valores adecuados. Ejecute el siguiente comando: openssl req -new -x509 -keyout vault.key -out vault.crt -days 1100 -config /etc/certs/openxpki_democa/openssl.conf Cambie el asunto de la solicitud con la información de CA mediante  openxpkiadm certificate import --file vault.crt . Ejecute el siguiente comando: openxpkiadm alias --realm democa --token datasafe --file vault.crt --key vault.key Proporcione los valores necesarios, pero mantenga  /CN=DataVault  como asunto. certificados de almacén creación"},{"UUID":"3bd45269-9c4e-4368-9a1d-dcbdd71de826","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Creación de un certificado web","descFull":"Creación de un certificado web Ejecute el siguiente comando: archivo openssl genrsa -out /etc/certs/openxpki_democa/web-1.key -passout:/etc/certs/openxpki_democa/pd.pass 4096 Cambie el asunto de la solicitud con la información de CA mediante  openssl req -config /etc/certs/openxpki_democa/openssl.conf -reqexts v3_web_reqexts -new -key /etc/certs/openxpki_democa/web-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=FQDN of your system -out /etc/certs/openxpki_democa/web-1.csr . Ejecute el siguiente comando: openssl x509 -req -extfile /etc/certs/openxpki_democa/openssl.conf -extensions v3_web_extensions -days 900 -in /etc/certs/openxpki_democa/web-1.csr -CA /etc/certs/openxpki_democa/ca-signer-1.crt -CAkey /etc/certs/openxpki_democa/ca-signer-1.key -CAcreateserial -out /etc/certs/openxpki_democa/web-1.crt -sha256 certificado web creación"},{"UUID":"f8ea49ef-a8cd-42e7-9ea2-8fc1837bfbe7","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Configuración del servidor web Ejecute","descFull":"Configuración del servidor web Ejecute los siguientes comandos: a2enmod ssl rewrite headers a2ensite openxpki a2dissite 000-default default-ssl mkdir -m755 -p /etc/openxpki/tls/chain cp /etc/certs/openxpki_democa/ca-root-1.crt /etc/openxpki/tls/chain/ cp /etc/certs/openxpki_democa/ca-signer-1.crt /etc/openxpki/tls/chain/ c_rehash /etc/openxpki/tls/chain/ mkdir -m755 -p /etc/openxpki/tls/endentity mkdir -m700 -p /etc/openxpki/tls/private cp /etc/certs/openxpki_democa/web-1.crt /etc/openxpki/tls/endentity/openxpki.crt cat /etc/certs/openxpki_democa/ca-signer-1.crt >> /etc/openxpki/tls/endentity/openxpki.crt archivo openssl rsa -in /etc/certs/openxpki_democa/web-1.key -passin:/etc/certs/openxpki_democa/pd.pass -out /etc/openxpki/tls/private/openxpki.pem chmod 400 /etc/openxpki/tls/private/openxpki.pem Reinicie el servicio Apache mediante  apache2 restart . Ejecute el siguiente comando para comprobar que la importación de los archivos se ha realizado correctamente: openxpkiadm alias --realm democa Salida de ejemplo === functional token ===\nca-signer (certsign):\n  \t\tAlias     : ca-signer-2\n  \t\tIdentifier: XjC6MPbsnyfLZkI9Poi9vm4Z5rk\n \t\t NotBefore : 2022-04-06 10:03:01\n  \t\tNotAfter  : 2032-04-03 10:03:01\n\nvault (datasafe):\n  \t\tAlias     : vault-2\n  \t\tIdentifier: G8ekluAsskGVC0N-jZhB2n9kvdM\n  \t\tNotBefore : 2022-04-06 09:53:57\n  \t\tNotAfter  : 2025-04-10 09:53:57\n\nscep (scep):\n  \t\tnot set\n\nratoken (cmcra):\n  \t\tnot set\n\n=== root ca ===\ncurrent root ca:\n  \t\tAlias     : root-2\n  \t\tIdentifier: prTHU5vCfcJuCnQWyb5wUknvXQM\n  \t\tNotBefore : 2022-04-06 09:40:27\n  \t\tNotAfter  : 2032-01-04 09:40:27\n configuración del servidor web servidor web configuración"},{"UUID":"f741ec38-9ee9-4d83-9f49-e12056d1e02a","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Poner la contraseña de la","descFull":"Poner la contraseña de la clave de certificado a disposición de OpenXPKI Cambie el valor en el archivo  nano /etc/openxpki/config.d/system/crypto.yaml . Quite los comentarios de la caché:  daemon under secret: default : secret:\n  default:\n    label: Global Secret group\n    export: 0\n    method: literal\n    value: root\n    cache: daemon contraseña de clave de certificado poner a disposición de openXPKI"},{"UUID":"ede6fa6b-d47d-42f3-8ee4-a520f50099e3","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Inicio de OpenXPKI Ejecute el","descFull":"Inicio de OpenXPKI Ejecute el comando  openxpkictl start Salida de ejemplo Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Acceda al servidor de OpenXPKI: En un navegador web, escriba  http://ipaddress/openxpki/ . Agregue los nombres de usuario y las contraseñas correspondientes en un archivo  userdb.yaml : Eche un vistazo a  /home/pkiadm  y  nano userdb.yaml . Pegue lo siguiente: estRA:  \n       digest:\"{ssha256}somePassword”\n       role: RA Operator Aquí  estRA  hace referencia al nombre de usuario. Para generar la contraseña, escriba  openxpkiadm hashpwd . Aparece un mensaje que muestra la contraseña y una contraseña cifrada con ssha256. Copie la contraseña y péguela en el resumen de cualquier usuario. El inicio de sesión del operador tiene dos funciones preconfiguradas disponibles: Operador de RA, Operador de CA y usuario. Introduzca el nombre de usuario y la contraseña. Cree una solicitud de certificado y, a continuación, pruébela. OpenXPKI inicio"},{"UUID":"1471d481-e521-4fb1-a3dc-6f37ef534606","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Generación de información de la","descFull":"Generación de información de la CRL Si se puede acceder al servidor mediante el FQDN, utilice el DNS del servidor en lugar de su dirección IP. Detenga el servicio OpenXPKI mediante  openxpkictl stop . En  nano /etc/openxpki/config.d/realm/democa/publishing.yaml , actualice la sección  connectors: cdp  para que muestre lo siguiente: class: Connector::Builtin::File::Path\nLOCATION: /var/www/openxpki/CertEnroll/\nfile: \"[% ARGS.0 %].crl\"\ncontent: \"[% pem %]\" En  nano /etc/openxpki/config.d/realm/democa/profile/default.yaml , actualice lo siguiente: crl_distribution_points:  sección critical: 0\nuri:\n    - https://FQDN of the est/openxkpi/CenrtEnroll/[% ISSUER.CN.0 %].crl\n    - ldap://localhost/[% ISSUER.DN %]\n authority_info_access:  sección critical: 0\nca_issuers: http://FQDN of the est/download/MYOPENXPKI.crt\nocsp: http://ocsp.openxpki.org/ Cambie la dirección IP y el nombre del certificado de la CA de acuerdo con el servidor de la CA. La ruta authority_info_access (AIA) se guarda en la carpeta  Download , pero puede establecer la ubicación según sus preferencias. En  nano /etc/openxpki/config.d/realm/democa/crl/default.yaml , realice lo siguiente: Si es necesario, actualice  nextupdate  y  renewal . Agregue  ca_issuers  a la siguiente sección: extensions:\n    \t\tauthority_info_access:\n        \t\t\tcritical: 0\n        \t\t\t# ca_issuers and ocsp can be scalar or list\n        \t\t\tca_issuers: https://FQDN of the est/download/MYOPENXPKI.crt\n       \t\t\t#ocsp: http://ocsp.openxpki.org/\n Cambie la dirección IP y el nombre del certificado de la CA de acuerdo con el servidor de la CA. Inicie el servicio OpenXPKI mediante  openxpkictl start . información de la CRL generación"},{"UUID":"7a5b6813-df16-4fd0-8cce-e5e79309d15c","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Publicación de información de la","descFull":"Publicación de información de la CRL Después de crear las CRL, debe publicarlas para que todos puedan acceder a ellas. Detenga el servicio Apache mediante  service apache2 stop . Cree un directorio  CertEnroll  para la CRL en el directorio  /var/www/openxpki/ . Defina  openxpki  como propietario de este directorio y, a continuación, configure los permisos para permitir a Apache leer y ejecutar, y a otros servicios solo leer. chown openxpki /var/www/openxpki/CertEnroll chmod 755 /var/www/openxpki/CertEnroll Agregue una referencia al archivo alias.conf de Apache mediante  nano /etc/apache2/mods-enabled/alias.conf . Después de la sección  <Directory \"/usr/share/apache2/icons\"> , agregue lo siguiente:         \tAlias /CertEnroll/ \"/var/www/openxpki/CertEnroll/\"\n         \t<Directory \"/var/www/openxpki/CertEnroll\">\n               Options FollowSymlinks\n               AllowOverride None\n               Require all granted\n         \t</Directory> Agregue una referencia en el archivo apache2.conf utilizando  nano /etc/apache2/apache2.conf . Agregue lo siguiente en la sección  Apache2 HTTPD server :          \t<Directory /var/www/openxpki/CertEnroll>\n               Options FollowSymlinks\n               AllowOverride None\n               Allow from all\n         \t</Directory> Inicie el servicio Apache mediante  service apache2 start . información de la CRL publicación"},{"UUID":"9c052394-894e-473f-82a7-a7287eb0af5c","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Activación de la aprobación automática","descFull":"Activación de la aprobación automática de solicitudes de certificado en la CA OpenXPKI Detenga el servicio OpenXPKI mediante  openxpkictl stop . En  /etc/openxpki/config.d/realm/democa/est/default.yaml , actualice la sección  eligible:  : Contenido antiguo eligible:\n\t\t\tinitial:\n\t\t\t\tvalue@: connector:scep.generic.connector.initial\n       \t\targs: '[% context.cert_subject_parts.CN.0 %]'\n       \t\texpect:\n       \t\t\t- Build\n       \t\t\t- New Nuevo contenido eligible:\n\t\t\tinitial:\n\t\t\t\tvalue: 1\n\t\t\t\t# value@: connector:scep.generic.connector.initial\n\t\t\t\t# args: '[% context.cert_subject_parts.CN.0 %]'\n\t\t\t\t# expect:\n\t\t\t\t#\t- Build\n\t\t\t\t#\t- New Revise el espacio y la sangría en el archivo de script. Para aprobar certificados de forma manual, comente  value: 1  y, a continuación, quite el comentario de las otras líneas que se hayan comentado previamente. Guarde el archivo. Inicie el servicio OpenXPKI mediante  openxpkictl start . aprobación automática de solicitudes de certificado activación en la CA de OpenXPKI solicitudes de certificado en la CA de OpenXPKI aprobación automática"},{"UUID":"9bc23ef1-6d42-4662-adc6-209a2901fab2","title":"Configuración de la CA de OpenXPKI de forma manual","link":"managing-certificates-using-EST-group.html","desc":"Cambio de detalles para habilitar","descFull":"Cambio de detalles para habilitar la descarga de certificados CA Ejecute el siguiente comando: /usr/lib/cgi-bin/est.fcgi Sustituya  my $mime = \"application/pkcs7-mime; smime-type=certs-only\";  por  my $mime = \"application/pkcs7-mime\"; . Inicie el servicio OpenXPKI mediante  openxpkictl start . descarga de certificados de ca cambio de detalles para activar"},{"UUID":"ef8cc171-c847-435b-a7dd-ee6ace502d7d","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"Copia y configuración del directorio","descFull":"Copia y configuración del directorio Cree un directorio, a saber  democa2 , para el segundo dominio dentro  de /etc/openxpki/config.d/realm . Copie el árbol de directorios de ejemplo  /etc/openxpki/config.d/realm/ca-one  en un nuevo directorio ( cp -r /etc/openxpki/config.d/realm.tpl/*/etc/openxpki/config.d/realm/democa2 ) dentro del directorio del dominio. En  /etc/openxpki/config.d/system/reinos.yaml , actualice la siguiente sección: Contenido antiguo # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\ndemoca:\n    label: Verbose name of this realm\n    baseurl: https://pki.example.com/openxpki/\n\n#democa2:\n#    label: Verbose name of this realm\n#    baseurl: https://pki.acme.org/openxpki/ Nuevo contenido # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\ndemoca:\n    label: Example.org Demo CA\n    baseurl: https://pki.example.com/openxpki/\n\ndemoca2:\n    label: Example.org Demo CA2\n    baseurl: https://pki.example.com/openxpki/ Guarde el archivo. copia del directorio configuración del directorio directorio copia y configuración"},{"UUID":"0c2382c7-1d39-4fea-ab08-9471792c782f","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"Configuración de puntos finales EST","descFull":"Configuración de puntos finales EST para varios dominios Puede configurar el punto final EST con una tupla compuesta por la parte de autoridad del URI y la etiqueta opcional (por ejemplo, www.ejemplo.com:80 y arbitraryLabel1). En las siguientes instrucciones, utilizamos dos dominios PKI,  democa  y  democa2 . Copie el archivo de configuración predeterminado en  cp /etc/openxpki/est/default.conf /etc/openxpki/est/democa.conf . Asigne al archivo el nombre  democa.conf . En  nano /etc/openxpki/est/democa.conf , cambie el valor de dominio a  realm=democa . De acuerdo a sus necesidades, puede que tenga que quitar los comentarios de las líneas correspondientes para las secciones  simpleenroll ,  simplereenroll ,  csrattrs  y  cacerts . Mantenga comentadas las secciones de entorno. Haga lo mismo para  default.conf . Cree otro archivo de configuración en  cp /etc/openxpki/est/default.conf /etc/openxpki/est/democa2.conf . Asigne al archivo el nombre  democa2.conf . En  nano /etc/openxpki/est/democa2.conf , cambie el valor de dominio a  realm=democa2 . De acuerdo a sus necesidades, puede que tenga que quitar los comentarios de las líneas correspondientes para las secciones  simpleenroll ,  simplereenroll ,  csrattrs  y  cacerts . Mantenga comentadas las secciones de entorno. Copie el archivo  default.yaml  en las siguientes ubicaciones: cp /etc/openxpki/config.d/realm/democa/est/default.yaml /etc/openxpki/config.d/realm/democa/est/democa.yaml Asigne al archivo el nombre  democa.yaml . Copie el archivo  default.yaml  en las siguientes ubicaciones: cp /etc/openxpki/config.d/realm/democa2/est/default.yaml /etc/openxpki/config.d/realm/democa2/est/democa2.yaml Asigne al archivo el nombre  democa2.yaml . Reinicie el servicio OpenXPKI mediante  openxpkictl restart . Seleccione las siguientes URL para abrir el servidor de la EST correspondiente a un dominio a través de un navegador web: democa — http://ipaddress/est/democa democa2 — http://ipaddress/est/democa2 Si desea diferenciar entre credenciales de inicio de sesión y plantillas de certificado predeterminadas para diferentes dominios PKI, puede que necesite una configuración avanzada. configuración de puntos finales EST para varios dominios puntos finales EST configuración para varios dominios"},{"UUID":"6098aaad-3bee-4f18-9d7c-e840b43be107","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"Creación de un certificado de","descFull":"Creación de un certificado de firmante Las siguientes instrucciones muestran cómo generar un certificado de firmante en el segundo dominio. Puede utilizar los mismos certificados raíz y de almacén que los del primer dominio. Cree un archivo de configuración OpenSSL en  nano /etc/certs/openxpki_democa2/openssl.conf . Cambie el nombre común del certificado para que el usuario pueda distinguir fácilmente entre distintos certificados para diferentes dominios. Los archivos de certificado se crean en el directorio  /etc/certs/openxpki_democa2/ . Vaya al directorio del certificado del almacén en el primer dominio y, a continuación, importe el certificado desde el primer dominio. Ejecute el siguiente código: openxpkiadm alias --realm democa2 --token datasafe --file vault.crt certificados creación certificados de firmante creación"},{"UUID":"e3e25e0b-b534-49ac-ab8c-394cba01e033","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"Creación de un archivo de","descFull":"Creación de un archivo de contraseña para claves de certificado Ejecute el siguiente comando: nano /etc/certs/openxpki_democa2/pd.pass Escriba su contraseña. Cree un certificado de firmante. Para obtener más información, consulte  . Compruebe que la importación se realiza correctamente mediante  openxpkiadm alias --realm democa2 . Si cambió la contraseña de clave del certificado durante la creación del certificado, actualice  nano /etc/openxpki/config.d/realm/democa2/crypto.yaml . Genere las CRL para el segundo dominio. Para obtener más información, consulte  . Asegúrese de utilizar el nombre de certificado CA correcto según el dominio. Publique las CRL para este dominio. Para obtener más información, consulte  . Reinicie el servicio OpenXPKI mediante  openxpkictl restart . Salida de ejemplo Stopping OpenXPKI\nStopping gracefully, 3 (sub)processes remaining...\nDONE.\nStarting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. creación de archivos de contraseña para claves de certificado archivos de contraseña para claves de certificado creación claves de certificado creación de archivos de contraseña"},{"UUID":"f3040e20-8b57-4b97-9939-640cd61905b2","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"Activación de varios certificados activos","descFull":"Activación de varios certificados activos con el mismo asunto para que estén presentes a la vez De forma predeterminada, en OpenXPKI sólo puede estar activo un certificado con el mismo nombre de asunto a la vez. Sin embargo, cuando se aplican varios certificados con nombre, deben estar presentes varios certificados activos con el mismo nombre de asunto a la vez. En  /etc/openxpki/config.d/realm/REALM NAME/est/< REALM NAME >.yaml , en la sección  policy , cambie el valor de  max_active_certs  de  1  a  0 . REALM NAME es el nombre de dominio. Por ejemplo,  ca‑one . Revise el espacio y la sangría en el archivo de script. Reinicie el servicio OpenXPKI mediante  openxpkictl restart . varios certificados activos con el mismo asunto activación certificados con el mismo asunto activación"},{"UUID":"4da2475f-35c7-43fb-9b35-d8f26bbd4fe5","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"Definición del número de puerto","descFull":"Definición del número de puerto predeterminado para la CA OpenXPKI De forma predeterminada, Apache escucha en el número de puerto 443 para https. Defina el número de puerto predeterminado para la CA OpenXPKI para evitar conflictos. En  /etc/apache2/ports.conf , modifique el puerto 443 a cualquier otro puerto. Por ejemplo: Contenido antiguo Listen 80\n\n<IfModule ssl_module>\n   Listen 443\n</IfModule>\n\n<IfModule mod_gnutls.c>\n  Listen 443\n</IfModule> Nuevo contenido Listen 80\n\n<IfModule ssl_module>\n   Listen 9443\n</IfModule>\n\n<IfModule mod_gnutls.c>\n  Listen 9443\n</IfModule> En  /etc/apache2/sites-available/openxpki.conf , agregue o modifique la sección  VirtualHost  para asignar un nuevo puerto. Por ejemplo,  <VirtualHost *:443>  a  <VirtualHost *:9443> . En  /etc/apache2/sites-available/default-ssl.conf , agregue o modifique la sección  VirtualHost  para asignar un nuevo puerto. Por ejemplo, cambie  <VirtualHost *:443>  a  <VirtualHost *:9443> . Reinicie el servidor Apache con  systemctl restart apache2 . Si solicita la frase de contraseña para   SSL/TLS , escriba la contraseña mientras agrega el certificado del servidor web TLS en el servidor EST. En  tinddopenxpkiweb01.dhcp.dev.lexmark.com:9443 (RSA): , introduzca la frase de contraseña para las claves  SSL/TLS . Para comprobar el estado, ejecute  netstat -tlpn| grep apache . La URL de OpenXPKI SCEP es ahora  https://ipaddress  y la URL web es  FQDN:9443/openxpki . números de puerto predeterminados para la CA de OpenXPKI cambio números de puerto predeterminados cambio para la CA de OpenXPKI Números de puerto predeterminados de la CA de OpenXPKI cambio"},{"UUID":"5dbb26ed-5413-47e1-b127-330bf94f8d75","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"Activación de la autenticación básica","descFull":"Activación de la autenticación básica Ejecute el siguiente comando: apt -y install apache2-utils Cree una cuenta de usuario que tenga acceso al servidor. Introduzca la siguiente información: htpasswd -c /etc/apache2/.htpasswd <username>\n                New password:     \n                Re-type new password:\n                Adding password for user <username> Vaya al directorio  cd /etc/apache2/sites-enabled/ . En  nano openxpki.conf , agregue las siguientes líneas en  <VirtualHost *: 443 block> : #HTTPS BASIC AUTH FOR LABELS\nLocation /.well-known/est/*/simpleenroll\n    AuthType Basic\n    AuthName \"estrealm\"\n    AuthUserFile /etc/apache2/.htpasswd\n    require valid-user\n    </Location>\n    #HTTPS BASIC AUTH FOR NO LABEL\n    <Location /.well-known/est/simpleenroll>\n    AuthType Basic\n    AuthName \"estrealm\"\n    AuthUserFile /etc/apache2/.htpasswd\n    require valid-user\n    </Location> Agregue   ErrorDocument 401 %{unescape:%00}   antes de  SSLEngine  en el mismo bloque de host virtual. Ejemplo ServerAlias *\nDocumentRoot /var/www/\nErrorDocument 401 %{unescape:%00}\nSSLEngine On Inicie el  apache2  con  service apache2 start . La autenticación básica funciona con el nombre de usuario y la contraseña anteriores. activación de la autenticación básica autenticación básica activación"},{"UUID":"4cbeba79-ad24-45a5-a0db-fc4c8b186e74","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"Activación de la autenticación de","descFull":"Activación de la autenticación de certificado de cliente Vaya al siguiente directorio:  cd /etc/apache2/sites-enabled/ . Para el host requerido en  nano openxpki.conf , agregue  SSLVerifyClient require . Por ejemplo, si está utilizando el puerto 443, modifique la sección  VirtualHost  a: <VirtualHost *:443>\nSSLVerifyClient require\n</VirtualHost> Elimine el comando  SSLVerifyClient optional_no_ca . Guarde el archivo y, a continuación, escriba  quit  para salir de MySQL. Vaya al siguiente directorio:  cd /etc/openxpki/config.d/realm/democa/est . Abra  default.yaml  y  democa.yaml . Si la etiqueta es diferente, cambie el archivo YAML. Ejecute el siguiente comando: vi default.yaml En la sección  authorized_signer , agregue lo siguiente: authorized_signer:\nrule2:\n\t\t\tsubject: CN=,. Por ejemplo, si el nombre del asunto del certificado de cliente es  test123 , agregue lo siguiente en la sección  authorized_signer : authorized_signer:\nrule1:\n\t\t# Full DN\t\n\t\tsubject: CN=.+:pkiclient,.\nrule2:\t\n\t\tsubject: CN=test123,.* Guarde el archivo y, a continuación, escriba  quit  para salir de MySQL. Reinicie el servicio OpenXPKI mediante  openxpkictl restart . Inicie el servicio Apache mediante  service apache2 restart . autenticación básica activación"},{"UUID":"05eed18e-104d-499a-827f-9c1396dcc086","title":"Creación de un segundo dominio","link":"managing-certificates-using-EST-group.html","desc":"¿Qué causa el error de","descFull":"¿Qué causa el error de falta de coincidencia de SAN que impide que el sistema busque la CRL? El error de falta de coincidencia de SAN puede ocurrir cuando se activa la información de CRL. Este error indica que la dirección IP o el nombre de host no coinciden con el valor de SAN del certificado web. Para evitar que se produzca este error, utilice el FQDN en la ruta de acceso de la CRL en lugar de la IP. También puede configurar el certificado web y utilizar el FQDN del sistema en el campo SAN. ¿Por qué están sin conexión los tokens ca‑signer‑1 y vault‑1? Si la página  Estado del sistema  muestra que los tokens ca‑signer‑1 y vault‑1 están sin conexión, haga lo siguiente: En  /etc/openxpki/config.d/realm/realm name/crypto.yaml , cambie el valor de la clave correspondiente. Reinicie el servicio de OpenXPKI. preguntas más frecuentes preguntas frecuentes"},{"UUID":"fd6a6e33-4ef3-4cc2-ad15-d2ba19bcc2ef","title":"Administración de alertas de impresora","link":"managing-printer-alerts-overview-topic.html","desc":"Descripción general Las alertas se","descFull":"Descripción general Las alertas se activan cuando hay una impresora que requiere atención. Las acciones le permiten enviar correos electrónicos personalizados o ejecutar scripts cuando se produce una alerta. Los eventos definen las acciones que se ejecutan cuando las alertas específicas están activas. Para registrar alertas de una impresora, cree acciones y asócielas a un evento. Asigne el evento a las impresoras que desee controlar. Esta función no se aplica a las impresoras protegidas. descripción general de la administración de alertas de impresoras descripción general administración de alertas de impresora"},{"UUID":"4f75287c-e55c-419c-9e22-bfbf0b9dc30e","title":"Administración de alertas de impresora","link":"creating-action-topic.html","desc":"Creación de una acción Una","descFull":"Creación de una acción Una acción es una notificación por correo electrónico o un registro del visor de eventos. Las acciones asignadas a los eventos se activan cuando aparece una alerta de impresora. En el menú  Impresoras , haga clic en  Eventos y acciones Acciones Crear . Escriba un nombre exclusivo para la acción y su descripción. Seleccione un tipo de acción. Correo electrónico Antes de empezar, asegúrese de que los ajustes del correo electrónico están configurados. Para obtener más información, consulte  . En el menú  Tipo , seleccione  Correo electrónico . Introduzca los valores apropiados en los campos. También puede utilizar los marcadores disponibles como la totalidad o parte del título del asunto, o como parte de un mensaje de correo electrónico. Para obtener más información, consulte  . Haga clic en  Crear acción . Registrar evento En el menú  Tipo , seleccione  Registrar evento . Escriba los parámetros del evento. También puede utilizar los marcadores de posición disponibles en el menú desplegable. Para obtener más información, consulte  . Haga clic en  Crear acción . acciones creación creación de una acción marcadores de posición acción de correo electrónico acción de registro de eventos"},{"UUID":"b769be74-b322-4caf-ab10-776eeec6d68f","title":"Administración de alertas de impresora","link":"understanding-action-placeholders-topic.html","desc":"Descripción de los marcadores de","descFull":"Descripción de los marcadores de posición de acción Utilice los marcadores disponibles en el título del asunto o el mensaje de correo electrónico. Los marcadores de posición representan elementos variables y se sustituyen por valores reales cuando se utilizan. ${eventHandler.timestamp} —La fecha y la hora en que se MVE ha procesado el evento. Por ejemplo,  14 de marzo de 2017 1:42:24 PM . ${eventHandler.name} —El nombre del evento. ${configurationItem.name} —El nombre del sistema de la impresora que ha desencadenado la alerta. ${configurationItem.address} —La dirección MAC de la impresora que ha desencadenado la alerta. ${configurationItem.ipAddress} —La dirección IP de la impresora que ha desencadenado la alerta. ${configurationItem.ipHostname} —El nombre de host de la impresora que ha desencadenado la alerta. ${configurationItem.model} —El nombre de modelo de la impresora que ha desencadenado la alerta. ${configurationItem.serialNumber} —El número de serie de la impresora que ha desencadenado la alerta. ${configurationItem.propertyTag} —La etiqueta de propiedad de la impresora que ha desencadenado la alerta. ${configurationItem.contactName} —El nombre de contacto de la impresora que ha desencadenado la alerta. ${configurationItem.contactLocation} —La ubicación de contacto de la impresora que ha desencadenado la alerta. ${configurationItem.Manufacturer} —El fabricante de la impresora que ha desencadenado la alerta. ${alert.name} —El nombre de la alerta que se ha activado. ${alert.state} —El estado de la alerta. Puede estar activa o borrada. ${alert.location} —La ubicación dentro de la impresora donde se ha producido la alerta activada. ${alert.Escriba} —La gravedad de la alerta activada, como  Advertencia  o  Se necesita intervención . descripción de los marcadores de posición de acción marcadores de posición de acción descripción acción marcadores de posición"},{"UUID":"03cc0f0c-ca90-4b26-820c-06572c2c016d","title":"Administración de alertas de impresora","link":"managing-actions-topic.html","desc":"Administración de acciones En el","descFull":"Administración de acciones En el menú Impresoras, haga clic en  Eventos y acciones Acciones . Haga lo siguiente: Editar una acción Seleccione una acción y haga clic en  Editar . Configure los valores. Haga clic en  Guardar cambios . Eliminar acciones Seleccione una o más acciones. Haga clic en  Eliminar y, a continuación, confirme la eliminación. Probar una acción Seleccione una acción y, a continuación, haga clic en  Probar . Para verificar los resultados, consulte los registros de tareas. Para obtener más información, consulte  . Si va a probar una acción de correo electrónico, a continuación, compruebe si el correo electrónico se ha enviado al destinatario. administración de acciones acciones administración acciones edición acciones eliminación acciones pruebas edición de acciones eliminación de acciones prueba de acciones"},{"UUID":"ff45d3ff-dae8-4d1d-81a5-51ea1812093f","title":"Administración de alertas de impresora","link":"creating-event-topic.html","desc":"Creación de un evento Puede","descFull":"Creación de un evento Puede controlar alertas en su grupo de impresoras. Cree un evento y, a continuación, defina una acción para que se ejecute cuando se produzcan las alertas especificadas. Los eventos no se admiten en las impresoras protegidas. En el menú Impresoras, haga clic en  Eventos y acciones Eventos Crear . Introduzca un nombre exclusivo para el evento y su descripción. En la sección Alertas, seleccione una o más alertas. Para obtener más información, consulte  . En la sección Acciones, seleccione una o más acciones para ejecutar cuando se activen las alertas seleccionadas. Para obtener más información, consulte  . Active el sistema para ejecutar las acciones seleccionadas cuando las alertas se desactiven en la impresora. Establezca un periodo de gracia antes de ejecutar las acciones seleccionadas. Si se elimina la alerta durante el período de gracia, no se ejecutará la acción. Haga clic en  Crear evento . creación de un evento evento crear"},{"UUID":"4d47b7ab-4240-4be7-982e-b2235de164fd","title":"Administración de alertas de impresora","link":"understanding-printer-alerts-topic.html","desc":"Descripción de las alertas de","descFull":"Descripción de las alertas de impresora Las alertas se activan cuando hay una impresora que requiere atención. Las siguientes alertas se pueden asociar a un evento en MVE: Atasco del Alimentador automático de documentos (ADF) atasco —Se ha producido un atasco de papel en el ADF y tiene que retirarse físicamente. Atasco de la salida del ADF del escáner Atasco del alimentador del ADF del escáner Atasco del inversor del ADF del escáner Papel eliminado del ADF del escáner Falta papel en el ADF del escáner Atasco del prerregistro del ADF del escáner Atasco del registro del ADF del escáner Alerta de escáner- Reemplace todos los originales si reinicia el trabajo Puerta o cubierta abierta —Hay una puerta abierta en la impresora y debe cerrarse. Comprobar puerta/cubierta - buzón Puerta abierta Alerta de cubierta Cubierta cerrada Cubierta abierta Cubierta abierta o falta cartucho Cubierta del dúplex abierta Cubierta del ADF del escáner abierta Atasco de escáner Cubierta de acceso abierta Tamaño o tipo de soporte incorrecto —Se está imprimiendo un trabajo que requiere que se cargue un papel determinado en la bandeja. Tamaño de sobre incorrecto Alimentación manual incorrecta Papel incorrecto Tamaño de papel incorrecto Cargar papel Memoria llena o error —Se está agotando la memoria de la impresora y se tienen que aplicar cambios. Página compleja Los archivos se eliminarán Memoria clasif. insuficiente Memoria para defragmentar insuficiente Memoria de fax insuficiente Memoria insuficiente Memoria insuficiente: puede que se pierdan los trabajos retenidos Memoria insuficiente para guardar recursos Memoria llena Escasez de memoria PS Demasiadas páginas en el escáner - escáner cancelado Reducción de la resolución Funcionamiento incorrecto de la opción —Una opción asociada a la impresora se encuentra en estado de error. Las opciones incluyen opciones de entrada, opciones de salida, tarjetas de fuente, tarjetas Flash de usuario, discos y clasificadores. Comprobar alineación/conexión Comprobar conex. del dúplex Comprobar instalación de clasificador/buzón Comprobar alimentación Opción dañada Opción defectuosa Retirar dispositivo Alerta de dúplex Falta bandeja dúplex Adaptador de red externo desconectado Alerta de clasificador Puerta del clasificador o interbloqueo abiertos Placa para el papel del clasificador abierta Dispositivo dúplex incompatible Dispositivo de entrada incompatible Dispositivo de salida incompatible Dispositivo desconocido incompatible Instalación de opción incorrecta Alerta de entrada Error de configuración de bandeja de entrada Alerta de opción Bandeja de salida llena Bandeja de salida casi llena Error de configuración de salida Opción llena Falta la opción Falta mecanismo de alimentación de papel Imprimir trabajos con la opción Reinstalar dispositivo Reinstalar dispositivo de salida Demasiadas entradas instaladas Demasiadas opciones instaladas Demasiadas salidas instaladas Falta la bandeja Falta la bandeja durante encendido Error de sensor de bandeja Entrada no calibrada Opción no formateada Opción no admitida Reinstalar dispositivo de entrada Atasco de papel —Se ha producido un atasco de papel en la impresora y se tiene que retirar físicamente. Atasco de papel interno Alerta de atasco Atasco de papel Error del escáner —El escáner tiene un problema. Cable trasero del escáner desenchufado El carro del escáner está bloqueado Limpieza del cristal de la superficie y de la cinta de soporte del escáner Escáner desactivado Cubierta de la superficie del escáner abierta Cable frontal del escáner desenchufado Registro de escáner no válido Error de suministros —Un suministro de la impresora tiene un problema. Suministro incorrecto La región del cartucho no coincide Suministro defectuoso Faltan la unidad de fusor o el rodillo de aplicación Falta el cartucho izquierdo, o bien, no es válido Falta el cartucho derecho, o bien, no es válido Suministro no válido Fallo importante Alerta de suministro Atasco de suministros Falta suministro Se ha tirado de la palanca de extracción del cartucho de tóner El cartucho de tóner no se ha instalado correctamente Suministro no calibrado Suministro sin licencia Suministro no admitido Suministros o consumibles vacíos —Un suministro de la impresora tiene que ser sustituido. Entrada vacía Duración agotada Impresora lista para mantenimiento Mantenimiento programado Suministro vacío Suministro lleno Suministro lleno o falta La impresora envía la alerta como error y como advertencia. Si se activa alguna de estas alertas, la acción que tiene asociada se realiza dos veces. Suministros o consumibles bajos —Un suministro de la impresora se está agotando. Aviso temprano Primero inferior Entrada baja Agotándose Casi vacío Casi bajo Suministro bajo Suministro casi lleno Alerta o condición no clasificada Error de calibración de color Error de transmisión de datos Fallo de CRC de motor Alerta externa Pérdida de conexión de fax Ventilador detenido Hex. activo Inserte páginas dúplex y pulse Continuar Alerta interna El adaptador de red interno requiere mantenimiento Alerta de unidad lógica Sin conexión Sin conexión para el indicador de advertencia Se ha producido un error en la operación Alerta de intervención del operador Error de página Alerta de puerto Error de comunicación de puerto Puerto desactivado Ahorro energía Apagando Tiempo de espera del trabajo PS Tiempo de espera manual PS Instalación requerida Error de totales de validación de SIMM Calibración de suministro Fallo del sensor de parches de tóner Condición de alerta desconocida Configuración desconocida Condición de alerta de escáner desconocida Usuario(s) bloqueado(s) Alerta de advertencia descripción de las alertas de impresora alertas de impresora descripción"},{"UUID":"cee2f338-f5f9-4efa-b880-a55cb155b05e","title":"Administración de alertas de impresora","link":"managing-events-topic.html","desc":"Administración de eventos En el","descFull":"Administración de eventos En el menú Impresoras, haga clic en  Eventos y acciones Eventos . Realice una de las siguientes acciones: Editar un evento Seleccione un evento y haga clic en  Editar . Configure los valores. Haga clic en  Guardar cambios . Eliminar eventos Seleccione uno o más eventos. Haga clic en  Eliminar y, a continuación, confirme la eliminación. administración de eventos eventos administración eventos edición eventos eliminación"},{"UUID":"40115d7a-19d4-4681-a0b4-0e6151a5de63","title":"Visualización del estado y el historial de las tareas","link":"viewing-task-status-history-overview-topic.html","desc":"Descripción general Las tareas son","descFull":"Descripción general Las tareas son cualquier actividad de administración de impresoras realizadas en MVE, tales como la búsqueda de impresoras, auditorías y la ejecución de las configuraciones. La página  Estado  muestra el estado de todas las tareas que se están ejecutando actualmente y las tareas ejecutadas en las últimas 72 horas. La información sobre las tareas que se están ejecutando actualmente se introduce en el registro. Las tareas anteriores a 72 horas solo se pueden ver como entradas de registro individuales en la página  Registro , y se pueden buscar utilizando los identificadores de tarea. descripción general de la visualización del estado y el historial de la tarea descripción general visualización del estado y el historial de la tarea"},{"UUID":"13c5e458-b1e1-4d83-9639-42c85c4db495","title":"Visualización del estado y el historial de las tareas","link":"viewing-task-status-topic.html","desc":"Visualización del estado de la","descFull":"Visualización del estado de la tarea En el menú Tareas, haga clic en  Estado . El estado de la tarea se actualiza en tiempo real. Visualización del estado de la tarea Estado de la tarea visualización"},{"UUID":"559b52e8-0ab1-41fc-aa86-9bb87a242ada","title":"Visualización del estado y el historial de las tareas","link":"stopping-tasks-topic.html","desc":"Detención de tareas En el","descFull":"Detención de tareas En el menú Tareas, haga clic en  Estado . En la sección Tareas en ejecución, seleccione uno o más tareas. Haga clic en  Parar . detención de tareas tareas detención"},{"UUID":"2f51af36-495c-4783-92e6-471372857b77","title":"Visualización del estado y el historial de las tareas","link":"viewing-logs-topic.html","desc":"Visualización de archivos de registro","descFull":"Visualización de archivos de registro En el menú Tareas, haga clic en  Registros . Seleccione las categorías de tareas, los tipos de tareas o un período de tiempo. Utilice el campo de búsqueda para buscar varias ID de tareas. Utilice comas para separar varias ID de tareas o un guión para indicar un intervalo. Por ejemplo,  11, 23, 30-35 . Para exportar los resultados de la búsqueda, haga clic en  Exportar a CSV . visualización de registros registros visualización"},{"UUID":"d70e17e8-2d13-4fc7-9b36-d9ee27866a78","title":"Visualización del estado y el historial de las tareas","link":"clearing-logs-topic.html","desc":"Borrado de registros En el","descFull":"Borrado de registros En el menú Tareas, haga clic en  Registro . Haga clic en  Borrar registro  y, a continuación, seleccione una fecha. Haga clic en  Borrar registro . borrado de registros registros borrado"},{"UUID":"de24414d-78af-4a2d-aa0f-47aa5a2b6c7c","title":"Visualización del estado y el historial de las tareas","link":"exporting-logs-topic.html","desc":"Exportación de registros En el","descFull":"Exportación de registros En el menú  Tareas  , haga clic en  Registro . Seleccione las categorías de tareas, los tipos de tareas o un período de tiempo. Haga clic en  Exportar a CSV . exportación de registros registros exportación"},{"UUID":"b0503448-a9ab-4712-adf9-d2228557ad21","title":"Programación de tareas","link":"creating-schedule-topic.html","desc":"Creación de un programa En","descFull":"Creación de un programa En el menú  Tareas , haga clic en  Programar Crear . En la sección  General , escriba un nombre exclusivo para las tareas programadas y su descripción. En la sección  Tareas , realice una de las siguientes acciones: Programar una auditoría Seleccione una  Auditoría . Seleccione una búsqueda guardada. Programar una comprobación de conformidad Seleccione el grado de  Conformidad . Seleccione una búsqueda guardada. Programar una comprobación del estado de una impresora Seleccione  Estado actual . Seleccione una búsqueda guardada. Seleccione una acción. Programar una implementación de configuración Seleccione  Implementar archivo . Seleccione una búsqueda guardada. Busque el archivo y, a continuación, seleccione el tipo de archivo. Si es necesario, seleccione un método de implementación o protocolo. Programar una búsqueda Seleccione  Búsqueda . Seleccione un perfil de búsqueda. Programar una aplicación de configuración Seleccione  Aplicación . Seleccione una búsqueda guardada. Programar una validación de certificado Seleccione  Validar certificado . Durante la validación, MVE se comunica con el servidor de la CA para descargar la cadena de certificados y la lista de revocación de certificados (CRL). También se genera el certificado de agente de inscripción. Este certificado permite al servidor de la CA confiar en MVE. Programar una exportación de visualización Seleccione  Ver exportación . Seleccione una búsqueda guardada. Seleccione una plantilla de visualización. Escriba la lista de direcciones de correo electrónico donde se envían los archivos exportados. En la sección  Programar , establezca la fecha, la hora y la frecuencia de la tarea. Haga clic en  Crear una tarea programada . creación de un programa programación creación"},{"UUID":"b64f12d8-f302-4bb2-912d-b1fb3de2c1a7","title":"Programación de tareas","link":"managing-schedules-topic.html","desc":"Administración de tareas programadas En","descFull":"Administración de tareas programadas En el menú  Tareas  , haga clic en  Programa . Realice una de las siguientes acciones: Editar una tarea programada Seleccione una tarea y haga clic en  Editar . Configure los valores. Haga clic en  Editar tarea programada . La información sobre la última ejecución se elimina cuando se edita una tarea programada. Eliminar una tarea programada Seleccione una tarea y haga clic en  Eliminar . Haga clic en  Eliminar tarea programada . administración de tareas programaciones administración edición de programaciones eliminación de programaciones programaciones edición programaciones eliminación"},{"UUID":"3b061ff1-e20e-4d45-8217-7a89fbd00c6d","title":"Realización de otras tareas administrativas","link":"configuring-system-settings-topic.html","desc":"Configuración de los valores generales","descFull":"Configuración de los valores generales Haga clic en  , en la esquina superior derecha de la página. Haga clic en  General  y, a continuación, seleccione una fuente de nombre de host. Impresora —El sistema recupera el nombre de host de la impresora. Búsqueda DNS inversa —El sistema recupera el nombre de host de la tabla DNS mediante la dirección IP. Establezca la frecuencia de nuevo registro de la alerta. Las impresoras pueden perder el estado de registro de alertas cuando se realizan cambios como, por ejemplo, reiniciar o actualizar el firmware. MVE intenta recuperar el estado automáticamente en el siguiente intervalo establecido de la frecuencia de nuevo registro de alertas. Configure los siguientes ajustes de registro del sistema: Hora de inicio de la limpieza del registro del sistema : La hora a la que se inicia la limpieza de los registros del sistema o de las tareas. Período de retención de registros del sistema (semanas) : El número de semanas durante las que se almacenan los registros del sistema en la base de datos. Se eliminan las entradas almacenadas en la base de datos durante más de 52 semanas. Archivo de registros del sistema : Permite al sistema archivar los registros del sistema y las entradas codificadas en el sistema de archivos. El destino y el formato de los archivos se definen en el archivo log4j2.xml. Haga clic en  Guardar cambios . configuración de los valores generales valores generales configuración"},{"UUID":"a16767a3-3ef3-4df7-844f-ca7adf1385e1","title":"Realización de otras tareas administrativas","link":"configuring-email-settings-topic.html","desc":"Configuración de los valores del","descFull":"Configuración de los valores del correo electrónico Active la configuración de SMTP para que MVE pueda enviar archivos de exportación de datos y notificaciones de eventos mediante correo electrónico. Haga clic en  , en la esquina superior derecha de la página. Haga clic en  Correo electrónico  y, a continuación, seleccione  Habilitar configuración SMTP de correo electrónico . Escriba el servidor de correo electrónico SMTP y el puerto. Seleccione el cifrado adecuado. Para el cifrado SSL, seleccione el puerto 465. Para el cifrado TLS/STARTTLS, seleccione el puerto 587. Escriba la dirección de correo electrónico del remitente. Si un usuario se tiene que conectar antes de enviar correos electrónicos, seleccione  Inicio de sesión obligatorio  y, a continuación, introduzca las credenciales del usuario. Haga clic en  Guardar cambios . configuración de los valores del correo electrónico valores del correo electrónico configuración"},{"UUID":"52543719-a288-42d8-aaab-eb0bd8975bfd","title":"Realización de otras tareas administrativas","link":"adding-login-disclaimer-topic.html","desc":"Adición de una renuncia de","descFull":"Adición de una renuncia de responsabilidad de inicio de sesión Puede configurar una renuncia de responsabilidad de inicio de sesión que se muestre cuando los usuarios se conecten con una nueva sesión. Los usuarios deben aceptar la renuncia de responsabilidad antes de acceder a MVE. Haga clic   en la esquina superior derecha de la página. Haga clic en  Renuncia de responsabilidad  y, a continuación, seleccione  Activar renuncia de responsabilidad antes de iniciar sesión . Escriba el texto de renuncia de responsabilidad. Haga clic en  Guardar cambios . adición de una renuncia de responsabilidad de inicio de sesión renuncia de responsabilidad de inicio de sesión adición"},{"UUID":"b7453c97-b672-481f-b036-df801883dfd6","title":"Realización de otras tareas administrativas","link":"signing-mve-certificate-topic.html","desc":"Firma del certificado MVE Secure","descFull":"Firma del certificado MVE Secure Socket Layer (SSL) o Transport Layer Security (TLS) es un protocolo de seguridad que utiliza el cifrado de datos y la autenticación de certificados para proteger la comunicación servidor-cliente. En MVE, se utiliza TLS para proteger la información confidencial que se comparte entre el servidor MVE y el navegador web. La información protegida puede comprender contraseñas de impresora, políticas de seguridad, credenciales de usuario de MVE o información de autenticación de la impresora, como LDAP o Kerberos. TLS permite al servidor MVE y el navegador web cifrar los datos antes de enviarlos y descifrarlos luego tras su recepción. SSL también requiere que el servidor presente un certificado que demuestre su identidad ante el navegador web. Este certificado se firma automáticamente o mediante una autoridad de certificación externa de confianza. De forma predeterminada, MVE está configurado para utilizar un certificado firmado automáticamente. Descargue la solicitud de firma del certificado. Haga clic en  , en la esquina superior derecha de la página. Haga clic en  TLS Descargar . Seleccione  Solicitud de firma de certificado . La solicitud de firma de certificado incluye nombres alternativos de sujeto (SAN). Utilice una autoridad de certificación de confianza para firmar la solicitud de certificado. Instale el certificado firmado por la autoridad de certificación. Haga clic en  , en la esquina superior derecha de la página. Haga clic en  TLS Instalar certificado firmado . Cargue el certificado firmado de la autoridad de certificación y haga clic en  Instalar certificado . Haga clic en  Reiniciar servicio MVE . Reiniciar el servicio MVE también reinicia el sistema, por lo que es posible que el servidor no se encuentre disponible en los siguientes minutos. Antes de reiniciar el servicio, asegúrese de que no haya tareas ejecutándose actualmente. firma del certificado MVE certificado MVE firma"},{"UUID":"7d6a2562-d3e8-4e95-9e18-0369e462e33b","title":"Realización de otras tareas administrativas","link":"removing-user-information-topic.html","desc":"Eliminación de la información de","descFull":"Eliminación de la información de usuario y las referencias a este MVE cumple con las normas de protección de datos que establece el Reglamento General de Protección de Datos (RGPD). MVE puede configurarse para aplicar el derecho al olvido y eliminar del sistema la información privada del usuario. Eliminación de usuarios Haga clic en  , en la esquina superior derecha de la página. Haga clic en  Usuario  y seleccione uno o más usuarios. Haga clic en  Eliminar Eliminar usuarios . Eliminación de las referencias a un usuario de LDAP Haga clic en  , en la esquina superior derecha de la página. Haga clic en  LDAP . Elimine toda la información relacionada con el usuario en los filtros de búsqueda y encuadernación. Eliminación de las referencias al usuario en el servidor de correo electrónico Haga clic en  , en la esquina superior derecha de la página. Haga clic en  Correo . Elimine cualquier información relacionada con el usuario, como las credenciales de usuario empleadas para la autenticación con el servidor de correo electrónico. Eliminación de las referencias al usuario en los registros de tareas Para obtener más información, consulte  . Eliminación de las referencias al usuario en una configuración En el menú  Configuraciones , haga clic en  Todas las configuraciones . Haga clic en el nombre de la configuración. En la pestaña  Básicas , elimine todos los valores relacionados con el usuario de Printer Settings, como el nombre y la ubicación del contacto. Eliminación de las referencias al usuario en el componente de seguridad avanzada En el menú  Configuraciones , haga clic en  Todos los componentes de seguridad avanzada . Haga clic en el nombre del componente. En la sección  Valores de seguridad avanzada , elimine todos los valores relacionados con el usuario. Eliminación de las referencias al usuario en búsquedas guardadas En el menú  Impresoras , haga clic en  Búsquedas guardadas . Haga clic en una búsqueda guardada. Elimine cualquier regla de búsqueda que utilice valores relacionados con los usuarios, como el nombre y la ubicación del contacto. Eliminación de las referencias al usuario en palabras clave En el menú  Impresoras , haga clic en  Lista de impresoras . Elimine la asignación de palabras clave relacionadas con el usuario de las impresoras. En el menú  Impresoras , haga clic en  Palabras clave . Elimine cualquier palabra clave que utilice información relacionada con el usuario. Eliminación de las referencias al usuario de eventos y acciones En el menú  Impresoras , haga clic en  Eventos y acciones . Elimine las acciones que contengan referencias al correo electrónico de los usuarios. eliminación de la información de usuario y las referencias a este información del usuario eliminación"},{"UUID":"c9fd08fb-6484-4081-82ee-ee5886ed1024","title":"Gestión de SSO","link":"mve-configuration-workflow-adfs-overview-topic.html","desc":"Descripción general Active Directory Federation","descFull":"Descripción general Active Directory Federation Services (AD FS) es una solución de acceso de identidad que proporciona a los equipos cliente acceso de inicio de sesión único (SSO) a aplicaciones o servicios protegidos. Los usuarios pueden acceder a estas aplicaciones o servicios aunque sus cuentas y aplicaciones se encuentren en redes u organizaciones completamente diferentes. ADFS utiliza autenticación de Security Assertion Markup Language (SAML) y autorización Claims-based Access Control (CBAC) para garantizar la seguridad en todas las aplicaciones que utilizan la identidad federada. Debe establecer una comunicación cifrada entre los servidores MVE y ADFS. Para ello, ADFS debe confiar en el servidor MVE. ADFS también contiene grupos de usuarios del servidor de Active Directory (AD) que deben corresponder a las funciones de usuario de MVE necesarias. Al configurar el servidor ADFS se necesita la siguiente información de la aplicación MVE: Identificador de confianza de la parte confiante — https://mve-host/mve/saml URL o punto final del servicio SAML 2.0 SSO de la parte confiante  — https://mve-host/mve/adfs/saml En las URL,  mve-host  es la dirección IP o FQDN del servidor MVE. Flujo de trabajo de configuración de MVE para ADFS descripción general"},{"UUID":"893684c8-55e9-46e0-bd25-7226f0a5d466","title":"Gestión de SSO","link":"setting-claim-issuance-policy-grouprule-topic.html","desc":"Configuración de la política de","descFull":"Configuración de la política de emisión de reclamaciones para GroupRule En la ventana  AD FS , haga clic en  Confianza de la parte confiante  y, a continuación, haga clic con el botón secundario en la confianza de parte confiante aplicable. Haga clic en  Editar política de emisión de reclamaciones  y, a continuación, en  Añadir regla . En la lista  Plantilla de regla de reclamación , seleccione  Enviar atributos LDAP como reclamaciones . En el campo  Nombre de regla de reclamación , escriba  GroupRule . En la lista  Almacén de atributos , seleccione  Active Directory . Establezca el  atributo LDAP  en  Token-Groups - Unqualified Names  y, a continuación, establezca el  Tipo de reclamación saliente  en  MVEGroup . Haga clic en  Finalizar . configuración de la política de emisión de reclamaciones GroupRule política de emisión de reclamaciones para GroupRule establecimiento"},{"UUID":"4982a77b-f345-4054-9150-3dd015c66f2b","title":"Gestión de SSO","link":"setting-claim-issuance-policy-name-id-topic.html","desc":"Configuración de la política de","descFull":"Configuración de la política de emisión de reclamaciones para el ID de nombre En la ventana  AD FS , haga clic en  Confianza de la parte confiante  y, a continuación, haga clic con el botón secundario en la confianza de parte confiante aplicable. Haga clic en  Editar política de emisión de reclamaciones  y, a continuación, en  Añadir regla . En la lista  Plantilla de regla de reclamación , seleccione  Enviar atributos LDAP como reclamaciones . En el campo  Nombre de regla de reclamación , escriba  Name ID  . En la lista  Almacén de atributos , seleccione  Active Directory . Establezca  Atributo LDAP  en  SAM-Account-Name  y, a continuación, establezca  Tipo de reclamación saliente  en  Name ID . Haga clic en  Finalizar . configuración de la política de emisión de reclamaciones ID de nombre política de emisión de reclamaciones para el ID de nombre establecimiento"},{"UUID":"a70053ff-c2e2-4a04-804a-ae34002d2011","title":"Gestión de SSO","link":"enabling-adfs-server-authentication-topic.html","desc":"Activación de la autenticación del","descFull":"Activación de la autenticación del servidor ADFS Haga clic en  , en la esquina superior derecha de la página. Haga clic en  ADFS  y, a continuación, seleccione  Activar ADFS para la autenticación . En el campo  URL de SSO (obligatorio) , escriba la URL de SSO publicada por el servidor ADFS como proveedor de identidad. En la sección  Grupos de ADFS para la asignación de la función de MVE , escriba los nombres de los grupos ADFS que corresponden a las funciones de MVE. Haga clic en  Guardar cambios . Servidor ADFS activación de la autenticación activación de la autenticación del servidor ADFS"},{"UUID":"a98b2c0d-c676-451d-9d84-14df8837b99b","title":"Gestión de SSO","link":"accessing-mve-adfs-topic.html","desc":"Acceso a MVE mediante ADFS","descFull":"Acceso a MVE mediante ADFS Al habilitar ADFS y acceder a MVE, se abre automáticamente la página de inicio de sesión de ADFS. Realice la autenticación en la página ADFS antes de que se le redirija a la página de inicio de MVE. Abra un navegador web y escriba  https:// MVE_SERVER /mve/ , donde  MVE_SERVER  es el nombre de host o la dirección IP del servidor que aloja MVE. Cuando se abra la página de inicio de sesión de ADFS, introduzca sus credenciales de ADFS y, a continuación, haga clic en  Iniciar sesión . Si los usuarios tienen problemas al acceder a MVE mediante ADFS, los administradores pueden iniciar sesión en MVE con sus credenciales de host local y resolver el problema. Si ADFS no está configurado en el servidor MVE, se muestra la página de inicio de sesión predeterminada de MVE tanto para los usuarios de host local como para los que no son de host local. En ese caso, los usuarios deben iniciar sesión en MVE con las cuentas configuradas en el servidor MVE. MVE a través de ADFS ADSF"},{"UUID":"dd1383f5-3bc0-40c8-a261-eb0f91c50fa3","title":"Gestión de SSO","link":"logging-out-mve-adfs-topic.html","desc":"Cerrar sesión en MVE Si","descFull":"Cerrar sesión en MVE Si ha accedido a MVE mediante ADFS, el botón  Cerrar sesión  no aparece en la página de inicio de MVE. La sesión de MVE solo finaliza si cierra la página MVE o si la sesión de MVE está inactiva durante más de 30 minutos. Si intenta acceder a la URL de MVE después de 30 minutos de inactividad, se le redirigirá a la página de inicio de sesión de ADFS. Si ha accedido a MVE con sus credenciales de MVE de host local, el botón  Cerrar sesión  seguirá apareciendo en la página de inicio de MVE. cerrar sesión en MVE a través de ADFS"},{"UUID":"4e6c7472-dee4-4e8f-9e93-bd7acb6f03b5","title":"Preguntas más frecuentes","link":"faq-chapter.html","desc":"Preguntas más frecuentes sobre Markvision","descFull":"Preguntas más frecuentes sobre Markvision Enterprise ¿Por qué no puedo seleccionar varias impresoras en la lista de modelos admitidos al crear una configuración? Los valores de configuración y los comandos difieren entre los distintos modelos de impresora. ¿Pueden acceder otros usuarios a mis búsquedas guardadas? Sí. Todos los usuarios pueden acceder a las búsquedas guardadas. ¿Dónde se encuentran los archivos de registro? Encontrará los archivos de registro de instalación en el directorio oculto del usuario que instala MVE. Por ejemplo,  C:\\Users\\Administrator\\AppData\\Local\\Temp\\mveLexmark-install.log . Encontrará los archivos de registro de la aplicación  *.log  en la carpeta  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\logs , donde  installation_dir  es la carpeta de instalación de MVE. ¿Cuál es la diferencia entre el nombre de host y la búsqueda DNS inversa? Un nombre de host es un nombre exclusivo asignado a una impresora en una red. Cada nombre de host corresponde a una dirección IP. La búsqueda DNS inversa se utiliza para determinar el nombre de host designado y el nombre de dominio de una dirección IP determinada. ¿Dónde puedo encontrar la búsqueda DNS inversa en MVE? La búsqueda DNS inversa se puede encontrar en los valores generales. Para obtener más información, consulte  . ¿Cómo puedo añadir reglas manualmente al cortafuegos de Windows? Ejecute la línea de comandos como administrador y escriba lo siguiente: firewall add allowedprogram \" installation_dir /Lexmark/Markvision Enterprise/tomcat/bin/tomcat9.exe\" \"Markvision Enterprise Tomcat\" firewall add portopening UDP 9187 \"Markvision Enterprise NPA UDP\" firewall add portopening UDP 6100 \"Markvision Enterprise LST UDP\" Donde  installation_dir  es la carpeta de instalación de MVE. ¿Cómo puedo configurar MVE para utilizar un puerto distinto al 443? Pare el dispositivo Markvision Enterprise. Abra el cuadro de diálogo  Ejecutar  y escriba  services.msc . Haga clic con el botón derecho en  Markvision Enterprise  y, a continuación, haga clic en  Detener . Abra el archivo  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml . Donde  installation_dir  es la carpeta de instalación de MVE. Cambie el valor  Connector port  a otro puerto no utilizado. <Connector port=\"443\" protocol=\"org.apache.coyote.http11.Http11NioProtocol\" \nsslImplementationName=\"org.apache.tomcat.util.net.jsse.JSSEImplementation\" \nSSLEnabled=\"true\" scheme=\"https\" secure=\"true\" clientAuth=\"false\" \ncompression=\"on\" compressableMimeType=\"text/html,text/xml,text/plain,text/css,\ntext/javascript,application/javascript,application/json\" maxThreads=\"150\" \nmaxHttpHeaderSize=\"16384\" minSpareThreads=\"25\" enableLookups=\"false\" \nacceptCount=\"100\" connectionTimeout=\"120000\" disableUploadTimeout=\"true\" \nURIEncoding=\"UTF-8\" server=\"Apache\" sslEnabledProtocols=\"TLSv1,TLSv1.1,TLSv1.2\" \nsslProtocol=\"TLS\" keystoreFile=\"C:/Program Files/Lexmark/Markvision Enterprise/\n../mve_truststore.p12\" keystorePass=\"markvision\" keyAlias=\"mve\" keyPass=\"markvision\" \nkeystoreType=\"PKCS12\" ciphers=\"TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256,\nTLS_ECDHE_RSA_WITH_AES_128_CBC_SHA,TLS_RSA_WITH_AES_128_CBC_SHA256,\nTLS_RSA_WITH_AES_128_CBC_SHA\"/> Cambie el valor  redirectPort  al mismo número de puerto utilizado como puerto conector. <Connector port=\"9788\" maxHttpHeaderSize=\"16384\" maxThreads=\"150\" minSpareThreads=\"25\" \nenableLookups=\"false\" redirectPort=\"443\" acceptCount=\"100\" connectionTimeout=\"120000\" \ndisableUploadTimeout=\"true\" compression=\"on\" compressableMimeType=\"text/html,text/xml,\ntext/plain,text/css,text/javascript,application/javascript,application/json\" \nURIEncoding=\"UTF-8\" server=\"Apache\"/> Reinicie el servicio Markvision Enterprise. Abra el cuadro de diálogo  Ejecutar  y escriba  services.msc . Haga clic con el botón derecho en  Markvision Enterprise  y, a continuación, haga clic en  Reiniciar . Acceda a MVE utilizando el nuevo puerto. Por ejemplo, abra un navegador web y escriba  https:// MVE_SERVER : port /mve . MVE_SERVER  es el nombre de host o dirección IP del servidor que aloja MVE y  port  es el número de puerto conector. ¿Cómo puedo personalizar los códigos y las versiones de TLS que utiliza MVE? Pare el dispositivo Markvision Enterprise. Abra el cuadro de diálogo  Ejecutar  y escriba  services.msc . Haga clic con el botón derecho en  Markvision Enterprise  y, a continuación, haga clic en  Detener . Abra el archivo  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml . Donde  installation_dir  es la carpeta de instalación de MVE. Configure los códigos y las versiones de TLS. Para obtener más información acerca de la configuración, consulte las  Instrucciones de configuración de Apache Tomcat SSL/TLS . Para obtener más información acerca de los protocolos y los valores de código, consulte la  documentación de información de asistencia de Apache Tomcat SSL . Reinicie el servicio Markvision Enterprise. Abra el cuadro de diálogo  Ejecutar  y escriba  services.msc . Haga clic con el botón derecho en  Markvision Enterprise  y, a continuación, haga clic en  Reiniciar . ¿Cómo puedo gestionar los archivos CRL si utilizo la CA de Microsoft Enterprise? Obtenga el archivo CRL del servidor de la CA. Si utiliza la CA de Microsoft Enterprise, el CRL no se descarga de forma automática a través del protocolo SCEP. Para obtener más información, consulte la  guía de configuración de la autoridad de certificación de Microsoft . Guarde el archivo CRL en la carpeta  installation_dir \\Lexmark\\Markvision Enterprise\\apps\\library\\crl , donde  installation_dir  es la carpeta de instalación de MVE. Configure la autoridad de certificación en MVE. Este proceso sólo es aplicable si se utiliza el protocolo SCEP. modelos admitidos configuración búsqueda DNS inversa consulta de nombre de host búsqueda inversa archivos de registro localización archivos de registro de la aplicación localización archivos de registro de instalación localización búsquedas guardadas acceso cortafuegos de Windows adición de reglas cifrado AES256 configuración puertos configuración códigos personalización versiones de TLS personalización CA de Microsoft Enterprise configuración"},{"UUID":"b9f577b1-a4e6-4996-9e6e-db83ea47a31d","title":"Solución de problemas","link":"trb-forgotten-password-mve-topic.html","desc":"El usuario ha olvidado la","descFull":"El usuario ha olvidado la contraseña Restablezca la contraseña de usuario Necesita derechos de administrador para restablecer la contraseña. Haga clic   en la esquina superior derecha de la página. Haga clic en  Usuario  y, a continuación, seleccione un usuario. Haga clic en  Editar  y, a continuación, cambie la contraseña. Haga clic en  Guardar cambios . Si ha olvidado su contraseña, realice una de las siguientes acciones: Póngase en contacto con otro usuario administrador para restablecer su contraseña. Póngase en contacto con el Centro de soporte al cliente de Lexmark. el usuario ha olvidado la contraseña solución de problemas el usuario ha olvidado la contraseña contraseña restablecer"},{"UUID":"ed3869b5-da00-4963-8828-49eac29913b8","title":"Solución de problemas","link":"trb-admin-forgotten-password-mve-topic.html","desc":"El usuario administrador ha olvidado","descFull":"El usuario administrador ha olvidado la contraseña Cree otro usuario administrador y elimine la cuenta anterior. Puede utilizar la utilidad de contraseña de Markvision Enterprise para crear otro usuario administrador. Vaya a la carpeta donde se ha instalado Markvision Enterprise. Por ejemplo,  C:\\Archivos de programa\\ Ejecute el archivo  mvepwdutility-windows.exe  en el directorio Lexmark\\Markvision Enterprise\\. Seleccione un dispositivo y, a continuación, haga clic en  Aceptar Siguiente . Seleccione  Añadir cuenta de usuario Siguiente . Introduzca las credenciales de usuario. Haga clic en  Siguiente . Acceda a MVE y elimine el usuario administrador anterior. Para obtener más información, consulte  . el usuario administrador ha olvidado la contraseña solución de problemas el usuario administrador ha olvidado la contraseña"},{"UUID":"4ae0dbe6-d051-4df6-a7c5-a21d11c243d5","title":"Solución de problemas","link":"trb-page-loading-infinitely-topic.html","desc":"La página no se carga","descFull":"La página no se carga Es posible que este problema ocurra si ha cerrado el navegador web sin cerrar sesión. Realice al menos una de las siguientes acciones: Borre la caché y elimine las cookies de su navegador web Acceda a la página de inicio de sesión de MVE y, a continuación, inicie sesión con sus credenciales Abra un navegador web y escriba  https:// MVE_SERVER /mve/login , donde  MVE_SERVER  es el nombre de host o la dirección IP del servidor que aloja MVE. la página tarda mucho en cargar solución de problemas la página tarda mucho en cargar"},{"UUID":"098e695b-a69c-4e01-968f-ad568ced01aa","title":"Solución de problemas","link":"trb-cannot-discover-network-device-topic.html","desc":"No se puede encontrar una","descFull":"No se puede encontrar una impresora de red Realice alguna de estas acciones: Asegúrese de que la impresora está encendida Asegúrese de que el cable de alimentación está enchufado de manera segura a la impresora y a una toma de alimentación debidamente conectada a tierra Asegúrese de que la impresora esté conectada a la red Reinicie la impresora Asegúrese de que el protocolo TCP/IP está habilitado en la impresora Asegúrese de que los puertos utilizados por MVE estén abiertos y SNMP y mDNS están activados. Para obtener más información, consulte  . Póngase en contacto con el representante de Lexmark solución de problemas no se puede encontrar una impresora de red no se puede encontrar una impresora de red"},{"UUID":"6eaf203e-09d0-43f1-b760-6c2d6301e5a0","title":"Solución de problemas","link":"trb-incorrect-device-information-topic.html","desc":"Información de la impresora incorrecta","descFull":"Información de la impresora incorrecta Realice una auditoría Para obtener más información, consulte  . información de la impresora incorrecta solución de problemas información de la impresora incorrecta"},{"UUID":"879595d7-d135-4941-a0cf-b320d498c909","title":"Solución de problemas","link":"trb-mve-does-not-recognize-secured-printer-topic.html","desc":"MVE no reconoce una impresora","descFull":"MVE no reconoce una impresora como protegida Asegúrese de que la impresora esté protegida Asegúrese de que el mDNS esté activado y de que no esté bloqueado Elimine la impresora y, a continuación, vuelva a ejecutar la búsqueda de impresoras. Para obtener más información, consulte  . MVE no reconoce una impresora como protegida solución de problemas MVE no reconoce una impresora como protegida"},{"UUID":"aa02b578-3d79-49e1-b36b-1045b6fcaaa1","title":"Solución de problemas","link":"trb-config-enforcement-fails-topic.html","desc":"El uso de las configuraciones","descFull":"El uso de las configuraciones con varias aplicaciones genera un error en el primer intento, pero no se producen problemas en los intentos posteriores Aumentar los tiempos de espera Vaya a la carpeta donde se ha instalado Markvision Enterprise. Por ejemplo,  C:\\Archivos de programa\\ Vaya a la carpeta Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes. Utilice un editor de texto para abrir el archivo  platform.properties . Edite el valor  cdcl.ws.readTimeout . El valor está en milisegundos. Por ejemplo, 90 000 milisegundos es igual a 90 segundos. Utilice un editor de texto para abrir el archivo  devCom.properties . Edite los valores  lst.responseTimeoutsRetries . El valor está en milisegundos. Por ejemplo, 10 000 milisegundos es igual a 10 segundos. Por ejemplo,  lst.responseTimeoutsRetries=10000 15000 20000 . El primer reintento de conexión se produce después de 10 segundos; el segundo, después de 15 segundos; y el tercero, después de 20 segundos. Si es necesario, cuando utilice LDAP GSSAPI, a cree un archivo  parameters.properties . Añada el siguiente valor:  lst.negotiation.timeout=400 El valor está en segundos. Guarde los cambios. el uso de las configuraciones con varias aplicaciones genera un error en el primer intento, pero no se producen problemas en los intentos posteriores solución de problemas el uso de las configuraciones con varias aplicaciones genera un error en el primer intento, pero no se producen problemas en los intentos posteriores"},{"UUID":"8910ac4e-7d1b-48ef-9501-36ac70495d29","title":"Solución de problemas","link":"trb-enforcement-printer-cert-fails-topic.html","desc":"Aplicación de configuraciones si falla","descFull":"Aplicación de configuraciones si falla la emisión del certificado de la impresora En algunas ocasiones, no se emite ningún certificado durante la aplicación. Aumente el número de reintentos de inscripción Añada la siguiente clave en el archivo  platform.properties : enrol.maxEnrolmentRetry=10 El valor de reintento debe ser superior a cinco. aplicación de configuraciones si falla la emisión del certificado de la impresora solución de problemas aplicación de configuraciones si falla la emisión del certificado de la impresora"},{"UUID":"a2844982-ac7e-4b90-a98a-1819b45f0d72","title":"Autoridad certificadora de OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Error en la emisión del","descFull":"Error en la emisión del certificado con el servidor de la CA OpenXPKI Compruebe que la clave de \"firmante en nombre de\" en MVE coincide con la clave del firmante autorizado en el servidor de la CA Por ejemplo: Si la siguiente es la clave  ca.onBehalf.cn  del archivo  platform.properties  en MVE, ca.onBehalf.cn=Markvision_SQA-2012-23AB.lrdc.lexmark.ds la siguiente debe ser la clave  authorized_signer  del archivo  generic.yaml  en el servidor de la CA. rule1:\n\t\t\t# Full DN\n\t\t\t\t\tSubject: CN=Markvision_SQA-2012-23AB.lrdc.lexmark.ds Para obtener más información sobre la configuración del servidor de la CA OpenXPKI, consulte la  guía de configuración de la autoridad certificadora OpenXPKI . error en la emisión del certificado con el servidor de la CA OpenXPKI solución de problemas error en la emisión del certificado con el servidor de la CA OpenXPKI"},{"UUID":"f7a02057-e3ef-43b5-bed4-8d01a130a1e9","title":"Autoridad certificadora de OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Se produce un error interno","descFull":"Se produce un error interno del servidor Instale la configuración regional en_US.utf8 Ejecute el comando  dpkg-reconfigure locales . Instale la configuración regional  en_US.utf8  (locale -a | grep en_US). solución de problemas error interno del servidor error interno del servidor"},{"UUID":"55f807d9-98aa-46b3-902d-69f8d38f93ad","title":"Autoridad certificadora de OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"No aparece la solicitud de","descFull":"No aparece la solicitud de inicio de sesión Al acceder a  http://suhost/openxpki/ , solo se muestra el banner Open Source TrustCenter, sin una solicitud de inicio de sesión. Active  fcgid Ejecute los siguientes comandos: a2enmod fcgid reinicio del servicio apache2 solución de problemas no aparece la solicitud de inicio de sesión no aparece la solicitud de inicio de sesión"},{"UUID":"e079da37-c63f-44c6-8495-62c152ff53f9","title":"Autoridad certificadora de OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Se produce un error de","descFull":"Se produce un error de conector anidado sin clase Aparece el error  EXCEPCIÓN: conector anidado sin clase (scep.scep-server-1.connector.initial)  en la línea 201 de /usr/share/perl5/Connector/Multi.pm. Actualice  scep.scep-server-1 En  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml , sustituya  scep.scep-server-1  por  scep.generic . Sustituya  REALM  por el nombre de su dominio. Por ejemplo, cuando utilice el dominio predeterminado, utilice  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial solución de problemas error de conector anidado sin clase error de conector anidado sin clase"},{"UUID":"b9509fdc-b6b1-4462-979e-74396ef1116f","title":"Autoridad certificadora de OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"No se pueden aprobar certificados","descFull":"No se pueden aprobar certificados de forma manual El botón  Aprobación manual  no aparece cuando se aprueban certificados de forma manual. Actualice  scep.scep-server-1 En  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml , sustituya  scep.scep-server-1  por  scep.generic . Sustituya  REALM  por el nombre de su dominio. Por ejemplo, cuando utilice el dominio predeterminado, utilice  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial solución de problemas no se pueden aprobar certificados de forma manual no se pueden aprobar certificados de forma manual"},{"UUID":"b3d3cf4a-1382-43ab-80c1-3a4e000379ea","title":"Autoridad certificadora de OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Se produce un error Perl","descFull":"Se produce un error Perl al aprobar solicitudes de inscripción Actualice  scep.scep-server-1 En  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml , sustituya  scep.scep-server-1  por  scep.generic . Sustituya  REALM  por el nombre de su dominio. Por ejemplo, cuando utilice el dominio predeterminado, utilice  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial solución de problemas error Perl error Perl"},{"UUID":"5039547f-fadd-4efb-94c3-0a8ed72ec0d7","title":"Autoridad certificadora de OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Los tokens  ca-signer-1 ","descFull":"Los tokens  ca-signer-1  y  vault-1  están sin conexión La página  Estado del sistema  muestra que los tokens  ca-signer-1  y  vault-1  están sin conexión. Realice alguna de estas acciones: Cambie la contraseña de la clave de certificado En  /etc/openxpki/config.d/realm/ca-one/crypto.yaml , cambie la contraseña de la clave de certificado. Cree los enlaces simbólicos correctos y copie el archivo de clave Para obtener más información, consulte  . Asegúrese de que el archivo de clave es legible para OpenXPKI solución de problemas ca-signer-1 está sin conexión solución de problemas vault-1 está sin conexión ca-signer-1 está sin conexión solución de problemas vault-1 está sin conexión solución de problemas"},{"UUID":"cca0e7aa-0804-4ba1-b558-cb3844962bea","title":"Acceso a la base de datos","link":"differences-supported-databases-data-types-topic.html","desc":"Diferencias en los tipos de","descFull":"Diferencias en los tipos de datos de bases de datos compatibles MVE es compatible con Firebird y Microsoft SQL Server. La tabla siguiente muestra los tipos de datos Firebird utilizados en MVE y sus tipos de datos correspondientes en Microsoft SQL Server. Tipos de datos Firebird Tipos de datos de Microsoft SQL Server * Este tipo de datos es necesario para Microsoft SQL Server. BIGINT Bigint VARCHAR(x) varchar(x) TIMESTAMP Fecha/hora INTEGER Int SMALLINT/ TINYINT * Bit BLOB SUB_TYPE 0 varbinary(1024) diferencias en los tipos de datos de bases de datos compatibles tipos de datos de bases de datos compatibles diferencias"},{"UUID":"8cd70f31-a8c2-46c4-ba43-ea1d26b48c39","title":"Impresora","link":"config-item-topic.html","desc":"CONFIG_ITEM La tabla CONFIG_ITEM representa","descFull":"CONFIG_ITEM La tabla CONFIG_ITEM representa los elementos de configuración (CI) ITIL de la impresora. Muestra el estado del CI y las marcas de hora de su creación, administración inicial, última búsqueda y otras acciones. La tabla no representa ninguna parte física de una impresora; solo es una representación abstracta del dispositivo. CONFIG_ITEM Nombre del campo Tipo de datos Descripción CI_ID BIGINT Clave principal. CI_STATE VARCHAR(255) Estado actual del CI. Las opciones son NEW, MANAGED, MISSING, FOUND, CHANGED, UNMANAGED y RETIRED. CREATION_DATE TIMESTAMP Fecha en la que el CI entró por primera vez en el sistema. INITIAL_MANAGEMENT_DATE TIMESTAMP Fecha en la que el CI entró por primera vez en el estado o subestado MANAGED. LAST_AUDIT_DATE TIMESTAMP Fecha de la última auditoría intentada en el CI (tanto si es correcta como si no). PRINTER_ID BIGINT La clave ajena para NETWORK_PRINTER.PRINTER_ID. LAST_DISCOVERY_DATE TIMESTAMP Fecha en la que se intentó la última búsqueda en el CI (tanto si se realizó correctamente como si no). LAST_SUCCESSFUL_AUDIT_DATE TIMESTAMP Fecha de la última auditoría correcta del CI. LAST_SUCCESSFUL_DISCOVERY_ DATE TIMESTAMP Fecha de la última búsqueda correcta del CI. DEFAULT_CERT_COMMON_NAME VARCHAR(255) Nombre del certificado predeterminado. DEFAULT_CERT_ISSUER_NAME VARCHAR(255) Nombre del emisor del certificado. DEFAULT_CERT_SIGNING_STATUS VARCHAR(255) Estado de firma del certificado de la impresora. Las opciones son SIGNED, INVALID_CERT, NO_CA y UNKNOWN. DEFAULT_CERT_VALID_FROM TIMESTAMP Fecha de inicio de la validez del certificado. DEFAULT_CERT_VALID_TO TIMESTAMP Última fecha de validez del certificado. DEFAULT_CERTIFICATE VARCHAR(8190) Certificado predeterminado. DEFAULT_CERT_SERIAL_NUMBER VARCHAR(255) Número de serie del certificado predeterminado. CONFIG_ITEM"},{"UUID":"2bf732ea-f0f9-4105-8d18-faa63e50f9b5","title":"Impresora","link":"config-item-topic.html","desc":"NETWORK_ADAPTER Esta tabla representa el","descFull":"NETWORK_ADAPTER Esta tabla representa el adaptador de red (también conocido como servidor de impresión) de una impresora física. NETWORK_ADAPTER Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. ADAPTER_TYPE VARCHAR(31) Siempre INA (adaptador de red interno). ADAPTER_ID BIGINT La clave principal. FIRMWARE_REVISION VARCHAR(255) La revisión actual del firmware de red. MANUFACTURER VARCHAR(255) N/A. MODEL_NAME VARCHAR(255) N/A. SERIAL_NUMBER VARCHAR(50) N/A. SYSTEM_NAME VARCHAR(255) N/A. RETRIES INTEGER El número de intentos para volver a tratar de comunicarse con una impresora. SNMP_READ_COMMUNITY_NAME VARCHAR(255) El nombre de la comunidad SNMP que se va a leer. TIMEOUT BIGINT El número de milisegundos que se debe esperar para que un intento de comunicación concreto con una impresora tenga éxito. CONTACT_LOCATION VARCHAR(255) N/A. CONTACT_NAME VARCHAR(255) N/A. DOMAIN_NAME_SUFFIX VARCHAR(191) El sufijo del nombre de dominio asociado a este adaptador de red (por ejemplo, foo.lexmark.com). Combinar con HOSTNAME para obtener el nombre de dominio completo (FQDN). HOSTNAME VARCHAR(63) El nombre de host asociado con este adaptador de red. MVE se puede configurar para recuperar el nombre de host de DNS o del propio adaptador de red. Combinar con DOMAIN_NAME_SUFFIX para obtener el nombre de dominio completo (FQDN). IP_ADDRESS VARCHAR(15) La representación entera de la dirección IP de este adaptador de red. Obsoleto. IP_ADDRESS_INT INTEGER La representación entera de la dirección IP de este adaptador de red. IP_ADDRESS_SUBNET INTEGER La representación entera de la subred en la que reside este adaptador de red. MAC_CANONICAL VARCHAR(12) La dirección MAC del adaptador de red, en formato canónico. PORTS INTEGER El número de puertos que admite el adaptador de red. Siempre 1. RAND_MAC SMALLINT/ TINYINT * Indicador que señala si el valor actual de MAC_CANONICAL se ha generado aleatoriamente. CREDENTIAL_REQUIRED SMALLINT/ TINYINT * Indicador que señala si se necesita una credencial para comunicarse con la impresora asociada. CREDENTIAL_PASSWORD BLOB SUB_TYPE 0 Este valor está cifrado y no está disponible para su uso fuera de MVE. CREDENCIAL_PIN BLOB SUB_TYPE 0 Este valor está cifrado y no está disponible para su uso fuera de MVE. CREDENTIAL_REALM VARCHAR(64) El dominio de credenciales, si se ha establecido. CREDENTIAL_USERNAME VARCHAR(255) El nombre de usuario de la credencial, si se ha establecido. PORT_CONFIG_LST_TCP_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. PORT_CONFIG_LST_UDP_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. PORT_CONFIG_MDNS_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. PORT_CONFIG_NPA_TCP_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. PORT_CONFIG_NPA_UDP_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. PORT_CONFIG_RAW_PRINT_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. PORT_CONFIG_SNMP_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. PORT_CONFIG_XML_TCP_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. PORT_CONFIG_XML_UDP_OPEN SMALLINT/ TINYINT * El indicador que señala si este puerto de la impresora asociada está abierto. SECURE_COMMUNICATION_STATE VARCHAR(255) El estado de la comunicación. Las opciones son UNSECURE, MISSING_CREDENTIALS y SECURED. USER_PASSWORD Blob sub_type 0 Parte del nombre de usuario de las credenciales. SNMP_USERNAME VARCHAR(32) El nombre de usuario utilizado para las comunicaciones SNMPv3. SNMP_PASSWORD VARCHAR(255) Este valor está cifrado y no está disponible para su uso fuera de MVE. SNMP_MIN_AUTHENTICATION_LEVEL VARCHAR(50) El nivel de autenticación mínimo utilizado para las comunicaciones SNMPv3. SNMP_AUTHENTICATION_HASH VARCHAR(50) La autenticación hash utilizada para las comunicaciones SNMPv3. SNMP_PRIVACY_ALGORITHM VARCHAR(50) El algoritmo de privacidad utilizado para las comunicaciones SNMPv3. LOGIN_METHOD VARCHAR(256) Método de autenticación utilizado para iniciar sesión en la impresora. LOGIN_METHOD_NAME VARCHAR(256) Si LOGIN_METHOD es LDAP o LDAP+GSSAPI, este campo muestra el nombre del método de autenticación. TRACING_SERIAL_NUMBER VARCHAR(64) El método de autenticación utilizado para rastrear el número de serie. NETWORK_ADAPTER"},{"UUID":"ef193e8f-61f3-4b06-bb2f-caa08b93ae43","title":"Impresora","link":"config-item-topic.html","desc":"NETWORK_PRINTER Esta tabla representa la","descFull":"NETWORK_PRINTER Esta tabla representa la parte de impresora real de la impresora física. NETWORK_PRINTER Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. PRINTER_ID BIGINT La clave principal. MANUFACTURER VARCHAR(255) La empresa que realmente fabricó la impresora. Puede diferir de DISPLAY_MANUFACTURER. MODEL_NAME VARCHAR(255) El nombre de modelo de la impresora. SERIAL_NUMBER VARCHAR(50) Número de serie de esta impresora. SYSTEM_NAME VARCHAR(255) Nombre utilizado para identificar el dispositivo. COPIAR SMALLINT/ TINYINT * Indicador que señala si la impresora admite la copia. DUPLEX SMALLINT/ TINYINT * Indicador que señala si la impresora admite impresión a doble cara. ESF SMALLINT/ TINYINT * Indicador que señala si la impresora admite aplicaciones eSF. MARKING_TECHNOLOGY VARCHAR(255) El tipo de tecnología de marcado que utiliza la impresora (por ejemplo, electrofotográfica). MEMORY BIGINT Cantidad de memoria, en bytes. PROFILE (PERFIL) SMALLINT/ TINYINT * Indicador que señala si esta impresora admite perfiles. RECEIVE_FAX SMALLINT/ TINYINT * Indicador que señala si esta impresora admite la recepción de faxes. SCAN_TO_EMAIL SMALLINT/ TINYINT * Indicador que señala si esta impresora admite la digitalización en correo electrónico. SCAN_TO_FAX SMALLINT/ TINYINT * Indicador que señala si esta impresora admite la digitalización en fax. SCAN_TO_NETWORK SMALLINT/ TINYINT * Indicador que señala si esta impresora admite la digitalización en una red. SPEED VARCHAR(255) Número de hojas que el papel puede imprimir por minuto. DISPLAY_MANUFACTURER VARCHAR(255) Nombre que aparece en el exterior de la impresora. Por ejemplo, MANUFACTURER podría ser LEXMARK, pero DISPLAY_MANUFACTURER podría ser Dell. FAMILY_ID INTEGER El ID de la familia NPA. INITIAL_DISCOVERY_TIMESTAMP TIMESTAMP Cuando se detectó la impresora por primera vez. LIFETIME_PAGE_COUNT BIGINT Recuento de página totales. MAINTENANCE_COUNTER BIGINT Contador de mantenimiento. ADAPTER_PORT INTEGER El puerto en el que está conectada esta impresora al adaptador de red asociado. Por ahora, los datos son siempre 1. PROPERTY_TAG VARCHAR(255) La etiqueta asset, brass o property. ADAPTER_ID BIGINT La clave ajena a NETWORK_ADAPTER.ADAPTER_ID. RAND_SN SMALLINT/ TINYINT * Indicador que señala si el valor actual de SERIAL_NUMBER se ha generado aleatoriamente. DEV_STATUS_REG_COUNTER INTEGER Número de registros de estado del dispositivo. SCANNER_SERIAL_NUMBER VARCHAR(12) Para MFP modulares, el número de serie del cabezal de escaneado. DISK_ENCRYPTION VARCHAR(8) Frecuencia con la que se activa el cifrado de disco. DISK_WIPING VARCHAR(8) La frecuencia a la que se activa la limpieza de disco. COLOR SMALLINT/ TINYINT * Indicador que señala si la impresora imprime en color. PRINTER_STATUS_SUMMARY SMALLINT/ TINYINT * Indicador que señala el mensaje de estado más grave presente en la impresora. SUPPLY_STATUS_SUMMARY SMALLINT/ TINYINT * Indicador que señala el mensaje de estado de los consumibles más grave presente en la impresora. TLI VARCHAR(255) Indicador de nivel superior (TLI) del modelo de impresora. FAX_STATION_NAME VARCHAR(255) El valor de la configuración de nombre de fax en la impresora. FAX_STATION_NUMBER VARCHAR(255) El valor de la configuración de número de fax en la impresora. SCANNER_SERIAL_NUMBER VARCHAR(50) Número de serie del escáner de la impresora. TIME_ZONE VARCHAR(255) El ID de las diferentes zonas horarias admitidas por la impresora. MODULAR_SERIAL_NUMBER VARCHAR(255) El número de serie modular. TRACING_SERIAL_NUMBER VARCHAR(64) Método de autenticación utilizado para rastrear el número de serie. NETWORK_PRINTER"},{"UUID":"e489cf2a-7a65-41b2-8313-fcd34c5ce6de","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_CURRENT_STATUS Esta tabla representa el","descFull":"PRINTER_CURRENT_STATUS Esta tabla representa el estado de la impresora cuando se recopilaron los datos. Hay una fila en esta tabla para cada condición de estado de una impresora determinada, todas apuntando al mismo PRINTER_ID. PRINTER_CURRENT_STATUS Nombre del campo Tipo de datos Descripción STATUS_ID BIGINT La clave principal. STATUS_MESSAGE VARCHAR(255) Texto para este estado (por ejemplo, Bandeja 1 baja). STATUS_SEVERITY VARCHAR(255) La gravedad de este estado (por ejemplo, Advertencia). STATUS_TYPE VARCHAR(255) El tipo de este estado (por ejemplo, Impresora o Consumible). PRINTER_ID BIGINT La clave ajena para NETWORK_PRINTER.PRINTER_ID. PRINTER_CURRENT_STATUS"},{"UUID":"f7c6e818-80d0-4a39-a79d-1ef96dc5802d","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_ESF_APPS Esta tabla representa las","descFull":"PRINTER_ESF_APPS Esta tabla representa las aplicaciones eSF instaladas en las impresoras cuando se recopilaron los datos. Hay una fila en esta tabla para cada aplicación eSF instalada actualmente en una impresora determinada, todas apuntando al mismo PRINTER_ID. PRINTER_ESF_APPS Nombre del campo Tipo de datos Descripción APPLICATION_ID BIGINT La clave principal. NAME VARCHAR(255) El nombre de la aplicación. STATE VARCHAR(255) El estado actual. VERSION VARCHAR(255) La versión actual. PRINTER_ID BIGINT La clave ajena para NETWORK_PRINTER.PRINTER_ID. PRINTER_ESF_APPS"},{"UUID":"f8199268-0afc-478a-a894-6b511316c7ee","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_INPUT_OPTIONS Esta tabla representa las","descFull":"PRINTER_INPUT_OPTIONS Esta tabla representa las opciones de entrada instaladas en las impresoras cuando se recopilaron datos. Hay una fila en esta tabla para cada opción de entrada instalada actualmente en una impresora determinada, todas apuntando al mismo PRINTER_ID. PRINTER_INPUT_OPTIONS Nombre del campo Tipo de datos Descripción INPUT_OPTION_ID BIGINT La clave principal. NAME VARCHAR(255) El nombre de la opción de entrada (por ejemplo, bandeja multiuso). PRINTER_ID BIGINT La clave ajena para NETWORK_PRINTER.PRINTER_ID. PRINTER_INPUT_OPTIONS"},{"UUID":"6a22fdff-e5cc-4f1c-a197-8db2175adf88","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_INPUT_TRAYS Esta tabla representa las","descFull":"PRINTER_INPUT_TRAYS Esta tabla representa las bandejas de entrada asociadas a una opción de entrada. Hay una fila en esta tabla para cada bandeja de entrada asociada a una opción de entrada determinada, todas apuntando al mismo INPUT_OPTION_ID. PRINTER_INPUT_TRAYS Nombre del campo Tipo de datos Descripción INPUT_OPTION_ID BIGINT La clave ajena a PRINTER_INPUT_OPTIONS.INPUT_OPTION_ID. CAPACITY BIGINT El número máximo de hojas que puede contener la bandeja. FEED_TYPE VARCHAR(255) Manual o automático. FORM_SIZE VARCHAR(255) El tamaño de papel actual (por ejemplo, carta). FORM_TYPE VARCHAR(255) El tipo de papel actual (por ejemplo, papel normal). TYPE VARCHAR(255) El tipo de bandeja de entrada (por ejemplo, alimentador multiuso). PRINTER_INPUT_TRAYS"},{"UUID":"644f210c-65a4-4393-bee3-b957b919cef4","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_OPTIONS Esta tabla representa las","descFull":"PRINTER_OPTIONS Esta tabla representa las opciones instaladas en las impresoras cuando se recopilaron datos. Hay una fila en esta tabla para cada opción instalada actualmente en una impresora determinada, todas apuntando al mismo PRINTER_ID. Normalmente, la opción es un dispositivo de almacenamiento. PRINTER_OPTIONS Nombre del campo Tipo de datos Descripción OPTION_ID BIGINT La clave principal. FREESPACE_ BIGINT Cantidad de espacio libre restante en el dispositivo de almacenamiento. NAME VARCHAR(255) El nombre de la opción de impresora (por ejemplo, DISCO). SIZE_ BIGINT La cantidad total de espacio. PRINTER_ID BIGINT La clave ajena para NETWORK_PRINTER.PRINTER_ID. PRINTER_OPTIONS"},{"UUID":"69261551-a504-4d5a-9b61-1b58eb4ef94f","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_OUTPUT_BINS Esta tabla representa las","descFull":"PRINTER_OUTPUT_BINS Esta tabla representa las bandejas de salida asociadas a una opción de salida. Hay una fila en esta tabla para cada bandeja de salida asociada a una opción de salida determinada, todas apuntando al mismo OUTPUT_OPTION_ID. PRINTER_OUTPUT_BINS Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. OUTPUT_OPTION_ID BIGINT La clave ajena a PRINTER_OUTPUT_OPTIONS.OUTPU T_OPTION_ID. BINDING SMALLINT/ TINYINT * Indicador que señala si esta bandeja admite encuadernación. BURSTING SMALLINT/ TINYINT * Indicador que señala si esta bandeja admite máxima velocidad. CAPACITY BIGINT El número máximo de hojas que puede contener la bandeja. COLLATION SMALLINT/ TINYINT * Indicador que señala si esta bandeja admite clasificación. FACE_DOWN SMALLINT/ TINYINT * Indicador que señala si el papel se ha cargado boca abajo en esta bandeja. FACE_UP SMALLINT/ TINYINT * Indicador que señala si el papel se ha cargado boca arriba en esta bandeja. LEVEL_SENSING SMALLINT/ TINYINT * Indicador que señala si esta bandeja admite la detección del nivel de papel. PUNCHING SMALLINT/ TINYINT * Indicador que señala si esta bandeja admite perforación. SECURITY SMALLINT/ TINYINT * Indicador que señala si esta bandeja admite seguridad. SEPARATION SMALLINT/ TINYINT * Indicador que señala si esta bandeja admite separación. STITICHING SMALLINT/ TINYINT * Indicador que señala si esta bandeja admite cosido. TYPE VARCHAR(255) El tipo de bandeja de salida de la impresora (por ejemplo, Bandeja estándar, Bandeja 5, etc.) PRINTER_OUTPUT_BINS"},{"UUID":"27af6aea-4e92-49e1-b78e-8c336f28c432","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_OUTPUT_OPTIONS Esta tabla representa las","descFull":"PRINTER_OUTPUT_OPTIONS Esta tabla representa las opciones de salida instaladas en las impresoras. Hay una fila en esta tabla para cada opción de salida instalada actualmente en una impresora determinada, todas apuntando al mismo PRINTER_ID. PRINTER_OUTPUT_OPTIONS Nombre del campo Tipo de datos Descripción OUTPUT_OPTION_ID BIGINT La clave principal. NAME VARCHAR(255) El nombre de la opción (por ejemplo, depósito integrado, buzón y finalizador). PRINTER_ID BIGINT La clave ajena para NETWORK_PRINTER.PRINTER_ID. PRINTER_OUTPUT_OPTIONS"},{"UUID":"adab86b9-d32a-4648-9b9a-b860a4b37897","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_STATISTICS Esta tabla contiene información","descFull":"PRINTER_STATISTICS Esta tabla contiene información recopilada a partir de los datos de contadores de la impresora. Cada fila representa los datos de una impresora individual. En función del modelo de impresora al que esté asociado el registro, no se aplicarán todas las columnas. PRINTER_STATISTICS Nombre del campo Tipo de datos Descripción STATISTICS_ID BIGINT La clave principal. COVG_LAST_JOB_BLACK BIGINT Cobertura de tóner negro del último trabajo de impresión. COVG_LIFETIME_BLACK BIGINT Cobertura del tóner negro de todos los trabajos de impresión. CART_PAGES_PRINT_BLACK BIGINT Recuento de páginas impresas que utilizaron el cartucho de tóner negro. BLACK_TONER_LEVEL VARCHAR(255) Nivel de consumible actual del cartucho de tóner negro. PHOTO_COND_LEVEL_K VARCHAR(255) El nivel de consumible actual del fotoconductor (negro). BLANK_SAFE_SIDE_COPY BIGINT Recuento de las caras seguras en blanco de una copia. BLANK_SAFE_SIDE_FAX BIGINT Recuento de las caras seguras en blanco de un fax. BLANK_SAFE_SIDE_PRINT BIGINT Recuento de las caras seguras en blanco de una impresión. PAPER_CHANGE BIGINT Recuento de eventos de cambio de papel. COVER_OPEN BIGINT Recuento de eventos de cubierta abierta. COVG_LAST_JOB_CYAN BIGINT Cobertura del tóner cian del último trabajo de impresión. COVG_LIFETIME_CYAN BIGINT Cobertura del tóner cian de todos los trabajos de impresión. CART_PAGES_PRINT_CYAN BIGINT Recuento de páginas impresas que utilizaron el cartucho de tóner cian. CYAN_TONER_LEVEL VARCHAR(255) Nivel del consumible actual del cartucho de tóner cian. CYAN_TONER_STATUS VARCHAR(255) El estado del consumible del cartucho cian (por ejemplo, intermedio). YELLOW_TONER_STATUS VARCHAR(255) El estado del consumible del cartucho amarillo (por ejemplo, intermedio). MAGENTA_TONER_STATUS VARCHAR(255) El estado del consumible del cartucho magenta (por ejemplo, intermedio). BLACK_TONER_STATUS VARCHAR(255) El estado del consumible del cartucho negro (por ejemplo, intermedio). PHOTO_COND_LEVEL_C VARCHAR(255) Nivel de consumible actual del fotoconductor (cian). DEVICE_INSTALL_DATE TIMESTAMP Marca de hora de la primera instalación de la impresora. FUSER_CURRENT_LEVEL VARCHAR(255) Nivel de suministro actual del fusor. IMG_SAFE_SIDE_COPY BIGINT Recuento de caras con imágenes impresas de un trabajo de copia. IMG_SAFE_SIDE_FAX BIGINT Recuento de caras con imágenes impresas de un trabajo de fax. IMG_SAFE_SIDE_PRINT BIGINT Recuento de caras con imágenes impresas de un trabajo de impresión. LAST_FAX_JOB_DATE TIMESTAMP Marca de hora del último trabajo de fax. LAST_PRINTED_JOB_DATE TIMESTAMP Marca de hora del último trabajo de impresión. LAST_SCAN_JOB_DATE TIMESTAMP Marca de hora del último trabajo de digitalización. COVG_LAST_JOB_MAGENTA BIGINT Cobertura del tóner magenta del último trabajo. COVG_LIFETIME_MAGENTA BIGINT Cobertura del tóner magenta de todos los trabajos. CART_PAGES_PRINT_MAGENTA BIGINT Recuento de páginas impresas que utilizaron el cartucho de tóner magenta. MAGENTA_TONER_LEVEL VARCHAR(255) Nivel de consumible actual del cartucho de tóner magenta. PHOTO_COND_LEVEL_M VARCHAR(255) Nivel de consumible actual del fotoconductor (magenta). MAINT_KIT_LEVEL VARCHAR(255) Nivel de consumible actual del kit de mantenimiento. MEDIA_SIZE_TYPE_MONO_SIDE_ SAFE BIGINT Las caras impresas en blanco y negro (seguras). MEDIA_SIZE_TYPE_COLOR_SIDE_ SAFE BIGINT Las caras impresas en color (seguras). SUPPLY_EVENTS BIGINT El recuento de otros eventos de consumibles. PAPER_JAMS BIGINT Recuento de eventos de atasco de papel. PAPER_LOAD BIGINT Recuento de eventos de carga de papel. PRINT_SHEET_USE_PICKED BIGINT Las hojas impresas (recogidas). PRINT_SIDE_USE_PICKED BIGINT Las caras impresas (recogidas). POR BIGINT El recuento de restablecimientos de encendido. PRINT_AND_HOLD_JOB BIGINT Recuento de trabajos de impresión y en espera. SAFE_SHT_COPY BIGINT Las hojas impresas (seguras) de los trabajos de copia. SAFE_SHT_FAX BIGINT Las hojas impresas (seguras) de los trabajos de fax. SAFE_SHT_PRINT BIGINT Las hojas impresas (seguras) de los trabajos de impresión. SCAN_PAPER_JAMS BIGINT Recuento de atascos del escáner. PRINTED_FROM_PRINT_AND_HOLD BIGINT Recuento de trabajos de impresión y en espera impresos. PRINTED_FROM_USB BIGINT Recuento de impresiones desde USB. TRANS_BELT_LEVEL VARCHAR(255) El nivel de consumible actual de la cinta de transferencia. USB_DIRECT_JOB BIGINT Número de inserciones USB. WASTE_TONER_LEVEL VARCHAR(255) Nivel actual del contenedor de tóner de desecho. COVG_LAST_JOB_YELLOW BIGINT Cobertura del tóner amarillo del último trabajo. COVG_LIFETIME_YELLOW BIGINT Cobertura del tóner amarillo de todos los trabajos. CART_PAGES_PRINT_YELLOW BIGINT Recuento de páginas impresas que utilizaron el cartucho de tóner amarillo. YELLOW_TONER_LEVEL VARCHAR(255) Nivel de consumible actual del cartucho de tóner amarillo. PHOTO_COND_LEVEL_Y VARCHAR(255) Nivel actual del fotoconductor (amarillo). IMG_SAFE_SIDE_PRINT_MONO BIGINT Recuento de caras con imágenes impresas en blanco y negro (seguras) de los trabajos de impresión. IMG_SAFE_SIDE_PRINT_COLOR BIGINT Recuento de caras con imágenes impresas en color (seguras) de los trabajos de impresión. IMG_SAFE_SIDE_COPY_MONO BIGINT Recuento de caras con imágenes impresas en blanco y negro (seguras) de los trabajos de copia. IMG_SAFE_SIDE_COPY_COLOR BIGINT Recuento de caras con imágenes impresas en color (seguras) de los trabajos de copia. IMG_SAFE_SIDE_FAX_MONO BIGINT Recuento de caras con imágenes impresas en blanco y negro (seguras) de los trabajos de fax. IMG_SAFE_SIDE_FAX_COLOR BIGINT Recuento de caras con imágenes impresas en color (seguras) de los trabajos de fax. FAX_JOB_RECV BIGINT Recuento de trabajos de fax recibidos. FAX_JOB_SENT BIGINT Recuento de trabajos de fax enviados. FAX_PAGE_RECV BIGINT Recuento de páginas de fax recibidas. FAX_PAGE_SENT BIGINT Recuento de páginas de fax enviadas. SCAN_COPY BIGINT Recuento de digitalizaciones de trabajos de copia. SCAN_FAX BIGINT Recuento de digitalizaciones del fax. SCAN_LOCAL BIGINT Recuento de digitalizaciones locales. SCAN_NET BIGINT Recuento de digitalizaciones en la red. SCAN_FLAT BIGINT Recuento de digitalizaciones desde la superficie del cristal del escáner. SCAN_ADF_SIMPLEX BIGINT Recuento de digitalizaciones desde el ADF (a una cara). SCAN_ADF_DUPLEX BIGINT Recuento de digitalizaciones desde el ADF (a doble cara). SCAN_USB_DIRECT BIGINT Recuento de digitalizaciones directamente a USB. USB_DIRECT_INSERT BIGINT Número de inserciones USB. CART_INST_DATE_CYAN TIMESTAMP Marca de hora de la instalación del cartucho cian. CART_INST_DATE_YELLOW TIMESTAMP Marca de hora de la instalación del cartucho amarillo. CART_INST_DATE_MAGENTA TIMESTAMP Marca de hora de la instalación del cartucho magenta. CART_INST_DATE_BLACK TIMESTAMP Marca de hora del cartucho negro instalado. PRINTER_ID BIGINT La clave ajena para NETWORK_PRINTER.PRINTER_ID. MAINT_KIT_STATUS_100K VARCHAR(255) El nivel del kit de mantenimiento de 100K. MAINT_KIT_STATUS_160K VARCHAR(255) El nivel del kit de mantenimiento de 160K. MAINT_KIT_STATUS_200K VARCHAR(255) El nivel del kit de mantenimiento de 200K. MAINT_KIT_STATUS_300K VARCHAR(255) El nivel del kit de mantenimiento de 300K. MAINT_KIT_STATUS_320K VARCHAR(255) El nivel del kit de mantenimiento de 320K. MAINT_KIT_STATUS_480K VARCHAR(255) El nivel del kit de mantenimiento de 480K. MAINT_KIT_STATUS_600K VARCHAR(255) El nivel del kit de mantenimiento de 600K. PRINTER_STATISTICS"},{"UUID":"5b83ec0b-7e1b-44a4-a5f2-ab7df5628516","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_SUPPLIES Esta tabla representa los","descFull":"PRINTER_SUPPLIES Esta tabla representa los consumibles de las impresoras. Hay una fila en esta tabla para cada consumible de una impresora determinada, todas apuntando al mismo PRINTER_ID. En función del tipo, no se aplican todas las columnas. PRINTER_SUPPLIES Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. SUPPLY_ID BIGINT La clave principal. CAPACITY BIGINT La capacidad máxima de hojas del consumible. COLOR VARCHAR(255) El color del consumible (por ejemplo, negro, cian o NULO). NAME VARCHAR(255) El nombre del consumible (por ejemplo, tóner negro, fusor y conenedor de desecho). SMART_CARTRIDGE_PREBATE SMALLINT/ TINYINT * Indicador que señala si este consumible es un cartucho inteligente prebate. SMART_CARTRIDGE_REFILLED SMALLINT/ TINYINT * Indicador que señala si este consumible es una recarga de cartucho inteligente. SMART_CARTRIDGE_SERIAL_NUMBER VARCHAR(255) El número de serie del cartucho inteligente. TYPE VARCHAR(255) El tipo de consumible (por ejemplo, tóner, cinta de transferencia, fusor, depósito, o unidad de captura de imágenes). PRINTER_ID BIGINT La clave ajena para NETWORK_PRINTER.PRINTER_ID. PERCENT_FULL BIGINT El porcentaje restante calculado del consumible. PRINTER_SUPPLIES"},{"UUID":"f45e042d-3be3-4f76-84e3-51f5ed672f29","title":"Impresora","link":"config-item-topic.html","desc":"CHANGED_SETTINGS Esta tabla contiene información","descFull":"CHANGED_SETTINGS Esta tabla contiene información sobre los ajustes que han cambiado entre las dos últimas auditorías. CHANGED_SETTINGS Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. CI_ID BIGINT Hace referencia a CONFIG_ITEM.ID. SETTING_NAME VARCHAR(255) El nombre del ajuste que ha cambiado. CHANGE_TYPE VARCHAR(255) El tipo de cambio. Las opciones son ADD, UPDATE y REMOVE. CHANGED_SETTINGS"},{"UUID":"c128036c-fd54-4db5-9664-e7ab54048643","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_PORTS Esta tabla contiene información","descFull":"PRINTER_PORTS Esta tabla contiene información sobre el estado de los puertos TCP/UDP de la impresora. PRINTER_PORTS Nombre del campo Tipo de datos Descripción PRINTER_PORTS_ID BIGINT La clave principal. PRINTER_ID BIGINT Hace referencia a PRINTER.ID. TCP21 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP69 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP79 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP80 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP137 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP161 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP162 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP515 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP631 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP5001 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP5353 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP8000 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP9100 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP9200 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP9200 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP9300 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP9301 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP9302 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP9400 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP9500 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP9501 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP9600 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP9700 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP9000 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP5000 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP443 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP4000 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. UDP6100 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP6100 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP65002 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP65004 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP65004 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP65001 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TCP65003 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. PRINTER_PORTS"},{"UUID":"cdf75414-4c84-4c0f-98b4-2178bd51ca5e","title":"Impresora","link":"config-item-topic.html","desc":"PRINTER_SECURITY-OPTIONS Esta tabla contiene información","descFull":"PRINTER_SECURITY-OPTIONS Esta tabla contiene información relacionada con los detalles de seguridad de la impresora. PRINTER_SECURITY-OPTIONS Nombre del campo Tipo de datos Descripción PRINTER_SECURITY_ID BIGINT La clave principal. PRINTER_ID BIGINT Hace referencia a PRINTER.ID. OWASP_CIPHER_CATEGORY VARCHAR(500) Lista de categorías de cifrado compatibles con el dispositivo. TLS10 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. TLS11 VARCHAR(255) Las opciones son OFF, ON, UNKNOWN y NONE. PRINTER_SECURITY-OPTIONS"},{"UUID":"8bf7ba50-ee75-43fb-93ca-a39f250560ec","title":"Palabras clave","link":"config-item-topic.html","desc":"ASSIGNED_KEYWORDS Esta tabla representa las","descFull":"ASSIGNED_KEYWORDS Esta tabla representa las palabras clave asignadas a sus respectivos CI e impresoras. ASSIGNED_KEYWORDS Nombre del campo Tipo de datos Descripción KEYWORD_ID BIGINT La clave principal compuesta y la clave ajena a KEYWORD.KEYWORD_ID. CI_ID BIGINT La clave principal compuesta y la clave ajena a CONFIGURATION_ITEM.CI_ID. ASSIGNED_KEYWORDS"},{"UUID":"3d4d11dd-35cc-46da-88b6-95e8eac8b736","title":"Palabras clave","link":"config-item-topic.html","desc":"KEYWORD Esta tabla representa todas","descFull":"KEYWORD Esta tabla representa todas las palabras clave definidas en el sistema. KEYWORD Nombre del campo Tipo de datos Descripción KEYWORD_ID BIGINT La clave principal. KEYWORD_VALUE VARCHAR(255) El nombre de la palabra clave. CATEGORY_ID BIGINT La clave ajena a KEYWORD_CATEGORY.CATEGORY_ID. KEYWORD"},{"UUID":"1f8d5ede-2b99-4971-8f98-2973e0172398","title":"Palabras clave","link":"config-item-topic.html","desc":"KEYWORD_CATEGORY Esta tabla enumera todas","descFull":"KEYWORD_CATEGORY Esta tabla enumera todas las categorías definidas en el sistema. Se utiliza para agrupar palabras clave. KEYWORD_CATEGORY Nombre del campo Tipo de datos Descripción CATEGORY_ID BIGINT La clave principal. CATEGORY_VALUE VARCHAR(255) El nombre de la categoría. KEYWORD_CATEGORY"},{"UUID":"fc1ddd4f-4f9b-4240-a328-a5d327b97c9e","title":"Configuraciones","link":"config-item-topic.html","desc":"CONFIGURATION Esta tabla representa una","descFull":"CONFIGURATION Esta tabla representa una configuración de impresora en el nivel más alto, incluyendo el nombre de la impresora, el modelo y si se puede asignar. CONFIGURATION Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. CONFIGURATION_ID BIGINT La clave principal. CONFIGURATION_NAME VARCHAR(255) El nombre de la configuración. ASSIGNABLE SMALLINT/ TINYINT * El indicador que señala si la configuración es asignable. DESCRIPTION VARCHAR(4000) Descripción de la configuración introducida por el usuario. LAST_MODIFIED TIMESTAMP Marca de hora de la última edición de la configuración. MANAGING_DEV_CERTIFICATE BOOLEAN El valor booleano predeterminado. Este campo indica si esta configuración administra el certificado de dispositivo automáticamente. CONFIGURATION"},{"UUID":"fa1592ce-9e2e-491d-8a7f-3f54f46ef8fd","title":"Configuraciones","link":"config-item-topic.html","desc":"CONFIGURATION_COMPONENT Esta tabla representa un","descFull":"CONFIGURATION_COMPONENT Esta tabla representa un componente de una configuración. CONFIGURATION_COMPONENT Nombre del campo Tipo de datos Descripción CONFIGURATION_COMPONENT_ID BIGINT La clave principal. COMPONENT_TYPE VARCHAR(255) El tipo de componente. Las opciones son DEVICE_SETTINGS, SECURITY_CAESAR1, SECURITY_CAESAR2, ESF y FIRMWARE. CREDENTIAL_PASSWORD BLOB SUB_TYPE 0 La contraseña de credencial cifrada, si se ha establecido. CREDENCIAL_PIN BLOB SUB_TYPE 0 El PIN de credenciales cifrado, si se ha establecido. CREDENTIAL_REALM VARCHAR(255) El dominio de credenciales, si se ha establecido. CREDENTIAL_USERNAME VARCHAR(255) El nombre de usuario de la credencial, si se ha establecido. COMPONENT_NAME VARCHAR(255) El nombre del componente. LICENSE_TYPE VARCHAR(255) El tipo de licencia del componente de configuración. Las opciones son PRODUCTION, TRIAL y FACTORY. LOGIN_METHOD VARCHAR(256) Método de autenticación utilizado para iniciar sesión en la impresora. MERGE_DATA_PATH VARCHAR(255) La ubicación de un archivo de ajustes variables. FLASH_FILE_SHA1 VARCHAR(255) El hash SHA1 del archivo flash para un componente de firmware. LOGIN_METHOD_NAME VARCHAR(256) Si LOGIN_METHOD es LDAP o LDAP+GSSAPI, este campo muestra el nombre del método de inicio de sesión concreto. DESCRIPTION VARCHAR(4000) Este campo muestra la descripción si se agrega a un componente. LAST_MODIFIED TIMESTAMP La marca de hora de la última modificación. ASSIGNABLE Booleano El valor es verdadero si el componente está asignado a una impresora. De lo contrario, el valor es falso. PRE_POPULATED Booleano Se ha añadido para identificar los componentes de seguridad avanzada rellenados previamente. CONFIGURATION_COMPONENT"},{"UUID":"01178a81-9c96-4aa3-9b8c-411b7ff734ab","title":"Configuraciones","link":"config-item-topic.html","desc":"CONFIGURATION_COMPONENTS Esta tabla contiene información","descFull":"CONFIGURATION_COMPONENTS Esta tabla contiene información sobre los diferentes componentes relacionados con las diferentes configuraciones, si se ha seleccionado. CONFIGURATION_COMPONENTS Nombre del campo Tipo de datos Descripción CONFIGURATION_ID BIGINT La clave ajena a CONFIGURATION.CONFIGURATION_ID. CONFIGURATION_COMPONENT_ID BIGINT La clave ajena a CONFIGURATION_COMPONENT. CONFIGURATION_COMPONENT_ID. COMPONENT_TYPE VARCHAR(255) Se ha añadido para discriminar entre el Componente de ajuste del dispositivo y otros ocho componentes. CONFIGURATION_COMPONENTS"},{"UUID":"2b5684e7-b032-4a0f-9353-92b93d6c14f2","title":"Configuraciones","link":"config-item-topic.html","desc":"ASSIGNED_CONFIGURATIONS Esta tabla muestra qué","descFull":"ASSIGNED_CONFIGURATIONS Esta tabla muestra qué configuraciones se asignan a cada CI e impresoras. ASSIGNED_CONFIGURATIONS Nombre del campo Tipo de datos Descripción CI_ID BIGINT La clave principal compuesta y la clave ajena devueltas a CONFIGURATION_ITEM.CI_ID. CONFIGURATION_ID BIGINT La clave principal compuesta y la clave ajena devueltas a CONFIGURATION.CONFIGURATION_ID. COMPLIANCE_STATE VARCHAR(255) El estado de cumplimiento actual de la configuración. LAST_COMPLIANCE_CHECK TIMESTAMP Marca de hora de la última comprobación de cumplimiento ejecutada. ASSIGNED_CONFIGURATIONS"},{"UUID":"6bb745b2-f524-4ce8-bcd0-c42d5440bdb3","title":"Configuraciones","link":"config-item-topic.html","desc":"FAILED_COMPONENT Esta tabla incluye todos","descFull":"FAILED_COMPONENT Esta tabla incluye todos los componentes que tienen una configuración que no cumple los requisitos. FAILED_COMPONENT Nombre del campo Tipo de datos Descripción FAILED_COMPONENT_ID BIGINT La clave principal. CI_ID BIGINT La clave ajena devuelta a ASSIGNED_CONFIGURATIONS.CI_ID. CONFIGURATION_ID BIGINT (no nulo) La clave ajena devuelta a ASSIGNED_CONFIGURATIONS.CONFIGURATION_ID. COMPONENT_TYPE VARCHAR(255) El tipo del componente fallido. COMPONENT_NAME VARCHAR(255) El nombre del componente fallido. FAILED_COMPONENT"},{"UUID":"f5a91409-e5f5-4f0c-9ed2-e863a8d1436c","title":"Configuraciones","link":"config-item-topic.html","desc":"FAILED_COMPONENT_SETTINGS Esta tabla incluye todos","descFull":"FAILED_COMPONENT_SETTINGS Esta tabla incluye todos los ajustes que no cumplen los requisitos y sus valores. FAILED_COMPONENT_SETTINGS Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. TYPE SMALLINT/ TINYINT * , valor predeterminado 0 Se ha añadido para discriminar motivos de error de cumplimiento entre Discrepancia, No aplicable, No compatible, Recurso no en la biblioteca y No se puede combinar el ajuste del token. FAILED_COMPONENT_ID BIGINT (no nulo) La clave ajena devuelta a FAILED_COMPONENT.FAILED_COMPONENT_ID. SETTING_NAME VARCHAR(255) El nombre de la configuración fallida. PRINTER_VALUE dropNotNullConstraint Puede ser un valor nulo. COMPONENT_VALUE dropNotNullConstraint Puede ser un valor nulo. FAILED_COMPONENT_SETTINGS"},{"UUID":"f41fab46-ff23-4427-a015-7e59f6ac7bfe","title":"Configuraciones","link":"config-item-topic.html","desc":"FLASHFILE Esta tabla representa información","descFull":"FLASHFILE Esta tabla representa información sobre los recursos de la biblioteca de firmware de MVE. FLASHFILE Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. FILENAME VARCHAR(256) El nombre del archivo y la ubicación dentro del repositorio de MVE. SHA1 VARCHAR(255) El hash SHA1 del archivo flash. DISPLAY_NAME VARCHAR(255) Identificador de versión del archivo flash. DATE_IMPORTED TIMESTAMP La fecha en la que se importó el archivo flash. DESCRIPTION VARCHAR(255) La descripción del archivo flash. FLASHFILE"},{"UUID":"8b90e05f-ba60-4f31-b412-45e6d94b3eed","title":"Configuraciones","link":"config-item-topic.html","desc":"FLASH_NET_IDS Esta tabla almacena el","descFull":"FLASH_NET_IDS Esta tabla almacena el NETFLASH ID que se encuentra en la parte superior de cada archivo flash de la Biblioteca de recursos. FLASH_NET_IDS Nombre del campo Tipo de datos Descripción FLASHNETID BIGINT La clave principal. NET_ID VARCHAR(255) El NETFLASH ID. FLASH_NET_IDS"},{"UUID":"27fba7e3-c5b4-4caf-b533-ee7c8edfd3c9","title":"Configuraciones","link":"config-item-topic.html","desc":"CERTIFICATES Esta tabla representa información","descFull":"CERTIFICATES Esta tabla representa información sobre los recursos de la biblioteca de certificados CA de MVE. CERTIFICATES Nombre del campo Tipo de datos Descripción CERTIFICATE_ID BIGINT La clave principal. NAME VARCHAR(255) El nombre descriptivo de un certificado CA. PEM_CERTIFICATE BLOB Representación PEM de un certificado CA. DATE_IMPORTED TIMESTAMP Fecha en la que se importó el certificado CA a MVE. PEM_CERTIFICATE_SHA2 VARCHAR (64) Hash SHA2 de este certificado CA. DESCRIPTION VARCHAR (255) Descripción del certificado CA. CERTIFICATES"},{"UUID":"1bdbd52e-e061-414d-a7e3-2b07dcf426ff","title":"Configuraciones","link":"config-item-topic.html","desc":"CERTIFICATE_COMP_CERTIFICATES Esta tabla muestra la","descFull":"CERTIFICATE_COMP_CERTIFICATES Esta tabla muestra la vinculación del certificado de la Biblioteca de recursos a un componente de configuración y, por tanto, a una configuración. CERTIFICATE_COMP_CERTIFICATES Nombre del campo Tipo de datos Descripción CONFIGURATION_COMPONENT_ID BIGINT La clave ajena a CONFIGURATION_COMPONENT.CONFIGURATION_ COMPONENT_ID. CERTIFICATE_ID BIGINT La clave ajena devuelta a CERTIFICATES.CERTIFICATE_ID. CERTIFICATE_COMP_CERTIFICATES"},{"UUID":"bb48ab7e-d65b-41df-8185-f4c282eb45f1","title":"Configuraciones","link":"config-item-topic.html","desc":"COMPONENT_SETTINGS Esta tabla representa los","descFull":"COMPONENT_SETTINGS Esta tabla representa los ajustes contenidos en un componente de configuración determinado. Hay una fila en esta tabla para cada valor asociado con el componente de configuración, que apunta al mismo CONFIGURATION_COMPONENT.CONFIGURATION_COMPONENT_ID. Los valores están cifrados y no están disponibles fuera de MVE. COMPONENT_SETTINGS Nombre del campo Tipo de datos Descripción SETTING_ID BIGINT La clave principal. SETTING_NAME VARCHAR(255) El nombre del ajuste. SETTING_VALUE VARCHAR(1280) El valor de configuración cifrado. CONFIGURATION_COMPONENT_ID BIGINT La clave ajena a CONFIGURATION_COMPONENT.CONFIG URATION_COMPONENT_ID. DISCRIMINATOR VARCHAR(255) Las opciones son SIMPLE_SETTING y TABULAR_SETTING. TABULAR_SETTING_VALUE_ID BIGINT La clave ajena a COMPONENT_TAB_SETTING_VALUE.TA BULAR_SETTING_VALUE_ID. COMPONENT_SETTINGS"},{"UUID":"46cd2ed1-d1e6-4a51-99a9-bb116499bf17","title":"Configuraciones","link":"config-item-topic.html","desc":"COMPONENT_TAB_TABLE Esta tabla representa las","descFull":"COMPONENT_TAB_TABLE Esta tabla representa las tablas de permisos de impresión en color incluidas en las configuraciones. COMPONENT_TAB_TABLE Nombre del campo Tipo de datos Descripción TABLE_ID BIGINT La clave principal. TABLE_TYPE VARCHAR(255) Las opciones son HOST_TABLE y USER_TABLE. COMPONENT_TAB_TABLE"},{"UUID":"8fbf3e3a-5f5b-4103-b10c-3542c489ad12","title":"Configuraciones","link":"config-item-topic.html","desc":"COMPONENT_TAB_ROW Esta tabla representa una","descFull":"COMPONENT_TAB_ROW Esta tabla representa una fila de las tablas permisos de impresión en color. Los valores están cifrados y no se pueden utilizar fuera de MVE. COMPONENT_TAB_ROW Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. TABLE_ID BIGINT La clave ajena a COMPONENT_TAB_TABLE.TABLE_ID HOST_NAME VARCHAR(255) El valor del ajuste  Nombre de host  en la tabla de hosts. USER_NAME VARCHAR(255) El valor del ajuste  Nombre de usuario  en la tabla de usuarios. ALLOWED_TO_PRINT_COLOR SMALLINT/ TINYINT * El valor del ajuste  Permitir impresión en color  para las tablas de host y de usuario. USER_PERMISSION_OV ERRIDDEN SMALLINT/ TINYINT * El valor del ajuste  Permisos de usuario anulados  en la tabla de host. COMPONENT_TAB_ROW"},{"UUID":"d6fc11a1-a473-43eb-9b30-963752876405","title":"Configuraciones","link":"config-item-topic.html","desc":"COMPONENT_TAB_SETTING_VALUE Esta tabla muestra la","descFull":"COMPONENT_TAB_SETTING_VALUE Esta tabla muestra la correlación de las tablas de permisos de impresión en color con los componentes y, por tanto, con las configuraciones. COMPONENT_TAB_SETTING_VALUE Nombre del campo Tipo de datos Descripción TABULAR_SETTING_VALUE_ID BIGINT La clave ajena a COMPONENT_SETTINGS.TABULAR_SETTING_VALUE_ID. TABLE_ID BIGINT La clave ajena a COMPONENT_TAB_TABLE.TABLE_ID. COMPONENT_TAB_SETTING_VALUE"},{"UUID":"5765acf8-01ba-4a62-927f-9ea75c78de77","title":"Configuraciones","link":"config-item-topic.html","desc":"CC_SUPPORTED_MODEL_BACKUP CC_SUPPORTED_MODEL_BACKUP Nombre del campo","descFull":"CC_SUPPORTED_MODEL_BACKUP CC_SUPPORTED_MODEL_BACKUP Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. SUPPORTED_MODEL VARCHAR(255) Se utiliza para crear una copia de seguridad a partir de CONFIGURATION y CONFIGURATION_COMPONENT para los  Componentes de ajuste de dispositivos . CC_SUPPORTED_MODEL_BACKUP"},{"UUID":"71df4c57-6d42-4db9-b752-600fbf4f3384","title":"Configuraciones","link":"config-item-topic.html","desc":"ESF_COMP_PRODUCTS ESF_COMP_PRODUCTS Nombre del campo","descFull":"ESF_COMP_PRODUCTS ESF_COMP_PRODUCTS Nombre del campo Tipo de datos Descripción CONFIGURATION_COMPONENT_ID BIGINT Las referencias de clave ajena. Mesa: CONFIGURATION_COMPONENT Columna: CONFIGURATION_COMPONENT_ID PART_NUMBER VARCHAR(255) El número de artículo del producto del componente de la solución. ESF_COMP_PRODUCTS"},{"UUID":"5abc4379-1fd1-4fd7-9645-0398bff4e8a5","title":"Configuraciones","link":"config-item-topic.html","desc":"VCCFILE VCCFILE Nombre del campo","descFull":"VCCFILE VCCFILE Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. FILENAME VARCHAR(255) Nombre del archivo cargado. DISPLAY_NAME VARCHAR(255) El nombre del archivo VCC que se muestra en MVE. DATE_IMPORTED TIMESTAMP Marca de hora de la carga del archivo. SHA1 VARCHAR(255) Hash del contenido del archivo. DESCRIPTION VARCHAR(255) La descripción del archivo VCC. VCCFILE"},{"UUID":"bd7960f4-a613-4db3-aae1-76edecd797c5","title":"Configuraciones","link":"config-item-topic.html","desc":"UCFFILE UCFFILE Nombre del campo","descFull":"UCFFILE UCFFILE Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. FILENAME VARCHAR(255) Nombre del archivo cargado. DISPLAY_NAME VARCHAR(255) El nombre del archivo UCF que se muestra en MVE. DATE_IMPORTED TIMESTAMP Marca de hora de la carga del archivo. SHA1 VARCHAR(255) Hash del contenido del archivo. DESCRIPTION VARCHAR(255) La descripción del archivo UCF. UCFFILE"},{"UUID":"6414cbff-c0c0-423f-ab0a-e201b498086c","title":"Configuraciones","link":"config-item-topic.html","desc":"UCF_VCC_RESOURCE_FILES Esta tabla contiene información","descFull":"UCF_VCC_RESOURCE_FILES Esta tabla contiene información sobre el estado de los puertos TCP/UDP de la impresora. UCF_VCC_RESOURCE_FILES Nombre del campo Tipo de datos Descripción RESOURCE_ID BIGINT La clave principal. SHA1 VARCHAR(255) Hash del contenido del archivo. RESOURCE_TYPE VARCHAR(255) El tipo de archivo de recursos. Las opciones son UCF_FILE, VCC_FILE y APP_FLS. CONFIGURATION_COMPONENT_ID VARCHAR(255) La clave ajena del identificador de la tabla CONFIGURATION_COMPONENT. UCF_VCC_RESOURCE_FILES"},{"UUID":"07002a83-927b-4220-9363-d8a6f4428130","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"Perfiles de búsqueda Las siguientes","descFull":"Perfiles de búsqueda Las siguientes tablas se utilizan para rastrear los perfiles de búsqueda de MVE. DISCOVERY_PROFILE DISCOVERY_PROFILE Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. NAME VARCHAR(255) El nombre proporcionado por el usuario para el perfil. RETRIES INTEGER El número de intentos para volver a tratar de comunicarse con una impresora. SNMP_READ_COMMUNITY_NAME VARCHAR(255) El nombre de la comunidad SNMP que se va a utilizar al leer. TIMEOUT BIGINT El número de milisegundos que se debe esperar para que un intento de comunicación concreto con una impresora tenga éxito. SNMP_USERNAME VARCHAR(32) Nombre de usuario para la comunicación SNMP. SNMP_PASSWORD VARCHAR(32) La contraseña para la comunicación SNMP. SNMP_MIN_AUTHENTICATION_LEVEL VARCHAR(255) El nivel de autenticación mínimo para SNMP. SNMP_AUTHENTICATION_HASH VARCHAR(50) Hash utilizado para la autenticación SNMP. SNMP_PRIVACY_ALGORITHM VARCHAR(50) El algoritmo utilizado para la privacidad de SNMP. DISCOVERY_PROFILE_CI Esta tabla contiene las partes específicas de CI del perfil de búsqueda. DISCOVERY_PROFILE_CI Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. CI_DP_ID BIGINT La clave primaria y la clave ajena a DISCOVERY_PROFILE.ID. AUTOMANAGE SMALLINT/ TINYINT * El indicador que señala si los CI detectados con este perfil deben administrarse automáticamente. DESCRIPTION VARCHAR(4000) La descripción proporcionada por el usuario del perfil de búsqueda. LAST_RUN TIMESTAMP Marca de hora de la última ejecución del perfil. CREDENTIAL_USERNAME VARCHAR(255) El nombre de usuario de la credencial, si se ha establecido. CREDENTIAL_REALM VARCHAR(64) El dominio de credenciales, si se ha establecido. LOGIN_METHOD VARCHAR(256) Método de autenticación utilizado para iniciar sesión en la impresora. LOGIN_METHOD_NAME VARCHAR(256) El nombre del método de autenticación si LOGIN_METHOD es LDAP o LDAP+GSSAPI. CREDENTIAL_PASSWORD BLOB Este valor está cifrado y no está disponible para su uso fuera de MVE. CREDENCIAL_PIN BLOB Este valor está cifrado y no está disponible para su uso fuera de MVE. ASSIGN_KEYWORD_IDS VARCHAR(512) Las palabras clave asignadas en un perfil de búsqueda. EXCLUDE_PROFILE_ITEM Esta tabla representa la lista  Excluir  de un perfil. Cada elemento excluido tiene una fila en esta tabla. EXCLUDE_PROFILE_ITEM Nombre del campo Tipo de datos Descripción DISCOVERY_PROFILE_ID BIGINT La clave primaria compuesta y la clave ajena a DISCOVERY_PROFILE.ID. VALUE_ VARCHAR(255) La clave primaria compuesta. Este campo define los elementos que se deben excluir. INCLUDE_PROFILE_ITEM Esta tabla representa la lista  Incluir  de un perfil. Cada elemento incluido tiene una fila en esta tabla. INCLUDE_PROFILE_ITEM Nombre del campo Tipo de datos Descripción DISCOVERY_PROFILE_ID BIGINT La clave primaria compuesta y la clave ajena a DISCOVERY_PROFILE.ID. VALUE_ VARCHAR(255) La clave primaria compuesta. Este campo define los elementos que se deben incluir. DISCOVERY_PROFILE_MODEL_CONFIG Esta tabla representa la parte  Asignar configuraciones  de un perfil de búsqueda. DISCOVERY_PROFILE_MODEL_CONFIG Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. MODEL VARCHAR(255) El nombre de modelo de las impresoras a las que está asignada la configuración. DISCOVERY_PROFILE_ID BIGINT La clave ajena a DISCOVERY_PROFILE.ID. CI_CONFIGURATION_ID BIGINT La clave ajena a CONFIGURATION.CONFIGURATION_ID. Perfiles de búsqueda"},{"UUID":"28e11a3a-cc35-482b-913c-19228d08fde1","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"ESF ESF_APPLICATION Esta tabla contiene","descFull":"ESF ESF_APPLICATION Esta tabla contiene todas las aplicaciones eSF de todos los paquetes eSF implementable. Puede haber muchas aplicaciones eSF en cada paquete implementable. ESF_APPLICATION Nombre del campo Tipo de datos Descripción ESF_APP_ID BIGINT La clave principal. ESF_DP_ID BIGINT La clave ajena devuelta a ESF_DEPLOYABLE_PACKAGE.ESF_DP_ID. APP_ID VARCHAR(255) El ID de aplicación de las aplicaciones eSF. VERSION VARCHAR(255) Versión de aplicaciones eSF DESCRIPTION_URI VARCHAR(255) La descripción URI de la aplicación eSF. FLS_URI VARCHAR(255) El URI al archivo flash. ESF_APPLICATION_LOCALE Esta tabla contiene el nombre y la descripción de cada aplicación eSF en todos los idiomas admitidos por MVE. ESF_APPLICATION_LOCALE Nombre del campo Tipo de datos Descripción ESF_APP_LOCALE_ID BIGINT La clave principal. ESF_APP_ID BIGINT La clave ajena ESF_APPLICATION.ESF_APP_ID. LOCALE VARCHAR(255) Código de idioma de dos caracteres. NAME VARCHAR(255) Nombre de la aplicación eSF en el idioma indicado por LOCALE. DESCRIPTION VARCHAR(510) La descripción de la aplicación eSF en el idioma indicado por LOCALE. ESF_COMP_DEPLOYABLE_PACKAGE Esta tabla contiene una fila para cada paquete implementable en uso por una configuración de MVE. ESF_COMP_DEPLOYABLE_PACKAGE Nombre del campo Tipo de datos Descripción ESF_COMPONENT_ID BIGINT La clave ajena a CONFIGURATION_COMPONENT.CONFIGURATION_COMPONENT_ID. ESF_DP_ID VARCHAR(255) La clave ajena a ESF_DEPLOYABLE_PACKAGE.ESF_DP_ID. ESF_DEPLOYABLE_PACKAGE Esta tabla representa todos los paquetes implementables cargados en la biblioteca MVE. ESF_DEPLOYABLE_PACKAGE Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. ESF_DP_ID BIGINT La clave principal. NAME VARCHAR(255) Nombre del paquete implementable. PART_NUMBER VARCHAR(255) Número de artículo del paquete implementable. PART_REVISION VARCHAR(255) La revisión de artículo del paquete implementable. LICENSE_REQUIRED SMALLINT/ TINYINT * Indicador que señala si se requiere una licencia para el paquete implementable. URI VARCHAR(255) URI del paquete implementable. DATE_IMPORTED TIMESTAMP Fecha en la que se importó el paquete implementable. VERSION VARCHAR(255) Versión del paquete implementable. DESCRIPTION VARCHAR(255) Descripción del paquete implementable. ESF_DEPLOYABLE_PACKAGE_LOCALE Esta tabla contiene el nombre y la descripción de cada paquete implementable en todos los idiomas admitidos por MVE. ESF_DEPLOYABLE_PACKAGE_LOCALE Nombre del campo Tipo de datos Descripción ESF_DP_LOCALE_ID BIGINT La clave principal. ESF_DP_ID BIGINT La clave ajena a ESF_DEPLOYABLE_PACKAGE.ESF_ DP_ID. LOCALE VARCHAR(255) Código de idioma de dos caracteres. NAME VARCHAR(255) El nombre del paquete implementable en el idioma indicado por LOCALE. DESCRIPTION VARCHAR(2048) La longitud de la descripción aumentada, de 510 a 2048 caracteres. ESF_DP_SUPPORTED MODELS Esta tabla contiene una fila para cada modelo admitido por un paquete implementable en la biblioteca MVE. ESF_DP_SUPPORTED MODELS Nombre del campo Tipo de datos Descripción ESF_DP_ID BIGINT La clave ajena devuelta a ESF_DEPLOYABLE_PACKA GE.ESF_DP_ID. SUPPORTED_MODEL VARCHAR(255) Nombre de modelo de la impresora compatible con el paquete implementable. ESF_LICENSE Esta tabla representa las licencias de las aplicaciones eSF disponibles en la biblioteca MVE. ESF_LICENSE Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. ESF_LICENSE_ID BIGINT La clave principal. PRINTER_SERIAL VARCHAR(255) El número de serie de la impresora a la que está vinculada la licencia. PART_NUMBER VARCHAR(255) El número de artículo del paquete al que está vinculada la licencia. PART_REVISION VARCHAR(255) La revisión de artículo del paquete al que está vinculada la licencia. LICENSE_TYPE VARCHAR(255) Las opciones son TRIAL y PRODUCTION. FILE_NAME VARCHAR(255) El nombre de archivo del archivo binario de licencia. DEPLOYED SMALLINT/ TINYINT * Indicador que señala si se ha implementado la licencia. RAWESFAPPFILE Esta tabla representa los detalles del archivo de aplicación eSF sin procesar disponibles en la biblioteca MVE. RAWESFAPPFILE Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. FILENAME VARCHAR(255) Nombre del archivo de paquete. DISPLAY_NAME VARCHAR(255) Nombre de visualización del archivo de paquete. DATE_IMPORTED TIMESTAMP Marca de hora de la importación del paquete. SHA1 VARCHAR(255) El hash SHA1 del paquete. DESCRIPTION VARCHAR(255) Descripción del paquete. APP_ID VARCHAR(255) ID de aplicación del paquete. VERSION VARCHAR(255) Versión del paquete. APP_FLS_RESOURCE_FILES Esta tabla representa la asociación del archivo de aplicaciones eSF disponible en la biblioteca MVE con la configuración. APP_FLS_RESOURCE_FILES Nombre del campo Tipo de datos Descripción RESOURCE_ID BIGINT La clave principal. SHA1 VARCHAR(255) El hash SHA1 del paquete. RESOURCE_TYPE VARCHAR(255) Tipo del archivo de recursos. Las opciones son UCF_FILE, VCC_FILE y APP_FLS. CONFIGURATION_COMPONENT_ID BIGINT La clave ajena con la columna ID de CONFIGURATION_COMPONENT. ESF"},{"UUID":"4044366d-7f7b-465f-bfbc-385d2fdf3a64","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"Administración de certificados A continuación,","descFull":"Administración de certificados A continuación, se muestra la lista de certificaciones que se deben verificar. ENROLLMENT_STATUS En la tabla siguiente se enumeran los certificados emitidos. ENROLLMENT_STATUS Nombre del campo Tipo de datos Descripción ENROLLMENT_STATUS_ID BIGINT La clave principal. CERTIFICATE_ENROL_STATUS VARCHAR(255) El estado de inscripción del certificado. Las opciones son Issued, Pending y Failed. CERT_ENROL_TRANSACTION_ID VARCHAR(2048) La respuesta del certificado pendiente para la EST. A veces, este campo muestra el ID de transacción para la inscripción de certificados. CERT_SUBJECT_IDENTITY VARCHAR(255) La identidad de asunto del certificado. CERT_SERIAL_NUMBER VARCHAR(255) El número de serie del certificado emitido. PRINTER_ID BIGINT Impresora de referencia. DEFAULT_CERT_REVISION_NO VARCHAR(255) El número de revisión del certificado que se ha renovado. DEFAULT_CERT_RENEWAL_DATE VARCHAR(255) La fecha de renovación del certificado. CERTIFICATE_FRIENDLY_NAME VARCHAR(255) El nombre descriptivo del certificado. CERTIFICATE_USED_FOR VARCHAR(255) La asociación del certificado nombrado. Las opciones son DEFAULT, HTTPS, WIRELESS, IPSEC y UNASSIGNED. CA_CERT_REVOCATION_COMP_LIST En la tabla siguiente se muestra información sobre los certificados revocados. CA_CERT_REVOCATION_COMP_LIST Nombre del campo Tipo de datos Descripción ID BIGINT El identificador único. SERIAL_NUMBER VARCHAR(255) El número de serie del certificado presente en la clave principal de la lista de revocación. CERTIFICATE_SUBJECT VARCHAR(255) El asunto del certificado revocado. REVOCATION_DATE TIMESTAMP La fecha en que se revoca el certificado. ISSUER VARCHAR(255) Emisor del certificado revocado. REVOCATION_REASON VARCHAR(255) El motivo de la revocación. NAMED_CERTIFICATE_SETTINGS En la tabla siguiente se muestran el nombre y la asociación del certificado nombrado. NAMED_CERTIFICATE_SETTINGS Nombre del campo Tipo de datos Descripción CERT_SETTING_ID BIGINT El identificador único. FRIENDLY_NAME VARCHAR(255) El nombre descriptivo del certificado nombrado. CERT_USED_FOR VARCHAR(255) La asociación del certificado nombrado. Las opciones son DEFAULT, HTTPS, WIRELESS, IPSEC y UNASSIGNED. CONFIGURATION_COMPONENT_ID BIGINT La clave ajena asociada al ID de la tabla CONFIGURATION_COMPONENT. TEMPLATE_ID BIGINT El ID de la plantilla asociada. PRINTER_CERTIFICATE La siguiente tabla representa los detalles del certificado nombrado. PRINTER_CERTIFICATE Nombre del campo Tipo de datos Descripción CERTIFICATE_ID BIGINT El identificador único. CERTIFICATE_FRIENDLY_NAME VARCHAR(255) El nombre descriptivo del certificado. CERTIFICATE_COMMON_NAME VARCHAR(255) El nombre común del certificado. CERTIFICATE_ISSUER_NAME VARCHAR(255) Nombre del emisor del certificado. CERTIFICATE_SIGNING_STATUS VARCHAR(255) El estado de firma del certificado. Las opciones son SIGNED, INVALID_CERT, NO_CA, REVOKED y UNKNOWN. CERTIFICATE_VALID_FROM TIMESTAMP La hora a la que el certificado comenzó a ser válido. CERTIFICATE_VALID_TO TIMESTAMP La hora a la que el certificado ya no es válido. CERTIFICATE_SIGNATURE VARCHAR(8190) Firma del certificado. CERTIFICATE_SERIAL_NUMBER VARCHAR(255) El número de serie del certificado. TYPE VARCHAR(255) Tipo de certificado. Las opciones son DEFAULT, HTTPS, WIRELESS, IPSEC y UNASSIGNED. PRINTER_ID BIGINT La clave ajena asociada al ID de la tabla CONFIGURATION_COMPONENT. ENROLLED_CERTIFICATE_TYPE La siguiente tabla muestra la relación entre el certificado y el estado de inscripción. ENROLLED_CERTIFICATE_TYPE Nombre del campo Tipo de datos Descripción TYPE_ID BIGINT El identificador único. ENROLLMENT_STATUS_ID BIGINT Clave ajena de la columna ID de la tabla ENROLLMENT_STATUS. TYPE VARCHAR(255) Tipo de certificado. Las opciones son DEFAULT, HTTPS, WIRELESS, IPSEC y UNASSIGNED. CA_TEMPLATE La siguiente tabla muestra los detalles de las plantillas seleccionadas al configurar el servidor MSCA mediante el protocolo MSCEWS. CA_TEMPLATE Nombre del campo Tipo de datos Descripción TEMPLATE_ID BIGINT El identificador único para las plantillas del servidor MSCA con MSCEWS (no puede ser nulo). TEMPLATE_NAME VARCHAR(255) El nombre de las plantillas en el servidor CEP. TEMPLATE_OID VARCHAR(255) La ruta MIB SNMP correspondiente. Administración de certificados"},{"UUID":"a4053b9c-23f5-43ea-8c6a-88b2e46d6e66","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"Autenticación y autorización Las siguientes","descFull":"Autenticación y autorización Las siguientes tablas se utilizan para el mecanismo de autenticación y autorización de usuarios de MVE. MASTER_ROLE Esta tabla contiene todos los roles compatibles con MVE. MASTER_ROLE Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. ROLE_NAME VARCHAR(255) Nombre de la función. USERS Esta tabla enumera todas las cuentas de usuario internas de MVE. USERS Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. ID BIGINT La clave principal. USER_NAME VARCHAR(15) El nombre de usuario proporcionado por el usuario. USER_PASS VARCHAR(1024) La contraseña proporcionada por el usuario. ENABLED SMALLINT/ TINYINT * Indicador que señala si esta cuenta está activada. NAME VARCHAR(255) Nombre completo del usuario. LAST_LOGIN TIMESTAMP Marca de hora del último intento de inicio de sesión. LOGIN_ATTEMPT BIGINT Número actual de intentos realizados al iniciar sesión correctamente. REFRESH_TOKEN VARCHAR(1024) Token de autenticación cuando el usuario inicia sesión. USER_ROLE Esta tabla describe la asociación de usuarios a funciones. USER_ROLE Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. USER_NAME VARCHAR(15) La clave ajena devuelta a USERS.USER_NAME. ROLE_NAME VARCHAR(30) La clave ajena devuelta a MASTER_ROLE.ROLE_NAME. autenticación y autorización"},{"UUID":"1ad54653-7b6d-445e-ad34-3156ac5fed0d","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"Ajustes de seguridad En las","descFull":"Ajustes de seguridad En las siguientes tablas se describen los ajustes de seguridad de una configuración. La información de configuración de seguridad está cifrada para garantizar la seguridad de los datos, no está disponible fuera de MVE y no es útil en el ámbito de este documento. Por lo tanto, se omiten los detalles de las siguientes tablas. SEC_ACCESS_CONTROL SEC_AUTH_GROUP SEC_BUILDING_BLOCK SEC_BUILDING_BLOCK_SETTINGS SEC_COMPONENT_MISC_SETTINGS SEC_INTERNAL_ACCOUNT SEC_INTERNAL_ACCOUNT_GROUPS SEC_INTERNAL_ACCOUNT_SETTINGS SEC_SECURITY_TEMPLATE SEC_SECURITY_TEMPLATE_BBS SEC_SECURITY_TEMPLATE_GROUPS CAESAR2_LOCAL_ACCOUNTS CAESAR2_MISC_SETTINGS CAESAR2_KRB_SETUP CAESAR2_COMP_LOCAL_ACCTS CAESAR2_LOCAL_ACCOUNT_GROUPS CAESAR2_GROUPS CAESAR2_COMP_GROUPS CAESAR2_GROUP_PERMISSIONS CAESAR2_KRB_SETUP_PERMISSIONS CAESAR2_COMP_PUBLIC_PERMS CAESAR2_LDAP_SETUPS CAESAR2_COMP_LDAP_SETUPS CAESAR2_LDAP_SEARCH_OBJECTS CAESAR2_LDAP_SETUP_GROUPS CAESAR2_LDAP_SERVER_INFO CAESAR2_LDAP_DEVICE_CREDS CAESAR2_SOLUTION_ACCTS CAESAR2_LDAP_ADDRESS_BOOKS CAESAR2_LDAP_SEARCH_ATTRS CAESAR2_COMP_SOLN_ACCTS CAESAR2_SOLUTION_ACCT_GROUPS CAESAR2_MISC_SETTINGS CAESAR2_MISC_SETTINGS Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. MINIMUM_PASSWORD_LENGTH SMALLINT/ TINYINT * Se ha añadido un nuevo ajuste Varios en Componente de seguridad avanzada. PROTECTED_FEATURES VARCHAR(255) PRINT_PERMISSION_PRINT VARCHAR(255) PRINT_PERMISSION_BROWSER VARCHAR(255) PRINT_PERMISSION_CONTROL_PAN EL VARCHAR(255) Ajustes de seguridad"},{"UUID":"4425efb7-591d-4e49-b7f9-928d0a3649a1","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"Vistas y exportación de datos","descFull":"Vistas y exportación de datos Las siguientes tablas describen información sobre las vistas de MVE y los campos incluidos en cada vista. DATA_EXPORT_TEMPLATE Esta tabla contiene información sobre las vistas en MVE. DATA_EXPORT_TEMPLATE Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. DATA_EXPORT_ID BIGINT La clave principal. NAME VARCHAR(255) El nombre de la vista. DEFAULT_TEMPLATE SMALLINT/ TINYINT * Si la plantilla es la plantilla predeterminada que se mostrará al iniciar sesión inicialmente, solo una vista puede tener este valor establecido en  True . LANGUAGE_CODE VARCHAR(255) Obsoleto. INCLUDE_HEADER SMALLINT/ TINYINT * Obsoleto. WRAP_FIELDS SMALLINT/ TINYINT * Obsoleto. DESCRIPTION VARCHAR(4000) La descripción de la vista. IS_SYSTEM SMALLINT/ TINYINT * Este campo indica si la plantilla está en la vista sistema, que no se puede editar ni eliminar. IDENTIFIER_FIELD VARCHAR(255) El campo de identificador seleccionado para esta vista. DATA_EXPORT_FIELDS Esta tabla contiene los campos incluidos en cada vista. DATA_EXPORT_FIELDS Nombre del campo Tipo de datos Descripción FIELD_INDEX Entero La clave principal. FIELD VARCHAR(255) El nombre del campo que se va a incluir en la vista. DATA_EXPORT_ID BIGINT La clave ajena a DATA_EXPORT_TEMPLATE.DATA_EXPORT_ID. Vistas y exportación de datos"},{"UUID":"73750f2e-90dc-49e7-945c-1b50ec1f51d5","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"Administrador de eventos Las siguientes","descFull":"Administrador de eventos Las siguientes tablas abordan la información relacionada con la creación y administración de eventos. ALERT Esta tabla contiene todas las alertas que admite MVE. ALERT Nombre del campo Tipo de datos Descripción ID BIGINT Clave principal NAME VARCHAR(255) Nombre textual de la alerta. Por ejemplo, “Alerta de consumible”. SEVERITY VARCHAR(255) Por ejemplo, “ERROR”. CATEGORY VARCHAR(255) Por ejemplo, “CONSUMIBLES”. ASSIGNED_EVENTS Esta tabla vincula eventos con sus elementos de configuración asignados. ASSIGNED_EVENTS Nombre del campo Tipo de datos Descripción CI_ID BIGINT La clave primaria compuesta. Hace referencia a CONFIG_ITEM.CI_ID. EVENT_ID BIGINT La clave primaria compuesta. Hace referencia a EVENT.EVENT_ID. EVENT_REGISTRATION_STATE VARCHAR(255) Las opciones son REGISTERED y NOT_REGISTERED. DESTINATION (DESTINO) Esta tabla representa una acción dentro del módulo Administrador de eventos. DESTINATION (DESTINO) Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. DESTINATION_TYPE VARCHAR(31) El tipo de destino, actualmente correo electrónico o comando shell. En función del tipo, no se aplican todas las columnas. NAME VARCHAR(255) El nombre del destino proporcionado por el usuario. EMAIL_BODY VARCHAR(255) Texto del cuerpo del correo electrónico. EMAIL_CC VARCHAR(255) La lista CC de correo electrónico. EMAIL_FROM VARCHAR(255) El campo de remitente del correo electrónico. EMAIL_SUBJECT VARCHAR(255) El campo de asunto del correo electrónico. EMAIL_TO VARCHAR(255) El campo de destinatario del correo electrónico. COMMAND_PATH VARCHAR(255) La ruta de acceso completa al comando. COMMAND_PARAMS VARCHAR(255) Los parámetros que se van a enviar al comando. DESCRIPTION VARCHAR(4000) Una descripción opcional del usuario de la acción. LAST_MODIFIED Marca de hora La fecha de la última edición de la acción. EVENT Esta tabla contiene eventos creados por el usuario, que constan de un nombre, una descripción y una colección de alertas que se deben incluir. EVENT Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. NAME VARCHAR(255) Nombre del evento proporcionado por el usuario. DESCRIPTION VARCHAR(255) Descripción del evento proporcionada por el usuario. EVENT_ID BIGINT La clave principal. TRIGGER_DESTINATIONS VARCHAR(255) Los destinos de activación del evento. Las opciones son on_active_only y on_active_and_clear. GRACE_PERIOD_ENABLED SMALLINT/ TINYINT * Indicador que señala si hay activado un período de gracia. GRACE_PERIOD_MINUTES INTEGER Número de minutos del período de gracia. LAST_MODIFIED TIMESTAMP Hora de la última edición del evento. EVENT_ALERTS Esta tabla vincula un evento a la colección de alertas que incluye. EVENT_ALERTS Nombre del campo Tipo de datos Descripción EVENT_ID BIGINT La clave primaria compuesta. Hace referencia a EVENT.EVENT_ID. ALERT_ID BIGINT La clave primaria compuesta. Hace referencia a ALERT.ALERT_ID. EVENT_DESTINATIONS Esta tabla vincula un evento a una acción asociada. EVENT_DESTINATIONS Nombre del campo Tipo de datos Descripción EVENT_ID BIGINT La clave primaria compuesta. Hace referencia a EVENT.EVENT_ID. DESTINATION_ID BIGINT La clave primaria compuesta. Hace referencia a DESTINATION.DESTINATION_ID. PRINTER_EVENT_ACTIVE_CONDITIONS Esta tabla representa las condiciones o alertas activas para impresoras con eventos que activan esa condición o alerta. Varias condiciones tienen sus filas correspondientes, todas apuntando al mismo PRINTER_ID. PRINTER_EVENT_ACTIVE_CONDITIONS Nombre del campo Tipo de datos Descripción ACTIVE_CONDITION_ID BIGINT La clave principal. LOCATION VARCHAR(255) Por ejemplo, “Bandeja 1”. MESSAGE VARCHAR(255) Por ejemplo, “Falta bandeja”. TYPE VARCHAR(255) Por ejemplo, “Intervención necesaria”. CI_ID BIGINT Hace referencia a CONFIG_ITEM.ID. DESTINATION_TASK_ID VARCHAR(80) La clave ajena a SYSTEM_LOG.TASK_ID. Administrador de eventos"},{"UUID":"4b9777f4-1b13-4286-bca5-a90177122b50","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"Varios Las siguientes tablas proporcionan","descFull":"Varios Las siguientes tablas proporcionan un almacenamiento útil, pero no se ajustan a ninguna de las categorías de tablas anteriores. APPLICATION_SETTINGS Esta tabla contiene actualmente toda la configuración del sistema MVE. Los valores están cifrados y no están disponibles fuera de MVE. APPLICATION_SETTINGS Nombre del campo Tipo de datos Descripción ID BIGINT La clave principal. SETTING_KEY VARCHAR(255) Nombre de la preferencia. SETTING_VALUE VARCHAR(8190) Valor de preferencia. BOOKMARK Esta tabla contiene todas las búsquedas guardadas de MVE. Actualmente están almacenados como BLOB, por lo que no se pueden editar fuera de MVE. BOOKMARK Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. ID BIGINT La clave principal. DEFAULT_SEARCH SMALLINT/ TINYINT * Indicador que señala si este marcador es uno de los valores predeterminados que se incluyen con MVE. NAME VARCHAR(255) Nombre del marcador proporcionado por el usuario. SEARCH_CRITERIA BLOB SUB_TYPE 0 Representación binaria del marcador. DESERIALIZABLE SMALLINT/ TINYINT * Indica si la búsqueda guardada es deserializable. DESCRIPTION VARCHAR(4000) Descripción opcional introducida por el usuario de la búsqueda guardada. Tablas Liquibase e Hibernate Liquibase e Hibernate son bibliotecas de terceros que MVE utiliza para ayudar a mantener la base de datos. Estas bibliotecas utilizan las siguientes tablas. Estas tablas no contienen ningún dato significativo de la impresora, por lo que su contenido no se detalla aquí. DATABASECHANGELOG DATABASECHANGELOGLOCK Todas las tablas cuyos nombres empiecen por  HT_ . HIBERNATESEQUENCE SMTP_CONFIGURATION Esta tabla contiene la configuración del protocolo simple de transferencia de correo (SMTP), que permite a los usuarios de MVE enviar correos electrónicos. SMTP_CONFIGURATION Nombre del campo Tipo de datos Descripción * Este tipo de datos es necesario para Microsoft SQL Server. ID BIGINT La clave principal. FROM_ADDRESS VARCHAR(255) Dirección de correo electrónico del remitente. LOGIN_ID VARCHAR(255) ID de usuario del servidor SMTP. LOGIN_PASSWORD VARCHAR(255) Contraseña asociada con el ID de usuario del servidor SMTP. LOGIN_REQ SMALLINT/ TINYINT * Indicador que señala si el servidor SMTP requiere un inicio de sesión. SMTP_PORT BIGINT Puerto del servidor SMTP. SMTP_SERVER VARCHAR(255) El nombre de host o la dirección IP del servidor SMTP. SMTP_ENABLE SMALLINT/ TINYINT * Indicador que señala si SMTP está habilitado. EMAIL_ENCRYPTION VARCHAR(64) Hace referencia a los tipos de cifrado admitidos. El valor predeterminado es null. SYSTEM_LOG Esta tabla contiene todos los mensajes del registro del sistema que se producen cuando MVE realiza sus tareas. Esta tabla puede llegar a ser muy grande. SYSTEM_LOG Nombre del campo Tipo de datos Descripción LOG_ID BIGINT La clave principal. TIMESTAMP_ TIMESTAMP Hora a la que se registró el mensaje. TASKID BIGINT Instancia de la tarea que generó el mensaje. TASKNAME VARCHAR(50) Tarea que generó el mensaje. LEVEL_ INTEGER Las opciones son DEBUG, INFO, etc. MESSAGE_ VARCHAR(8000) Mensaje de registro real. USER_NAME VARCHAR(255) Nombre del usuario que llevó a cabo la acción. IP_ADDRESS VARCHAR(50) La dirección IP del cliente. Varios"},{"UUID":"3a295668-5c9b-47ca-a303-f225586e3463","title":"Tablas FRAMEWORK y nombres de campo","link":"config-item-topic.html","desc":"Base de datos de Quartz","descFull":"Base de datos de Quartz QRTZ_FIRED_TRIGGERS Nombre del campo Tipo de datos Descripción SCHED_TIME BIGINT Se ha añadido una nueva columna para la hora programada. Base de datos de Quartz"},{"UUID":"fe30e8f3-8db3-4473-ab03-b8cf36f6211c","title":"Apéndice","link":"understanding-ports-and-protocols-topic.html","desc":"Descripción de puertos y protocolos","descFull":"Descripción de puertos y protocolos MVE utiliza diferentes puertos y protocolos para varios tipos de comunicación de red, como se muestra en el diagrama siguiente: Los puertos son bidireccionales y deben estar abiertos o activos para que MVE funcione correctamente. Asegúrese de que todos los puertos de la impresora están habilitados. Algunas comunicaciones requieren un puerto efímero, que es un intervalo asignado de puertos disponibles en el servidor. Cuando un cliente solicita una sesión de comunicación temporal, el servidor asigna un puerto dinámico al cliente. El puerto es válido sólo durante un breve período de tiempo y puede volver a estar disponible para usarlo cuando la sesión anterior caduca. Comunicación del servidor a la impresora Los puertos y protocolos utilizados durante la comunicación del servidor MVE a las impresoras de red Protocolo Servidor MVE Impresora Se utiliza para Network Printing Alliance Protocol (NPAP) UDP 9187 UDP 9300 Comunicación con impresoras de red Lexmark. Comunicación con impresoras de red. Transporte de red XML (XMLNT) UDP 9187 UDP 6000 Comunicación con algunas impresoras de red Lexmark. Comunicación con algunas impresoras de red. Lexmark Secure Transport (LST) UDP 6100 Puerto de protocolo de control de transmisión (TCP) efímero (intercambio) UDP 6100 TCP 6110 (intercambio) Comunicación segura con algunas impresoras de red Lexmark. Comunicación segura con algunas impresoras de red. Multicast Domain Name System (mDNS) Puerto de protocolo de datagramas de usuario (UDP) efímero UDP 5353 Búsqueda de impresoras de red Lexmark y determinación de los recursos de seguridad de las impresoras. Búsqueda de determinadas impresoras de red y determinación de los recursos de seguridad de las impresoras. Este puerto es necesario para permitir a MVE comunicarse con impresoras con seguridad. Protocolo de administración de red simple (SNMP) Puerto UDP efímero UDP 161 Búsqueda y comunicación con impresoras de red Lexmark y de terceros. Búsqueda y comunicación con impresoras de red. Protocolo de transferencia de archivos (FTP) Puerto TCP efímero TCP 21 TCP 20 Implementación de archivos. Protocolo de transferencia de hipertexto (HTTP) Puerto TCP efímero TCP 80 Implementación de archivos o cumplimiento de configuraciones. TCP 443 Implementación de archivos o cumplimiento de configuraciones. Protocolo de transferencia de hipertexto sobre SSL (HTTPS) Puerto TCP efímero TCP 161 TCP 443 Implementación de archivos o cumplimiento de configuraciones. RAW Puerto TCP efímero TCP 9100 Implementación de archivos o cumplimiento de configuraciones. Comunicación de la impresora al servidor El puerto y el protocolo utilizados durante la comunicación desde las impresoras de red al servidor MVE Protocolo Impresora Servidor MVE Se utiliza para NPAP UDP 9300 UDP 9187 Generar y recibir alertas Comunicación del servidor a la base de datos Puertos utilizados durante la comunicación del servidor MVE a las bases de datos Servidor MVE Base de datos Se utiliza para Puerto TCP efímero Puerto definido por el usuario. El puerto predeterminado es TCP 1433. Comunicación con una base de datos SQL Server. Puerto TCP efímero TCP 3050 Comunicación con una base de datos Firebird. Comunicación del cliente al servidor El puerto y el protocolo utilizados durante la comunicación del navegador local al servidor MVE Protocolo Navegador local Servidor MVE Protocolo de transferencia de hipertexto sobre SSL (HTTP) Puerto TCP TCP 443 Comunicación entre servidor y servidor de correo Puerto y protocolo utilizados durante la comunicación del servidor MVE a un servidor de correo Protocolo Servidor MVE Servidor SMTP Se utiliza para Protocolo simple de transferencia de correo (SMTP) Puerto TCP efímero Puerto definido por el usuario. El puerto predeterminado es TCP 25. Proporcionar la función de correo electrónico que se utiliza para recibir alertas de las impresoras. Comunicación entre servidor y servidor LDAP Los puertos y protocolos utilizados durante la comunicación del servidor MVE a un servidor LDAP que implican a grupos de usuarios y la función de autenticación Protocolo Servidor MVE Servidor LDAP Se utiliza para Protocolo ligero de acceso a directorios (LDAP) Puerto TCP efímero Puerto definido por el usuario. El puerto predeterminado es TCP 389. Autenticación de usuarios de MVE mediante un servidor LDAP. Lightweight Directory Access Protocol sobre TLS (LDAPS) Puerto TCP efímero Puerto definido por el usuario. El puerto predeterminado es TCP 636. Autenticación de usuarios MVE mediante un servidor LDAP sobre TLS. Kerberos Puerto UDP efímero Puerto definido por el usuario. El puerto predeterminado es UDP 88. Autenticación de usuarios MVE con Kerberos. puertos descripción protocolos descripción"},{"UUID":"0f49513b-0b7a-4b94-b5d2-94809b80458a","title":"Apéndice","link":"enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html","desc":"Activación de la aprobación automática","descFull":"Activación de la aprobación automática de solicitudes de certificado en la CA de Microsoft De forma predeterminada, todos los servidores de la CA están en modo pendiente y debe aprobar manualmente cada solicitud de certificado firmada. Dado que este método no es factible para solicitudes masivas, debe activar la aprobación automática de certificados firmados. En Server Manager, haga clic en  Herramientas  Entidad de certificación . En el panel de la izquierda, haga clic con el botón derecho del ratón en la CA y, a continuación, haga clic en  Propiedades  Módulo de directivas . En la pestaña  Gestión de solicitudes , haga clic en  Seguir la configuración de la plantilla de certificado si procede  y, a continuación, haga clic en  Aceptar . Si  Establecer el estado de solicitud de certificado en pendiente  está seleccionado, deberá aprobar el certificado de forma manual. Reinicie el servicio CA. activación de la aprobación automática de solicitudes de certificado en la CA de Microsoft aprobación automática de solicitudes de certificado activación en la CA de Microsoft solicitudes de certificado en la CA de Microsoft aprobación automática"},{"UUID":"7784a98a-5674-45a4-8b89-c65ab5bfa367","title":"Apéndice","link":"revoking-certificates-topic.html","desc":"Revocación de certificados Antes de","descFull":"Revocación de certificados Antes de comenzar, asegúrese de que el servidor de la CA está configurado para las CRL y que están disponibles. En el servidor de la CA, abra  Entidad de certificación . En el panel de la izquierda, expanda la CA y, a continuación, haga clic en  Certificados emitidos . Haga clic con el botón derecho del ratón en un certificado para revocarlo y, a continuación, haga clic en  Todas las tareas  Revocar certificado . Seleccione un código de motivo y la fecha y hora de la revocación y, a continuación, haga clic en  Sí . En el panel de la izquierda, haga clic con el botón derecho del ratón en  Certificados revocados  y, a continuación, haga clic en  Todas las tareas  Publicar . Asegúrese de que el certificado revocado se encuentra en  Certificados revocados . Puede ver el número de serie del certificado revocado en la CRL. revocación de certificados certificados revocación"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"divd0e8"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_vm._m(44),_vm._v(" "),_c('div',{attrs:{"id":"divd0e18170"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"Markvision Enterprise"}},[_vm._v("\n    Markvision Enterprise\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"change-history.html#change-history_es","title":"Historial de cambios"}},[_vm._v("\n    Historial de cambios\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"overview-chapter.html#overview-chapter_es","title":"Descripci&oacute;n general"}},[_vm._v("\n    Descripción general\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e260"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"overview-chapter.html#overview-markvision-enterprise_es","title":"Descripci&oacute;n de Markvision Enterprise"}},[_vm._v("\n     Descripción de Markvision Enterprise\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"getting-started-chapter.html#getting-started-chapter_es","title":"Introducci&oacute;n"}},[_vm._v("\n    Introducción\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e289"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"best-practices-topic.html#best-practices_es","title":"Mejores pr&aacute;cticas"}},[_vm._v("\n     Mejores prácticas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"system-requirements-topic.html#system-requirements_es","title":"Requisitos del sistema"}},[_vm._v("\n     Requisitos del sistema\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-languages-topic.html#supported-languages_es","title":"Idiomas compatibles"}},[_vm._v("\n     Idiomas compatibles\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-printer-models-topic.html#supported-printer-models_es","title":"Modelos de impresora admitidos"}},[_vm._v("\n     Modelos de impresora admitidos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-database-topic.html#setting-up-database_es","title":"Configuraci&oacute;n de la base de datos"}},[_vm._v("\n     Configuración de la base de datos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-mve-run-as-user-topic.html#d0e1132","title":"Configuraci&oacute;n para ejecutar como usuario"}},[_vm._v("\n     Configuración para ejecutar como usuario\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-markvision-topic.html#installing-markvision_es","title":"Instalaci&oacute;n de MVE"}},[_vm._v("\n     Instalación de MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-mve-silently-topic.html#installing-mve-silently_es","title":"Instalaci&oacute;n silenciosa de MVE"}},[_vm._v("\n     Instalación silenciosa de MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-mve-topic.html#accessing-mve_es","title":"Acceso a MVE"}},[_vm._v("\n     Acceso a MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-language-topic.html#changing-language_es","title":"Cambio de idioma"}},[_vm._v("\n     Cambio de idioma\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-your-password-topic.html#changing-your-password_es","title":"Cambio de la contrase&ntilde;a"}},[_vm._v("\n     Cambio de la contraseña\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintaining-application-chapter.html#maintaining-application-chapter_es","title":"Mantenimiento de la aplicaci&oacute;n"}},[_vm._v("\n    Mantenimiento de la aplicación\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1715"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"upgrading-to-latest-version-topic.html#upgrading-to-latest-version_es","title":"Actualizaci&oacute;n a MVE 4.3"}},[_vm._v("\n     Actualización a MVE 4.3\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_es","title":"Copia de seguridad y restauraci&oacute;n de la base de datos"}},[_vm._v("\n     Copia de seguridad y restauración de la base de datos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-installer-settings-topic.html#changing-installer-settings_es","title":"Actualizaci&oacute;n de la configuraci&oacute;n del instalador tras la instalaci&oacute;n"}},[_vm._v("\n     Actualización de la configuración del instalador tras la instalación\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-user-access-chapter.html#setting-user-access-chapter_es","title":"Configuraci&oacute;n del acceso de usuario"}},[_vm._v("\n    Configuración del acceso de usuario\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1987"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-user-access-overview-topic.html#setting-up-user-access-overview_es","title":"Descripci&oacute;n general"}},[_vm._v("\n     Descripción general\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-user-roles-topic.html#understanding-user-roles_es","title":"Descripci&oacute;n de las funciones de usuario"}},[_vm._v("\n     Descripción de las funciones de usuario\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-users-topic.html#managing-users_es","title":"Administraci&oacute;n de usuarios"}},[_vm._v("\n     Administración de usuarios\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_es","title":"Activaci&oacute;n de la autenticaci&oacute;n del servidor LDAP"}},[_vm._v("\n     Activación de la autenticación del servidor LDAP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_es","title":"Instalaci&oacute;n de certificados del servidor LDAP"}},[_vm._v("\n     Instalación de certificados del servidor LDAP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adding-root-ca-certificate-java-truststore-topic.html#adding-root-ca-certificate-java-truststore_es","title":"Adici&oacute;n de un certificado CA ra&iacute;z en el almac&eacute;n de confianza de Java"}},[_vm._v("\n     Adición de un certificado CA raíz en el almacén de confianza de Java\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"discovering-devices-chapter.html#discovering-devices-chapter_es","title":"B&uacute;squeda de impresoras"}},[_vm._v("\n    Búsqueda de impresoras\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2401"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-discovery-profile-topic.html#creating-discovery-profile_es","title":"Creaci&oacute;n de perfiles de b&uacute;squeda"}},[_vm._v("\n     Creación de perfiles de búsqueda\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-discovery-profiles-topic.html#managing-discovery-profiles_es","title":"Administraci&oacute;n de perfiles de b&uacute;squeda"}},[_vm._v("\n     Administración de perfiles de búsqueda\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_es","title":"Caso de ejemplo: B&uacute;squeda de impresoras"}},[_vm._v("\n     Caso de ejemplo: Búsqueda de impresoras\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_es","title":"Administraci&oacute;n del panel de seguridad"}},[_vm._v("\n    Administración del panel de seguridad\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2657"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"overview-security-dashboard-topic.html#overview-security-dashboard_es","title":"Descripci&oacute;n general"}},[_vm._v("\n     Descripción general\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-dashboard-topic.html#accessing-dashboard_es","title":"Acceso al panel de seguridad"}},[_vm._v("\n     Acceso al panel de seguridad\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-device-security-information-topic.html#managing-device-security-information_es","title":"Administraci&oacute;n de Informaci&oacute;n de seguridad del dispositivo"}},[_vm._v("\n     Administración de Información de seguridad del dispositivo\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-device-conformance-check-topic.html#managing-device-conformance-check_es","title":"Administraci&oacute;n de Comprobaci&oacute;n de cumplimiento del dispositivo"}},[_vm._v("\n     Administración de Comprobación de cumplimiento del dispositivo\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"finding-devices-chapter.html#finding-devices-chapter_es","title":"Visualizaci&oacute;n de impresoras"}},[_vm._v("\n    Visualización de impresoras\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2766"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-printer-list-topic.html#viewing-printer-list_es","title":"Visualizaci&oacute;n de la lista de la impresora"}},[_vm._v("\n     Visualización de la lista de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-device-information-topic.html#viewing-device-information_es","title":"Visualizaci&oacute;n de la informaci&oacute;n de la impresora"}},[_vm._v("\n     Visualización de la información de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-data-topic.html#exporting-data_es","title":"Exportaci&oacute;n de datos de la impresora"}},[_vm._v("\n     Exportación de datos de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-views-topic.html#managing-views_es","title":"Administraci&oacute;n de vistas"}},[_vm._v("\n     Administración de vistas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-printer-listing-view-topic.html#changing-printer-listing-view_es","title":"Cambio de la vista de lista de impresoras"}},[_vm._v("\n     Cambio de la vista de lista de impresoras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_es","title":"Filtrado de impresoras mediante la barra de b&uacute;squeda"}},[_vm._v("\n     Filtrado de impresoras mediante la barra de búsqueda\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-keywords-topic.html#managing-keywords_es","title":"Administraci&oacute;n de palabras clave"}},[_vm._v("\n     Administración de palabras clave\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-device-life-cycle-states-topic.html#d0e3226","title":"Utilizaci&oacute;n de las b&uacute;squedas guardadas"}},[_vm._v("\n     Utilización de las búsquedas guardadas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_es","title":"Caso de ejemplo: Controlar los niveles de t&oacute;ner de su flota"}},[_vm._v("\n     Caso de ejemplo: Controlar los niveles de tóner de su flota\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-devices-chapter.html#securing-devices-chapter_es","title":"Protecci&oacute;n de las comunicaciones de la impresora"}},[_vm._v("\n    Protección de las comunicaciones de la impresora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4163"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-security-status-topic.html#understanding-security-status_es","title":"Descripci&oacute;n de los estados de seguridad de la impresora"}},[_vm._v("\n     Descripción de los estados de seguridad de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printers-using-default-config-topic.html#securing-printers-using-default-config_es","title":"Protecci&oacute;n de impresoras con la configuraci&oacute;n predeterminada"}},[_vm._v("\n     Protección de impresoras con la configuración predeterminada\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-fac-permissions-topic.html#understanding-fac-permissions_es","title":"Descripci&oacute;n de los permisos y controles de acceso a funci&oacute;n"}},[_vm._v("\n     Descripción de los permisos y controles de acceso a función\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-device-security-topic.html#configuring-device-security_es","title":"Configuraci&oacute;n de la seguridad de la impresora"}},[_vm._v("\n     Configuración de la seguridad de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_es","title":"Protecci&oacute;n de las comunicaciones de la impresora en su grupo"}},[_vm._v("\n     Protección de las comunicaciones de la impresora en su grupo\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printers-topic.html#securing-printers_es","title":"Otras maneras de proteger sus impresoras"}},[_vm._v("\n     Otras maneras de proteger sus impresoras\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-assets-chapter.html#managing-assets-chapter_es","title":"Administraci&oacute;n de impresoras"}},[_vm._v("\n    Administración de impresoras\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4527"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restarting-printer-topic.html#restarting-printer_es","title":"Reinicio de la impresora"}},[_vm._v("\n     Reinicio de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-ews-topic.html#viewing-ews_es","title":"Visualizaci&oacute;n de Embedded Web Server de la impresora"}},[_vm._v("\n     Visualización de Embedded Web Server de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"auditing-devices-topic.html#auditing-devices_es","title":"Auditor&iacute;a de impresoras"}},[_vm._v("\n     Auditoría de impresoras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"updating-printer-status-topic.html#updating-printer-status_es","title":"Actualizaci&oacute;n del estado de la impresora"}},[_vm._v("\n     Actualización del estado de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-device-state-topic.html#setting-device-state_es","title":"Configuraci&oacute;n del estado de la impresora"}},[_vm._v("\n     Configuración del estado de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_es","title":"Asignaci&oacute;n de configuraciones a impresoras"}},[_vm._v("\n     Asignación de configuraciones a impresoras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"unassigning-configurations-topic.html#unassigning-configurations_es","title":"Desasignaci&oacute;n de configuraciones"}},[_vm._v("\n     Desasignación de configuraciones\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enforcing-configurations-topic.html#enforcing-configurations_es","title":"Aplicaci&oacute;n de configuraciones"}},[_vm._v("\n     Aplicación de configuraciones\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-device-conformance-topic.html#checking-device-conformance_es","title":"Comprobaci&oacute;n de la conformidad de la impresora con una configuraci&oacute;n"}},[_vm._v("\n     Comprobación de la conformidad de la impresora con una configuración\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"deploying-files-to-printers-topic.html#deploying-files-to-printers_es","title":"Implementaci&oacute;n de archivos en impresoras"}},[_vm._v("\n     Implementación de archivos en impresoras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"updating-printer-firmware-topic.html#updating-printer-firmware_es","title":"Actualizaci&oacute;n del firmware de la impresora"}},[_vm._v("\n     Actualización del firmware de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_es","title":"Desinstalaci&oacute;n de aplicaciones de las impresoras"}},[_vm._v("\n     Desinstalación de aplicaciones de las impresoras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-events-to-device-topic.html#assigning-events-to-device_es","title":"Asignaci&oacute;n de eventos a impresoras"}},[_vm._v("\n     Asignación de eventos a impresoras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-keyword-topic.html#assigning-keyword_es","title":"Asignar palabras clave a impresoras"}},[_vm._v("\n     Asignar palabras clave a impresoras\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_es","title":"Introducci&oacute;n de las credenciales para impresoras protegidas"}},[_vm._v("\n     Introducción de las credenciales para impresoras protegidas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_es","title":"Configuraci&oacute;n de los certificados de la impresora predeterminada de forma manual"}},[_vm._v("\n     Configuración de los certificados de la impresora predeterminada de forma manual\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"removing-printers-topic.html#removing-printers_es","title":"Eliminaci&oacute;n de impresoras"}},[_vm._v("\n     Eliminación de impresoras\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-configurations-chapter.html#managing-configurations-chapter_es","title":"Administraci&oacute;n de configuraciones"}},[_vm._v("\n    Administración de configuraciones\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5133"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-configurations-overview-topic.html#managing-configurations-overview_es","title":"Descripci&oacute;n general"}},[_vm._v("\n     Descripción general\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-configuration-topic.html#creating-configuration_es","title":"Creaci&oacute;n de una configuraci&oacute;n"}},[_vm._v("\n     Creación de una configuración\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-configuration-from-printer-topic.html#creating-configuration-from-printer_es","title":"Creaci&oacute;n de una configuraci&oacute;n desde una impresora"}},[_vm._v("\n     Creación de una configuración desde una impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_es","title":"Caso de ejemplo: clonaci&oacute;n de una configuraci&oacute;n"}},[_vm._v("\n     Caso de ejemplo: clonación de una configuración\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-advanced-security-component-topic.html#creating-advanced-security-component_es","title":"Creaci&oacute;n de un componente de seguridad avanzada desde una impresora"}},[_vm._v("\n     Creación de un componente de seguridad avanzada desde una impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-printable-version-topic.html#generating-printable-version_es","title":"Generaci&oacute;n de una versi&oacute;n para imprimir de la configuraci&oacute;n"}},[_vm._v("\n     Generación de una versión para imprimir de la configuración\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-dynamic-settings-topic.html#understanding-dynamic-settings_es","title":"Descripci&oacute;n de los ajustes din&aacute;micos"}},[_vm._v("\n     Descripción de los ajustes dinámicos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-variable-settings-topic.html#understanding-variable-settings_es","title":"Descripci&oacute;n de los ajustes de variables"}},[_vm._v("\n     Descripción de los ajustes de variables\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-color-permissions-topic.html#configuring-color-permissions_es","title":"Configuraci&oacute;n de los permisos de impresi&oacute;n en color"}},[_vm._v("\n     Configuración de los permisos de impresión en color\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-applications-package-topic.html#creating-applications-package_es","title":"Creaci&oacute;n de un paquete de aplicaciones"}},[_vm._v("\n     Creación de un paquete de aplicaciones\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_es","title":"Importaci&oacute;n o exportaci&oacute;n de una configuraci&oacute;n"}},[_vm._v("\n     Importación o exportación de una configuración\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"importing-files-to-resource-library-topic.html#importing-files-to-resource-library_es","title":"Importaci&oacute;n de archivos a la biblioteca de recursos"}},[_vm._v("\n     Importación de archivos a la biblioteca de recursos\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_es","title":"Administraci&oacute;n de certificados"}},[_vm._v("\n    Administración de certificados\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5644"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-MVE-manage-certificates-automatically-group.html#d0e5647","title":"Configuraci&oacute;n de MVE para gestionar certificados de forma autom&aacute;tica"}},[_vm._v("\n     Configuración de MVE para gestionar certificados de forma automática\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-SCEP-group.html#d0e5973","title":"Administraci&oacute;n de certificados mediante la autoridad certificadora de Microsoft a trav&eacute;s de SCEP"}},[_vm._v("\n     Administración de certificados mediante la autoridad certificadora de Microsoft a través de SCEP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-MSCEWS-group.html#d0e6695","title":"Administraci&oacute;n de certificados mediante la autoridad certificadora de Microsoft a trav&eacute;s de MSCEWS"}},[_vm._v("\n     Administración de certificados mediante la autoridad certificadora de Microsoft a través de MSCEWS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-OpenXPKI-CA-group.html#d0e7680","title":"Administraci&oacute;n de certificados mediante la autoridad certificadora de OpenXPKI a trav&eacute;s de SCEP"}},[_vm._v("\n     Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de SCEP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-EST-group.html#d0e8747","title":"Administraci&oacute;n de certificados mediante la autoridad certificadora de OpenXPKI a trav&eacute;s de EST"}},[_vm._v("\n     Administración de certificados mediante la autoridad certificadora de OpenXPKI a través de EST\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-device-alerts-chapter.html#managing-device-alerts-chapter_es","title":"Administraci&oacute;n de alertas de impresora"}},[_vm._v("\n    Administración de alertas de impresora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9833"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_es","title":"Descripci&oacute;n general"}},[_vm._v("\n     Descripción general\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-action-topic.html#creating-action_es","title":"Creaci&oacute;n de una acci&oacute;n"}},[_vm._v("\n     Creación de una acción\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-action-placeholders-topic.html#understanding-action-placeholders_es","title":"Descripci&oacute;n de los marcadores de posici&oacute;n de acci&oacute;n"}},[_vm._v("\n     Descripción de los marcadores de posición de acción\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-actions-topic.html#managing-actions_es","title":"Administraci&oacute;n de acciones"}},[_vm._v("\n     Administración de acciones\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-event-topic.html#creating-event_es","title":"Creaci&oacute;n de un evento"}},[_vm._v("\n     Creación de un evento\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-printer-alerts-topic.html#understanding-printer-alerts_es","title":"Descripci&oacute;n de las alertas de impresora"}},[_vm._v("\n     Descripción de las alertas de impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-events-topic.html#managing-events_es","title":"Administraci&oacute;n de eventos"}},[_vm._v("\n     Administración de eventos\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"viewing-tasks-chapter.html#viewing-tasks-chapter_es","title":"Visualizaci&oacute;n del estado y el historial de las tareas"}},[_vm._v("\n    Visualización del estado y el historial de las tareas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10465"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_es","title":"Descripci&oacute;n general"}},[_vm._v("\n     Descripción general\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-task-status-topic.html#viewing-task-status_es","title":"Visualizaci&oacute;n del estado de la tarea"}},[_vm._v("\n     Visualización del estado de la tarea\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stopping-tasks-topic.html#stopping-tasks_es","title":"Detenci&oacute;n de tareas"}},[_vm._v("\n     Detención de tareas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-logs-topic.html#viewing-logs_es","title":"Visualizaci&oacute;n de archivos de registro"}},[_vm._v("\n     Visualización de archivos de registro\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-logs-topic.html#clearing-logs_es","title":"Borrado de registros"}},[_vm._v("\n     Borrado de registros\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-logs-topic.html#exporting-logs_es","title":"Exportaci&oacute;n de registros"}},[_vm._v("\n     Exportación de registros\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"scheduling-tasks.html#scheduling-tasks_es","title":"Programaci&oacute;n de tareas"}},[_vm._v("\n    Programación de tareas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10573"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-schedule-topic.html#creating-schedule_es","title":"Creaci&oacute;n de un programa"}},[_vm._v("\n     Creación de un programa\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-schedules-topic.html#managing-schedules_es","title":"Administraci&oacute;n de tareas programadas"}},[_vm._v("\n     Administración de tareas programadas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"admin-tasks-chapter.html#admin-tasks-chapter_es","title":"Realizaci&oacute;n de otras tareas administrativas"}},[_vm._v("\n    Realización de otras tareas administrativas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10715"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-system-settings-topic.html#configuring-system-settings_es","title":"Configuraci&oacute;n de los valores generales"}},[_vm._v("\n     Configuración de los valores generales\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-email-settings-topic.html#configuring-email-settings_es","title":"Configuraci&oacute;n de los valores del correo electr&oacute;nico"}},[_vm._v("\n     Configuración de los valores del correo electrónico\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adding-login-disclaimer-topic.html#adding-login-disclaimer_es","title":"Adici&oacute;n de una renuncia de responsabilidad de inicio de sesi&oacute;n"}},[_vm._v("\n     Adición de una renuncia de responsabilidad de inicio de sesión\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"signing-mve-certificate-topic.html#signing-mve-certificate_es","title":"Firma del certificado MVE"}},[_vm._v("\n     Firma del certificado MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"removing-user-information-topic.html#removing-user-information_es","title":"Eliminaci&oacute;n de la informaci&oacute;n de usuario y las referencias a este"}},[_vm._v("\n     Eliminación de la información de usuario y las referencias a este\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-SSO-chapter.html#managing-SSO-chapter_es","title":"Gesti&oacute;n de SSO"}},[_vm._v("\n    Gestión de SSO\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10973"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"mve-configuration-workflow-adfs-overview-topic.html#d0e10978","title":"Descripci&oacute;n general"}},[_vm._v("\n     Descripción general\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-claim-issuance-policy-grouprule-topic.html#setting-claim-issuance-policy-grouprule_es","title":"Configuraci&oacute;n de la pol&iacute;tica de emisi&oacute;n de reclamaciones para GroupRule"}},[_vm._v("\n     Configuración de la política de emisión de reclamaciones para GroupRule\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-claim-issuance-policy-name-id-topic.html#setting-claim-issuance-policy-name-id_es","title":"Configuraci&oacute;n de la pol&iacute;tica de emisi&oacute;n de reclamaciones para el ID de nombre"}},[_vm._v("\n     Configuración de la política de emisión de reclamaciones para el ID de nombre\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-adfs-server-authentication-topic.html#enabling-adfs-server-authentication_es","title":"Activaci&oacute;n de la autenticaci&oacute;n del servidor ADFS"}},[_vm._v("\n     Activación de la autenticación del servidor ADFS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-mve-adfs-topic.html#accessing-mve-adfs_es","title":"Acceso a MVE mediante ADFS"}},[_vm._v("\n     Acceso a MVE mediante ADFS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"logging-out-mve-adfs-topic.html#logging-out-mve-adfs_es","title":"Cerrar sesi&oacute;n en MVE"}},[_vm._v("\n     Cerrar sesión en MVE\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"faq-chapter.html#faq-chapter_es","title":"Preguntas m&aacute;s frecuentes"}},[_vm._v("\n    Preguntas más frecuentes\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11143"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"faq-chapter.html#frequently-asked-questions_es","title":"Preguntas m&aacute;s frecuentes sobre Markvision Enterprise"}},[_vm._v("\n     Preguntas más frecuentes sobre Markvision Enterprise\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_es","title":"Soluci&oacute;n de problemas"}},[_vm._v("\n    Solución de problemas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11337"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_es","title":"El usuario ha olvidado la contrase&ntilde;a"}},[_vm._v("\n     El usuario ha olvidado la contraseña\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_es","title":"El usuario administrador ha olvidado la contrase&ntilde;a"}},[_vm._v("\n     El usuario administrador ha olvidado la contraseña\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_es","title":"La p&aacute;gina no se carga"}},[_vm._v("\n     La página no se carga\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_es","title":"No se puede encontrar una impresora de red"}},[_vm._v("\n     No se puede encontrar una impresora de red\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-incorrect-device-information-topic.html#trb-incorrect-device-information_es","title":"Informaci&oacute;n de la impresora incorrecta"}},[_vm._v("\n     Información de la impresora incorrecta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_es","title":"MVE no reconoce una impresora como protegida"}},[_vm._v("\n     MVE no reconoce una impresora como protegida\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_es","title":"El uso de las configuraciones con varias aplicaciones genera un error en el primer intento, pero no se producen problemas en los intentos posteriores"}},[_vm._v("\n     El uso de las configuraciones con varias aplicaciones genera un error en el primer intento, pero no se producen problemas en los intentos posteriores\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_es","title":"Aplicaci&oacute;n de configuraciones si falla la emisi&oacute;n del certificado de la impresora"}},[_vm._v("\n     Aplicación de configuraciones si falla la emisión del certificado de la impresora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-openxpki-ca-group.html#d0e11554","title":"Autoridad certificadora de OpenXPKI"}},[_vm._v("\n     Autoridad certificadora de OpenXPKI\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"database-access-chapter.html#database-access-chapter_es","title":"Acceso a la base de datos"}},[_vm._v("\n    Acceso a la base de datos\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11724"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"differences-supported-databases-data-types-topic.html#differences-supported-databases-data-types_es","title":"Diferencias en los tipos de datos de bases de datos compatibles"}},[_vm._v("\n     Diferencias en los tipos de datos de bases de datos compatibles\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"config-item-topic.html#d0e11785","title":"Tablas FRAMEWORK y nombres de campo"}},[_vm._v("\n     Tablas FRAMEWORK y nombres de campo\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"appendix-chapter.html#appendix-chapter_es","title":"Ap&eacute;ndice"}},[_vm._v("\n    Apéndice\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17725"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_es","title":"Descripci&oacute;n de puertos y protocolos"}},[_vm._v("\n     Descripción de puertos y protocolos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_es","title":"Activaci&oacute;n de la aprobaci&oacute;n autom&aacute;tica de solicitudes de certificado en la CA de Microsoft"}},[_vm._v("\n     Activación de la aprobación automática de solicitudes de certificado en la CA de Microsoft\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"revoking-certificates-topic.html#revoking-certificates_es","title":"Revocaci&oacute;n de certificados"}},[_vm._v("\n     Revocación de certificados\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"leap_notices.html#leap_notices_es","title":"Avisos"}},[_vm._v("\n    Avisos\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18101"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#d0e18104","title":"Nota sobre la edici&oacute;n"}},[_vm._v("\n     Nota sobre la edición\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#d0e18140","title":"Marcas comerciales"}},[_vm._v("\n     Marcas comerciales\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#us-government-rights_es","title":"GOVERNMENT END USERS"}},[_vm._v("\n     GOVERNMENT END USERS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#jmdns-license_es","title":"JmDNS License"}},[_vm._v("\n     JmDNS License\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#licensing-notices-program-folder_es","title":"Avisos de licencia"}},[_vm._v("\n     Avisos de licencia\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"glossary.html#glossary_es","title":"Glosario"}},[_vm._v("\n    Glosario\n   ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js